(function(){"use strict";try{if(typeof document<"u"){var r=document.createElement("style");r.appendChild(document.createTextNode(".react-tel-input{font-family:Roboto,sans-serif;font-size:15px;position:relative;width:100%}.react-tel-input :disabled{cursor:not-allowed}.react-tel-input .flag{width:16px;height:11px;background-image:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQAAAACmCAMAAAACnqETAAADAFBMVEUAAAD30gQCKn0GJJ4MP4kMlD43WGf9/f329vcBAQHhAADx8vHvAwL8AQL7UlL4RUUzqDP2MjLp6un2Jyj0Ghn2PTr9fHvi5OJYuln7Xl75+UPpNzXUAQH29jH6cXC+AAIAJwBNtE/23Ff5aGdDr0TJAQHsZV3qR0IAOQB3x3fdRD/Z2NvuWFLkcG7fVlH4kI4AAlXO0M8BATsdS6MCagIBfQEASgPoKSc4VKL442q4xeQAigD46eetAABYd9jvf3nZMiwAAoD30zz55X5ng9tPbKZnwGXz8x77+lY7OTjzzikABGsenh72pKNPldEAWgHgGBgAACH88/Gqt95JR0OWAwP3uLd/qdr53kMBBJJ3d3XMPTpWer8NnAwABKPH1O1VVFIuLSz13NtZnlf2kEh9keLn7vfZ4vNkZGHzvwJIXZRfZLuDwfv4y8tvk79LlUblzsxorGcCBusFKuYCCcdmfq5jqvlxt/tzktEABLb8/HL2tlTAw8SLlMFpj/ZlpNhBZ81BYbQcGxuToN9SYdjXY2Lz7lD0dCQ6S9Dm0EUCYPdDlvWWvd2AnviXqc11eMZTqPc3cPMCRev16ZrRUE0Hf/tNT7HIJyTptDVTffSsTkvhtgQ0T4jigoFUx/g+hsX9/QUHzQY1dbJ7sHV02Pduvd0leiK1XmaTrfpCQPgELrrdsrY1NamgyPrh03iPxosvX92ysbCgoZzk5kP1YD7t6AILnu+45LykNS40qvXDdHnR6tBennz6u3TSxU1Or9Swz6wqzCsPZKzglJbIqEY8hDhyAgFzbJxuOC+Li4d9sJLFsnhwbvH2d1A3kzAqPZQITsN76nq2dzaZdKJf4F6RJkb078YFiM+tnWZGh2F+dDibykYoMcsnekdI1UhCAwWb25qVkEq43km9yBrclQMGwfyZ3/zZ2QK9gJxsJWCBUk32QwqOSYKRxh6Xdm3B4oMW22EPZzawnR72kgZltCqPxrdH1dkBkqDdWwwMwMO9O2sqKXHvipPGJkzlRVLhJjVIs9KrAAAAB3RSTlMA/v3+/Pn9Fk05qAAAUU9JREFUeNp0nAlYVNcVxzHazoroGBkXhAgCCjMsroDoKIgKdFABBwQUnSAoCqLRFBfcCBIM4kbqShO1hlSrCJqQQmNssVFqjBarsdjFJWlMTOLXJDZt8/X7+j/n3pk3vNq/bb8+3nbP79137/+dd954qTVt8uTJL73OMhqNer03ady4cWOhWbNmjV+0FfKGjMb36Y9/1fXUst9cb2y8/lpb797z5k2dOjXVD9Ljn59fcHBwQEDAgGch3l9on6feeeedn0r9kvT222+/sErRgvcDArwV8f5tN/rcvPnMZ22pqVFRSVGjR38k9Rsp9fLql/MXLj20VGjt2rVeak2Og/auI/kHBQ3We/tCo0ZNhwYNGj58/NaWlpbOyMhIX1//2/jTrICvckhXruQsWbJw4cL3tzhPORynSk5lZWVtglL9IkmdDQ05NqvVGhLwbKSUL+Tvb9yH/2sj+eN0IZZ3fvq3Hnp71ZtCOyofdnTYSzq9xX7UtsF9+/Y1FpeZT54sc2aUlq6Jy89YM/qj2oZaoeOkMR8dV/Tee++NWb04rrA5MRYKDAyc/NKCpwDIyKhE9LEzZ/r4DLQAAE6EyEeM6AcNH7m1pTMnB+fHX7tG9Bs0Xt+GwM/frqm5tz950aKDk6rsiA0xbUrbRAii/BDeV9bGhQsPRlyOCAuZ9GykZwT++n2RHPnVYQU+oaFDPQD8jEQAPiDdaLPaHGVXbn/O7YHQuIH9B/gYgzts1iqrtSopKWlNRkzS6I8arFaOFvTfew8AfiYil/rN6sWTKwtbArOzExISUl7+vwCuQNt8Bg71AQCcTwNpWeFbW3IIQEmJr08XgIzX2xDcvZrs7Jru5EWXwwKSwh2RkQ77w7Q0bXp6YRoDaKO+kZl8MCwsYpJ3pEf8liAAoPhDhqUMQ/wAkF+oqKiosJYA7HxotdnTtVe6Pr/S0h+AI90QffU3T9obGuwdD5PqkmJiMtbM+ajWI/60TX0COhoarAAE1dfXV80FgMmLi1oSKP7/B6ASAGyBV4YM7D/Bx8/bF7g5fgmgEwCCSiJtJQRgxEi9zZqVdYUu9pW0tLCIgOvxdR0dpxx5aWl7EzV7CYDV+tXnCzMzkzMvE4AFlTuhZaSf/OQny1L32RC+JcHikzJ06NAJoe+YNKRbsbG3xPlWZTxssNmdOP/J27ffudLJ60V7DAaT1lxRVvfwYe3Jlrq4uJiKjAwAcIWP+BkAhV/i7HA0uAG8BAIUf8qfzvwvgJcQf+XMK4GWi8OGTpgQ6uftzwC0LIM2WgcASwaXOBwlA7v6/YgAhFRt2pRGeu0/UyImbal77eHDo2kVAJAeKwE0fl6P63/5nSlTAKBCiR8AovbZEL9lf8I5AMD5booAE7OzY8X5fhGJi0/nTzTcMh+80iIBaF0APqvIu3EjqfRGcV3S4aSKYk8AaW4ADU4gOFlfn8sAXnoJBDpTCMDL87zU2kwATl+x1Nw+P2HChKHBBMDHFT8DwGjX11FSYu/f/aMf9XtOjwAacf2hmxRg7ywXDrr30kb7NVhDquo/z0y+nJs7ZUoYA5DxM4BFmcnJyV93PzjbvQhK3urqAYF7xflWVT5ssDaU4Ox7T9+6Ei4BaN0AUkvXJEExMTGHD9cdFgA2yfgZQAP1f0dJw0lrfS4BmIb4z5yZBgL/H8DibbehGROenQ0AQRhvZPwQAGDQ8wlqsFkmdP9ofr/n/OgK2ml1xxQECAAy/tdee++91wCA1mfWJy/KXUTr536T+O67764X2r9//T+3JkPdDx50f7qItDXfff+zeAxY1lYV0VCmPV1Ts5fGAGUYDbHpo0qT6vKTignAtWvXiuf0StwGZZPQybMPAYC8/xF/bj0AUPwvvzytKCdl6dMAvJxRuXjxkCHnL86YMXs2A8B4m4yWQTrdIp0uByMajcATJrwzXwCIiIjAFSrbJwGI+FlH00YH8/rQy5enQPsYgBK/BLCI1c0Afonhn/XjH8MNLP9o1Y4Pfg795N9hYQ23bt1q4fb07z+A/ITR2J8AFJnqOP7iuj7Fc35TK+9/bkPaM+NGiSnsB6wRIwGA4n/5T5Pzc5aeeAqAP1VCM4niWRqVgr1p1sEYlskNJQC4BQZbLJi0MAgCgBUKqYo3VEVEhIWFTZqXtYmVxiIAtB4QeDUAvMuSFBgAJCkwAKHlLAKw4wMIFG5URVgdLdwedEq6BuCgj1qzpi4uiVScYa6I0fWKJQVC2aRDY0eNWrlyECwMMIDDc2vZ6UF0F7z8tB5w4kTvtZ+ygklGkk4lvZ6sne45SDg8aJIQ2z+4Mmg0qcfauXPnfvPNN9XV/1S0VSWyf1Ls4FZ5aIHu/blGKb2UOM0ckq4PmsZ2b8yYMb2l4FbhX8ePHwmhuSPXkhaQ5q0tXzBvntdUUq9eSyFu9njXxpA74Leg198yktRWVI4OkAkymw2Q3WO90+nnN3u2H0QkHI6JpHHj2GvTYdsupd68GfVZ4yTJqJeUaNKhQ+rzCUvOMXEr//4vD3333XdLe+rRJx4iqumDnT2O5zW1HII1hPLy8pJGjz9GWgk9D61Al4fWkWay9VRbUa1GEVCYDRoonu0dr++n0ZQ0dMCNdDRYHVrtuImjWHQ80lvfl4WfhJetw1CFm6h+rkazd28iJHvyIe/IHt7ZOBY7o4GPH4smPqf7nRwz/sH6bmmi2HtvYiBUYPxEcZakt701PdsPAIhb3DBbYmIIAOK+F9HXJ6z7t799AwDI48+cOQRi66m2ogoAYVwIQEkQb8DrJza1azRWq9NpjUjXtg+aNXHU9EEQHW/YsGFD3toHMFZbgzUsDNPkPgAgpScG1vA4TgB8PZATAAoc6IasWPHhhwCQkyNCdwMIJCVqDabA8+cAAJFLYVD92dvpjvQe7ZcA7p0/350dEzNmy+iRAHBPrO9+AwB41Of4h2HoFdZYhsfL7ej7QmbSBdED/GkDXv+ju9Pv4i9mM+g09Rs1duKoQSQR/4whb7msbFhufHy8M2xup6AZ3sHzWOChaveIWQCtn00A7s/84MDuD4bd+fBDcYEukrVna5fwMQPAsqnQZOqqLtBzezysvHd6z/YLANndUELMGAmgXqzPfeON3+IE8PHbuL2YegYCAO+/fz/io2VMM+5HpR/BGXIPGCzix3oAaBo13aApK9Mahg8fNAo9ANsPGi7iB4BLZRUPH9advJGb6zx+3Jk7FwFtCNekNzQUabW3cAv0Ek9uUA0U+PGsY4NmzrxQVBS3e82wGQDA7bvI8SsAsgNP7y26HV4GALyeJzGaY5J18fZ4GT+3DwBK8/K2ZF/s7v46ZYwEsMJHrJ/gApBJ8QPAs9gh2BYBnT077OwUnvcBwB0/nCEAQPFBdADefv5dPEu3p2u18e39Bg2aPou2h9wNmP3wi7bGL9qsuVOcizoBgM/X0BBtamggK2wGABn+WSLw8awm9P4Du3ecys+aMWPGt6J9medF/EsBIBbxJxSFm4vM5moJAOGL+AHAO90jfglgy5bshO7uFAIQM2fkyhUr6sX6fW+MJQDYX1wvWI/+uOIc79mziJec4ESxDPGy6AF9RfzYHgBw02s7yswNhf1GDJ8+lvcfPgKrxfoAa0S9uP9HTV95LHdur8TzuF7W5OSqDdEGAFiaiIjk9U8hAMdw+1Ts3r37VPOMGR/K9l3k+CUA9P9b4c6y8LKC6upqAiDj3wpxD1Dix/m9Uku3KAD6xMx5DgC6xfrLYwnAEuw/jOJnAMHjpnvECwA8aK5YseK3EA2aogf0pQNIAIOaXI8S0/sBAPaHaLUEIOJHPmjUsWACACN7/qLVmoz2Zjabv3x8X+oBdP/DWeih94d9sHv3BzO+fOOND6l9C93xL00BgOy97dHo/ZHm6EcAwM8OHlZ+YLpFtF9eQAGA9+81pg8DQCzdU3D9Ef/YN3AC8OP4Z5D1DBg7XYmfAKitqYl7AA8AvDxxVLtGW1VVVhYRZjC0jhg/Tuzv3j6gCuEjfghGYd/cXrFk5BNqai4K633k938h/Zp15C8Tx68E7X7Dtm2b8QZEAH743j8gYQQwC8TGlp08Z7ZWC+k/4eFf6pc//Sje3+TZ/pFeqXkQ7hoIhhoAnve8ogRgCQZBMQsgTgBgXykpAoDKmpoIuJP/wMvzwaOKHkisVfUnDYZZ2J/k3n4ST/94UiHt2/d+Lx7yttFAXnP+60W6+X9ggQFzGDdeOJT791fQNAgAv/qHFFMAAJou7AWQBCAkKXzknW71bD96APnWQ4c+hthRsv1Ty2WNA4InwYYpzhJSW1MT+lmkxx9awyfNhQVmvf9+c9M4kVt1by8tsmuLub3I/in6er7URGkh1SZ1znfk/xR9o2oP7F8Pax1vbO8RgJcwhYp8BvpMcD1t+0GffPJ7xUo+CA54Yc+DPXv2vGA0vkBavfqIW+xeH3kr8iJ9QxJegQNpu/TMzZupnzXOkQ7+OkumeCCOU+Si2Sr7kR6RkQZ/iA0y62PWVKlUiLy8fsz1MSd6s+YhLz1vu0t7ILS4T1Rqn2cU9fF6YQdpMZIAG6dNmzZ5bX+7PZKGsXi0CM9xwZ+0DmuVnejxsHMDJu3Zu24vkrT+QTtYq4/8nvWHPzyeCa2HUySRbzMKAO9CGhZ15Pku67uGlaS7frzoeFat26uY2CpzijiIrbKfLdH2buy7eKLkR8oAaXWhQNLH8+qEKirKy0tLS6O8bXVZQpvg8dPmbV/O+jH0IvRClLY06hkPAcBGqLa19ckBzC0HVg+0R9rQFpqFtWER1oBPhr3+eutPocevPzIaBwTseTORAu/rQ7sd2AgA4g69T1PlfmGVsX9fn8ESALk4ER5Gsb/Mny2tbzGkPQwASH1s2iTDBwC2yhYeVdgq+yXODAwpCCzAozT7Dml12fqR8VGcOMtk9A0pkUvsI7YvR+DQrl2vQLtWpdbFPAVAq8lgMrcygKEEoKQsJKTMYQgLDQn4ZN3r60T43ngSrH5g1rBcWaINAoCMX1plXq8GoBUAXNYX4RcfPqzVXa8tqk3bpATAVtnCVpytsp8tsCBifcJVil8BoFhfu7OE5RCyGn0HWxweQLYvf/HF2tp1T568IgD0Gf2MJilKBSCrPf5Cc3h76e4zuwmAv8ZqQ5cLMwwNA4DWn+IfwoeqX3/8kQvAQC2rGQCU+NkqywuiAqAVACa6rO/hYsR/uBi3wKZd7wGA1gPAcEvfhAQAmEEA4DwLEgo4/tmzwyYdYqurWF+9zWKxhCKlTjnV2WEBxkhHX5/G8jSZEZoKALWJWbuyYgWBVRgA6vqk9hgDNh54YtI2t2jbn5wBgAl2m1XTYAmxhFoNU5DG/uRnHuG/d/yjEa0X7kID+99tgu6OxTytxK8A0KoAaCGexz+rWHPpUtKaG4e1hwnAhhNZlLtMhwyG+HhDGVvl0PXZ2fv7w3oMe8vPijuf4of2AQCyutDmzWdI1zcv0Psr8SOFF2As0Th8Qr84CiEzcjSKni09b4l5C+al4r9uAcCBA1nthuYKc3spA4i0hWgNdFazgbK8n3iEjzct380S1rd/f+mkAECJH87O21/2v76eALQM4MiRX0+MKqXsFXSYAei8/d3WXLHaoQNTUga4AYSGiesPTSEASvwEwCrin4D4GYAv4m9MS5M5yalGX1uixccntCDwKqf5n5FSboGNBw4caG03m1tbz5zZs3v1bAAAKvtJDAuzAeD1c0r4DEBY4f4DKH4C8AclfgYQxFl0etRWAAj+RwjA6DUyfuoC3xt02F6JnwDQ8UNpeQAB+DTY6op/HxJLU+au3jj5JYRPwvR5ZoFN3v12oVxjkE+oXbG+4o71WH5dJa9VALD7wBPMArvP7AEAfaTVgm3NZkzcszHoBCvhM4BvhTcfMOCB8OZH/sDxp0hrCwA8PvKjNqkaAPaL80sAyvU3fF+sU1tptspDaRkA3gKAEIoforwaAPhZ3f2de4RWeUvAARqDKH65ZDKE7/nxriexm17ZtO0JxvhXX1n1Q5UAYCMQTCsvn7ybEuYL9JE2q9jfZJoSBgADEP5xt757MJM0xMcHUUOfzr9Pywlua+vtThhJAOvdPYDc/LjRayC+CxiDTm2l2SpbeJmPHywzyhLDXH1ICI96wEAcAlIr4ABKSThuXt4c75ByyJ2Zj9qDWbD2SSJmAdaqBSp5CdPoB5frx9LDdEVDG6C5cKnB/xz1kdB3rAcP2Bb7+X0q9GtOXirWU7HGEgBSwI/CoehosrIT2f7pFKmtNFvlYF4W/jvAI6kMoX2y1kBIZKBHu1PDwfNI7A1ZbP+UIgPMAn08hFnAIOROal3P6pnlzSQlK8pHf4F2s+AwjSRNvDsCadl76bQif9tbqDBdNvzPfxcy8+nCw1OULDDrOukEi7PXnngo+IDLY8UZZMmGOmsMn09yPTI8VwjhWEUkXIY4mYVu2/7qq9tJXuqsLoxJj+XMZqEWUmdnskabf8olWOI9Rl9Ik07vqeh1id/EpqZRUGKOhksqxveuZGm0Idx3g//+BPrd734n793wXnuFEoUOXc+ClJcrC4wiI8rv0On4GNUbbh8TBRtwDOPVWerxv2P9SuiPukKcBwd0xRPusuLSH+/xUmd1r9dm5XsuZzZ35kBLxCt+ANBoihA5CY6YAODEmnS8KRpIr7cBgJp2uyDkahcmi+EAUE7SpvPQFRrw9yfcvk5nPHUyApDokQWPBQCOXN7DafPo+ABH1RN8fL0t6OrVq1X3eC7C8dVZ6vHu2P/4xz//WQDAQ44rnmhXFlrYYxeAW+mJ6bcSEyUAEFCyqJdPfkX6HLp8+fJXBEBTyAR2uAD0tWjSfbh9BGAUxX/1zi8HVXcpAHZq03m9BNBptXY4ET8DUOKXANJk/AxAFETYbO/ayJ3aACAwcH3gep/Qru4PUZ8w/nW8X9gWOMSdZR7bRG81jkOU1XjeDUArFOey4i++WFW1vr4NAMTLaFjLvekuAJvylYKIXIcvFcQItzLB9o5G44CzylcA+Pe1+GjS+fojwGDO4hbcOfuXX35bnZ0deIgB7Nyp1QqrygB+1Wb9lbOBAUQTAOV1XuwhdRZXI7Q3UVplfSKS45aEc0MH9p/yTveKkQCw7WrIXneWmYDMrD3++Mnx47x8Iqt8GiTs4+bJ8y6V3Xj4sOLkjV27qjA9AYCBvGJsQkLgXraKBAAEOsCdZPfLdbjjRwQAUOJvxy7t/BK+NKuPhqVYTX6PEHJ101+qq8MWLcrUqdf/ne5Pa+OvMLPRPB3dBw+ychaDSkers7gaFiAliv31sSHr14euv0o8n322XoeAHXhwOyuydsMYwJDax0+ePD5OywCA8NM4fAIwdWfdtIqKvKyMXbuKDPWFRS8wAG3r3lvtF0RBAveANuqv7K2Dc+3K9Z/g7gGtlKRja9sjPjSQF6/eqc7+9ttztKz3Z6uarl22BcqL+jvdo1URvyqzGbSUpOTX6XlkW0mvpaqzuBLA6dOxOD4DKMA7koRzaMyUf3+xczUCvlVgic+m+CWAIUNqjz95vEkBwJdfAniVhj6+/xuRjGyTAO42XRjVxJMfACjxE4CuveRlC2SO7d13NJD59yJFSQD0QRj+tPHu7flhpqv6y+pv/9lF7wn0QexZ4g1bBIBZBCAnIsJaEm+QAJT4f/Naqrmndd2wCFMPhuHTp3OWQDk6vS1hfcL+6v6I/iU8vgPAkAs1+5vPIn62zt6+56AsdNChjx49OqcvwsEQPx2OjwcAIv5d+YW5hfkSgNZ814wNGADHP0HEo58Q8PXe2Fjx/JkCxd7T8uXn+CUA3P4AILcPFu8NuqrDziF+lND4hfCjigAQsywKozQN0Esc8eJ89LTHLk8+7ZmV+LnBnJX2KNAA8KvVQ//9xWTYkDNnJq9VW2m5XF8vl2lSx/X3AMDhU35kee7yXS94mfh8St78RNZDOetAEwBAmaRjoS6t4a7M0TKFcWxNtfE+cvvgsWKCjs3U8jwFAGxd0w150DIAkHO0QSjaSPM3Pa6BI+RnVtojAPAErBRo6AeHtN1YDP8uRra1aiutXgYALTZ1H287pn+SxAAA0pFB0aQT7wuzKbOQwV93kfC/Qt13j/TI0k5kg2Yqox1YY0VBwlKdWXgx6VvLzKlRrPEjRU53Q7QQdpenE/bW7G7JBpZOpUmfLVi9arXQWkhtpdXLZP8WzFsQFx3Hh2vm/CjrBZaX9UbvmzenotZWWmpZ3AOJUgvCtkq/2u2Vy0lmbiOfZhxLqSWuyC/FpS5qbCyiW/6LUm/om2rv6mrvR9VGyCRkNErs6uOprS2bcpaZ91Bbd0CTmsTiPd/i8gtuzxGVPpoIebTY61qJ+aT9pJOytEnQ6NfiSBlxcbWsMTRG7LBtdFvJ8nxI9FAyKEhgkJRa4jqHpigjQxMZqamry/fV1Hk3eWRx198zmjTpmEZovSbe7tRGq4+ntraGnlY9nJfT47Wu5YAGVIKSZIEF7y8KOrg9R5C++r2iI6/W9myvF2p3/YNwyqQYcl/Fc14TkcNAk+r60AkPhBzg0wkA4GNi2fyDCMAg5VURKkfz4uwOzWJN0GBNuR0Qrnk3jTrrqlh68O1wvDlyNCBp6R+k0Tqq7ACgOp7K2koA6b7xSgFGeuTgvkElWBYAEDgidxVY8P5c0DGMrbLTgx908tVTPdo73uumw+4baW94WByTlp+fFuMCkJGhBqD1ACCeFP2pTg/WVzkgTpiXUV6GtCCeD4Li82N29vYGoDs1/Lrvy379ngcADaWtg0JwMAe8ufp46gIM+brdYnEKL4/lSF5fItqjFE6ms6/g/UVBB18Qb1xgeno4x7qqf/XUKdr81i2ZIfJaU1LR0YEsbUxMWmnFUQEgP5/sYFxceXlWn1XIGR6w0JzDWosGZ2SIBgeFwJvDeBBvtxWVz5Ior2Xle486i4KIO1fP3aEXkiv0QQ47pa9CQoTTnP304227d08ejwMsszRaylwAZIGDvwCw/RQ8ObRRaBUXcIiCDpwPAN6NvQoN5vgHngOA5XT7NDVJa+31WUXSjRsxa27EXEuLawGAo3HU/+OysnBjlpdmPeNnExkYV16+HO3NEKMQJjgrGizjl1a0MTLI4xL2vek9KrBg+IiuhBRUFhMAfrojiae74Kcf715m8j0+ngDgj/vBR9QOAyArUmj2njc5cJmkOLCKa5u5PTO4YMM7cR0REPELAMtxxA0bpDX3SsXYFwNdu5bWmZN0bc7RjNraOMSPHpBRCgCrKWcYKq//njNrp4kGmyCQCQlGg5X40WDZA3z6u3vAnUEjRtw5d+5LAJi/Qm9xcOstFht9JxHp9/TjDeteKJyd7AFhuVPKhFX39vcXXd4hssjbuQO4IGxkAD6iPZy1Rg9Yj/g5/IGPAGD58kJ42Q0bwnE8AUDG39mZl5eToyMAiL62Fok2AkD34O7QM26jlIcG14oui6sYEjymrpxeyuUJlaZuqViWnz5Y0x8AQpt7J6V6Hxs+4k4N2chD386f/6EeRseB9lso89oBY6I+3lhVAQYDSHfud5qEkUEWGftj574ii2xWUqJyPTqfKOjg/WlQ5P7v4wJwSguhoJEV7hW1huOHKO1xDQD45aJWWyoAUAPOhBEAgwtAbZ2YhC2haDA/bbkfNvKmxmRobJF5mgEDNL/Q2EPKU72nD7rPPhq5rwf9CIDdageAUK2hod4GAKrj/U8BRiQ/ju8/R/7UJ4Ssbl9HutbpL63uUws2RH/k5bKe1vrKq8td1nsflDsXAES5OXQY9da639SS6uQswAC0ByyTlR6QAQkbEgIBQNbicggY8qCpdRpb3M6dNAguS4rTWC4ZjwVCXIABCitgdZ2RGNBDMAs4bSUAoDre/xRgsCFYvx5hkbkVVjfIv6/L6j61YIMLOs7ysuvttdSRV+vcnqEecycAiFpbFtUbiEpbzpiy6NKsDlhL/pS1ZQuq6TZwkjCYJOtuSVNJpZ8nIQeaf/NmPlKyz9R+b4T++cj46JF+9iM9JK2un5+0uurjkX2T5Qsso5Df/7O6smCj5/a93oI+5eUjKu0JVpLMJK/r18PDZRaWq4i3k0ykcHbLKmcqaoVlCvcQtGjEjyZ6emF1Fre3CpDa6vKZhbHn8wdLueytnqU8n7CTFSllugeMik0WaJd6CrUZDTfmwep/cY3S5M/hmqjP73V9Mj0uKjnA7ZQtFebiRWiVt8x/yrHW6GE1SYf8Hraa2psUa2m0QWRlQ0QWd8FiUrkrL5XK+ytm13iiUog3mzZtQbANsrpL7CfpySCz+G8BXEChYRVAxj1vSsmCDVUBxTfFTq3zpDO+Li5/Q9OFlrg6tdX2MovZCn6MtXM7PS8LAPQ+HQA48IcPeardqFesJtf6HvL2bby97tat9unCCQIAz/ORkWKeBwB3PgafKWxOFVYXCYvjwuqe4NAlnpcIgIhcFkQAAAfOfwwNIwAALR4IkKEpMJp6ZrWj1QUUgx2Yde32G/hIB+VVx6LUVlsCcF2Dyt4MQBzvFQgAKP62pvA2CUBaTZmF/RjLEV+dn7nuVvuo4fQRFQBYoHRH31DKAgdX5EMSb0ZGXIy0uiU+JcLqEoBprvgZgBK/BKDEHxYBAIMEAG16NQDoJYAdO7QCQAKnL043N5+mbpB4qNEZ77CXlFRk5FMJfFOd/OyOxJ/deZ1A99+8Weue5gjALphFLL+yezcB2AhZmy5Y2Wnh9feSCGE1ET8DAM2D3WeHDKFuMGi80R/hl+CjqvgSBsBlc5V0vMpCqigRF4viN7AVXV252B3+S8jaKtdTZoH5q7IIaUUjJnEBhYHWxysA3ty4482Nb2r5+KyMuvw64fQqnBknT2aU7aQe0PX8MqoXaKUsaCvivWvQmiQA7qHQ5t7bkSt5RctWYzcD2MEAwsNDJICvFi7sewf6knRnIltPn8vdxGNYvGkcAPj42OPt9hJfTqpyAws1GRnaImRBXQAQf4mBG7i2snwnaxlp51R1FjnEYRfqgBo69nHO0YD1ngAKNxbiP7S9BFAXV1EhnN7D8KLw5riiirq4lXUHK47VIf6mC63tTU3trU3T78IJilJSpQcAwK5XeLlQAXCg6oMbVYife8DCep8RSqkpACD+e0hL70UPGD5S70/pLXQ6pyhY4BzfYi20uNDgBoD4Bxi4gQyQZnVZPK3OMquXOecIdgQA0vMGuPwbD+yg9RIA4o8T20+tAFvxlV59Te6y0Vh5wWQytLYaTOgBAFCp3KNiEPzxrldUADD8VV06/wUWfw4AZDUVqzoSy2GXHwyZiTGgHwGhLHGoj7Mk0jmUAVS4D54BxcVcr90E5fUfkJTGb36ox4gSDwg9hkthP4RQCDtu3Ic6dYEDF1CYPAHweowBwgqPbVoJyXJXfFCxrCgjDv8Jr4urO51bk1GBLDOUQ+IssxesKKlSqveeH7+iBnAAqo/YTTogsq49rOfB7m23brUOp2UGQNH4DJ1gEVnledP47pKvfLdEqd/9occo8TMAJX4CoFXilwBg+lQA5HoFAIcvviiZWsHXH4q5nVDzk9HqLLNXUaFLJlORqahuz4uQOCDPAkblUYvkx1bTw3oGt3Xi4ivLsoDBnVWeygNc3mYSsoQA4PnyFwDIMCglD8EjXc3/kAQAPbPE4Wx9PW6BF6RDkW1ci2+K+JsngQE9AB2QOwEudGNdRoU6y+zl/ohMmjWyf6uiyfduWEVSnJ0wZLw4UvkMTaebCCuqLOtVFQxKGasQdwSYZdcZPWweSykFFuKwlZxoOBdQXIiGmvUkVxJ5g5TaSivnHs3SqeQ1UZUl7Q1p9Bp3kQWvFicXNvvQfGX7cR8fmqs6oPozOp1KAqgClSyw1AKSnqVA/PbTXj3E7RWnn/81jrcb4loHme7+n/Pz5krWuu3GM5+hVnmOfAICAFVWtzdVE9g05VApHvNTPawnW8fLiYmPeXvofmCNztv2lRxRuG/p1AUXOl6rrDd6WFGyyqsXQ4oXnKe3sRIT2f5YAsY2PV4nNJPUS2nv/a9wQJ3yewPiW2OcP3wDN8LQvIHP3zO+7/kXJ8IvrYGuJBUDgEhqyruaAJSXa0I0eaSjRwGA1otw2DrqOs8HBt6hzb+tSbi4RAdn17jE/UI7UwJw+Po6xLOFjmsroj//fEMmr+eCCovl6lUfeqHu47d2scsG0WA5eSqMj1AovM/QiAB8JXZnnRvBul6u9k4/v9Ccmbzwn8ZIgROwwDPET6sxdeaEa5xOTfiSnHA+//OeWetce0cDVAzl5BwGgNb29lb570L73fZ+AFCqsWg4fgCIYuspLidbVxzwNgggzZOQ0o2AyNpG2JWHKQZgJ6sdycvR3CGdDbYyE6kFABD/+uyEgoFcUBHQEAHVV1XxZyNhcwUAy/r1FP+UiIBZo0zmY+2etcQc//3uzE5T54P1evSokvj4SB/w7I/jAUB4Z3N6ZF8f3/TmJRsYwMILraQLUOvwz8ocHR2ODlSo5V65sg8ANKx0B7IsJGGtLaraXXF+Nir0/r77fPb58wkXM1HAAACUpbZjvQJAfJY00EnLRt8gdPXPIyIuiwoRLqi4mlBQkFI9gQFQUWpDhNNZbwWAXADg+AMD9w8dOmVKaMAsg2FQ+3BYFs/2TL+/EIN4Z8qjgXqjf4kdpoP7kwCgMWkdMGNDI03hOD+11+xhrWWt8uHiwyfbGk+6AdjtjkhhPV3Fx2F0/tnyszixP9cCy8/UshP2y8/Q7Brg9sHeImvLX42JlLADy+E4HrxxZlhY8gSuEGGrjOrnagAg4wMA9RH4lCu+w5lLADpQ+mlxxm8LvFUytKTEcnCWofV5fOVzzAmVlDk7yAneP4/4M79GcSoBcJb4l8SHIH4+Hj8oNoeGLtv8kNojASjWGlnwS5eK16BMM6eidMlhFwBtpK/Bw3qGqqyn2J+SkASAPtM6fz7l62QG4O8RvwQQL95qOGnZDeCyLGaGVeYesL8ayxKANl6Lt125+/DV2CVTZZGzcrHZPDmvbPLm8O/RA4a39+uux+WQF2T6/ZZMxJ/yDbcHPcBGPYDjFwBM2lPL8jafyTCF4/zUXrOHlY7iStXDEDlUAPCNdzgdeHqz8z9Hwzx8SQoAR4/S6/yYo1FsPbUKADipewnZeMvxZcrS7q2LuNY3TMYPAQAUSfHbeDma/1xmtdIYYMYYQE5yYEFKyjdoLwMIC4sHAPzHSQAqKovi8L5w2uT8yrz8uPLiWStN7Su60COnkADg8fkWU2dmZkr/ZwWAoCCMAUEU/7M4np9BE57TrM3avLm8sHnhBkM0ffbX4S4mdoSNXiPiv3b7ypIlt2/rvNjaYnwXFQb99QRAO5QB4Fvio6PZeor4OAury7mYXfMtWeFvD/X6OpNqfbtkXpYLIkTBhX1w30gDA6D9Mfp2d/cTn6kZg7gQoLpaFlQsKH/J9Sj6p1/8Yktq76LFIDAtP39yXn5dXv4zs5DFqFB06Us8jYZn7v/GVRCBW4qrC4aKMQA9wJyzJFqbn2+IXrgkmgHkDqRV8nwE4DDU53DO7dt0C6gLCqZi+tdatHlyGhjN1lPL4vVbAwPvu2aVOyn7dd4h92ReVhREqAsuxk6XqyFplT0LMILXyklQUpiaVJlfWRkXt7g8P6M8I2Na1KyVpTt2vPjiRgjO/MAq3RKopsDd3lNFbuVDWTj/hmYTj3ctzQYCEIFRVzkfirUheRdcAwB1lpXsnyHAFOVyj2w9hdPk9UsPjVM+Oxv/9cdzx49VliF1wcVY1S84eBg9JavMLlyqeOrhw6mpl4qjooqfiSruM+sErLmHYP7++sijvduVYgfa7gX1+XV6Y48TzoF6WOFPDilfxZHUWWB1VlY+Fe12qTe0wCOIQKkE+SaAQcp6E1JvlZRSYaH+AyCPn1sTnxMqmq2SOsurXl5L6vUWnYFb4KXWJ3v39viFBXXWVFpT/EFY0wOiSjg//03Wmd5ZdRcSL9SJdyN4MRK4cuX69bHvtjWyLn4claHNqFCssfN/ACSSlF+MGKC8+fSFjHPbWOJ4Bw/+1VsldXvVy2sXQ+ug2Fgy108DwIHXPr4gfmHhs4fQDegL0g2dPhI20/2ISwA4B52fv5EeQncAwGk0/HReHj/u5qUGrny+oCBWNPhg48GuKK3GcMkKcR2DddI8IfQYIffvA8hfjEDBBklG4A8AHDj0DnTwr656mAApdZZXvcxWe+bM27e3bQujn/J6CoDH/FFkQs1dBnCiklL4izERbebSUmEMTE3HzOIzOQaw42+dnX/bCBGAFjS/heNXADQ27u+6eLHrIABkGOouKVmdsgyhiooMoU/58/ga1vnzNV/j9beUqB94v02JnwDopFxPzOqCCvUyAZi8rQa/d5f9fwAkcg/APXteApgGFWq0hZM9ANx9fkWTJ4CizOQiAWDBYnR8cf1BYHNq4PMAEAgACfsPgkBXVMWlS+gBso6lapJGqKVFI6T+BQpTz6ywuSzeKVVG6tCxtrZsdQPgeLu65C9W8LLyCxEAgFlm2+2IiHsAMOWpAKgHXKAe8AQE3j5BxMrp/NO4tJQBtFOKpp2sJAPYsTwuOTnuRQbwfcWNG5eEMLdc0kkABxMu7t+f0nWzK75nlrdMxpe8SAGgxA8fYVJlhf+nFpkVvUSn6RQAOCtd39WVi3gJQKS4f0R9bxAATAaAewUFADDlqQD+W9y1hkVRRmGyy+6ygrYleMVCM4sQoRvQKiFSBlG56CZiYYigEIgFlcJWhIJ0YUuUCLMbT1mhS4ClaRJPEQRElhbhpRD1qSyhInvq6f6e832zMzta/arebm4zOzvnnW9n3j3fOe9H8f/gev6HH57vpPZyMAbK0pESpAfz/YKA5YuWvb9skdnMBGCq6PO2lpbMz6l19pWhUZdg8h1ljvLHSOCiZUxASxyw/eM9F7Cbn1LHNGWugYHyv3pJgIcDhSRAla5B/zQCZNvdnj2y7U73/lAiYFVJ3/33980jJXkqAsDA84e+aaorq5MEYCaLlBjiVwgw73z//eadZgAEIAV3O6YB9qN4CASQ1t/KMkP82BEE4Mu/5+ieoyDA6pnVzd3G6Ni3r0P8aVqwNA94nJDcetfnWyRuB7Z80rqDvv8MPA+36y1M9W13escIEACVNW9eX9+8vyIghr0Fnq/r/IEdFnq/xP1fwbHjprFqZyYCvHDaYzRXGBkHJAoCArby5qtJa4KAGctAwIzqTR9/vP3j7Xu20whQ69gwAs7UgbPIfGyRRUYxs1LMCzy6tnWTGj8R8CkDnUfyDyc5WOiyxCtmQmTOGxcXd20cm7mdTIALI4DwvHBYGOopjceO9czaggDcA0TBA+4BIGCSsp1mr8YIAgKrqqs/BrbvOWr1lMa5egJ0WWQQAIhqXgAEqE9BQu+3OuilvL7W+FZKOAmHvYuBkwl4rV81WCB4CmNtgncag+XfKyr0bWyiq7kK2MDQdb2dPALUtzPWywznWolWoFcD/fv1Ul6pE1DKjVmkiloGPgMvPTh/qpGOWjsGoPeZUlF9+ypv//pVTspyLe5S3n/paR5YynvfweDt+qzzEAn5CWhkdySGR2NKMD4+1oH/c5WAsv9lO9qSqJZ5k5LbNgukKuerrxUmKrSXzyTQ2moSuJEgiiouIKBfAPBTpWO0IzJS9rAsWNAWPLR0ZQw9VyIisH1UQcnXnJVdSYjg/U/Twcdvl5/fewzejv0ZSlZ2SDmhsLs7t5w+I2yIozwjwwGxjFcZkflh+iz1L7VBtW+jzc3pzM8CwoyGUM7hBcjz5YIKqTSBaWrWWbTxcVZ6IHhgYNMAZ6Vv7ADEk4J9jgUBE1TpiConQzls5WJji2IHStN+8vErCEzzpSqlEVtnVG0dylnZEioQmMf7y7jnzXMTEDjBF/aHAG/n/YHD54us8xDE7WjurLVXuPDDlAjIiUzPyTcY8ImRKSBAZH0PHJAFF4+/jfDwd2wl5c5jw8xB9cSAzVeeL0tleZ8gpYik6yRlQp0KMSkrXb3uq2EXvpv8LmWluWNFEIAqBDcBqnSMTiQCEH7R/D2lu1ItkJZdBWm+aWkj0qq2YjtnZbkKawbvf4TQ39/d3d/Pf/TZFVjg+xID22l/jv6aiyYOP4DECBNQX9HgKMx3VRAB0Q5k9nNiiYCUICaA4p84ejTCp/25zQ21zCCgvHxmJUZAoYEJkOcLLzQMDE5fsRcaLDQ+BA5to8IwImCA4qcn7cePX6cSAG8zI0nj8WJ6fJQqHeMdiZH5dPk3IXyjOf/rkC5fhF9QUFp69jkoNOSsLBdIzOD9ScGcf+gio/GiQ+dfjxcYMV2SAN6O/YGJzcaJQuoSARXfFDkiwztiYjPzw8opNZcSaTBGRpYnwhwT+59/WEijfux/heI4URk+8+aamZWzzTKNPUyebxKZwRURwskLbSqatCj+nTsPCQJ8/Dyn35kAY27nV7VaAiZdDAjT03gUfdLl79rVbcxw5M+mvjykMEePSyutikPpKkvXEtkxzwQA2wzANv6jT0RBYJcggLfT/ofroKK2NSOi4ZOHOEBAaE650VEUkwkC+LGNf5SkJRFwzWiaGm08QbW+xxxZe/dWOvdmhs901EzP1BAgpO9UR74U4sBZbSYm4KNtOz8iIAlLSlGVSgoB/vUDQWb+bSAIGMnnTlL0ivgcXP62Tbu6zZE54bDW+toPI6CrNC6utPQcGgEsXRE/CGDlxe1Tt8Ay8NAtz9KffWBmtpXCv/NO1RFip9G80+hfh+MTAfmFFbGO0AUdMZnhsbPLUzLSMQjQ05kY5J8YGUv7L2scfaB/XOMLtH+8MysWU9tAT0tfX7gkwGgdIaWvvlZZEPAhj4DPQIDOoYIJ2GdsQFkiDDLcBJyvFjzE5+Dmtys7qDwW1ZIgAFJza0HaCIRf+v3XisMD1+IKAoRIsaRmp2/nP/pEzPAkgM3TcAecOFwc35Gf73C5CuubY9rDQQCMkVPgCms04kVkfvhs3v/9/nHj+hE/E1CE+LmYt69vtyQAOWSY1UkCZPyybQ7KkupCP9yG+ImAG2vUyXYyiLyCCfBvaPDXEGA8Xy14iM9v67Tj4u++dPduJiCgYF7p2WdXVZ177tenfT9CODzw58Wx9OQMlq/9ppvsvufSn/EVmAECKEGnOkIMP7TN/9A1fHwiIL+jor4+ph7FuUxAeUo+EwBvcBDA+7//Pp8PEyDiZ4AAPl8iQErfE4cPc8GSBNr4hDK/Wrb9ieOp8YGAffvEF078NmDpeI1a4DC1vjYxJ5YQDuArMCuwC4MItjaY7Kq6lmtz5VOApScr2DE3QcvjP4APPZ9fYpyyljdetMkWFnJ2lghIsVgc+UYjnoL+QeGz9ftP5cd/bCxYIJhk1tn6F7XC+qzzeP32K94ABAEXAyCApOONkwGRtT1rSLxaPQzAP4qwdKk34wvOEn/xKnDUmzBGB9477w4gj7frfX01hg8MvMbfYRZLmHAX4/35DfyOydjbo5pZJn1zvSXUUmEBVb4L6D+f/yMKQKYRvPKSBgeTUKp7gdT0c3XSNSlaZqzjo4upse0DAVFcDHytgmt3rwDqLNQXbekwAaLAwky1x3w8ofRVua/P4iImwwcGNQ198OBBLy2mMlQSnQGLF/vOnD5scyCjTPEpVnZhFjRtdkrbHX8U4JVUUVFfUeF4z2wjWHN9NtZ5SNFop8PBZXzF6dmjID0/ePjh4vLyYsXn4davd0mI/uKh8CWm2Wwz5uN2ki8xS1tRsMDHQy2ytnfzTn3tMLLQhocNAcETpOPEwaHeBz0IQLM5Q5ixzX4iIzVjZUZ2yr0ls8gQvEw6RNCdZm8+vmLjbXZjsGfbnTGdunBEgYa31/6KehdKS9dMkVlfH79JfdousCSnK7ANPviRlgBIz4TmDx7+xlUyq6T+vpkzUeM0EwSkKSil2l2y2AQBNTWoxiSLTZa2ggA+HipRAf65DxABOBN3HpMImGS42cClc+w4sXmoNfVlDwI4cDm7Ezt7UmpMQkRIRMLqEkYZHCJYOmeGH99xfDcISDWkTvHwPU7npplhskADBDhcaE5fY7EycimrmqvxCU5yBoIAZ0YqbEKH5W678VgFcsz7R4/u3MsIy7ZZFaQCtZMFAYsWGY3bXmACRgoCjGaWtg8h06Ma3N3+4Dlau/xRAd6CAJmCIQJsqanW0zUE5GjihxvdsOyYkEC/iLensB98SZl0iNiLG+bx3cczZ4832g1TZPxyBKRsYTM04XiBr0CM0+VyrrmYSwKmjB+6o2CS77qFC5WSl2hnW1tloiUE99yQoIuoDW3WrP19eAYMGwY16uuN2IDsXbtkSQwREGrYtuydDiLgHZNa22tmKawYQsRUiIIFs2cWOMgA3Ky+tuy2W63eY4d4jgCKX5qxPZFhD5oVaX9xeiPiBwGKQ0T4pszdxzcdnz0+WG2rpPoD5fMofiYgz4HLDygjYKhrfqDvsGTFwQEEVGbh8o84e5h950RuQ5vVtx8MjEP8RIA4YEJX6S7hQEG+xKGGmnfeWW5sJgLU2l4LZX0VApo3SkcIszZ+aeCw+D5gJq8Qcesv3t6bdyN9oBCwocKloKmpyTW4KmHx4mGLnVOyED9QdmxvZlvbk20gYNPu3cfDmQAZPxOwfosYfTTbRZ4kXhdQ/z6AEUfCYLz3QGDwsGS+/A8IAootCfh2+gUdIqlMI2B0H+KfQfFTZ6c6AjgLS77Eoc3L33lnUUcz+RKrtb0Wer86AmKE9jfrsrj06j5NQcMvYzdu5OsvQStKuGd3z8g0Bc7CzY/RyASobYAQckPCTdK3mJukqP6A70G4Aymf52W1EZRvsTWXtHM20hUSndEZVrQt4vKPFFJ58jdNfXPm9I07wZnJfaZt8maxU6D5PCKgbhkufkcz+RKTtJUE8PvlPeD55/kxcPfa0++RM/EA2d9ByRnuY8cV4RU2NSo1dcpULQHlhoxYEf4ZggAZ/jyE31g1NV+N/9iQ3aZp5Fs8nCDOn9sBRDl0SBSyxl5jgy/RZnWnQfunwdWcgPRG3NEgKviZkNs8XErJyW8coJo4jh+pWZNH29pVw88jX2I00eBGENRMvsQsRQUB/H4qxmasB2BuFp0jg+dmrefCxk4iAjhLTO5x08JgTD9pWpibAHiRWSIRvyDgSRDA8SN8ip8IcMdfXX0MBJBvscZHGN5iiJ8IyL5wTDYISLUB6n28FtpftrkxC0d98JCy+9e5peR57FEk8SkI0ElN8iVGaVxNjdFcCF9isV0QwNvXqklvgAjIkUOAAQImGW82KlVaIOACOKmOBwMqATnKUwA8yBEgKWACshQdn3kcbYDsW6w5v7UYeQSaqU6lEUBunLUCbxOGfr90A5qtjiqAYuqsu0yVkqjj9YBeatLmGmRlC4NCF7m3hwbR/zmPtq8FtPZm0bpaXsg/88sWNcuJ/81QGFCW01DA8k+iCsD+HrtwOhonqIh9pZgCYpghfIXF1RcNegLu1rVeb0+p2pDkmTcmWenO4QI2BXJIXRYVdUWS5h1508aqWXZAX2sszNDUz1uvgvXzKZf40MwX6R0puCXvVeC009T0uSZGL5aimlrgsbq2NdPARqFSAgp4++juYqdmsawwesRrpbPNs1Y4NcpiycbuLqcLv7OzKqfe8d6XG0UWF4Djg77WGFIaULPU6kQJpm0efXTtqZf4GFD8vkx6RwquRdYsEeI9aRSyppw2JYwHATiQphZ4rK5tDVnV6kt8gbQZcVuxHQEmInBgMyAIuIZqd6Ujg00bPhPgb8/KaiqrbGrLbNkNApAvp/dI5OprjSGllx9oKiiQWV8QgMB/+OabH14ngIBTLfGB0IXXGQjQOVLk0WSvcJTg/b1HjRmT3NWVfDWDCcDxNLXAcqkrV0y3UGKUVv4KS06k4a5IvsFGg82W4pTxny4IQPzI+E1sngil5yZABvhCtr2msrKsrL2sJbNpSWwYCHjpvQx1u77WGAQ0lXVtLaiSWV8i4BCmYcYJBtby8ckugn1ozf5iBHD8TIDekSKPJns1S4SMRU3pxStXagkAnZpaYNGuHjElLcIqCVhY2DCnetjWrajuRUbI2L1ypc3s3Mzxn75ZElDnP3L4yJ3NUHoKAcoVDsKZVFa2tcMvP65lScvUOx5JwdpRe1ezozwmS30CRslaY5WArtTcLrmEBxMw7hmgkVYgen2tCDg1JCRVU5w9wPEzAXpHCnah1SwRMgQP3ITkZDseusBz8V6cNVVrgQUBFYGrdwRWSHO0woVz6ue8m3z2OaVLUZxs6541q9uwsuH4McJxk5l+506sI9P+kcNJKofILyjPWI7CXB0IaI/tmUEE7G8JuyPSkIFs0XEpTVuJAG2tsSAgI7iKs54gAN/9ZwjjBAHpQnnWObOF9BZKEvFLAvSOFAoBSOLheIIAFDFnX6olQK4mp86vm8v37i2HYwET0DBnznx8P7efc24ptmMEVNhsIe4sKxFw/sSLzIdkgYM+CxtKBLS0NM3vw11uMBNfgUhaNkuugLYaI0CNX0rpAy1dUWVx4v0g4NFHrxUj4DUQcKcgIDUqCgSYFQIGZPyt75r0jhRUIHF/ibpECBEA45mNl3KPPAgQq8npCDBmwARItKlRre2cBvpl0Ps4B2zrtmVPkPFJApBTbTbX1TWPBAH6goWhWI+wMhMFUC0tRwaXbAYBuP4Z6nS5rtaYf0scaKqqKsX7FQLoHnBtx2uCAGVPbvNKZwKMRhl+77smvSPFipmo9OD4BQFGIDk7N5mPgQssaoU1tcB6H18QUN9O8QNzh3LACcPUggQmgB4AdTv9rxl+1clLbnh3pq3bvHl+S8sgsGTzbBCwyuJu6zHX6muNJ9MSH+/jAPx+IgC3vh8OH0b8TADf1QFaLg1marcyAQNMQG8rCNA7UqygUieO/1U+Ht+YduzINQv4i1phtRYYBEzx8PFFbW77EqXN7N2rva/tDtEvqWH+uyU3QMDqrErG5vDNRMBe7ZoarfpaY7HEh/r+9fT4B15nEAGA6LYGmACcungMAia9IwXXInMWex4fz6wWTwgChhJyGd6EC7QqDTB5ojVNV5BAVN+od3AANJP0c8NUeTo7r3U8jqsuqaGrNZZaW33/ep37WR5B02amb03TO1LQXis2cIGEPF8mxw0vo4TSO6lRngycm8f6c3mL895Tz2D7IGRuUvQR8i6Tvr46qXoGgAINLomYCgz19qw/GeMMv2l8uPNxxQhZ3/ZmtCkwQ1pbLM+6cQvDKODuHLuccBrjlFL6KkDbR6f3Fc5YzwVaAi7X3WshTRmyE9NUbFxsSHwPwJewweXaHw2dW78SSBPS9Ko6T6l6BrLHqATOEXg6zDvbZseyvAEy6zu2MiElISTFnuh0kt1g1lSeKFXPx6Jvw4MpitYW5Rb9+bO5GytfIX3VeISPsFqwIXyJ9b7C/kgZKVnrzrIyFwhwNyPj7rTMlFecQrGvATrLmpYhY5SV5YLUTGNpSgURNVqpCgJycvCDTVr0gQCbPcAOF6ULpZMUChsnTAAdYoa/CATgt4Z6PhabgWtm+bUgQLPuDlas0J0/CEBgmtXx1HiEj7BnBsq80+slt0cwrW35yB14g7L/fU1N5SBgUd225prmZvzT8QIIWJyBq4/w9zaVHXiBCWgX8Z+tFEQs12QYckHADcgv5CN+SUDqJVi2WcQPAi5IwHjxi9pRVNQCFE2FoUIGtxKuIkxPeiUxalSq36jixYziFZ9tOwQoo+DDZyUBLpdRIQAXViN9RTx3bdnyKKUh7lrrE8J1pAUFUqh54bHEEBO6L92xXsaP3ekNdxIBzc11zXUdy5mANcZVxmJx+V9A3osIcLnjv8SeS1ng5WrbSOhS/ZIYdlsCHtDSIv/C8UUJiVEbEzc6isKZgLAVM+1m+xrCQWBNdN4jAci8+zqJEJTu3qp+PTRSuK4C+dHl/BoE0Fp2Bw4I6QsCEM2WlIwMUPDoQyCACyZm4IRYamsJoCzFS3dgvh1QZpxLvkCWt3lnc0dH3aLlNcsQcF7kquJVuPxNB16QBLTL+M+eYIew4CzwIqVSDwREqPETAUNxBTTl9xfMjSzescNZviM8fMCR4ggHAZhtUOJ/GQQsDh6VGuI7cxURsMZNgHL8IL5gD3f+8ENPA7JMd93Jnz8aNSaHxep44oLiB3IK4gcBomAibdy4UsSvJ+AOEKAvOJisLqbGAa/A+HfSt5/iv4wIcHH8IwKy3W12y/3l+TEBFL+6GpzNMwucixHEX38QMLBsERGAG4wHAaHOmc7a6Rw/E6B9vyRgeWddTc+yh4gAWcDR3y+lr/ARvj09/faHeLuQ3jNQyS1Xm5u28WfCbwI/t+oLDkiaNjMKmwUBaxo6cfk5fiKggeIfRj/OcEtpvhxZ4EWaR23hkJynn0b80qP0uTAmQOMHEO1E/JVU4VS0bFlReNjcL38W+Jjwc+/4jW/nTg/FuuF8fuvmHpSOQwC7zrBP8H03d7bcdwNPtbEZm0b6Ch9h3Ai2KFNxbqXGaX0vvXRFAB7L0REBYt21ukV0xfPqcfkXyfiR9Y12pQ3zTbCiBubQRcOx/+XXLJqjdWgAAc/h+iN+JmC2TY2fgBGgVHjtxlK54WGn8AkOsEepr1es4tEB5AEHo0Wef0ts7O0iQM5Sq6vjgQB1KpK2mw3ysy2M0JPa5k7K8roNKd4hmOZ0lnVqV6ML2+Vn99/ZXDdyotj/suWeDg1UEIG7AB4CjNlmXe1wvJPL3ABRkPFPPsG3riIo3xEQIGcZRZhEgPoUoP312y93t/HJ1eZOMifTFRwAJi2ODr7g8frdd9+/6jLs7y5AMHmC5B+yzO4SB5Jz0gwil0ACkHPCEv/kE6zvslOFsgCXVyAHitU5dFJabscO2iy211kmT4zXFUioApyxoiF4UrCKKVfrs7TwRvFwJt7Rdvqxj4cc26Skvrm0gl0hNrAWlu+9SpGm+uONB7T11nkEFvj4B2jV7T958uPT5k4+7zvluumPZxZQzdSefEVncRHlKRXvhLXMI8WPKHeeFfWpU66+2I2bxuuztDeopjkPA2+dIWt9xSIwsWFsniYW1SA5PFYWSLg/T18wofcN5l+D5JPlqidtkGTq3OXx+ZM7MLkB++7QDp7BMZ3sU5zqB6td5TUIeH29RyelT9QkjfEuCPDw+gIBWEYZi2lLPL5dn6X9vkK7uvqun0St78bg2KL89vZYIgB5e9EoCCFABCRkB4waFSgelWVy9ThVCut9gykfkJ7TiQVPmnqK1tyfZJrfE9ilfj4I2LFxdce+jn3+b/ASG3x+2Zj/svtJn+JRtByesj8IwK+kyFSLgoU+fl1pJcDoRrqTNvanpKutuUBxvXVXdwgYUAjQL2xMxcvrqhcutNqruc3tmFzSIraoKbCqpWg2ETBTNEqyEPLB9Ugd5et2f6tkSyMH4AQc0eK5H1NREWHj43OOL316J9DUfpAIWNJXUqDWOk/uwFjZV7gv1PLGp5IAX7vdzzfAHjJB+BRnj4Kxsbrw8hkPbXvo0ewQBe9CKnaljR5dMoj4B68dfcTgqbUt9fVL2g3Z5yhfKzYsMDaT+dghiyQgrQWPgVBrbkvuu9W9+bLWt6ioottNADu9BUIOEwF2q93X94QEapI4feLOOhs5/u6KCmuMQkBDw/T0+9e0d7b3HLw/2tQQtHB/ybw0WTsMAlZvWr3vDf+gjn1MAElfu1+C1c8vdQJtlxdMXXj5jIefKXxw/c8+Er1QSl1bYex73eC4/bcNjpMEpNTUpIiChvr65x21BssxBXRArK6N+M+/iKRv647OzoUNDXMKl7TX7tmDEeBYwKvLhYe3NLWAAG7MdHG36BgmIISywr7utrloJ8evpt0pfuSpkaN2kfSFUnQ1dC5Ys6aop70FvxVMFqyEg4qVNFkLfB4TsG/fGxQ/pu9J+dl9rX7D7NZRtF1XOwwCHq149MEv8UoABPAIaBwcd+2rg9cyAXyNm2XBQkPnlztiUqBZBIbwCGCLjzp/MxPgKK+GCij0r9/elrO9N56qLlnptBw4MBg+m5e8cFH8IECt5j7BGH7iininev1PT9osa4PxiypGSGsQ0NlQ1g4CsEY6pDKPgMZ5aUoW+rw3Vg+sw7y1nL4XBASEWBP8Un1puz5r7XXWaw8+mNJtVbDQZ8LWNEUJv/pqY3+k+v0X94DumApHtLpiob5NjdvcPr7utsJaavOSBIQTAZktLWeFzz6dZmpcFH8ZF0EtjaCeYVmQgIWTk4o1M4+VWVPNuuODgPbOpibcAfct20cEzJ+zv0TMoigEVK/m+CUByDonJEwYAWfJS2i7LmsNAh5c/60GV/gEY4EkjVsc33SgvbDEHdTXqlvxFFgQPUSF3pzse9z+GVWEgp9AgIj/0ieBcNPp90xfsMDF/cJXEgEbIsoA8l0mxA3qzdN4Ieh3VOmNLG9WT1N7T0/PvmUvEwFL+maUqtIZBLy9eqMIXxKAeO2pVmvCKN6ul9pev6z/9lktAd471BwtcF6e6vIEHkBAyu54TfzxenMyOFMzygWGTOXHP0HU+t56j3ITdF0IoJbX8/N88MiWE0sEb/1C0LfiPJwNrsCypvY3yHHC1FMwSiOVQQAeg7J8AzD9g7TGCPiOcYWCabqCB9XxVqAt3mPR1l9MOkD+aZ2Jz9CW+tL205OAQV43mBPQemmql776haClFI6Pjxbo1e1vMs31qDn4J2ntpZeKVgzkB6y+7tetEr2M7b0vM2B6JrerWdbLTxzBB+qzynqCshT4BfAMvX7JjPjElKypUxMdiZI3xV3CIrPEdDlOkyDmXj1yhMsfFOxou/XYx0mQ3sBUQH98fbxeeql4jq1h/vwGm1153bpDwaZO16ae3pdp4QG4aSvb3W1uFzWW9KHAAQUNgFrQYFINHAmmLMMW+sv4ovimN5htFVjj62HCzcDp8UYkiOm2K+6Cs3k1OpRVKlnhvPe43oHTvlSQ8X7UykPyNWFpkpDexe4CjgqrrbvCUIG/u7u7K1z6eEWBREKC6sBgt7UvXDjfliBf66XpyzcXw4UX5dlyu2JudrgR1lq37R+k6WwOXRY0cIpN9SF+NWuLdCDBrDD8xqZYUHpbwfe8dEJkfEa6IyMyIzIofDM1SIAAIRttstY3773pq5TjkTna+4unf6M5/lLZZrfaXcBRERGD6CNKbLaIwLLGTindu7oUKcxS0Wq1qw4MCWBgznxriHgNy1as2vQmgMLNuI4hgoDp0y9Us8Bk7tXYuB/3wMHGfhCgncpae5pYKFlK3XlHs7YYHzM+Zn5sPY3LWeZCEFCyEi1jW7bwyh5vtX6ptAF+DFSblMXYbObuzs5uKwhYtQrF2qNJqpOP8WlEsOpzvEFI7417Kzcvwn0QBEBDlJQsdux9zzXuSFl3EMULFMxQpDCEiJ/Nb1jACOswxYEhwTZ/DjHAr/F+Q4qM/+mON0EA1ieFR+aFQkoyAbj8TXPQlHek8dAHTMBTMn5MZgqhk91gtIv9s7Y8Rlj/li8oP8dvndkaE2M1SpdReIzqsr6FICCCYMzo6Ww6UiEIOHzg8OETh6+l2uM8nqVIxwDiLHJSFknv4tq9mzfvq2letjnMaQx1BZY4sVNZo6sisZDPZ96M0aPj4s5mKQxlZLdhPCOppUhFMICCgCXWEHptaG7GIBDxPx3XEX36zewRugBnL9vi6PL34RnY19j45utrP3n4ecKbEpdCGAHGhiVGaoDfjnsALr/lQf8P+L6UXm+hiSCcvkShrna4cKkwWcFPIXNPj9koCDgwsbFxeP+1JJ3xGvEXrzlYnIEs2ZqkY85KVHdnEQF1ze+AgIxIgyHCFpy7uqy5OAMEsI0vjZcROH8mAPEGQCj5ZZ/rlooh1iW33bbEGoXXMRUx3Rkcf08cLWV98kLJB+jyX4fLX0fT16d5ZpVp/UASxsaL68XqcTwCHnzrg5eZQb/qG1J4+Ct4K10bv4YAY4WrtrY+NHSFGAEnTvQfuZZylnjN8R8EA5QjjHZL6X3LQMDs4sgUw7JAIqAx0uEPAvj8S5EWl1KYpKEd9Xw0Ia9KRTDwwAMLU6PO9jZ0d3P4lOmJewME6KTkVa6SPmigvsbDb74mCFDjJwIGXU3AEQX70Umi+qQGpba/fLNqsksE97KUdsO0IUa47GCuqbbWbAmlgFHwcWI4jk6lt71uvwdRshOfpfyU6Ozra9rMXWaNByqaWppccUGQ0uL8x20dgaSxJIDiDaH4tVIxxLrwgQfmpIZ466WpXkp+4VooLj8qWCQBavyvjtvwjOfrL/yy/ahVW3yDfAKqM/j+z4Crr6VQ5yvMBAQCZloMGgFQVrgEXYX9OBoRoD8fECB/SvUAggBzs6UszlVcaGYCeK0KavbD/kzAqaUixsB1ty1J9e5Vbsp7qvYgw3GStCQp3NdY8vzrDBCgPvUIG3y6BLYKeAepbFrS/f27XlZshm9gRF/h6SsMAuRTgN7DBOArII7feKqCjHihH+QwYAL487qRpmMC9FL4r6Virgmo7WVAYP7Ue0ppif+1/4sTH7izrm5jsA0C+v2nELhEpJrhr1teTilEUCCOcvRortxpxYqkJOXopyrI0LflWdxrTwicJIUf2GCaq5WGSTC4nzZtndvyIgzgo2G7B2SNw1VXjQw9R/N+/epzQZM1OWZgnhszGJfq8MckTbGtbdIfXv82TD0xAzs00jDJiaxncIIsY1s3Nyy/PMgRCTsouR0ODVF+qpPt2P66ukOWBPX9l9cp6CkoaEk7z2io+YaADlfCVaNHqEBKqErGHa4QkD3l92xeZZWqAX+fku31b8M0vy8QpbCKFGYCVq97e906tvYhAiLb2spRmy+2gwBEfoni4njJ2MGYi5ZftDNhgnw/CLhIunuPXJ6WVjMZN9FOrRSeN8LdIgkwAUVFOQtynAvuKSrCC4Ph1z9+tRm6ugw2/MFg8Pq3QVnVsq+q3VlSImAdCEhel2tMTU5uRYNCZnkbehPk9pBsuwLy6LzQ1BlxzfKROy3yfweDAMR/jSwrWT7ZuDLBMCBvgj/9tHU8CKDoq6q8CRczAU6MAAyBBQvwgi/879lRUfRvw39BgCuwqa9MWeh4jkkSkJycm1yLv0BAZmI59WZI6asvUKC8PFWLi6zGyCtAgDR3H3PObQ+keUfFzAqJql5XnZzMbnCt80Yg/LRzq6puSsPEEAgQGOjJFH8wEH4dExx8MS7/f0JA55KyOftlv8WGsj3JYi2L5GRj7eNvm0FAW2Ybxf+LlL46qUq+vX2B15xPFilw9Zl43uV1irm9IMAeMmuW3Sj5hRIUBFS99VZV2lg3AZkopJQMSJ/jm25KMPxHBPS0NO0vk+eHE5wWLK29UpPffhwjQC999W1uuIeU1cD1REwlnT8ZBMjhf+W5D4AAc8isAnM1H5L79ogA79KqHxdV/aQSgPjBQLgkgG8D+Ps/ImAJrv+c990LKU9bLU82udZci2puvfRtL9Sux19/namzERUFO/3FdGBklljiYqRKAHyWv8Is4k8//cQNGCDAG6iqajmGphVJQHgPCBhQRkAqf/v/s3vAEjV+QQDHT0DG7vFWvdTEkFduGDxiBiOoXWLxGqVgQV3i4qZzHzCVggBzzziNFJ43huMvrfqpCk07IICR2TMwHwNAfQoA/9VToM+15HzNQspz8fgHkiUNraeQvu48MGDqp6fgYnfFQrS6xMWFY667rdTbaK45wBBGF5fNGKN1uU0GAYz5bh1wCS484T/TAUdNk7ULKSuFvK0SJ0lfHS677MzyFZrV1NQlLi6Aj9dYb3+T55IXM9CxogAcV/3vSvC/Bj1utPD6n/EnnaQbrf6BCX0AAAAASUVORK5CYII=)}.react-tel-input .ad{background-position:-16px 0}.react-tel-input .ae{background-position:-32px 0}.react-tel-input .af{background-position:-48px 0}.react-tel-input .ag{background-position:-64px 0}.react-tel-input .ai{background-position:-80px 0}.react-tel-input .al{background-position:-96px 0}.react-tel-input .am{background-position:-112px 0}.react-tel-input .ao{background-position:-128px 0}.react-tel-input .ar{background-position:-144px 0}.react-tel-input .as{background-position:-160px 0}.react-tel-input .at{background-position:-176px 0}.react-tel-input .au{background-position:-192px 0}.react-tel-input .aw{background-position:-208px 0}.react-tel-input .az{background-position:-224px 0}.react-tel-input .ba{background-position:-240px 0}.react-tel-input .bb{background-position:0 -11px}.react-tel-input .bd{background-position:-16px -11px}.react-tel-input .be{background-position:-32px -11px}.react-tel-input .bf{background-position:-48px -11px}.react-tel-input .bg{background-position:-64px -11px}.react-tel-input .bh{background-position:-80px -11px}.react-tel-input .bi{background-position:-96px -11px}.react-tel-input .bj{background-position:-112px -11px}.react-tel-input .bm{background-position:-128px -11px}.react-tel-input .bn{background-position:-144px -11px}.react-tel-input .bo{background-position:-160px -11px}.react-tel-input .br{background-position:-176px -11px}.react-tel-input .bs{background-position:-192px -11px}.react-tel-input .bt{background-position:-208px -11px}.react-tel-input .bw{background-position:-224px -11px}.react-tel-input .by{background-position:-240px -11px}.react-tel-input .bz{background-position:0 -22px}.react-tel-input .ca{background-position:-16px -22px}.react-tel-input .cd{background-position:-32px -22px}.react-tel-input .cf{background-position:-48px -22px}.react-tel-input .cg{background-position:-64px -22px}.react-tel-input .ch{background-position:-80px -22px}.react-tel-input .ci{background-position:-96px -22px}.react-tel-input .ck{background-position:-112px -22px}.react-tel-input .cl{background-position:-128px -22px}.react-tel-input .cm{background-position:-144px -22px}.react-tel-input .cn{background-position:-160px -22px}.react-tel-input .co{background-position:-176px -22px}.react-tel-input .cr{background-position:-192px -22px}.react-tel-input .cu{background-position:-208px -22px}.react-tel-input .cv{background-position:-224px -22px}.react-tel-input .cw{background-position:-240px -22px}.react-tel-input .cy{background-position:0 -33px}.react-tel-input .cz{background-position:-16px -33px}.react-tel-input .de{background-position:-32px -33px}.react-tel-input .dj{background-position:-48px -33px}.react-tel-input .dk{background-position:-64px -33px}.react-tel-input .dm{background-position:-80px -33px}.react-tel-input .do{background-position:-96px -33px}.react-tel-input .dz{background-position:-112px -33px}.react-tel-input .ec{background-position:-128px -33px}.react-tel-input .ee{background-position:-144px -33px}.react-tel-input .eg{background-position:-160px -33px}.react-tel-input .er{background-position:-176px -33px}.react-tel-input .es{background-position:-192px -33px}.react-tel-input .et{background-position:-208px -33px}.react-tel-input .fi{background-position:-224px -33px}.react-tel-input .fj{background-position:-240px -33px}.react-tel-input .fk{background-position:0 -44px}.react-tel-input .fm{background-position:-16px -44px}.react-tel-input .fo{background-position:-32px -44px}.react-tel-input .fr,.react-tel-input .bl,.react-tel-input .mf{background-position:-48px -44px}.react-tel-input .ga{background-position:-64px -44px}.react-tel-input .gb{background-position:-80px -44px}.react-tel-input .gd{background-position:-96px -44px}.react-tel-input .ge{background-position:-112px -44px}.react-tel-input .gf{background-position:-128px -44px}.react-tel-input .gh{background-position:-144px -44px}.react-tel-input .gi{background-position:-160px -44px}.react-tel-input .gl{background-position:-176px -44px}.react-tel-input .gm{background-position:-192px -44px}.react-tel-input .gn{background-position:-208px -44px}.react-tel-input .gp{background-position:-224px -44px}.react-tel-input .gq{background-position:-240px -44px}.react-tel-input .gr{background-position:0 -55px}.react-tel-input .gt{background-position:-16px -55px}.react-tel-input .gu{background-position:-32px -55px}.react-tel-input .gw{background-position:-48px -55px}.react-tel-input .gy{background-position:-64px -55px}.react-tel-input .hk{background-position:-80px -55px}.react-tel-input .hn{background-position:-96px -55px}.react-tel-input .hr{background-position:-112px -55px}.react-tel-input .ht{background-position:-128px -55px}.react-tel-input .hu{background-position:-144px -55px}.react-tel-input .id{background-position:-160px -55px}.react-tel-input .ie{background-position:-176px -55px}.react-tel-input .il{background-position:-192px -55px}.react-tel-input .in{background-position:-208px -55px}.react-tel-input .io{background-position:-224px -55px}.react-tel-input .iq{background-position:-240px -55px}.react-tel-input .ir{background-position:0 -66px}.react-tel-input .is{background-position:-16px -66px}.react-tel-input .it{background-position:-32px -66px}.react-tel-input .je{background-position:-144px -154px}.react-tel-input .jm{background-position:-48px -66px}.react-tel-input .jo{background-position:-64px -66px}.react-tel-input .jp{background-position:-80px -66px}.react-tel-input .ke{background-position:-96px -66px}.react-tel-input .kg{background-position:-112px -66px}.react-tel-input .kh{background-position:-128px -66px}.react-tel-input .ki{background-position:-144px -66px}.react-tel-input .xk{background-position:-128px -154px}.react-tel-input .km{background-position:-160px -66px}.react-tel-input .kn{background-position:-176px -66px}.react-tel-input .kp{background-position:-192px -66px}.react-tel-input .kr{background-position:-208px -66px}.react-tel-input .kw{background-position:-224px -66px}.react-tel-input .ky{background-position:-240px -66px}.react-tel-input .kz{background-position:0 -77px}.react-tel-input .la{background-position:-16px -77px}.react-tel-input .lb{background-position:-32px -77px}.react-tel-input .lc{background-position:-48px -77px}.react-tel-input .li{background-position:-64px -77px}.react-tel-input .lk{background-position:-80px -77px}.react-tel-input .lr{background-position:-96px -77px}.react-tel-input .ls{background-position:-112px -77px}.react-tel-input .lt{background-position:-128px -77px}.react-tel-input .lu{background-position:-144px -77px}.react-tel-input .lv{background-position:-160px -77px}.react-tel-input .ly{background-position:-176px -77px}.react-tel-input .ma{background-position:-192px -77px}.react-tel-input .mc{background-position:-208px -77px}.react-tel-input .md{background-position:-224px -77px}.react-tel-input .me{background-position:-112px -154px;height:12px}.react-tel-input .mg{background-position:0 -88px}.react-tel-input .mh{background-position:-16px -88px}.react-tel-input .mk{background-position:-32px -88px}.react-tel-input .ml{background-position:-48px -88px}.react-tel-input .mm{background-position:-64px -88px}.react-tel-input .mn{background-position:-80px -88px}.react-tel-input .mo{background-position:-96px -88px}.react-tel-input .mp{background-position:-112px -88px}.react-tel-input .mq{background-position:-128px -88px}.react-tel-input .mr{background-position:-144px -88px}.react-tel-input .ms{background-position:-160px -88px}.react-tel-input .mt{background-position:-176px -88px}.react-tel-input .mu{background-position:-192px -88px}.react-tel-input .mv{background-position:-208px -88px}.react-tel-input .mw{background-position:-224px -88px}.react-tel-input .mx{background-position:-240px -88px}.react-tel-input .my{background-position:0 -99px}.react-tel-input .mz{background-position:-16px -99px}.react-tel-input .na{background-position:-32px -99px}.react-tel-input .nc{background-position:-48px -99px}.react-tel-input .ne{background-position:-64px -99px}.react-tel-input .nf{background-position:-80px -99px}.react-tel-input .ng{background-position:-96px -99px}.react-tel-input .ni{background-position:-112px -99px}.react-tel-input .nl,.react-tel-input .bq{background-position:-128px -99px}.react-tel-input .no{background-position:-144px -99px}.react-tel-input .np{background-position:-160px -99px}.react-tel-input .nr{background-position:-176px -99px}.react-tel-input .nu{background-position:-192px -99px}.react-tel-input .nz{background-position:-208px -99px}.react-tel-input .om{background-position:-224px -99px}.react-tel-input .pa{background-position:-240px -99px}.react-tel-input .pe{background-position:0 -110px}.react-tel-input .pf{background-position:-16px -110px}.react-tel-input .pg{background-position:-32px -110px}.react-tel-input .ph{background-position:-48px -110px}.react-tel-input .pk{background-position:-64px -110px}.react-tel-input .pl{background-position:-80px -110px}.react-tel-input .pm{background-position:-96px -110px}.react-tel-input .pr{background-position:-112px -110px}.react-tel-input .ps{background-position:-128px -110px}.react-tel-input .pt{background-position:-144px -110px}.react-tel-input .pw{background-position:-160px -110px}.react-tel-input .py{background-position:-176px -110px}.react-tel-input .qa{background-position:-192px -110px}.react-tel-input .re{background-position:-208px -110px}.react-tel-input .ro{background-position:-224px -110px}.react-tel-input .rs{background-position:-240px -110px}.react-tel-input .ru{background-position:0 -121px}.react-tel-input .rw{background-position:-16px -121px}.react-tel-input .sa{background-position:-32px -121px}.react-tel-input .sb{background-position:-48px -121px}.react-tel-input .sc{background-position:-64px -121px}.react-tel-input .sd{background-position:-80px -121px}.react-tel-input .se{background-position:-96px -121px}.react-tel-input .sg{background-position:-112px -121px}.react-tel-input .sh{background-position:-128px -121px}.react-tel-input .si{background-position:-144px -121px}.react-tel-input .sk{background-position:-160px -121px}.react-tel-input .sl{background-position:-176px -121px}.react-tel-input .sm{background-position:-192px -121px}.react-tel-input .sn{background-position:-208px -121px}.react-tel-input .so{background-position:-224px -121px}.react-tel-input .sr{background-position:-240px -121px}.react-tel-input .ss{background-position:0 -132px}.react-tel-input .st{background-position:-16px -132px}.react-tel-input .sv{background-position:-32px -132px}.react-tel-input .sx{background-position:-48px -132px}.react-tel-input .sy{background-position:-64px -132px}.react-tel-input .sz{background-position:-80px -132px}.react-tel-input .tc{background-position:-96px -132px}.react-tel-input .td{background-position:-112px -132px}.react-tel-input .tg{background-position:-128px -132px}.react-tel-input .th{background-position:-144px -132px}.react-tel-input .tj{background-position:-160px -132px}.react-tel-input .tk{background-position:-176px -132px}.react-tel-input .tl{background-position:-192px -132px}.react-tel-input .tm{background-position:-208px -132px}.react-tel-input .tn{background-position:-224px -132px}.react-tel-input .to{background-position:-240px -132px}.react-tel-input .tr{background-position:0 -143px}.react-tel-input .tt{background-position:-16px -143px}.react-tel-input .tv{background-position:-32px -143px}.react-tel-input .tw{background-position:-48px -143px}.react-tel-input .tz{background-position:-64px -143px}.react-tel-input .ua{background-position:-80px -143px}.react-tel-input .ug{background-position:-96px -143px}.react-tel-input .us{background-position:-112px -143px}.react-tel-input .uy{background-position:-128px -143px}.react-tel-input .uz{background-position:-144px -143px}.react-tel-input .va{background-position:-160px -143px}.react-tel-input .vc{background-position:-176px -143px}.react-tel-input .ve{background-position:-192px -143px}.react-tel-input .vg{background-position:-208px -143px}.react-tel-input .vi{background-position:-224px -143px}.react-tel-input .vn{background-position:-240px -143px}.react-tel-input .vu{background-position:0 -154px}.react-tel-input .wf{background-position:-16px -154px}.react-tel-input .ws{background-position:-32px -154px}.react-tel-input .ye{background-position:-48px -154px}.react-tel-input .za{background-position:-64px -154px}.react-tel-input .zm{background-position:-80px -154px}.react-tel-input .zw{background-position:-96px -154px}.react-tel-input *{box-sizing:border-box;-moz-box-sizing:border-box}.react-tel-input .hide{display:none}.react-tel-input .v-hide{visibility:hidden}.react-tel-input .form-control{position:relative;font-size:14px;letter-spacing:.01rem;margin-top:0!important;margin-bottom:0!important;padding-left:48px;margin-left:0;background:#FFFFFF;border:1px solid #CACACA;border-radius:5px;line-height:25px;height:35px;width:300px;outline:none}.react-tel-input .form-control.invalid-number{border:1px solid #d79f9f;background-color:#faf0f0;border-left-color:#cacaca}.react-tel-input .form-control.invalid-number:focus{border:1px solid #d79f9f;border-left-color:#cacaca;background-color:#faf0f0}.react-tel-input .flag-dropdown{position:absolute;top:0;bottom:0;padding:0;background-color:#f5f5f5;border:1px solid #cacaca;border-radius:3px 0 0 3px}.react-tel-input .flag-dropdown:hover,.react-tel-input .flag-dropdown:focus{cursor:pointer}.react-tel-input .flag-dropdown.invalid-number{border-color:#d79f9f}.react-tel-input .flag-dropdown.open{z-index:2;background:#fff;border-radius:3px 0 0}.react-tel-input .flag-dropdown.open .selected-flag{background:#fff;border-radius:3px 0 0}.react-tel-input input[disabled]+.flag-dropdown:hover{cursor:default}.react-tel-input input[disabled]+.flag-dropdown:hover .selected-flag{background-color:transparent}.react-tel-input .selected-flag{outline:none;position:relative;width:38px;height:100%;padding:0 0 0 8px;border-radius:3px 0 0 3px}.react-tel-input .selected-flag:hover,.react-tel-input .selected-flag:focus{background-color:#fff}.react-tel-input .selected-flag .flag{position:absolute;top:50%;margin-top:-5px}.react-tel-input .selected-flag .arrow{position:relative;top:50%;margin-top:-2px;left:20px;width:0;height:0;border-left:3px solid transparent;border-right:3px solid transparent;border-top:4px solid #555}.react-tel-input .selected-flag .arrow.up{border-top:none;border-bottom:4px solid #555}.react-tel-input .country-list{outline:none;z-index:1;list-style:none;position:absolute;padding:0;margin:10px 0 10px -1px;box-shadow:1px 2px 10px #00000059;background-color:#fff;width:300px;max-height:200px;overflow-y:scroll;border-radius:0 0 3px 3px}.react-tel-input .country-list .flag{display:inline-block}.react-tel-input .country-list .divider{padding-bottom:5px;margin-bottom:5px;border-bottom:1px solid #ccc}.react-tel-input .country-list .country{padding:7px 9px}.react-tel-input .country-list .country .dial-code{color:#6b6b6b}.react-tel-input .country-list .country:hover,.react-tel-input .country-list .country.highlight{background-color:#f1f1f1}.react-tel-input .country-list .flag{margin-right:7px;margin-top:2px}.react-tel-input .country-list .country-name{margin-right:6px}.react-tel-input .country-list .search{position:sticky;top:0;background-color:#fff;padding:10px 0 6px 10px}.react-tel-input .country-list .search-emoji{font-size:15px}.react-tel-input .country-list .search-box{border:1px solid #cacaca;border-radius:3px;font-size:15px;line-height:15px;margin-left:6px;padding:3px 8px 5px;outline:none}.react-tel-input .country-list .no-entries-message{padding:7px 10px 11px;opacity:.7}.react-tel-input .invalid-number-message{position:absolute;z-index:1;font-size:13px;left:46px;top:-8px;background:#fff;padding:0 2px;color:#de0000}.react-tel-input .special-label{display:none;position:absolute;z-index:1;font-size:13px;left:46px;top:-8px;background:#fff;padding:0 2px;white-space:nowrap}.userfront-toolkit{--userfront-container-width: auto;--userfront-container-max-width: 340px;--userfront-container-height: auto;--userfront-container-max-height: unset;--userfront-container-margin: 0 auto;--userfront-container-padding: 2em 1.5em;--userfront-container-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-container-active-box-shadow: var( --userfront-container-box-shadow );--userfront-container-border: 1px solid var(--userfront-container-border-color);--userfront-container-border-radius: 4px;--userfront-em-size: 14px;--userfront-spacing: 1em;--userfront-label-spacing: .5em;--userfront-button-height: 2em;--userfront-button-padding: .5em;--userfront-button-icon-size: 2em;--userfront-secured-font-size: 1em;--userfront-placeholder-height: 300px;--userfront-alignment: center;--userfront-label-alignment: left;--userfront-button-hover-transform: none;--userfront-border-radius: 4px;--userfront-font-family: Avenir, Helvetica, Arial, sans-serif;--userfront-input-font-size: 1em;--userfront-label-font-size: .8em;--userfront-title-font-size: 1.5em;--userfront-error-font-size: 1em;--userfront-button-font-size: 1em;--userfront-subtle-button-font-size: 1em}.userfront-toolkit{--userfront-logout-color: #c72a2a;--userfront-logout-color-active: #d84848;--userfront-logout-color-focus: var(--userfront-logout-color-active);--userfront-logout-color-disabled: #ff8e8e;--userfront-logout-color-text: #ffffff}.userfront-toolkit.userfront-light-scheme,.userfront-toolkit.userfront-auto-scheme{--userfront-dyn-light-color: var(--userfront-light-color);--userfront-dyn-dark-color: var(--userfront-dark-color);--userfront-dyn-accent-color: var( --userfront-accent-color, color-mix(in hsl, #ffffff 50%, var(--userfront-dark-color)) );--userfront-container-border-color: #ebeef5;--userfront-background-color: var( --userfront-light-background-color, #fdfdfd );--userfront-text-color: color-mix( in hwb, #000000 95%, var(--userfront-primary-color) );--userfront-divider-color: #ccc;--userfront-primary-color: var(--userfront-dyn-dark-color);--userfront-primary-color-active: color-mix( in hsl, #000000 15%, var(--userfront-primary-color) );--userfront-primary-color-focus: color-mix( in hsl, #000000 25%, var(--userfront-primary-color) );--userfront-primary-color-disabled: #color-mix( in hsl, #ffffff 25%, var(--userfront-primary-color) );--userfront-primary-color-text: color-mix( in hwb, #ffffff 95%, var(--userfront-primary-color) );--userfront-secondary-color: var(--userfront-dyn-light-color);--userfront-secondary-color-active: color-mix( in hsl, #ffffff 80%, var(--userfront-primary-color) );--userfront-secondary-color-focus: color-mix( in hsl, #ffffff 80%, var(--userfront-primary-color) );--userfront-secondary-color-disabled: #7a8291;--userfront-secondary-color-text: color-mix( in hwb, #000000 80%, var(--userfront-secondary-color) );--userfront-logout-color: #c72a2a;--userfront-logout-color-active: #d84848;--userfront-logout-color-focus: var(--userfront-logout-color-active);--userfront-logout-color-disabled: #ff8e8e;--userfront-logout-color-text: #ffffff;--userfront-link-color: color-mix( in hwb, #000000 50%, var(--userfront-primary-color) );--userfront-error-color: #c71717;--userfront-error-background-color: #fae3e3;--userfront-error-border-color: #f7dcdc;--userfront-info-color: var(--userfront-secondary-color-text);--userfront-info-background-color: #e6ffe5;--userfront-info-border-color: #edf4ec;--userfront-input-background-color: #ffffff;--userfront-input-background-color-active: #f8f9fa;--userfront-input-text-color: #606266;--userfront-placeholder-color: #999;--userfront-placeholder-color-active: #999;--userfront-input-border-color: #dcdfe6;--userfront-input-border: 1px solid var(--userfront-input-border-color);--userfront-input-border-active-color: #bcc1cf;--userfront-input-border-active: 1px solid var(--userfront-input-border-active-color);--userfront-input-border-focus-color: var(--userfront-dyn-accent-color);--userfront-input-border-focus: 2px solid var(--userfront-input-border-focus-color);--userfront-input-border-error: 1px solid var(--userfront-error-color);--userfront-label-text-color: var(--userfront-text-color);--userfront-label-text-color-error: var(--userfront-error-color);--userfront-title-text-color: var(--userfront-text-color);--userfront-error-text-color: var(--userfront-error-color);--userfront-secured-font-color: #666;--userfront-primary-button-border-color: transparent;--userfront-primary-button-border: none;--userfront-primary-button-border-active-color: transparent;--userfront-primary-button-border-active: none;--userfront-primary-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-primary-button-border-focus: 3px solid var(--userfront-primary-button-border-focus-color);--userfront-primary-button-box-shadow-active: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-secondary-button-border-color: #cbceda;--userfront-secondary-button-border: 1px solid var(--userfront-secondary-button-border-color);--userfront-secondary-button-border-active-color: #bcc1cf;--userfront-secondary-button-border-active: 1px solid var(--userfront-secondary-button-border-active-color);--userfront-secondary-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-secondary-button-border-focus: 2px solid var(--userfront-secondary-button-border-focus-color);--userfront-secondary-button-box-shadow-active: 0 2px 8px 0 rgba(0, 0, 0, .03);--userfront-logout-button-border: none;--userfront-logout-button-border-active: none;--userfront-logout-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-logout-button-border-focus: 3px solid var(--userfront-logout-button-border-focus-color);--userfront-logout-button-box-shadow-active: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-test-mode-background-color: #ffda96;--userfront-test-mode-text-color: #303133}@media (prefers-color-scheme: dark){.userfront-toolkit.userfront-auto-scheme{--userfront-dyn-light-color: var(--userfront-light-color);--userfront-dyn-dark-color: var(--userfront-dark-color);--userfront-dyn-accent-color: var( --userfront-accent-color, color-mix(in hsl, #000000 50%, var(--userfront-light-color)) );--userfront-dyn-dark-background-color: var( --userfront-dark-background-color, #2d2d2d );--userfront-dyn-secondary-color: color-mix( in hwb, #000000 90%, var(--userfront-light-color) );--userfront-container-border-color: color-mix( in hwb, #ffffff 20%, var(--userfront-dyn-dark-background-color) );--userfront-background-color: var(--userfront-dyn-dark-background-color);--userfront-text-color: color-mix( in hwb, #ffffff 95%, var(--userfront-primary-color) );--userfront-divider-color: color-mix( in hwb, #ffffff 20%, var(--userfront-dyn-dark-background-color) );--userfront-primary-color: var(--userfront-dyn-dark-color);--userfront-primary-color-active: color-mix( in hsl, #ffffff 15%, var(--userfront-primary-color) );--userfront-primary-color-focus: color-mix( in hsl, #ffffff 20%, var(--userfront-primary-color) );--userfront-primary-color-disabled: #color-mix( in hsl, #000000 25%, var(--userfront-primary-color) );--userfront-primary-color-text: color-mix( in hwb, #ffffff 90%, var(--userfront-primary-color) );--userfront-secondary-color: color-mix( in hwb, var(--userfront-dyn-dark-background-color), var(--userfront-light-color) 5% );--userfront-secondary-color-active: color-mix( in hsl, #ffffff 5%, var(--userfront-secondary-color) );--userfront-secondary-color-focus: color-mix( in hsl, #ffffff 10%, var(--userfront-secondary-color) );--userfront-secondary-color-disabled: #7a8291;--userfront-secondary-color-text: color-mix( in hwb, #ffffff 80%, var(--userfront-secondary-color) );--userfront-logout-color: #c72a2a;--userfront-logout-color-active: #d84848;--userfront-logout-color-focus: var(--userfront-logout-color-active);--userfront-logout-color-disabled: #ff8e8e;--userfront-logout-color-text: #ffffff;--userfront-link-color: var(--userfront-accent-color);--userfront-error-color: #ffc6c6;--userfront-error-background-color: #2b1e1e;--userfront-error-border-color: #951b1b;--userfront-info-color: var(--userfront-secondary-color-text);--userfront-info-background-color: #123926;--userfront-info-border-color: #25621d;--userfront-input-background-color: #1d1d1d;--userfront-input-background-color-active: #252525;--userfront-input-text-color: color-mix( in hwb, #ffffff 70%, var(--userfront-primary-color) );--userfront-placeholder-color: color-mix( in hwb, #ffffff 60%, var(--userfront-primary-color) );--userfront-placeholder-color-active: #999;--userfront-input-border-color: color-mix( in hwb, #333333 70%, var(--userfront-primary-color) );--userfront-input-border: 1px solid var(--userfront-input-border-color);--userfront-input-border-active-color: var(--userfront-dyn-accent-color);--userfront-input-border-active: 1px solid var(--userfront-input-border-active-color);--userfront-input-border-focus-color: var(--userfront-dyn-accent-color);--userfront-input-border-focus: 2px solid var(--userfront-input-border-focus-color);--userfront-input-border-error: 1px solid var(--userfront-error-color);--userfront-label-text-color: var(--userfront-text-color);--userfront-label-text-color-error: var(--userfront-error-color);--userfront-title-text-color: var(--userfront-text-color);--userfront-secured-font-color: #ccc;--userfront-primary-button-border-color: transparent;--userfront-primary-button-border: none;--userfront-primary-button-border-active-color: transparent;--userfront-primary-button-border-active: none;--userfront-primary-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-primary-button-border-focus: 3px solid var(--userfront-primary-button-border-focus-color);--userfront-primary-button-box-shadow-active: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-secondary-button-border-color: color-mix( in hwb, #aaaaaa 40%, var(--userfront-secondary-color) );--userfront-secondary-button-border: 2px solid var(--userfront-secondary-button-border-color);--userfront-secondary-button-border-active-color: color-mix( in hwb, #eeeeee 30%, var(--userfront-secondary-color) );--userfront-secondary-button-border-active: 2px solid var(--userfront-secondary-button-border-active-color);--userfront-secondary-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-secondary-button-border-focus: 3px solid var(--userfront-secondary-button-border-focus-color);--userfront-secondary-button-box-shadow-active: 0 2px 8px 0 rgba(0, 0, 0, .03);--userfront-logout-button-border: none;--userfront-logout-button-border-active: none;--userfront-logout-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-logout-button-border-focus: 3px solid var(--userfront-logout-button-border-focus-color);--userfront-logout-button-box-shadow-active: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-test-mode-background-color: #ffda96;--userfront-test-mode-text-color: #303133}}.userfront-toolkit.userfront-dark-scheme{--userfront-dyn-light-color: var(--userfront-light-color);--userfront-dyn-dark-color: var(--userfront-dark-color);--userfront-dyn-accent-color: var( --userfront-accent-color, color-mix(in hsl, #000000 50%, var(--userfront-light-color)) );--userfront-dyn-dark-background-color: var( --userfront-dark-background-color, #2d2d2d );--userfront-dyn-secondary-color: color-mix( in hwb, #000000 90%, var(--userfront-light-color) );--userfront-container-border-color: color-mix( in hwb, #ffffff 20%, var(--userfront-dyn-dark-background-color) );--userfront-background-color: var(--userfront-dyn-dark-background-color);--userfront-text-color: color-mix( in hwb, #ffffff 95%, var(--userfront-primary-color) );--userfront-divider-color: color-mix( in hwb, #ffffff 20%, var(--userfront-dyn-dark-background-color) );--userfront-primary-color: var(--userfront-dyn-dark-color);--userfront-primary-color-active: color-mix( in hsl, #ffffff 15%, var(--userfront-primary-color) );--userfront-primary-color-focus: color-mix( in hsl, #ffffff 20%, var(--userfront-primary-color) );--userfront-primary-color-disabled: #color-mix( in hsl, #000000 25%, var(--userfront-primary-color) );--userfront-primary-color-text: color-mix( in hwb, #ffffff 90%, var(--userfront-primary-color) );--userfront-secondary-color: color-mix( in hwb, var(--userfront-dyn-dark-background-color), var(--userfront-light-color) 5% );--userfront-secondary-color-active: color-mix( in hsl, #ffffff 5%, var(--userfront-secondary-color) );--userfront-secondary-color-focus: color-mix( in hsl, #ffffff 10%, var(--userfront-secondary-color) );--userfront-secondary-color-disabled: #7a8291;--userfront-secondary-color-text: color-mix( in hwb, #ffffff 80%, var(--userfront-secondary-color) );--userfront-logout-color: #c72a2a;--userfront-logout-color-active: #d84848;--userfront-logout-color-focus: var(--userfront-logout-color-active);--userfront-logout-color-disabled: #ff8e8e;--userfront-logout-color-text: #ffffff;--userfront-link-color: var(--userfront-accent-color);--userfront-error-color: #ffc6c6;--userfront-error-background-color: #2b1e1e;--userfront-error-border-color: #951b1b;--userfront-info-color: var(--userfront-secondary-color-text);--userfront-info-background-color: #123926;--userfront-info-border-color: #25621d;--userfront-input-background-color: #1d1d1d;--userfront-input-background-color-active: #252525;--userfront-input-text-color: color-mix( in hwb, #ffffff 70%, var(--userfront-primary-color) );--userfront-placeholder-color: color-mix( in hwb, #ffffff 60%, var(--userfront-primary-color) );--userfront-placeholder-color-active: #999;--userfront-input-border-color: color-mix( in hwb, #333333 70%, var(--userfront-primary-color) );--userfront-input-border: 1px solid var(--userfront-input-border-color);--userfront-input-border-active-color: var(--userfront-dyn-accent-color);--userfront-input-border-active: 1px solid var(--userfront-input-border-active-color);--userfront-input-border-focus-color: var(--userfront-dyn-accent-color);--userfront-input-border-focus: 2px solid var(--userfront-input-border-focus-color);--userfront-input-border-error: 1px solid var(--userfront-error-color);--userfront-label-text-color: var(--userfront-text-color);--userfront-label-text-color-error: var(--userfront-error-color);--userfront-title-text-color: var(--userfront-text-color);--userfront-secured-font-color: #ccc;--userfront-primary-button-border-color: transparent;--userfront-primary-button-border: none;--userfront-primary-button-border-active-color: transparent;--userfront-primary-button-border-active: none;--userfront-primary-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-primary-button-border-focus: 3px solid var(--userfront-primary-button-border-focus-color);--userfront-primary-button-box-shadow-active: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-secondary-button-border-color: color-mix( in hwb, #aaaaaa 40%, var(--userfront-secondary-color) );--userfront-secondary-button-border: 2px solid var(--userfront-secondary-button-border-color);--userfront-secondary-button-border-active-color: color-mix( in hwb, #eeeeee 30%, var(--userfront-secondary-color) );--userfront-secondary-button-border-active: 2px solid var(--userfront-secondary-button-border-active-color);--userfront-secondary-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-secondary-button-border-focus: 3px solid var(--userfront-secondary-button-border-focus-color);--userfront-secondary-button-box-shadow-active: 0 2px 8px 0 rgba(0, 0, 0, .03);--userfront-logout-button-border: none;--userfront-logout-button-border-active: none;--userfront-logout-button-border-focus-color: var( --userfront-dyn-accent-color );--userfront-logout-button-border-focus: 3px solid var(--userfront-logout-button-border-focus-color);--userfront-logout-button-box-shadow-active: 0 2px 12px 0 rgba(0, 0, 0, .1);--userfront-test-mode-background-color: #ffda96;--userfront-test-mode-text-color: #303133}.userfront-element{color:var(--userfront-text-color);font-family:var(--userfront-font-family);text-align:var(--userfront-alignment);font-size:var(--userfront-em-size)}.userfront-test-background{margin:0 auto;width:100%;max-width:min-content}.userfront-container{color:var(--userfront-text-color);background-color:var(--userfront-background-color);border:var(--userfront-container-border);border-radius:var(--userfront-border-radius);box-shadow:var(--userfront-container-box-shadow);padding:var(--userfront-container-padding);margin:var(--userfront-container-margin);width:var(--userfront-container-width);max-width:var(--userfront-container-max-width);min-width:150px;height:var(--userfront-container-height);max-height:var(--userfront-container-max-height);font-family:var(--userfront-font-family);text-align:var(--userfront-alignment);font-size:var(--userfront-em-size)}.userfront-container:hover,.userfront-container:active,.userfront-container:focus{box-shadow:var(--userfront-container-active-box-shadow)}.userfront-toolkit *{font-family:var(--userfront-font-family)}.userfront-toolkit ul{padding-left:0;width:fit-content;margin:0 auto}.userfront-toolkit h2{font-size:var(--userfront-title-font-size);color:var(--userfront-title-text-color);margin-top:0}.userfront-form{display:flex;flex-flow:column nowrap;justify-content:space-between;align-items:stretch;text-align:initial}.userfront-form .userfront-form-row{display:flex;flex-flow:column nowrap;margin-bottom:var(--userfront-spacing)}.userfront-form .userfront-form-row label{display:block;flex:1 0 auto;margin-left:1px}.userfront-form .userfront-form-row input{display:block;flex:0 0 auto;align-self:stretch}.userfront-form .userfront-input-container{flex:0 0 auto;align-self:stretch;display:flex;flex-flow:column nowrap;position:relative}.userfront-toolkit input.userfront-input{color:var(--userfront-input-text-color);background-color:var(--userfront-input-background-color);border:var(--userfront-input-border);border-radius:var(--userfront-border-radius);font-size:var(--userfront-input-font-size);line-height:calc(var(--userfront-input-font-size) * 2);padding:.25em 1em}.userfront-toolkit input.userfront-input:hover,.userfront-toolkit input.userfront-input:active{background-color:var(--userfront-input-background-color-active);border:var(--userfront-input-border-active)}.userfront-toolkit input.userfront-input:focus{background-color:var(--userfront-input-background-color-active);outline:var(--userfront-input-border-focus)}.userfront-toolkit input.userfront-input.userfront-has-error{border:var(--userfront-input-border-error)}.userfront-toolkit input.userfront-input::placeholder{color:var(--userfront-placeholder-color)}.userfront-toolkit input.userfront-input:hover::placeholder,.userfront-toolkit input.userfront-input:active::placeholder{color:var(--userfront-placeholder-color-active)}.userfront-toolkit .userfront-password-toggle{position:absolute;top:1px;right:8px;height:2.5em;display:flex;align-items:center;justify-content:center;cursor:pointer;color:var(--userfront-placeholder-color);width:15px}.userfront-toolkit input.userfront-input-error{border-color:var(--userfront-error-color)}.userfront-toolkit .userfront-input-error-message{color:var(--userfront-error-color);padding:.25em 0}.userfront-toolkit .userfront-input-error-placeholder{height:calc(1.5em + 6px)}.userfront-toolkit label{width:auto;text-align:var(--userfront-label-alignment);line-height:calc(var(--userfront-input-font-size) * 2);margin:0 .5em;font-size:max(var(--userfront-label-font-size),13px)}.userfront-toolkit .userfront-secondary-text{font-size:max(var(--userfront-label-font-size),13px);color:var(--userfront-secondary-color-text);display:inline-block;margin-top:.5em}.userfront-button{padding:var(--userfront-button-padding);font-size:var(--userfront-button-font-size);display:flex;justify-content:center;align-items:center;transition:border,color,background-color,box-shadow .1s ease-out}.userfront-tiny .userfront-button{padding:calc(var(--userfront-button-padding) * .75)}:not(.userfront-button-row) .userfront-button{width:100%;margin-bottom:var(--userfront-spacing)}.userfront-button:not(.userfront-button-subtle):hover:not(:disabled),.userfront-button:not(.userfront-button-subtle):active:not(:disabled){transform:var(--userfront-button-hover-transform)}.userfront-button .userfront-button-icon{width:var(--userfront-button-icon-size)!important;height:var(--userfront-button-icon-size)!important;color:var(--userfront-text-color)}.userfront-button .userfront-icon-button-content{flex:0 0 auto;min-width:7em;display:flex;align-items:center;justify-content:flex-start}.userfront-button .userfront-icon-button-content .userfront-button-icon{margin-right:var(--userfront-spacing)}.userfront-toolkit .userfront-button-primary{background-color:var(--userfront-primary-color);color:var(--userfront-primary-color-text);border:var(--userfront-primary-button-border);border-radius:var(--userfront-border-radius);cursor:pointer;line-height:2;font-weight:500}.userfront-toolkit .userfront-button-primary:hover:not(:disabled),.userfront-toolkit .userfront-button-primary:active:not(:disabled){background-color:var(--userfront-primary-color-active);border:var(--userfront-primary-button-border-active);box-shadow:var(--userfront-primary-button-box-shadow-active)}.userfront-toolkit .userfront-button-primary:focus{background-color:var(--userfront-primary-color-focus);outline:var(--userfront-primary-button-border-focus);box-shadow:var(--userfront-primary-button-box-shadow-active)}.userfront-button.userfront-button-logout{background-color:var(--userfront-logout-color);color:var(--userfront-logout-color-text);border:var(--userfront-logout-button-border);border-radius:var(--userfront-border-radius);cursor:pointer;line-height:2;font-weight:500;max-width:250px}.userfront-button.userfront-button-logout:hover:not(:disabled),.userfront-button.userfront-button-logout:active:not(:disabled){background-color:var(--userfront-logout-color-active);border:var(--userfront-logout-button-border-active);box-shadow:var(--userfront-logout-button-box-shadow-active)}.userfront-button.userfront-button-logout:focus{background-color:var(--userfront-logout-color-focus);outline:var(--userfront-logout-button-border-focus);box-shadow:var(--userfront-logout-button-box-shadow-active)}.userfront-button.userfront-button-logout:disabled{background-color:var(--userfront-logout-color-disabled);cursor:not-allowed;box-shadow:none}.userfront-toolkit .userfront-button-secondary{background-color:var(--userfront-secondary-color);color:var(--userfront-secondary-color-text);border:var(--userfront-secondary-button-border);border-radius:var(--userfront-border-radius);cursor:pointer}.userfront-toolkit .userfront-button-secondary:hover,.userfront-toolkit .userfront-button-secondary:active{background-color:var(--userfront-secondary-color-active);border:var(--userfront-secondary-button-border-active);box-shadow:var(--userfront-secondary-button-box-shadow-active)}.userfront-toolkit .userfront-button-secondary:focus{background-color:var(--userfront-secondary-color-focus);outline:var(--userfront-secondary-button-border-focus);box-shadow:var(--userfront-secondary-button-box-shadow-active)}.userfront-toolkit .userfront-button-subtle{font-size:var(--userfront-subtle-button-font-size);color:var(--userfront-link-color);text-decoration:underline;cursor:pointer;border:none;background-color:inherit}.userfront-toolkit .userfront-button-subtle:focus{font-weight:700}.userfront-toolkit .userfront-button-row{display:flex;flex-flow:row nowrap;column-gap:var(--userfront-spacing);margin-bottom:var(--userfront-spacing);justify-content:stretch}.userfront-toolkit .userfront-button-row:last-child{margin-bottom:0}.userfront-toolkit .userfront-button-row>.userfront-button{flex:1 1}.userfront-toolkit .userfront-secured,.userfront-toolkit .userfront-secured:visited{color:var(--userfront-secured-font-color);font-size:var(--userfront-secured-font-size);margin-right:var(--userfront-spacing);text-decoration:none}.userfront-toolkit .userfront-secured:hover{text-decoration:underline}.userfront-toolkit .userfront-secured .userfront-secured-icon{width:18px;height:18px;margin-right:.3em;vertical-align:top;filter:contrast(20%);transform:.2s ease-in-out}.userfront-toolkit .userfront-secured:hover .userfront-secured-icon{text-decoration:underline;filter:brightness(0) saturate(100%) invert(45%) sepia(10%) saturate(5443%) hue-rotate(201deg) brightness(96%) contrast(86%)}.userfront-divider{height:1px;border-bottom:1px solid var(--userfront-divider-color);margin-bottom:var(--userfront-spacing)}.userfront-divider-split{display:flex;flex-flow:row nowrap;justify-content:stretch;margin-bottom:var(--userfront-spacing);color:var(--userfront-secondary-color-text)}.userfront-divider-split .userfront-divider{flex:1 1 auto;height:calc(var(--userfront-em-size) / 2);margin-bottom:0}.userfront-divider-split .userfront-divider-text{flex:0 0 auto;margin:0 1em;line-height:1em}.userfront-error{border-radius:var(--userfront-border-radius);display:flex;flex-flow:column nowrap;justify-content:center;align-items:center}.userfront-error.userfront-has-error{background-color:var(--userfront-error-background-color);padding:calc(var(--userfront-spacing) / 2);border:1px solid var(--userfront-error-border-color);margin-bottom:var(--userfront-spacing)}.userfront-error .userfront-error-text{color:var(--userfront-error-color);display:block;flex:0 1 auto}.userfront-info-message{margin-top:var(--userfront-spacing);margin-bottom:var(--userfront-spacing);border-radius:var(--userfront-border-radius);display:flex;flex-flow:column nowrap;justify-content:center;align-items:center}.userfront-info-message.userfront-has-info-message{background-color:var(--userfront-info-background-color);padding:calc(var(--userfront-spacing) / 2);border:1px solid var(--userfront-info-border-color)}.userfront-info-message .userfront-info-message-text{color:var(--userfront-info-color);display:block;flex:0 1 auto}.userfront-test-mode-notice{background-color:var(--userfront-test-mode-background-color);color:var(--userfront-test-mode-text-color);padding:.25rem 2rem;margin:0 auto;margin-top:.5rem;width:max-content;border-radius:var(--userfront-border-radius);font-size:.8em}.userfront-toolkit .userfront-placeholder{height:var(--userfront-placeholder-height)}.userfront-toolkit .react-tel-input .form-control{max-width:var(--userfront-container-width)}.userfront-toolkit.userfront-rounded .userfront-button,.userfront-toolkit.userfront-rounded.userfront-button{border-radius:12px}.userfront-toolkit.userfront-rounded .userfront-input{border-radius:8px}.userfront-toolkit.userfront-squared .userfront-button,.userfront-toolkit.userfront-squared.userfront-button,.userfront-toolkit.userfront-squared .userfront-input{border-radius:0}.userfront-toolkit.userfront-hide-branding .userfront-secured{display:none}.userfront-toolkit.userfront-gradient-buttons .userfront-button.userfront-button-primary{background-image:linear-gradient(90deg,var(--userfront-primary-color) 0,color-mix(in hsl,var(--userfront-primary-color),#bbbbbb 20%) 51%,var(--userfront-primary-color));background-size:200% auto;transition:background-position .33s ease-out}.userfront-toolkit.userfront-gradient-buttons.userfront-button-logout{background-image:linear-gradient(90deg,var(--userfront-logout-color) 0,var(--userfront-logout-color-active) 51%,var(--userfront-logout-color));background-size:200% auto;transition:background-position .33s ease-out}.userfront-toolkit.userfront-gradient-buttons .userfront-button.userfront-button-primary:hover:not(:disabled),.userfront-toolkit.userfront-gradient-buttons .userfront-button.userfront-button-primary:focus:not(:disabled),.userfront-toolkit.userfront-gradient-buttons.userfront-button-logout:hover:not(:disabled),.userfront-toolkit.userfront-gradient-buttons.userfront-button-logout:focus:not(:disabled){background-position:50%}.userfront-toolkit.userfront-gradient-buttons .userfront-button.userfront-button-secondary{background-image:linear-gradient(90deg,var(--userfront-secondary-color) 0,color-mix(in hsl,var(--userfront-secondary-color),#888888 20%) 51%,var(--userfront-secondary-color));background-size:200% auto;transition:background-position .33s ease-out}.userfront-toolkit.userfront-gradient-buttons .userfront-button.userfront-button-secondary:hover:not(:disabled),.userfront-toolkit.userfront-gradient-buttons .userfront-button.userfront-button-secondary:focus:not(:disabled){background-position:50%}.userfront-toolkit.userfront-gradient-buttons.userfront-raised-buttons .userfront-button.userfront-button-primary,.userfront-toolkit.userfront-gradient-buttons.userfront-raised-button.userfront-button,.userfront-toolkit.userfront-gradient-buttons.userfront-raised-buttons .userfront-button.userfront-button-secondary{background-position:unset}.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-primary{border:1px solid var(--userfront-primary-color);background:linear-gradient(to bottom,color-mix(in hwb,#ffffff 10%,var(--userfront-primary-color)) 1%,color-mix(in hwb,#000000 10%,var(--userfront-primary-color)) 100%);text-shadow:1px 1px 0 rgba(0,0,0,.25);box-shadow:0 1px #ffffff4d,inset 0 1px #ffffff4d;outline-offset:2px}.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-primary:hover:not(:disabled),.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-primary:focus:not(:disabled){background:var(--userfront-primary-color)}.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-primary:active:not(:disabled){background:linear-gradient(to top,color-mix(in hwb,#ffffff 10%,var(--userfront-primary-color)) 1%,color-mix(in hwb,#000000 10%,var(--userfront-primary-color)) 100%)}.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-secondary{border:1px solid var(--userfront-secondary-button-border-color);background:linear-gradient(to bottom,color-mix(in hwb,#ffffff 10%,var(--userfront-secondary-color)) 1%,color-mix(in hwb,#000000 10%,var(--userfront-secondary-color)) 100%);box-shadow:0 1px #ffffff4d,inset 0 1px #ffffff4d;outline-offset:2px}.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-secondary:hover:not(:disabled),.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-secondary:focus:not(:disabled){background:linear-gradient(to bottom,color-mix(in hwb,#ffffff 15%,var(--userfront-secondary-color)) 1%,color-mix(in hwb,#000000 5%,var(--userfront-secondary-color)) 100%)}.userfront-toolkit.userfront-raised-buttons .userfront-button.userfront-button-secondary:active:not(:disabled){background:linear-gradient(to top,color-mix(in hwb,#ffffff 10%,var(--userfront-secondary-color)) 1%,color-mix(in hwb,#000000 10%,var(--userfront-secondary-color)) 100%)}.userfront-toolkit.userfront-raised-buttons.userfront-button-logout{border:1px solid var(--userfront-logout-color);background:linear-gradient(to bottom,color-mix(in hwb,#ffffff 10%,var(--userfront-logout-color)) 1%,color-mix(in hwb,#000000 10%,var(--userfront-logout-color)) 100%);text-shadow:1px 1px 0 rgba(0,0,0,.25);box-shadow:0 1px #ffffff4d,inset 0 1px #ffffff4d;outline-offset:2px}.userfront-toolkit.userfront-raised-buttons.userfront-button-logout:hover:not(:disabled),.userfront-toolkit.userfront-raised-buttons.userfront-button-logout:focus:not(:disabled){background:var(--userfront-logout-color)}.userfront-toolkit.userfront-raised-buttons.userfront-button-logout:active:not(:disabled){background:linear-gradient(to top,color-mix(in hwb,#ffffff 10%,var(--userfront-logout-color)) 1%,color-mix(in hwb,#000000 10%,var(--userfront-logout-color)) 100%)}.userfront-toolkit.userfront-raised-buttons .userfront-input{outline-offset:2px;border-width:1px;border-color:var(--userfront-secondary-button-border-color);border-style:outset}.userfront-toolkit.userfront-raised-buttons .userfront-input:hover:not(:disabled),.userfront-toolkit.userfront-raised-buttons .userfront-input:active:not(:disabled){border-width:2px;border-style:outset;margin-top:-2px}.userfront-toolkit.userfront-raised-buttons .userfront-input:focus:not(:disabled){border-width:2px;margin-top:-2px;border-style:inset;outline-style:hidden}.userfront-toolkit.userfront-dotted-outlines .userfront-button:active:not(:disabled),.userfront-toolkit.userfront-dotted-outlines .userfront-button:focus:not(:disabled),.userfront-toolkit.userfront-dotted-outlines .userfront-input:focus:not(:disabled),.userfront-toolkit.userfront-dotted-outlines.userfront-button:active:not(:disabled),.userfront-toolkit.userfront-dotted-outlines.userfront-button:focus:not(:disabled){outline-offset:1px;outline-width:2px;outline-style:dotted}")),document.head.appendChild(r)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
var ab = Object.defineProperty;
var sb = (t, r, i) => r in t ? ab(t, r, { enumerable: !0, configurable: !0, writable: !0, value: i }) : t[r] = i;
var bi = (t, r, i) => (sb(t, typeof r != "symbol" ? r + "" : r, i), i);
import * as $u from "react";
import en, { useState as Qt, Component as ub, useEffect as fc, useLayoutEffect as Qd, useCallback as Ou } from "react";
function Hd(t, r) {
  return function() {
    return t.apply(r, arguments);
  };
}
const { toString: cb } = Object.prototype, { getPrototypeOf: dc } = Object, ms = ((t) => (r) => {
  const i = cb.call(r);
  return t[i] || (t[i] = i.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), hn = (t) => (t = t.toLowerCase(), (r) => ms(r) === t), vs = (t) => (r) => typeof r === t, { isArray: fo } = Array, qo = vs("undefined");
function lb(t) {
  return t !== null && !qo(t) && t.constructor !== null && !qo(t.constructor) && Wr(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const Jd = hn("ArrayBuffer");
function fb(t) {
  let r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(t) : r = t && t.buffer && Jd(t.buffer), r;
}
const db = vs("string"), Wr = vs("function"), Zd = vs("number"), ys = (t) => t !== null && typeof t == "object", hb = (t) => t === !0 || t === !1, Za = (t) => {
  if (ms(t) !== "object")
    return !1;
  const r = dc(t);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, pb = hn("Date"), gb = hn("File"), mb = hn("Blob"), vb = hn("FileList"), yb = (t) => ys(t) && Wr(t.pipe), wb = (t) => {
  let r;
  return t && (typeof FormData == "function" && t instanceof FormData || Wr(t.append) && ((r = ms(t)) === "formdata" || r === "object" && Wr(t.toString) && t.toString() === "[object FormData]"));
}, bb = hn("URLSearchParams"), Sb = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Qo(t, r, { allOwnKeys: i = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let o, s;
  if (typeof t != "object" && (t = [t]), fo(t))
    for (o = 0, s = t.length; o < s; o++)
      r.call(null, t[o], o, t);
  else {
    const c = i ? Object.getOwnPropertyNames(t) : Object.keys(t), l = c.length;
    let d;
    for (o = 0; o < l; o++)
      d = c[o], r.call(null, t[d], d, t);
  }
}
function Xd(t, r) {
  r = r.toLowerCase();
  const i = Object.keys(t);
  let o = i.length, s;
  for (; o-- > 0; )
    if (s = i[o], r === s.toLowerCase())
      return s;
  return null;
}
const eh = (() => typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global)(), th = (t) => !qo(t) && t !== eh;
function Qu() {
  const { caseless: t } = th(this) && this || {}, r = {}, i = (o, s) => {
    const c = t && Xd(r, s) || s;
    Za(r[c]) && Za(o) ? r[c] = Qu(r[c], o) : Za(o) ? r[c] = Qu({}, o) : fo(o) ? r[c] = o.slice() : r[c] = o;
  };
  for (let o = 0, s = arguments.length; o < s; o++)
    arguments[o] && Qo(arguments[o], i);
  return r;
}
const Tb = (t, r, i, { allOwnKeys: o } = {}) => (Qo(r, (s, c) => {
  i && Wr(s) ? t[c] = Hd(s, i) : t[c] = s;
}, { allOwnKeys: o }), t), Mb = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), Eb = (t, r, i, o) => {
  t.prototype = Object.create(r.prototype, o), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: r.prototype
  }), i && Object.assign(t.prototype, i);
}, xb = (t, r, i, o) => {
  let s, c, l;
  const d = {};
  if (r = r || {}, t == null)
    return r;
  do {
    for (s = Object.getOwnPropertyNames(t), c = s.length; c-- > 0; )
      l = s[c], (!o || o(l, t, r)) && !d[l] && (r[l] = t[l], d[l] = !0);
    t = i !== !1 && dc(t);
  } while (t && (!i || i(t, r)) && t !== Object.prototype);
  return r;
}, Cb = (t, r, i) => {
  t = String(t), (i === void 0 || i > t.length) && (i = t.length), i -= r.length;
  const o = t.indexOf(r, i);
  return o !== -1 && o === i;
}, _b = (t) => {
  if (!t)
    return null;
  if (fo(t))
    return t;
  let r = t.length;
  if (!Zd(r))
    return null;
  const i = new Array(r);
  for (; r-- > 0; )
    i[r] = t[r];
  return i;
}, Nb = ((t) => (r) => t && r instanceof t)(typeof Uint8Array < "u" && dc(Uint8Array)), Ob = (t, r) => {
  const o = (t && t[Symbol.iterator]).call(t);
  let s;
  for (; (s = o.next()) && !s.done; ) {
    const c = s.value;
    r.call(t, c[0], c[1]);
  }
}, Lb = (t, r) => {
  let i;
  const o = [];
  for (; (i = t.exec(r)) !== null; )
    o.push(i);
  return o;
}, Ab = hn("HTMLFormElement"), Ib = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(i, o, s) {
    return o.toUpperCase() + s;
  }
), Vf = (({ hasOwnProperty: t }) => (r, i) => t.call(r, i))(Object.prototype), jb = hn("RegExp"), rh = (t, r) => {
  const i = Object.getOwnPropertyDescriptors(t), o = {};
  Qo(i, (s, c) => {
    let l;
    (l = r(s, c, t)) !== !1 && (o[c] = l || s);
  }), Object.defineProperties(t, o);
}, kb = (t) => {
  rh(t, (r, i) => {
    if (Wr(t) && ["arguments", "caller", "callee"].indexOf(i) !== -1)
      return !1;
    const o = t[i];
    if (!!Wr(o)) {
      if (r.enumerable = !1, "writable" in r) {
        r.writable = !1;
        return;
      }
      r.set || (r.set = () => {
        throw Error("Can not rewrite read-only method '" + i + "'");
      });
    }
  });
}, Db = (t, r) => {
  const i = {}, o = (s) => {
    s.forEach((c) => {
      i[c] = !0;
    });
  };
  return fo(t) ? o(t) : o(String(t).split(r)), i;
}, Rb = () => {
}, Pb = (t, r) => (t = +t, Number.isFinite(t) ? t : r), Lu = "abcdefghijklmnopqrstuvwxyz", Gf = "0123456789", nh = {
  DIGIT: Gf,
  ALPHA: Lu,
  ALPHA_DIGIT: Lu + Lu.toUpperCase() + Gf
}, Fb = (t = 16, r = nh.ALPHA_DIGIT) => {
  let i = "";
  const { length: o } = r;
  for (; t--; )
    i += r[Math.random() * o | 0];
  return i;
};
function Ub(t) {
  return !!(t && Wr(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const zb = (t) => {
  const r = new Array(10), i = (o, s) => {
    if (ys(o)) {
      if (r.indexOf(o) >= 0)
        return;
      if (!("toJSON" in o)) {
        r[s] = o;
        const c = fo(o) ? [] : {};
        return Qo(o, (l, d) => {
          const p = i(l, s + 1);
          !qo(p) && (c[d] = p);
        }), r[s] = void 0, c;
      }
    }
    return o;
  };
  return i(t, 0);
}, Bb = hn("AsyncFunction"), Wb = (t) => t && (ys(t) || Wr(t)) && Wr(t.then) && Wr(t.catch), V = {
  isArray: fo,
  isArrayBuffer: Jd,
  isBuffer: lb,
  isFormData: wb,
  isArrayBufferView: fb,
  isString: db,
  isNumber: Zd,
  isBoolean: hb,
  isObject: ys,
  isPlainObject: Za,
  isUndefined: qo,
  isDate: pb,
  isFile: gb,
  isBlob: mb,
  isRegExp: jb,
  isFunction: Wr,
  isStream: yb,
  isURLSearchParams: bb,
  isTypedArray: Nb,
  isFileList: vb,
  forEach: Qo,
  merge: Qu,
  extend: Tb,
  trim: Sb,
  stripBOM: Mb,
  inherits: Eb,
  toFlatObject: xb,
  kindOf: ms,
  kindOfTest: hn,
  endsWith: Cb,
  toArray: _b,
  forEachEntry: Ob,
  matchAll: Lb,
  isHTMLForm: Ab,
  hasOwnProperty: Vf,
  hasOwnProp: Vf,
  reduceDescriptors: rh,
  freezeMethods: kb,
  toObjectSet: Db,
  toCamelCase: Ib,
  noop: Rb,
  toFiniteNumber: Pb,
  findKey: Xd,
  global: eh,
  isContextDefined: th,
  ALPHABET: nh,
  generateString: Fb,
  isSpecCompliantForm: Ub,
  toJSONObject: zb,
  isAsyncFn: Bb,
  isThenable: Wb
};
function st(t, r, i, o, s) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", r && (this.code = r), i && (this.config = i), o && (this.request = o), s && (this.response = s);
}
V.inherits(st, Error, {
  toJSON: function() {
    return {
      message: this.message,
      name: this.name,
      description: this.description,
      number: this.number,
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      config: V.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const ih = st.prototype, oh = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
].forEach((t) => {
  oh[t] = { value: t };
});
Object.defineProperties(st, oh);
Object.defineProperty(ih, "isAxiosError", { value: !0 });
st.from = (t, r, i, o, s, c) => {
  const l = Object.create(ih);
  return V.toFlatObject(t, l, function(p) {
    return p !== Error.prototype;
  }, (d) => d !== "isAxiosError"), st.call(l, t.message, r, i, o, s), l.cause = t, l.name = t.name, c && Object.assign(l, c), l;
};
const qb = null;
function Hu(t) {
  return V.isPlainObject(t) || V.isArray(t);
}
function ah(t) {
  return V.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Kf(t, r, i) {
  return t ? t.concat(r).map(function(s, c) {
    return s = ah(s), !i && c ? "[" + s + "]" : s;
  }).join(i ? "." : "") : r;
}
function Yb(t) {
  return V.isArray(t) && !t.some(Hu);
}
const Vb = V.toFlatObject(V, {}, null, function(r) {
  return /^is[A-Z]/.test(r);
});
function ws(t, r, i) {
  if (!V.isObject(t))
    throw new TypeError("target must be an object");
  r = r || new FormData(), i = V.toFlatObject(i, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(_, N) {
    return !V.isUndefined(N[_]);
  });
  const o = i.metaTokens, s = i.visitor || w, c = i.dots, l = i.indexes, p = (i.Blob || typeof Blob < "u" && Blob) && V.isSpecCompliantForm(r);
  if (!V.isFunction(s))
    throw new TypeError("visitor must be a function");
  function v(E) {
    if (E === null)
      return "";
    if (V.isDate(E))
      return E.toISOString();
    if (!p && V.isBlob(E))
      throw new st("Blob is not supported. Use a Buffer instead.");
    return V.isArrayBuffer(E) || V.isTypedArray(E) ? p && typeof Blob == "function" ? new Blob([E]) : Buffer.from(E) : E;
  }
  function w(E, _, N) {
    let U = E;
    if (E && !N && typeof E == "object") {
      if (V.endsWith(_, "{}"))
        _ = o ? _ : _.slice(0, -2), E = JSON.stringify(E);
      else if (V.isArray(E) && Yb(E) || (V.isFileList(E) || V.endsWith(_, "[]")) && (U = V.toArray(E)))
        return _ = ah(_), U.forEach(function(j, R) {
          !(V.isUndefined(j) || j === null) && r.append(
            l === !0 ? Kf([_], R, c) : l === null ? _ : _ + "[]",
            v(j)
          );
        }), !1;
    }
    return Hu(E) ? !0 : (r.append(Kf(N, _, c), v(E)), !1);
  }
  const m = [], b = Object.assign(Vb, {
    defaultVisitor: w,
    convertValue: v,
    isVisitable: Hu
  });
  function x(E, _) {
    if (!V.isUndefined(E)) {
      if (m.indexOf(E) !== -1)
        throw Error("Circular reference detected in " + _.join("."));
      m.push(E), V.forEach(E, function(U, A) {
        (!(V.isUndefined(U) || U === null) && s.call(
          r,
          U,
          V.isString(A) ? A.trim() : A,
          _,
          b
        )) === !0 && x(U, _ ? _.concat(A) : [A]);
      }), m.pop();
    }
  }
  if (!V.isObject(t))
    throw new TypeError("data must be an object");
  return x(t), r;
}
function $f(t) {
  const r = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(o) {
    return r[o];
  });
}
function hc(t, r) {
  this._pairs = [], t && ws(t, this, r);
}
const sh = hc.prototype;
sh.append = function(r, i) {
  this._pairs.push([r, i]);
};
sh.toString = function(r) {
  const i = r ? function(o) {
    return r.call(this, o, $f);
  } : $f;
  return this._pairs.map(function(s) {
    return i(s[0]) + "=" + i(s[1]);
  }, "").join("&");
};
function Gb(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function uh(t, r, i) {
  if (!r)
    return t;
  const o = i && i.encode || Gb, s = i && i.serialize;
  let c;
  if (s ? c = s(r, i) : c = V.isURLSearchParams(r) ? r.toString() : new hc(r, i).toString(o), c) {
    const l = t.indexOf("#");
    l !== -1 && (t = t.slice(0, l)), t += (t.indexOf("?") === -1 ? "?" : "&") + c;
  }
  return t;
}
class Kb {
  constructor() {
    this.handlers = [];
  }
  use(r, i, o) {
    return this.handlers.push({
      fulfilled: r,
      rejected: i,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  eject(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }
  clear() {
    this.handlers && (this.handlers = []);
  }
  forEach(r) {
    V.forEach(this.handlers, function(o) {
      o !== null && r(o);
    });
  }
}
const Qf = Kb, ch = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, $b = typeof URLSearchParams < "u" ? URLSearchParams : hc, Qb = typeof FormData < "u" ? FormData : null, Hb = typeof Blob < "u" ? Blob : null, Jb = {
  isBrowser: !0,
  classes: {
    URLSearchParams: $b,
    FormData: Qb,
    Blob: Hb
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, lh = typeof window < "u" && typeof document < "u", Zb = ((t) => lh && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(typeof navigator < "u" && navigator.product), Xb = (() => typeof WorkerGlobalScope < "u" && self instanceof WorkerGlobalScope && typeof self.importScripts == "function")(), e1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: lh,
  hasStandardBrowserWebWorkerEnv: Xb,
  hasStandardBrowserEnv: Zb
}, Symbol.toStringTag, { value: "Module" })), dn = {
  ...e1,
  ...Jb
};
function t1(t, r) {
  return ws(t, new dn.classes.URLSearchParams(), Object.assign({
    visitor: function(i, o, s, c) {
      return dn.isNode && V.isBuffer(i) ? (this.append(o, i.toString("base64")), !1) : c.defaultVisitor.apply(this, arguments);
    }
  }, r));
}
function r1(t) {
  return V.matchAll(/\w+|\[(\w*)]/g, t).map((r) => r[0] === "[]" ? "" : r[1] || r[0]);
}
function n1(t) {
  const r = {}, i = Object.keys(t);
  let o;
  const s = i.length;
  let c;
  for (o = 0; o < s; o++)
    c = i[o], r[c] = t[c];
  return r;
}
function fh(t) {
  function r(i, o, s, c) {
    let l = i[c++];
    const d = Number.isFinite(+l), p = c >= i.length;
    return l = !l && V.isArray(s) ? s.length : l, p ? (V.hasOwnProp(s, l) ? s[l] = [s[l], o] : s[l] = o, !d) : ((!s[l] || !V.isObject(s[l])) && (s[l] = []), r(i, o, s[l], c) && V.isArray(s[l]) && (s[l] = n1(s[l])), !d);
  }
  if (V.isFormData(t) && V.isFunction(t.entries)) {
    const i = {};
    return V.forEachEntry(t, (o, s) => {
      r(r1(o), s, i, 0);
    }), i;
  }
  return null;
}
function i1(t, r, i) {
  if (V.isString(t))
    try {
      return (r || JSON.parse)(t), V.trim(t);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (i || JSON.stringify)(t);
}
const pc = {
  transitional: ch,
  adapter: ["xhr", "http"],
  transformRequest: [function(r, i) {
    const o = i.getContentType() || "", s = o.indexOf("application/json") > -1, c = V.isObject(r);
    if (c && V.isHTMLForm(r) && (r = new FormData(r)), V.isFormData(r))
      return s && s ? JSON.stringify(fh(r)) : r;
    if (V.isArrayBuffer(r) || V.isBuffer(r) || V.isStream(r) || V.isFile(r) || V.isBlob(r))
      return r;
    if (V.isArrayBufferView(r))
      return r.buffer;
    if (V.isURLSearchParams(r))
      return i.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), r.toString();
    let d;
    if (c) {
      if (o.indexOf("application/x-www-form-urlencoded") > -1)
        return t1(r, this.formSerializer).toString();
      if ((d = V.isFileList(r)) || o.indexOf("multipart/form-data") > -1) {
        const p = this.env && this.env.FormData;
        return ws(
          d ? { "files[]": r } : r,
          p && new p(),
          this.formSerializer
        );
      }
    }
    return c || s ? (i.setContentType("application/json", !1), i1(r)) : r;
  }],
  transformResponse: [function(r) {
    const i = this.transitional || pc.transitional, o = i && i.forcedJSONParsing, s = this.responseType === "json";
    if (r && V.isString(r) && (o && !this.responseType || s)) {
      const l = !(i && i.silentJSONParsing) && s;
      try {
        return JSON.parse(r);
      } catch (d) {
        if (l)
          throw d.name === "SyntaxError" ? st.from(d, st.ERR_BAD_RESPONSE, this, null, this.response) : d;
      }
    }
    return r;
  }],
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: dn.classes.FormData,
    Blob: dn.classes.Blob
  },
  validateStatus: function(r) {
    return r >= 200 && r < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
V.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  pc.headers[t] = {};
});
const gc = pc, o1 = V.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), a1 = (t) => {
  const r = {};
  let i, o, s;
  return t && t.split(`
`).forEach(function(l) {
    s = l.indexOf(":"), i = l.substring(0, s).trim().toLowerCase(), o = l.substring(s + 1).trim(), !(!i || r[i] && o1[i]) && (i === "set-cookie" ? r[i] ? r[i].push(o) : r[i] = [o] : r[i] = r[i] ? r[i] + ", " + o : o);
  }), r;
}, Hf = Symbol("internals");
function Lo(t) {
  return t && String(t).trim().toLowerCase();
}
function Xa(t) {
  return t === !1 || t == null ? t : V.isArray(t) ? t.map(Xa) : String(t);
}
function s1(t) {
  const r = /* @__PURE__ */ Object.create(null), i = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = i.exec(t); )
    r[o[1]] = o[2];
  return r;
}
const u1 = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function Au(t, r, i, o, s) {
  if (V.isFunction(o))
    return o.call(this, r, i);
  if (s && (r = i), !!V.isString(r)) {
    if (V.isString(o))
      return r.indexOf(o) !== -1;
    if (V.isRegExp(o))
      return o.test(r);
  }
}
function c1(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (r, i, o) => i.toUpperCase() + o);
}
function l1(t, r) {
  const i = V.toCamelCase(" " + r);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(t, o + i, {
      value: function(s, c, l) {
        return this[o].call(this, r, s, c, l);
      },
      configurable: !0
    });
  });
}
class bs {
  constructor(r) {
    r && this.set(r);
  }
  set(r, i, o) {
    const s = this;
    function c(d, p, v) {
      const w = Lo(p);
      if (!w)
        throw new Error("header name must be a non-empty string");
      const m = V.findKey(s, w);
      (!m || s[m] === void 0 || v === !0 || v === void 0 && s[m] !== !1) && (s[m || p] = Xa(d));
    }
    const l = (d, p) => V.forEach(d, (v, w) => c(v, w, p));
    return V.isPlainObject(r) || r instanceof this.constructor ? l(r, i) : V.isString(r) && (r = r.trim()) && !u1(r) ? l(a1(r), i) : r != null && c(i, r, o), this;
  }
  get(r, i) {
    if (r = Lo(r), r) {
      const o = V.findKey(this, r);
      if (o) {
        const s = this[o];
        if (!i)
          return s;
        if (i === !0)
          return s1(s);
        if (V.isFunction(i))
          return i.call(this, s, o);
        if (V.isRegExp(i))
          return i.exec(s);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(r, i) {
    if (r = Lo(r), r) {
      const o = V.findKey(this, r);
      return !!(o && this[o] !== void 0 && (!i || Au(this, this[o], o, i)));
    }
    return !1;
  }
  delete(r, i) {
    const o = this;
    let s = !1;
    function c(l) {
      if (l = Lo(l), l) {
        const d = V.findKey(o, l);
        d && (!i || Au(o, o[d], d, i)) && (delete o[d], s = !0);
      }
    }
    return V.isArray(r) ? r.forEach(c) : c(r), s;
  }
  clear(r) {
    const i = Object.keys(this);
    let o = i.length, s = !1;
    for (; o--; ) {
      const c = i[o];
      (!r || Au(this, this[c], c, r, !0)) && (delete this[c], s = !0);
    }
    return s;
  }
  normalize(r) {
    const i = this, o = {};
    return V.forEach(this, (s, c) => {
      const l = V.findKey(o, c);
      if (l) {
        i[l] = Xa(s), delete i[c];
        return;
      }
      const d = r ? c1(c) : String(c).trim();
      d !== c && delete i[c], i[d] = Xa(s), o[d] = !0;
    }), this;
  }
  concat(...r) {
    return this.constructor.concat(this, ...r);
  }
  toJSON(r) {
    const i = /* @__PURE__ */ Object.create(null);
    return V.forEach(this, (o, s) => {
      o != null && o !== !1 && (i[s] = r && V.isArray(o) ? o.join(", ") : o);
    }), i;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([r, i]) => r + ": " + i).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(r) {
    return r instanceof this ? r : new this(r);
  }
  static concat(r, ...i) {
    const o = new this(r);
    return i.forEach((s) => o.set(s)), o;
  }
  static accessor(r) {
    const o = (this[Hf] = this[Hf] = {
      accessors: {}
    }).accessors, s = this.prototype;
    function c(l) {
      const d = Lo(l);
      o[d] || (l1(s, l), o[d] = !0);
    }
    return V.isArray(r) ? r.forEach(c) : c(r), this;
  }
}
bs.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
V.reduceDescriptors(bs.prototype, ({ value: t }, r) => {
  let i = r[0].toUpperCase() + r.slice(1);
  return {
    get: () => t,
    set(o) {
      this[i] = o;
    }
  };
});
V.freezeMethods(bs);
const jn = bs;
function Iu(t, r) {
  const i = this || gc, o = r || i, s = jn.from(o.headers);
  let c = o.data;
  return V.forEach(t, function(d) {
    c = d.call(i, c, s.normalize(), r ? r.status : void 0);
  }), s.normalize(), c;
}
function dh(t) {
  return !!(t && t.__CANCEL__);
}
function Ho(t, r, i) {
  st.call(this, t == null ? "canceled" : t, st.ERR_CANCELED, r, i), this.name = "CanceledError";
}
V.inherits(Ho, st, {
  __CANCEL__: !0
});
function f1(t, r, i) {
  const o = i.config.validateStatus;
  !i.status || !o || o(i.status) ? t(i) : r(new st(
    "Request failed with status code " + i.status,
    [st.ERR_BAD_REQUEST, st.ERR_BAD_RESPONSE][Math.floor(i.status / 100) - 4],
    i.config,
    i.request,
    i
  ));
}
const d1 = dn.hasStandardBrowserEnv ? {
  write(t, r, i, o, s, c) {
    const l = [t + "=" + encodeURIComponent(r)];
    V.isNumber(i) && l.push("expires=" + new Date(i).toGMTString()), V.isString(o) && l.push("path=" + o), V.isString(s) && l.push("domain=" + s), c === !0 && l.push("secure"), document.cookie = l.join("; ");
  },
  read(t) {
    const r = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
    return r ? decodeURIComponent(r[3]) : null;
  },
  remove(t) {
    this.write(t, "", Date.now() - 864e5);
  }
} : {
  write() {
  },
  read() {
    return null;
  },
  remove() {
  }
};
function h1(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function p1(t, r) {
  return r ? t.replace(/\/+$/, "") + "/" + r.replace(/^\/+/, "") : t;
}
function hh(t, r) {
  return t && !h1(r) ? p1(t, r) : r;
}
const g1 = dn.hasStandardBrowserEnv ? function() {
  const r = /(msie|trident)/i.test(navigator.userAgent), i = document.createElement("a");
  let o;
  function s(c) {
    let l = c;
    return r && (i.setAttribute("href", l), l = i.href), i.setAttribute("href", l), {
      href: i.href,
      protocol: i.protocol ? i.protocol.replace(/:$/, "") : "",
      host: i.host,
      search: i.search ? i.search.replace(/^\?/, "") : "",
      hash: i.hash ? i.hash.replace(/^#/, "") : "",
      hostname: i.hostname,
      port: i.port,
      pathname: i.pathname.charAt(0) === "/" ? i.pathname : "/" + i.pathname
    };
  }
  return o = s(window.location.href), function(l) {
    const d = V.isString(l) ? s(l) : l;
    return d.protocol === o.protocol && d.host === o.host;
  };
}() : function() {
  return function() {
    return !0;
  };
}();
function m1(t) {
  const r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return r && r[1] || "";
}
function v1(t, r) {
  t = t || 10;
  const i = new Array(t), o = new Array(t);
  let s = 0, c = 0, l;
  return r = r !== void 0 ? r : 1e3, function(p) {
    const v = Date.now(), w = o[c];
    l || (l = v), i[s] = p, o[s] = v;
    let m = c, b = 0;
    for (; m !== s; )
      b += i[m++], m = m % t;
    if (s = (s + 1) % t, s === c && (c = (c + 1) % t), v - l < r)
      return;
    const x = w && v - w;
    return x ? Math.round(b * 1e3 / x) : void 0;
  };
}
function Jf(t, r) {
  let i = 0;
  const o = v1(50, 250);
  return (s) => {
    const c = s.loaded, l = s.lengthComputable ? s.total : void 0, d = c - i, p = o(d), v = c <= l;
    i = c;
    const w = {
      loaded: c,
      total: l,
      progress: l ? c / l : void 0,
      bytes: d,
      rate: p || void 0,
      estimated: p && l && v ? (l - c) / p : void 0,
      event: s
    };
    w[r ? "download" : "upload"] = !0, t(w);
  };
}
const y1 = typeof XMLHttpRequest < "u", w1 = y1 && function(t) {
  return new Promise(function(i, o) {
    let s = t.data;
    const c = jn.from(t.headers).normalize();
    let { responseType: l, withXSRFToken: d } = t, p;
    function v() {
      t.cancelToken && t.cancelToken.unsubscribe(p), t.signal && t.signal.removeEventListener("abort", p);
    }
    let w;
    if (V.isFormData(s)) {
      if (dn.hasStandardBrowserEnv || dn.hasStandardBrowserWebWorkerEnv)
        c.setContentType(!1);
      else if ((w = c.getContentType()) !== !1) {
        const [_, ...N] = w ? w.split(";").map((U) => U.trim()).filter(Boolean) : [];
        c.setContentType([_ || "multipart/form-data", ...N].join("; "));
      }
    }
    let m = new XMLHttpRequest();
    if (t.auth) {
      const _ = t.auth.username || "", N = t.auth.password ? unescape(encodeURIComponent(t.auth.password)) : "";
      c.set("Authorization", "Basic " + btoa(_ + ":" + N));
    }
    const b = hh(t.baseURL, t.url);
    m.open(t.method.toUpperCase(), uh(b, t.params, t.paramsSerializer), !0), m.timeout = t.timeout;
    function x() {
      if (!m)
        return;
      const _ = jn.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), U = {
        data: !l || l === "text" || l === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: _,
        config: t,
        request: m
      };
      f1(function(j) {
        i(j), v();
      }, function(j) {
        o(j), v();
      }, U), m = null;
    }
    if ("onloadend" in m ? m.onloadend = x : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(x);
    }, m.onabort = function() {
      !m || (o(new st("Request aborted", st.ECONNABORTED, t, m)), m = null);
    }, m.onerror = function() {
      o(new st("Network Error", st.ERR_NETWORK, t, m)), m = null;
    }, m.ontimeout = function() {
      let N = t.timeout ? "timeout of " + t.timeout + "ms exceeded" : "timeout exceeded";
      const U = t.transitional || ch;
      t.timeoutErrorMessage && (N = t.timeoutErrorMessage), o(new st(
        N,
        U.clarifyTimeoutError ? st.ETIMEDOUT : st.ECONNABORTED,
        t,
        m
      )), m = null;
    }, dn.hasStandardBrowserEnv && (d && V.isFunction(d) && (d = d(t)), d || d !== !1 && g1(b))) {
      const _ = t.xsrfHeaderName && t.xsrfCookieName && d1.read(t.xsrfCookieName);
      _ && c.set(t.xsrfHeaderName, _);
    }
    s === void 0 && c.setContentType(null), "setRequestHeader" in m && V.forEach(c.toJSON(), function(N, U) {
      m.setRequestHeader(U, N);
    }), V.isUndefined(t.withCredentials) || (m.withCredentials = !!t.withCredentials), l && l !== "json" && (m.responseType = t.responseType), typeof t.onDownloadProgress == "function" && m.addEventListener("progress", Jf(t.onDownloadProgress, !0)), typeof t.onUploadProgress == "function" && m.upload && m.upload.addEventListener("progress", Jf(t.onUploadProgress)), (t.cancelToken || t.signal) && (p = (_) => {
      !m || (o(!_ || _.type ? new Ho(null, t, m) : _), m.abort(), m = null);
    }, t.cancelToken && t.cancelToken.subscribe(p), t.signal && (t.signal.aborted ? p() : t.signal.addEventListener("abort", p)));
    const E = m1(b);
    if (E && dn.protocols.indexOf(E) === -1) {
      o(new st("Unsupported protocol " + E + ":", st.ERR_BAD_REQUEST, t));
      return;
    }
    m.send(s || null);
  });
}, Ju = {
  http: qb,
  xhr: w1
};
V.forEach(Ju, (t, r) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: r });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: r });
  }
});
const Zf = (t) => `- ${t}`, b1 = (t) => V.isFunction(t) || t === null || t === !1, ph = {
  getAdapter: (t) => {
    t = V.isArray(t) ? t : [t];
    const { length: r } = t;
    let i, o;
    const s = {};
    for (let c = 0; c < r; c++) {
      i = t[c];
      let l;
      if (o = i, !b1(i) && (o = Ju[(l = String(i)).toLowerCase()], o === void 0))
        throw new st(`Unknown adapter '${l}'`);
      if (o)
        break;
      s[l || "#" + c] = o;
    }
    if (!o) {
      const c = Object.entries(s).map(
        ([d, p]) => `adapter ${d} ` + (p === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = r ? c.length > 1 ? `since :
` + c.map(Zf).join(`
`) : " " + Zf(c[0]) : "as no adapter specified";
      throw new st(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Ju
};
function ju(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new Ho(null, t);
}
function Xf(t) {
  return ju(t), t.headers = jn.from(t.headers), t.data = Iu.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), ph.getAdapter(t.adapter || gc.adapter)(t).then(function(o) {
    return ju(t), o.data = Iu.call(
      t,
      t.transformResponse,
      o
    ), o.headers = jn.from(o.headers), o;
  }, function(o) {
    return dh(o) || (ju(t), o && o.response && (o.response.data = Iu.call(
      t,
      t.transformResponse,
      o.response
    ), o.response.headers = jn.from(o.response.headers))), Promise.reject(o);
  });
}
const ed = (t) => t instanceof jn ? t.toJSON() : t;
function so(t, r) {
  r = r || {};
  const i = {};
  function o(v, w, m) {
    return V.isPlainObject(v) && V.isPlainObject(w) ? V.merge.call({ caseless: m }, v, w) : V.isPlainObject(w) ? V.merge({}, w) : V.isArray(w) ? w.slice() : w;
  }
  function s(v, w, m) {
    if (V.isUndefined(w)) {
      if (!V.isUndefined(v))
        return o(void 0, v, m);
    } else
      return o(v, w, m);
  }
  function c(v, w) {
    if (!V.isUndefined(w))
      return o(void 0, w);
  }
  function l(v, w) {
    if (V.isUndefined(w)) {
      if (!V.isUndefined(v))
        return o(void 0, v);
    } else
      return o(void 0, w);
  }
  function d(v, w, m) {
    if (m in r)
      return o(v, w);
    if (m in t)
      return o(void 0, v);
  }
  const p = {
    url: c,
    method: c,
    data: c,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: d,
    headers: (v, w) => s(ed(v), ed(w), !0)
  };
  return V.forEach(Object.keys(Object.assign({}, t, r)), function(w) {
    const m = p[w] || s, b = m(t[w], r[w], w);
    V.isUndefined(b) && m !== d || (i[w] = b);
  }), i;
}
const gh = "1.6.2", mc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, r) => {
  mc[t] = function(o) {
    return typeof o === t || "a" + (r < 1 ? "n " : " ") + t;
  };
});
const td = {};
mc.transitional = function(r, i, o) {
  function s(c, l) {
    return "[Axios v" + gh + "] Transitional option '" + c + "'" + l + (o ? ". " + o : "");
  }
  return (c, l, d) => {
    if (r === !1)
      throw new st(
        s(l, " has been removed" + (i ? " in " + i : "")),
        st.ERR_DEPRECATED
      );
    return i && !td[l] && (td[l] = !0, console.warn(
      s(
        l,
        " has been deprecated since v" + i + " and will be removed in the near future"
      )
    )), r ? r(c, l, d) : !0;
  };
};
function S1(t, r, i) {
  if (typeof t != "object")
    throw new st("options must be an object", st.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(t);
  let s = o.length;
  for (; s-- > 0; ) {
    const c = o[s], l = r[c];
    if (l) {
      const d = t[c], p = d === void 0 || l(d, c, t);
      if (p !== !0)
        throw new st("option " + c + " must be " + p, st.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (i !== !0)
      throw new st("Unknown option " + c, st.ERR_BAD_OPTION);
  }
}
const Zu = {
  assertOptions: S1,
  validators: mc
}, Gn = Zu.validators;
class us {
  constructor(r) {
    this.defaults = r, this.interceptors = {
      request: new Qf(),
      response: new Qf()
    };
  }
  request(r, i) {
    typeof r == "string" ? (i = i || {}, i.url = r) : i = r || {}, i = so(this.defaults, i);
    const { transitional: o, paramsSerializer: s, headers: c } = i;
    o !== void 0 && Zu.assertOptions(o, {
      silentJSONParsing: Gn.transitional(Gn.boolean),
      forcedJSONParsing: Gn.transitional(Gn.boolean),
      clarifyTimeoutError: Gn.transitional(Gn.boolean)
    }, !1), s != null && (V.isFunction(s) ? i.paramsSerializer = {
      serialize: s
    } : Zu.assertOptions(s, {
      encode: Gn.function,
      serialize: Gn.function
    }, !0)), i.method = (i.method || this.defaults.method || "get").toLowerCase();
    let l = c && V.merge(
      c.common,
      c[i.method]
    );
    c && V.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (E) => {
        delete c[E];
      }
    ), i.headers = jn.concat(l, c);
    const d = [];
    let p = !0;
    this.interceptors.request.forEach(function(_) {
      typeof _.runWhen == "function" && _.runWhen(i) === !1 || (p = p && _.synchronous, d.unshift(_.fulfilled, _.rejected));
    });
    const v = [];
    this.interceptors.response.forEach(function(_) {
      v.push(_.fulfilled, _.rejected);
    });
    let w, m = 0, b;
    if (!p) {
      const E = [Xf.bind(this), void 0];
      for (E.unshift.apply(E, d), E.push.apply(E, v), b = E.length, w = Promise.resolve(i); m < b; )
        w = w.then(E[m++], E[m++]);
      return w;
    }
    b = d.length;
    let x = i;
    for (m = 0; m < b; ) {
      const E = d[m++], _ = d[m++];
      try {
        x = E(x);
      } catch (N) {
        _.call(this, N);
        break;
      }
    }
    try {
      w = Xf.call(this, x);
    } catch (E) {
      return Promise.reject(E);
    }
    for (m = 0, b = v.length; m < b; )
      w = w.then(v[m++], v[m++]);
    return w;
  }
  getUri(r) {
    r = so(this.defaults, r);
    const i = hh(r.baseURL, r.url);
    return uh(i, r.params, r.paramsSerializer);
  }
}
V.forEach(["delete", "get", "head", "options"], function(r) {
  us.prototype[r] = function(i, o) {
    return this.request(so(o || {}, {
      method: r,
      url: i,
      data: (o || {}).data
    }));
  };
});
V.forEach(["post", "put", "patch"], function(r) {
  function i(o) {
    return function(c, l, d) {
      return this.request(so(d || {}, {
        method: r,
        headers: o ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: c,
        data: l
      }));
    };
  }
  us.prototype[r] = i(), us.prototype[r + "Form"] = i(!0);
});
const es = us;
class vc {
  constructor(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    let i;
    this.promise = new Promise(function(c) {
      i = c;
    });
    const o = this;
    this.promise.then((s) => {
      if (!o._listeners)
        return;
      let c = o._listeners.length;
      for (; c-- > 0; )
        o._listeners[c](s);
      o._listeners = null;
    }), this.promise.then = (s) => {
      let c;
      const l = new Promise((d) => {
        o.subscribe(d), c = d;
      }).then(s);
      return l.cancel = function() {
        o.unsubscribe(c);
      }, l;
    }, r(function(c, l, d) {
      o.reason || (o.reason = new Ho(c, l, d), i(o.reason));
    });
  }
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  subscribe(r) {
    if (this.reason) {
      r(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(r) : this._listeners = [r];
  }
  unsubscribe(r) {
    if (!this._listeners)
      return;
    const i = this._listeners.indexOf(r);
    i !== -1 && this._listeners.splice(i, 1);
  }
  static source() {
    let r;
    return {
      token: new vc(function(s) {
        r = s;
      }),
      cancel: r
    };
  }
}
const T1 = vc;
function M1(t) {
  return function(i) {
    return t.apply(null, i);
  };
}
function E1(t) {
  return V.isObject(t) && t.isAxiosError === !0;
}
const Xu = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Xu).forEach(([t, r]) => {
  Xu[r] = t;
});
const x1 = Xu;
function mh(t) {
  const r = new es(t), i = Hd(es.prototype.request, r);
  return V.extend(i, es.prototype, r, { allOwnKeys: !0 }), V.extend(i, r, null, { allOwnKeys: !0 }), i.create = function(s) {
    return mh(so(t, s));
  }, i;
}
const Vt = mh(gc);
Vt.Axios = es;
Vt.CanceledError = Ho;
Vt.CancelToken = T1;
Vt.isCancel = dh;
Vt.VERSION = gh;
Vt.toFormData = ws;
Vt.AxiosError = st;
Vt.Cancel = Vt.CanceledError;
Vt.all = function(r) {
  return Promise.all(r);
};
Vt.spread = M1;
Vt.isAxiosError = E1;
Vt.mergeConfig = so;
Vt.AxiosHeaders = jn;
Vt.formToJSON = (t) => fh(V.isHTMLForm(t) ? new FormData(t) : t);
Vt.getAdapter = ph.getAdapter;
Vt.HttpStatusCode = x1;
Vt.default = Vt;
const Yo = Vt;
var Ao = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, vh = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(t, r) {
  (function(i) {
    var o;
    if (t.exports = i(), o = !0, !o) {
      var s = window.Cookies, c = window.Cookies = i();
      c.noConflict = function() {
        return window.Cookies = s, c;
      };
    }
  })(function() {
    function i() {
      for (var c = 0, l = {}; c < arguments.length; c++) {
        var d = arguments[c];
        for (var p in d)
          l[p] = d[p];
      }
      return l;
    }
    function o(c) {
      return c.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function s(c) {
      function l() {
      }
      function d(v, w, m) {
        if (!(typeof document > "u")) {
          m = i({
            path: "/"
          }, l.defaults, m), typeof m.expires == "number" && (m.expires = new Date(new Date() * 1 + m.expires * 864e5)), m.expires = m.expires ? m.expires.toUTCString() : "";
          try {
            var b = JSON.stringify(w);
            /^[\{\[]/.test(b) && (w = b);
          } catch {
          }
          w = c.write ? c.write(w, v) : encodeURIComponent(String(w)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), v = encodeURIComponent(String(v)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var x = "";
          for (var E in m)
            !m[E] || (x += "; " + E, m[E] !== !0 && (x += "=" + m[E].split(";")[0]));
          return document.cookie = v + "=" + w + x;
        }
      }
      function p(v, w) {
        if (!(typeof document > "u")) {
          for (var m = {}, b = document.cookie ? document.cookie.split("; ") : [], x = 0; x < b.length; x++) {
            var E = b[x].split("="), _ = E.slice(1).join("=");
            !w && _.charAt(0) === '"' && (_ = _.slice(1, -1));
            try {
              var N = o(E[0]);
              if (_ = (c.read || c)(_, N) || o(_), w)
                try {
                  _ = JSON.parse(_);
                } catch {
                }
              if (m[N] = _, v === N)
                break;
            } catch {
            }
          }
          return v ? m[v] : m;
        }
      }
      return l.set = d, l.get = function(v) {
        return p(v, !1);
      }, l.getJSON = function(v) {
        return p(v, !0);
      }, l.remove = function(v, w) {
        d(v, "", i(w, {
          expires: -1
        }));
      }, l.defaults = {}, l.withConverter = s, l;
    }
    return s(function() {
    });
  });
})(vh);
const uo = vh.exports, ee = { user: {}, tokens: {}, mode: "live" };
function yc(t) {
  try {
    const r = t.split(".")[1].replace(/-/g, "+").replace(/_/g, "/"), i = decodeURIComponent(window.atob(r).split("").map((o) => "%" + ("00" + o.charCodeAt(0).toString(16)).slice(-2)).join(""));
    return JSON.parse(i);
  } catch (r) {
    console.error("Problem decoding JWT payload", r);
  }
}
function yh(t) {
  try {
    if (!t)
      return !1;
    const r = yc(t);
    return new Date(1e3 * r.exp) > new Date();
  } catch {
    return !1;
  }
}
function ar(t) {
  var r, i;
  if (t)
    throw typeof t == "string" ? new Error(t) : t != null && (r = t.response) != null && (i = r.data) != null && i.message ? new Error(t.response.data.message) : t;
}
function ts() {
  return typeof window < "u";
}
const C1 = ee.user;
function wc(t) {
  return t.replace(/([^:]\/)\/+/g, "$1");
}
const Vo = function(t, r, i) {
  try {
    const o = wc(`${ee.baseUrl}${t}`);
    return Promise.resolve(Yo.put(o, r, i));
  } catch (o) {
    return Promise.reject(o);
  }
}, $n = function(t, r, i) {
  try {
    const o = wc(`${ee.baseUrl}${t}`);
    return Promise.resolve(Yo.post(o, r, i));
  } catch (o) {
    return Promise.reject(o);
  }
}, Zn = function(t, r) {
  try {
    const i = wc(`${ee.baseUrl}${t}`);
    return Promise.resolve(Yo.get(i, r));
  } catch (i) {
    return Promise.reject(i);
  }
};
function ku(t, r, i) {
  const o = `${i}.${ee.tenantId}`;
  r = r || { secure: ee.mode === "live", sameSite: "Lax" }, i === "refresh" && (r.sameSite = "Strict"), uo.set(o, t, r);
}
function Du(t) {
  let r, i;
  try {
    const o = window.location.pathname, s = window.location.hostname, c = s.split(".").slice(-2).join(".");
    r = [void 0, o, "/"], i = [void 0, s, `.${s}`, c, `.${c}`];
  } catch {
    r = [void 0, "/"], i = [void 0];
  }
  r.map((o) => {
    i.map((s) => {
      const c = {};
      s && (c.domain = s), o && (c.path = o), uo.remove(t, c);
    });
  });
}
function Qi() {
  Du(ee.tokens.accessTokenName), Du(ee.tokens.idTokenName), Du(ee.tokens.refreshTokenName), ee.tokens.accessToken = void 0, ee.tokens.idToken = void 0, ee.tokens.refreshToken = void 0, function() {
    for (const t in ee.user)
      typeof ee.user[t] != "function" && delete ee.user[t];
  }();
}
function bc() {
  return !!tn.firstFactorToken;
}
function Qn() {
  return tn.firstFactorToken ? { authorization: `Bearer ${tn.firstFactorToken}` } : {};
}
function Sc() {
  tn.secondFactors = [], tn.firstFactorToken = null;
}
const Ru = function() {
  try {
    return Promise.resolve(_1()).then(function(t) {
      return { isLoggedIn: t, needsSecondFactor: bc(), firstFactors: tn.firstFactors, secondFactors: tn.secondFactors, resetMfaState: Sc };
    });
  } catch (t) {
    return Promise.reject(t);
  }
}, _1 = function() {
  return Promise.resolve(function(t, r) {
    try {
      var i = !!id() || !!yh(ee.tokens.refreshToken) && Promise.resolve(Ss()).then(function() {
        return id();
      });
    } catch {
      return !1;
    }
    return i && i.then ? i.then(void 0, function() {
      return !1;
    }) : i;
  }());
}, Xn = { codeChallenge: "", get usePkce() {
  return !!Xn.codeChallenge;
} };
function ec() {
  ts() && (window.localStorage.removeItem("uf_pkce_code_challenge"), window.localStorage.removeItem("uf_pkce_code_challenge_expiresAt"));
}
function rd() {
  if (!ts())
    return;
  const t = dr("code_challenge");
  if (t)
    return Xn.codeChallenge = t, function(i) {
      if (!ts())
        return;
      if (!i)
        return ec();
      Xn.codeChallenge = i;
      const o = Date.now() + 3e5;
      try {
        window.localStorage.setItem("uf_pkce_code_challenge", i), window.localStorage.setItem("uf_pkce_code_challenge_expiresAt", o);
      } catch {
      }
    }(t), !0;
  const r = function() {
    if (!ts())
      return;
    const i = window.localStorage.getItem("uf_pkce_code_challenge");
    if (i) {
      const o = window.localStorage.getItem("uf_pkce_code_challenge_expiresAt");
      if (o && parseInt(o, 10) > Date.now())
        return i;
    }
  }();
  return r ? (Xn.codeChallenge = r, !0) : (ec(), !1);
}
function Hi() {
  return Xn.usePkce ? { code_challenge: Xn.codeChallenge } : {};
}
function dr(t) {
  if (typeof window == "object" && typeof window.location == "object" && window.location.href && !(window.location.href.indexOf(`${t}=`) < 0))
    return decodeURIComponent(window.location.href.split(`${t}=`)[1].split("&")[0]);
}
const wh = (t, r) => {
  t !== !1 && to(t !== !0 ? t || dr("redirect") || r.redirectTo || "/" : dr("redirect") || r.redirectTo || "/");
};
function to(t) {
  if (!t || typeof document != "object" || typeof window != "object")
    return;
  try {
  } catch {
    return;
  }
  const r = document.createElement("a");
  r.href = t, r.pathname !== window.location.pathname && window.location.assign(`${r.pathname}${r.hash}${r.search}`);
}
const Si = function({ data: t, redirect: r, handleUpstreamResponse: i, handleMfaRequired: o, handlePkceRequired: s, handleTokens: c, handleRedirect: l }) {
  try {
    let d = function() {
      let w;
      function m(x) {
        if (w)
          return x;
        function E() {
          let N;
          function U(j) {
            if (N)
              return j;
            const R = function() {
              if (t.hasOwnProperty("redirectTo") && r !== !1) {
                const F = function() {
                  if (typeof l == "function")
                    return Promise.resolve(l(p, t)).then(function() {
                    });
                  wh(p, t);
                }();
                if (F && F.then)
                  return F.then(function() {
                  });
              }
            }();
            return R && R.then ? R.then(function() {
              return t;
            }) : t;
          }
          const A = function() {
            if (t.hasOwnProperty("authorizationCode")) {
              if (!p)
                throw new Error("Missing PKCE redirect url");
              return typeof s == "function" ? Promise.resolve(s(t.authorizationCode, p, t)).then(function() {
              }) : (function(j, R, F) {
                if (!R || !j)
                  return;
                Xn.usePkce || console.warn("Redirecting with a PKCE authorization code, but no PKCE challenge code is present in the client. This is unexpected.");
                const B = new URL(R);
                B.searchParams.set("authorization_code", j), ec(), window.location.assign(B.href);
              }(t.authorizationCode, p), N = 1, t);
            }
          }();
          return A && A.then ? A.then(U) : U(A);
        }
        const _ = function() {
          if (t.hasOwnProperty("tokens")) {
            const N = typeof c == "function" ? Promise.resolve(c(t.tokens, t)).then(function() {
            }) : Promise.resolve(N1(t.tokens, t)).then(function() {
            });
            if (N && N.then)
              return N.then(function() {
              });
          }
        }();
        return _ && _.then ? _.then(E) : E();
      }
      const b = function() {
        if (t.hasOwnProperty("firstFactorToken")) {
          let x = function() {
            return w = 1, t;
          };
          const E = function() {
            if (typeof o == "function")
              return Promise.resolve(o(t.firstFactorToken, t)).then(function() {
              });
            (function(_, N) {
              N.isMfaRequired ? (tn.firstFactorToken = _, tn.secondFactors = N.authentication.secondFactors) : N.message === "OK" && Sc();
            })(t.firstFactorToken, t);
          }();
          return E && E.then ? E.then(x) : x();
        }
      }();
      return b && b.then ? b.then(m) : m(b);
    }, p = r || dr("redirect") || t.redirectTo || "/";
    const v = function() {
      if (typeof i == "function")
        return Promise.resolve(i(t.upstreamResponse, t)).then(function() {
        });
    }();
    return Promise.resolve(v && v.then ? v.then(d) : d());
  } catch (d) {
    return Promise.reject(d);
  }
}, tn = { firstFactors: [], secondFactors: [], firstFactorToken: null };
function bh(t) {
  ku(t.access.value, t.access.cookieOptions, "access"), ku(t.id.value, t.id.cookieOptions, "id"), t.refresh && t.refresh.value && ku(t.refresh.value, t.refresh.cookieOptions, "refresh"), Sh();
}
function nd(t, r) {
  try {
    var i = t();
  } catch (o) {
    return r(o);
  }
  return i && i.then ? i.then(void 0, r) : i;
}
const Ss = function() {
  try {
    const t = nd(function() {
      return Promise.resolve(function() {
        try {
          const r = uo.get(ee.tokens.refreshTokenName);
          return Promise.resolve(nd(function() {
            return Promise.resolve(Zn("/auth/refresh", { headers: { authorization: `Bearer ${r}` } })).then(function({ data: i, status: o }) {
              if (o !== 200)
                throw new Error(i.message || "Problem with request");
              if (i.tokens)
                return bh(i.tokens), i;
              throw new Error("Problem setting cookies");
            });
          }, function(i) {
            ar(i);
          }));
        } catch (r) {
          return Promise.reject(r);
        }
      }()).then(function() {
      });
    }, function(r) {
      console.warn(`Refresh failed: ${r.message}`);
    });
    return Promise.resolve(t && t.then ? t.then(function() {
    }) : void 0);
  } catch (t) {
    return Promise.reject(t);
  }
}, N1 = function(t, r) {
  try {
    return bh(t), Promise.resolve(function({}) {
      return Promise.resolve();
    }(r)).then(function() {
    });
  } catch (i) {
    return Promise.reject(i);
  }
};
function Sh() {
  ["access", "id", "refresh"].map((t) => {
    try {
      const r = uo.get(ee.tokens[`${t}TokenName`]);
      ee.tokens[`${t}Token`] = r, t === "id" && r && function() {
        if (!ee.tokens.idToken)
          return console.warn("Cannot define user: missing ID token");
        ee.user = ee.user || {};
        const i = yc(ee.tokens.idToken), o = ["email", "phoneNumber", "username", "name", "image", "data", "createdAt", "updatedAt", "mode", "userId", "userUuid", "tenantId", "isEmailConfirmed", "isPhoneNumberConfirmed", "confirmedEmailAt", "confirmedPhoneNumberAt", "isMfaRequired", "isConfirmed"];
        for (const s of o) {
          if (s === "update")
            return;
          ee.user[s] = i[s];
        }
      }();
    } catch {
      console.warn(`Problem setting ${t} token.`);
    }
  });
}
function id() {
  return yh(ee.tokens.accessToken);
}
ee.tokens = ee.tokens || {}, ee.tokens.refresh = Ss;
const O1 = ee.tokens;
function zo(t, r) {
  try {
    var i = t();
  } catch (o) {
    return r(o);
  }
  return i && i.then ? i.then(void 0, r) : i;
}
const od = function({ password: t, existingPassword: r }) {
  try {
    return Promise.resolve(zo(function() {
      if (!ee.tokens.accessToken)
        throw new Error('updatePassword({ method: "jwt" }) was called without a JWT access token.');
      const { tenantId: i } = ee;
      return Promise.resolve(Vo(`/tenants/${i}/auth/basic`, { password: t, existingPassword: r }, { headers: { Authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function({ data: o }) {
        return o;
      });
    }, function(i) {
      ar(i);
    }));
  } catch (i) {
    return Promise.reject(i);
  }
}, ad = function({ uuid: t, token: r, password: i, redirect: o, handleUpstreamResponse: s, handleMfaRequired: c, handlePkceRequired: l, handleTokens: d, handleRedirect: p }) {
  try {
    return Promise.resolve(zo(function() {
      if (r = r || dr("token"), t = t || dr("uuid"), !r || !t)
        throw new Error("Missing token or uuid");
      const { tenantId: v } = ee;
      return Promise.resolve(Vo(`/tenants/${v}/auth/reset`, { uuid: t, token: r, password: i })).then(function({ data: w }) {
        return Si({ data: w, redirect: o, handleUpstreamResponse: s, handleMfaRequired: c, handlePkceRequired: l, handleTokens: d, handleRedirect: p });
      });
    }, function(v) {
      ar(v);
    }));
  } catch (v) {
    return Promise.reject(v);
  }
}, Tc = function({ method: t, password: r, existingPassword: i, uuid: o, token: s, redirect: c, handleUpstreamResponse: l, handleMfaRequired: d, handlePkceRequired: p, handleTokens: v, handleRedirect: w }) {
  try {
    switch (t) {
      case "link":
        return ad({ uuid: o, token: s, password: r, redirect: c, handleUpstreamResponse: l, handleMfaRequired: d, handlePkceRequired: p, handleTokens: v, handleRedirect: w });
      case "jwt":
        return od({ password: r, existingPassword: i });
      default:
        if (s = s || dr("token"), (o = o || dr("uuid")) && s)
          return ad({ uuid: o, token: s, password: r, redirect: c, handleUpstreamResponse: l, handleMfaRequired: d, handlePkceRequired: p, handleTokens: v, handleRedirect: w });
        if (ee.tokens.accessToken)
          return od({ password: r, existingPassword: i });
        throw new Error("updatePassword() was called without link credentials (token & uuid) or a JWT access token.");
    }
  } catch (m) {
    return Promise.reject(m);
  }
}, L1 = Tc;
function za({ provider: t, redirect: r, providerId: i }) {
  if (!t)
    throw new Error("Missing provider");
  const o = function({ provider: s, redirect: c, providerId: l }) {
    if (!s)
      throw new Error("Missing provider");
    if (!ee.tenantId)
      throw new Error("Missing tenantId");
    if (s === "custom" && !l)
      throw new Error("Missing providerId");
    const d = new URL(`${ee.baseUrl}auth/${s}/login`);
    d.searchParams.append("origin", window.location.origin), d.searchParams.append("tenant_id", ee.tenantId), s === "custom" && d.searchParams.append("provider_id", l);
    let p = c || dr("redirect");
    return c === !1 && (p = typeof document == "object" && document.location.pathname), p && d.searchParams.append("redirect", p), d.toString();
  }({ provider: t, redirect: r, providerId: i });
  window.location.assign(o);
}
function tc(t, r) {
  try {
    var i = t();
  } catch (o) {
    return r(o);
  }
  return i && i.then ? i.then(void 0, r) : i;
}
const sd = function({ email: t, name: r, username: i, userData: o, options: s }) {
  try {
    return Promise.resolve(tc(function() {
      const { tenantId: c } = ee;
      return Promise.resolve($n(`/tenants/${c}/auth/link`, { email: t, name: r, username: i, data: o, options: s })).then(function({ data: l }) {
        return l;
      });
    }, function(c) {
      ar(c);
    }));
  } catch (c) {
    return Promise.reject(c);
  }
};
function Th(t, r) {
  try {
    var i = t();
  } catch (o) {
    return r(o);
  }
  return i && i.then ? i.then(void 0, r) : i;
}
function Mh({ channel: t, phoneNumber: r, email: i }) {
  if (t !== "sms" && t !== "email")
    throw new Error("Invalid channel");
  if (!bc()) {
    if (t === "sms" && !r)
      throw new Error('SMS verification code requires "phoneNumber"');
    if (t === "email" && !i)
      throw new Error('Email verification code requires "email"');
  }
}
const ud = function({ channel: t = "sms", phoneNumber: r, email: i, name: o, username: s, data: c }) {
  try {
    return Promise.resolve(Th(function() {
      Mh({ channel: t, phoneNumber: r, email: i });
      const { tenantId: l } = ee;
      return Promise.resolve($n(`/tenants/${l}/auth/code`, { channel: t, email: i, phoneNumber: r, name: o, username: s, data: c }, { headers: Qn() })).then(function({ data: d }) {
        return d;
      });
    }, function(l) {
      ar(l);
    }));
  } catch (l) {
    return Promise.reject(l);
  }
};
function Eh(t, r) {
  try {
    var i = t();
  } catch (o) {
    return r(o);
  }
  return i && i.then ? i.then(void 0, r) : i;
}
function cd(t, r) {
  try {
    var i = t();
  } catch (o) {
    return r(o);
  }
  return i && i.then ? i.then(void 0, r) : i;
}
const A1 = /((^127\.)|(^10\.)|(^172\.1[6-9]\.)|(^172\.2[0-9]\.)|(^172\.3[0-1]\.)|(^192\.168\.))\d{1,3}\.\d{1,3}/g, xh = function() {
  try {
    return Promise.resolve(function(t, r) {
      try {
        var i = Promise.resolve(Zn(`/tenants/${ee.tenantId}/mode`)).then(function({ data: o }) {
          var s;
          return In.value = o.mode || "test", In.reason = _h(In.value), ee.mode = In.value, s = o.authentication, ee.tenantId ? s && typeof s == "object" && Array.isArray(s.firstFactors) ? tn.firstFactors = s.firstFactors : console.warn("setFirstFactors: invalid factors passed.") : console.warn("setFirstFactors: tried to set factors without a tenantId set."), o;
        });
      } catch {
        return r();
      }
      return i && i.then ? i.then(void 0, r) : i;
    }(0, function() {
      In.value = "test", ee.mode = In.value;
    }));
  } catch (t) {
    return Promise.reject(t);
  }
}, In = { value: "live", reason: void 0, setMode: xh };
function Ch() {
  const t = function(r) {
    try {
      const i = window.location.hostname;
      return !(!i.match(/localhost/g) && !i.match(A1));
    } catch {
      return !0;
    }
  }() || !function() {
    try {
      return window.location.protocol === "https:";
    } catch {
      return !1;
    }
  }() ? "test" : "live";
  In.value = t, In.reason = _h(t), ee.mode = t;
}
function _h(t) {
  try {
    return t === "live" ? "domain" : window.location.protocol === "http:" ? "http" : window.location.protocol !== "https:" ? "protocol" : "domain";
  } catch {
  }
}
Ch(), ee.user.update = function(t) {
  try {
    return !t || Object.keys(t).length < 1 ? Promise.resolve(console.warn("Missing user properties to update")) : Promise.resolve(Vo("/self", t, { headers: { authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function() {
      return Promise.resolve(Ss()).then(function() {
        return ee.user;
      });
    });
  } catch (r) {
    return Promise.reject(r);
  }
}, ee.user.hasRole = function(t, { tenantId: r } = {}) {
  try {
    if (!ee.tokens.accessToken || !ee.tenantId)
      return !1;
    const { authorization: i } = yc(ee.tokens.accessToken);
    return !!i && !(!i[r = r || ee.tenantId] || !i[r].roles) && i[r].roles.indexOf(t) > -1;
  } catch {
    return !1;
  }
}, ee.user.updatePassword = Tc, ee.user.getTotp = function() {
  try {
    let t;
    return Promise.resolve(Eh(function() {
      function r(o) {
        if (t)
          return o;
        if (!ee.tokens.accessToken)
          throw new Error("getTotp() was called without a JWT access token.");
        return Promise.resolve(Zn("/auth/totp", { headers: { Authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function({ data: s }) {
          return s;
        });
      }
      const i = function() {
        if (bc())
          return Promise.resolve(Zn("/auth/totp", { headers: Qn() })).then(function({ data: o }) {
            return t = 1, o;
          });
      }();
      return i && i.then ? i.then(r) : r(i);
    }, function(r) {
      ar(r);
    }));
  } catch (t) {
    return Promise.reject(t);
  }
};
let Ba = [], ld = !1;
var Nh = { addInitCallback: function(t) {
  t && typeof t == "function" && Ba.push(t);
}, init: function(t, r = {}) {
  if (!t)
    return console.warn("Userfront initialized without tenantId");
  if (ee.tenantId = t, ee.baseUrl = r.baseUrl || "https://api.userfront.com/v0/", ee.baseUrl.endsWith("/") || (ee.baseUrl += "/"), r.domain) {
    ee.domain = r.domain;
    const i = `https://${ee.domain}`;
    Yo.defaults.headers.common["x-application-id"] = i, Yo.defaults.headers.common["x-origin"] = i;
  }
  ee.tokens = ee.tokens || {}, ee.tokens.accessTokenName = `access.${ee.tenantId}`, ee.tokens.idTokenName = `id.${ee.tenantId}`, ee.tokens.refreshTokenName = `refresh.${ee.tenantId}`, Sh(), Ch(), Sc(), tn.firstFactors = [];
  try {
    Ba.length > 0 && Ba.forEach((i) => {
      i && typeof i == "function" && i({ tenantId: t });
    }), Ba = [];
  } catch {
  }
}, registerUrlChangedEventListener: function() {
  if (!ld) {
    ld = !0;
    try {
      history.pushState = (t = history.pushState, function() {
        var r = t.apply(this, arguments);
        return window.dispatchEvent(new Event("pushstate")), window.dispatchEvent(new Event("urlchanged")), r;
      }), history.replaceState = ((r) => function() {
        var i = r.apply(this, arguments);
        return window.dispatchEvent(new Event("replacestate")), window.dispatchEvent(new Event("urlchanged")), i;
      })(history.replaceState), window.addEventListener("popstate", () => {
        window.dispatchEvent(new Event("urlchanged"));
      });
    } catch {
    }
    var t;
  }
}, logout: function({ method: t, redirect: r } = {}) {
  try {
    if (t === "saml")
      return function() {
        try {
          if (!ee.tokens.accessToken)
            throw new Error("Please log in to authorize your logout request.");
          const o = cd(function() {
            return Promise.resolve(Zn("/auth/saml/idp/token", { headers: { authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function({ data: s }) {
              window.location.assign(`${ee.baseUrl}auth/saml/idp/logout?tenant_id=${ee.tenantId}&token=${s.token}&uuid=${ee.user.userUuid}`);
            });
          }, function(s) {
            ar(s);
          });
          return Promise.resolve(o && o.then ? o.then(function() {
          }) : void 0);
        } catch (o) {
          return Promise.reject(o);
        }
      }();
    if (!ee.tokens.accessToken)
      return Promise.resolve(Qi());
    const i = cd(function() {
      return Promise.resolve(Zn("/auth/logout", { headers: { authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function({ data: o }) {
        Qi(), wh(r, o);
      });
    }, function() {
      Qi();
    });
    return Promise.resolve(i && i.then ? i.then(function() {
    }) : void 0);
  } catch (i) {
    return Promise.reject(i);
  }
}, mode: In, setMode: xh, refresh: (t, r, i) => {
  try {
    console.warn("Userfront.refresh() is deprecated and will be removed. Please use Userfront.tokens.refresh() instead.");
  } catch {
  }
  return Ss();
}, login: function({ method: t, userId: r, userUuid: i, email: o, username: s, emailOrUsername: c, phoneNumber: l, password: d, token: p, uuid: v, totpCode: w, backupCode: m, channel: b, verificationCode: x, providerId: E, redirect: _, handleUpstreamResponse: N, handleMfaRequired: U, handlePkceRequired: A, handleTokens: j, handleRedirect: R, options: F } = {}) {
  try {
    if (!t)
      throw new Error('Userfront.login called without "method" property.');
    switch (rd(), t) {
      case "apple":
      case "azure":
      case "facebook":
      case "github":
      case "google":
      case "linkedin":
      case "okta":
        return Promise.resolve(za({ provider: t, redirect: _ }));
      case "custom":
        return Promise.resolve(za({ provider: t, redirect: _, providerId: E }));
      case "password":
        return Promise.resolve(function({ email: B, username: $, emailOrUsername: H, password: te, redirect: G, handleUpstreamResponse: ve, handleMfaRequired: be, handlePkceRequired: xe, handleTokens: K, handleRedirect: ie, options: ae }) {
          try {
            return Promise.resolve(zo(function() {
              const se = { emailOrUsername: B || $ || H, password: te };
              ae && ae.noResetEmail && (se.options = { noResetEmail: !0 });
              const { tenantId: Re } = ee;
              return Promise.resolve($n(`/tenants/${Re}/auth/basic`, se, { headers: Qn(), params: Hi() })).then(function({ data: ct }) {
                return Si({ data: ct, redirect: G, handleUpstreamResponse: ve, handleMfaRequired: be, handlePkceRequired: xe, handleTokens: K, handleRedirect: ie });
              });
            }, function(se) {
              ar(se);
            }));
          } catch (se) {
            return Promise.reject(se);
          }
        }({ email: o, username: s, emailOrUsername: c, password: d, redirect: _, handleUpstreamResponse: N, handleMfaRequired: U, handlePkceRequired: A, handleTokens: j, handleRedirect: R, options: F }));
      case "password-migrate":
        return Promise.resolve(function({ email: B, username: $, emailOrUsername: H, password: te, redirect: G, handleUpstreamResponse: ve, handleMfaRequired: be, handlePkceRequired: xe, handleTokens: K, handleRedirect: ie, options: ae }) {
          try {
            return Promise.resolve(function(se, Re) {
              try {
                var ct = function() {
                  const oe = { emailOrUsername: B || $ || H, password: te };
                  ae && ae.noResetEmail && (oe.options = { noResetEmail: !0 });
                  const { tenantId: Q } = ee;
                  return Promise.resolve($n(`/tenants/${Q}/auth/password/migrate`, oe, { headers: Qn(), params: Hi() })).then(function({ data: we }) {
                    return Si({ data: we, redirect: G, handleUpstreamResponse: ve, handleMfaRequired: be, handlePkceRequired: xe, handleTokens: K, handleRedirect: ie });
                  });
                }();
              } catch (oe) {
                return Re(oe);
              }
              return ct && ct.then ? ct.then(void 0, Re) : ct;
            }(0, function(se) {
              ar(se);
            }));
          } catch (se) {
            return Promise.reject(se);
          }
        }({ email: o, username: s, emailOrUsername: c, password: d, redirect: _, handleUpstreamResponse: N, handleMfaRequired: U, handlePkceRequired: A, handleTokens: j, handleRedirect: R, options: F }));
      case "passwordless":
        return Promise.resolve(sd({ email: o }));
      case "link":
        return Promise.resolve(function({ token: B, uuid: $, redirect: H, handleUpstreamResponse: te, handleMfaRequired: G, handlePkceRequired: ve, handleTokens: be, handleRedirect: xe } = {}) {
          try {
            return Promise.resolve(tc(function() {
              if (B = B || dr("token"), $ = $ || dr("uuid"), !B || !$)
                return;
              const { tenantId: K } = ee;
              return Promise.resolve(Vo(`/tenants/${K}/auth/link`, { token: B, uuid: $ }, { headers: Qn(), params: Hi() })).then(function({ data: ie }) {
                return Si({ data: ie, redirect: H, handleUpstreamResponse: te, handleMfaRequired: G, handlePkceRequired: ve, handleTokens: be, handleRedirect: xe });
              });
            }, function(K) {
              ar(K);
            }));
          } catch (K) {
            return Promise.reject(K);
          }
        }({ token: p, uuid: v, redirect: _, handleUpstreamResponse: N, handleMfaRequired: U, handlePkceRequired: A, handleTokens: j, handleRedirect: R }));
      case "totp":
        return Promise.resolve(function({ totpCode: B, backupCode: $, userId: H, userUuid: te, emailOrUsername: G, email: ve, username: be, phoneNumber: xe, redirect: K, handleUpstreamResponse: ie, handleMfaRequired: ae, handlePkceRequired: se, handleTokens: Re, handleRedirect: ct } = {}) {
          try {
            return Promise.resolve(Eh(function() {
              const { tenantId: oe } = ee;
              return Promise.resolve($n(`/tenants/${oe}/auth/totp`, { totpCode: B, backupCode: $, userId: H, userUuid: te, emailOrUsername: G, email: ve, username: be, phoneNumber: xe }, { headers: Qn(), params: Hi() })).then(function({ data: Q }) {
                return Si({ data: Q, redirect: K, handleUpstreamResponse: ie, handleMfaRequired: ae, handlePkceRequired: se, handleTokens: Re, handleRedirect: ct });
              });
            }, function(oe) {
              ar(oe);
            }));
          } catch (oe) {
            return Promise.reject(oe);
          }
        }({ totpCode: w, backupCode: m, userId: r, userUuid: i, emailOrUsername: c, email: o, username: s, phoneNumber: l, redirect: _, handleUpstreamResponse: N, handleMfaRequired: U, handlePkceRequired: A, handleTokens: j, handleRedirect: R }));
      case "verificationCode":
        return Promise.resolve(function({ channel: B, verificationCode: $, email: H, phoneNumber: te, redirect: G, handleUpstreamResponse: ve, handleMfaRequired: be, handlePkceRequired: xe, handleTokens: K, handleRedirect: ie } = {}) {
          try {
            return Promise.resolve(Th(function() {
              Mh({ channel: B, phoneNumber: te, email: H });
              const { tenantId: ae } = ee;
              return Promise.resolve(Vo(`/tenants/${ae}/auth/code`, { channel: B, verificationCode: $, email: H, phoneNumber: te }, { headers: Qn(), params: Hi() })).then(function({ data: se }) {
                return Si({ data: se, redirect: G, handleUpstreamResponse: ve, handleMfaRequired: be, handlePkceRequired: xe, handleTokens: K, handleRedirect: ie });
              });
            }, function(ae) {
              ar(ae);
            }));
          } catch (ae) {
            return Promise.reject(ae);
          }
        }({ channel: b, email: o, phoneNumber: l, verificationCode: x, redirect: _, handleUpstreamResponse: N, handleMfaRequired: U, handlePkceRequired: A, handleTokens: j, handleRedirect: R }));
      case "saml":
        return Promise.resolve(function() {
          try {
            return Promise.resolve(function(B, $) {
              try {
                var H = ee.tokens.accessToken ? Promise.resolve(Zn("/auth/saml/idp/token", { headers: { authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function({ data: te }) {
                  window.location.assign(`${ee.baseUrl}auth/saml/idp/login?tenant_id=${ee.tenantId}&token=${te.token}&uuid=${ee.user.userUuid}`);
                }) : console.warn("Cannot complete SAML login without access token");
              } catch (te) {
                return $(te);
              }
              return H && H.then ? H.then(void 0, $) : H;
            }(0, function(B) {
              ar(B);
            }));
          } catch (B) {
            return Promise.reject(B);
          }
        }());
      default:
        throw new Error('Userfront.login called with invalid "method" property.');
    }
  } catch (B) {
    return Promise.reject(B);
  }
}, resetPassword: L1, updatePassword: Tc, sendLoginLink: function(t) {
  try {
    return Promise.resolve(tc(function() {
      const { tenantId: r } = ee;
      return Promise.resolve($n(`/tenants/${r}/auth/link`, { email: t })).then(function({ data: i }) {
        return i;
      });
    }, function(r) {
      ar(r);
    }));
  } catch (r) {
    return Promise.reject(r);
  }
}, sendResetLink: function(t) {
  try {
    return Promise.resolve(zo(function() {
      const { tenantId: r } = ee;
      return Promise.resolve($n(`/tenants/${r}/auth/reset/link`, { email: t })).then(function({ data: i }) {
        return i;
      });
    }, function(r) {
      ar(r);
    }));
  } catch (r) {
    return Promise.reject(r);
  }
}, sendVerificationCode: ud, signup: function({ method: t, email: r, username: i, phoneNumber: o, name: s, data: c, password: l, channel: d, providerId: p, redirect: v, handleUpstreamResponse: w, handleMfaRequired: m, handlePkceRequired: b, handleTokens: x, handleRedirect: E } = {}) {
  try {
    if (rd(), !t)
      throw new Error('Userfront.signup called without "method" property.');
    switch (t) {
      case "apple":
      case "azure":
      case "facebook":
      case "github":
      case "google":
      case "linkedin":
      case "okta":
        return Promise.resolve(za({ provider: t, redirect: v }));
      case "custom":
        return Promise.resolve(za({ provider: t, redirect: v, providerId: p }));
      case "password":
        return Promise.resolve(function({ username: _, name: N, email: U, password: A, userData: j, redirect: R, handleUpstreamResponse: F, handleMfaRequired: B, handlePkceRequired: $, handleTokens: H, handleRedirect: te } = {}) {
          try {
            return Promise.resolve(zo(function() {
              const { tenantId: G } = ee;
              return Promise.resolve($n(`/tenants/${G}/auth/create`, { username: _, name: N, email: U, password: A, data: j }, { headers: Qn(), params: Hi() })).then(function({ data: ve }) {
                return Si({ data: ve, redirect: R, handleUpstreamResponse: F, handleMfaRequired: B, handlePkceRequired: $, handleTokens: H, handleRedirect: te });
              });
            }, function(G) {
              ar(G);
            }));
          } catch (G) {
            return Promise.reject(G);
          }
        }({ username: i, name: s, email: r, password: l, userData: c, redirect: v, handleUpstreamResponse: w, handleMfaRequired: m, handlePkceRequired: b, handleTokens: x, handleRedirect: E }));
      case "passwordless":
        return Promise.resolve(sd({ email: r, name: s, username: i, userData: c }));
      case "verificationCode":
        return Promise.resolve(ud({ channel: d, email: r, phoneNumber: o, name: s, username: i, data: c }));
      default:
        throw new Error('Userfront.signup called with invalid "method" property.');
    }
  } catch (_) {
    return Promise.reject(_);
  }
}, store: ee, tokens: O1, accessToken: function() {
  return ee.tokens.accessToken = uo.get(ee.tokens.accessTokenName), ee.tokens.accessToken;
}, idToken: function() {
  return ee.tokens.idToken = uo.get(ee.tokens.idTokenName), ee.tokens.idToken;
}, getSession: Ru, redirectIfLoggedIn: function({ redirect: t } = {}) {
  try {
    return Promise.resolve(Ru()).then(function({ isLoggedIn: r }) {
      if (!r)
        return Qi();
      if (Xn.usePkce)
        return;
      if (t)
        return to(t);
      if (dr("redirect"))
        return to(dr("redirect"));
      const i = function(o, s) {
        try {
          var c = Promise.resolve(Zn("/self", { headers: { authorization: `Bearer ${ee.tokens.accessToken}` } })).then(function({ data: l }) {
            l.tenant && l.tenant.loginRedirectPath && to(l.tenant.loginRedirectPath);
          });
        } catch {
          return s();
        }
        return c && c.then ? c.then(void 0, s) : c;
      }(0, function() {
        Qi();
      });
      return i && i.then ? i.then(function() {
      }) : void 0;
    });
  } catch (r) {
    return Promise.reject(r);
  }
}, redirectIfLoggedOut: function({ redirect: t } = {}) {
  try {
    return Promise.resolve(Ru()).then(function({ isLoggedIn: r }) {
      if (!r)
        return Qi(), t ? to(t) : dr("redirect") ? to(dr("redirect")) : void 0;
    });
  } catch (r) {
    return Promise.reject(r);
  }
}, user: C1 }, Ts = { exports: {} }, Io = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fd;
function I1() {
  if (fd)
    return Io;
  fd = 1;
  var t = en, r = Symbol.for("react.element"), i = Symbol.for("react.fragment"), o = Object.prototype.hasOwnProperty, s = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, c = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(d, p, v) {
    var w, m = {}, b = null, x = null;
    v !== void 0 && (b = "" + v), p.key !== void 0 && (b = "" + p.key), p.ref !== void 0 && (x = p.ref);
    for (w in p)
      o.call(p, w) && !c.hasOwnProperty(w) && (m[w] = p[w]);
    if (d && d.defaultProps)
      for (w in p = d.defaultProps, p)
        m[w] === void 0 && (m[w] = p[w]);
    return { $$typeof: r, type: d, key: b, ref: x, props: m, _owner: s.current };
  }
  return Io.Fragment = i, Io.jsx = l, Io.jsxs = l, Io;
}
var jo = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dd;
function j1() {
  return dd || (dd = 1, process.env.NODE_ENV !== "production" && function() {
    var t = en, r = Symbol.for("react.element"), i = Symbol.for("react.portal"), o = Symbol.for("react.fragment"), s = Symbol.for("react.strict_mode"), c = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), p = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), m = Symbol.for("react.memo"), b = Symbol.for("react.lazy"), x = Symbol.for("react.offscreen"), E = Symbol.iterator, _ = "@@iterator";
    function N(M) {
      if (M === null || typeof M != "object")
        return null;
      var X = E && M[E] || M[_];
      return typeof X == "function" ? X : null;
    }
    var U = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function A(M) {
      {
        for (var X = arguments.length, ue = new Array(X > 1 ? X - 1 : 0), Ce = 1; Ce < X; Ce++)
          ue[Ce - 1] = arguments[Ce];
        j("error", M, ue);
      }
    }
    function j(M, X, ue) {
      {
        var Ce = U.ReactDebugCurrentFrame, He = Ce.getStackAddendum();
        He !== "" && (X += "%s", ue = ue.concat([He]));
        var Xe = ue.map(function(Ye) {
          return String(Ye);
        });
        Xe.unshift("Warning: " + X), Function.prototype.apply.call(console[M], console, Xe);
      }
    }
    var R = !1, F = !1, B = !1, $ = !1, H = !1, te;
    te = Symbol.for("react.module.reference");
    function G(M) {
      return !!(typeof M == "string" || typeof M == "function" || M === o || M === c || H || M === s || M === v || M === w || $ || M === x || R || F || B || typeof M == "object" && M !== null && (M.$$typeof === b || M.$$typeof === m || M.$$typeof === l || M.$$typeof === d || M.$$typeof === p || M.$$typeof === te || M.getModuleId !== void 0));
    }
    function ve(M, X, ue) {
      var Ce = M.displayName;
      if (Ce)
        return Ce;
      var He = X.displayName || X.name || "";
      return He !== "" ? ue + "(" + He + ")" : ue;
    }
    function be(M) {
      return M.displayName || "Context";
    }
    function xe(M) {
      if (M == null)
        return null;
      if (typeof M.tag == "number" && A("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof M == "function")
        return M.displayName || M.name || null;
      if (typeof M == "string")
        return M;
      switch (M) {
        case o:
          return "Fragment";
        case i:
          return "Portal";
        case c:
          return "Profiler";
        case s:
          return "StrictMode";
        case v:
          return "Suspense";
        case w:
          return "SuspenseList";
      }
      if (typeof M == "object")
        switch (M.$$typeof) {
          case d:
            var X = M;
            return be(X) + ".Consumer";
          case l:
            var ue = M;
            return be(ue._context) + ".Provider";
          case p:
            return ve(M, M.render, "ForwardRef");
          case m:
            var Ce = M.displayName || null;
            return Ce !== null ? Ce : xe(M.type) || "Memo";
          case b: {
            var He = M, Xe = He._payload, Ye = He._init;
            try {
              return xe(Ye(Xe));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var K = Object.assign, ie = 0, ae, se, Re, ct, oe, Q, we;
    function ke() {
    }
    ke.__reactDisabledLog = !0;
    function ne() {
      {
        if (ie === 0) {
          ae = console.log, se = console.info, Re = console.warn, ct = console.error, oe = console.group, Q = console.groupCollapsed, we = console.groupEnd;
          var M = {
            configurable: !0,
            enumerable: !0,
            value: ke,
            writable: !0
          };
          Object.defineProperties(console, {
            info: M,
            log: M,
            warn: M,
            error: M,
            group: M,
            groupCollapsed: M,
            groupEnd: M
          });
        }
        ie++;
      }
    }
    function S() {
      {
        if (ie--, ie === 0) {
          var M = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: K({}, M, {
              value: ae
            }),
            info: K({}, M, {
              value: se
            }),
            warn: K({}, M, {
              value: Re
            }),
            error: K({}, M, {
              value: ct
            }),
            group: K({}, M, {
              value: oe
            }),
            groupCollapsed: K({}, M, {
              value: Q
            }),
            groupEnd: K({}, M, {
              value: we
            })
          });
        }
        ie < 0 && A("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Be = U.ReactCurrentDispatcher, Ue;
    function Ie(M, X, ue) {
      {
        if (Ue === void 0)
          try {
            throw Error();
          } catch (He) {
            var Ce = He.stack.trim().match(/\n( *(at )?)/);
            Ue = Ce && Ce[1] || "";
          }
        return `
` + Ue + M;
      }
    }
    var it = !1, lt;
    {
      var dt = typeof WeakMap == "function" ? WeakMap : Map;
      lt = new dt();
    }
    function ht(M, X) {
      if (!M || it)
        return "";
      {
        var ue = lt.get(M);
        if (ue !== void 0)
          return ue;
      }
      var Ce;
      it = !0;
      var He = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Xe;
      Xe = Be.current, Be.current = null, ne();
      try {
        if (X) {
          var Ye = function() {
            throw Error();
          };
          if (Object.defineProperty(Ye.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(Ye, []);
            } catch (he) {
              Ce = he;
            }
            Reflect.construct(M, [], Ye);
          } else {
            try {
              Ye.call();
            } catch (he) {
              Ce = he;
            }
            M.call(Ye.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (he) {
            Ce = he;
          }
          M();
        }
      } catch (he) {
        if (he && Ce && typeof he.stack == "string") {
          for (var Ve = he.stack.split(`
`), Dt = Ce.stack.split(`
`), Ot = Ve.length - 1, y = Dt.length - 1; Ot >= 1 && y >= 0 && Ve[Ot] !== Dt[y]; )
            y--;
          for (; Ot >= 1 && y >= 0; Ot--, y--)
            if (Ve[Ot] !== Dt[y]) {
              if (Ot !== 1 || y !== 1)
                do
                  if (Ot--, y--, y < 0 || Ve[Ot] !== Dt[y]) {
                    var I = `
` + Ve[Ot].replace(" at new ", " at ");
                    return M.displayName && I.includes("<anonymous>") && (I = I.replace("<anonymous>", M.displayName)), typeof M == "function" && lt.set(M, I), I;
                  }
                while (Ot >= 1 && y >= 0);
              break;
            }
        }
      } finally {
        it = !1, Be.current = Xe, S(), Error.prepareStackTrace = He;
      }
      var W = M ? M.displayName || M.name : "", re = W ? Ie(W) : "";
      return typeof M == "function" && lt.set(M, re), re;
    }
    function Nt(M, X, ue) {
      return ht(M, !1);
    }
    function Qe(M) {
      var X = M.prototype;
      return !!(X && X.isReactComponent);
    }
    function k(M, X, ue) {
      if (M == null)
        return "";
      if (typeof M == "function")
        return ht(M, Qe(M));
      if (typeof M == "string")
        return Ie(M);
      switch (M) {
        case v:
          return Ie("Suspense");
        case w:
          return Ie("SuspenseList");
      }
      if (typeof M == "object")
        switch (M.$$typeof) {
          case p:
            return Nt(M.render);
          case m:
            return k(M.type, X, ue);
          case b: {
            var Ce = M, He = Ce._payload, Xe = Ce._init;
            try {
              return k(Xe(He), X, ue);
            } catch {
            }
          }
        }
      return "";
    }
    var J = Object.prototype.hasOwnProperty, ce = {}, Oe = U.ReactDebugCurrentFrame;
    function Se(M) {
      if (M) {
        var X = M._owner, ue = k(M.type, M._source, X ? X.type : null);
        Oe.setExtraStackFrame(ue);
      } else
        Oe.setExtraStackFrame(null);
    }
    function _e(M, X, ue, Ce, He) {
      {
        var Xe = Function.call.bind(J);
        for (var Ye in M)
          if (Xe(M, Ye)) {
            var Ve = void 0;
            try {
              if (typeof M[Ye] != "function") {
                var Dt = Error((Ce || "React class") + ": " + ue + " type `" + Ye + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof M[Ye] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Dt.name = "Invariant Violation", Dt;
              }
              Ve = M[Ye](X, Ye, Ce, ue, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (Ot) {
              Ve = Ot;
            }
            Ve && !(Ve instanceof Error) && (Se(He), A("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Ce || "React class", ue, Ye, typeof Ve), Se(null)), Ve instanceof Error && !(Ve.message in ce) && (ce[Ve.message] = !0, Se(He), A("Failed %s type: %s", ue, Ve.message), Se(null));
          }
      }
    }
    var Ee = Array.isArray;
    function qe(M) {
      return Ee(M);
    }
    function de(M) {
      {
        var X = typeof Symbol == "function" && Symbol.toStringTag, ue = X && M[Symbol.toStringTag] || M.constructor.name || "Object";
        return ue;
      }
    }
    function Te(M) {
      try {
        return je(M), !1;
      } catch {
        return !0;
      }
    }
    function je(M) {
      return "" + M;
    }
    function ge(M) {
      if (Te(M))
        return A("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", de(M)), je(M);
    }
    var pe = U.ReactCurrentOwner, ot = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, qt, At, Yt;
    Yt = {};
    function tr(M) {
      if (J.call(M, "ref")) {
        var X = Object.getOwnPropertyDescriptor(M, "ref").get;
        if (X && X.isReactWarning)
          return !1;
      }
      return M.ref !== void 0;
    }
    function br(M) {
      if (J.call(M, "key")) {
        var X = Object.getOwnPropertyDescriptor(M, "key").get;
        if (X && X.isReactWarning)
          return !1;
      }
      return M.key !== void 0;
    }
    function xt(M, X) {
      if (typeof M.ref == "string" && pe.current && X && pe.current.stateNode !== X) {
        var ue = xe(pe.current.type);
        Yt[ue] || (A('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', xe(pe.current.type), M.ref), Yt[ue] = !0);
      }
    }
    function Or(M, X) {
      {
        var ue = function() {
          qt || (qt = !0, A("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", X));
        };
        ue.isReactWarning = !0, Object.defineProperty(M, "key", {
          get: ue,
          configurable: !0
        });
      }
    }
    function qr(M, X) {
      {
        var ue = function() {
          At || (At = !0, A("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", X));
        };
        ue.isReactWarning = !0, Object.defineProperty(M, "ref", {
          get: ue,
          configurable: !0
        });
      }
    }
    var pn = function(M, X, ue, Ce, He, Xe, Ye) {
      var Ve = {
        $$typeof: r,
        type: M,
        key: X,
        ref: ue,
        props: Ye,
        _owner: Xe
      };
      return Ve._store = {}, Object.defineProperty(Ve._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Ve, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Ce
      }), Object.defineProperty(Ve, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: He
      }), Object.freeze && (Object.freeze(Ve.props), Object.freeze(Ve)), Ve;
    };
    function gn(M, X, ue, Ce, He) {
      {
        var Xe, Ye = {}, Ve = null, Dt = null;
        ue !== void 0 && (ge(ue), Ve = "" + ue), br(X) && (ge(X.key), Ve = "" + X.key), tr(X) && (Dt = X.ref, xt(X, He));
        for (Xe in X)
          J.call(X, Xe) && !ot.hasOwnProperty(Xe) && (Ye[Xe] = X[Xe]);
        if (M && M.defaultProps) {
          var Ot = M.defaultProps;
          for (Xe in Ot)
            Ye[Xe] === void 0 && (Ye[Xe] = Ot[Xe]);
        }
        if (Ve || Dt) {
          var y = typeof M == "function" ? M.displayName || M.name || "Unknown" : M;
          Ve && Or(Ye, y), Dt && qr(Ye, y);
        }
        return pn(M, Ve, Dt, He, Ce, pe.current, Ye);
      }
    }
    var Yr = U.ReactCurrentOwner, _i = U.ReactDebugCurrentFrame;
    function Vr(M) {
      if (M) {
        var X = M._owner, ue = k(M.type, M._source, X ? X.type : null);
        _i.setExtraStackFrame(ue);
      } else
        _i.setExtraStackFrame(null);
    }
    var mn;
    mn = !1;
    function Dn(M) {
      return typeof M == "object" && M !== null && M.$$typeof === r;
    }
    function vn() {
      {
        if (Yr.current) {
          var M = xe(Yr.current.type);
          if (M)
            return `

Check the render method of \`` + M + "`.";
        }
        return "";
      }
    }
    function nn(M) {
      {
        if (M !== void 0) {
          var X = M.fileName.replace(/^.*[\\\/]/, ""), ue = M.lineNumber;
          return `

Check your code at ` + X + ":" + ue + ".";
        }
        return "";
      }
    }
    var Sr = {};
    function ii(M) {
      {
        var X = vn();
        if (!X) {
          var ue = typeof M == "string" ? M : M.displayName || M.name;
          ue && (X = `

Check the top-level render call using <` + ue + ">.");
        }
        return X;
      }
    }
    function yn(M, X) {
      {
        if (!M._store || M._store.validated || M.key != null)
          return;
        M._store.validated = !0;
        var ue = ii(X);
        if (Sr[ue])
          return;
        Sr[ue] = !0;
        var Ce = "";
        M && M._owner && M._owner !== Yr.current && (Ce = " It was passed a child from " + xe(M._owner.type) + "."), Vr(M), A('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ue, Ce), Vr(null);
      }
    }
    function oi(M, X) {
      {
        if (typeof M != "object")
          return;
        if (qe(M))
          for (var ue = 0; ue < M.length; ue++) {
            var Ce = M[ue];
            Dn(Ce) && yn(Ce, X);
          }
        else if (Dn(M))
          M._store && (M._store.validated = !0);
        else if (M) {
          var He = N(M);
          if (typeof He == "function" && He !== M.entries)
            for (var Xe = He.call(M), Ye; !(Ye = Xe.next()).done; )
              Dn(Ye.value) && yn(Ye.value, X);
        }
      }
    }
    function Ni(M) {
      {
        var X = M.type;
        if (X == null || typeof X == "string")
          return;
        var ue;
        if (typeof X == "function")
          ue = X.propTypes;
        else if (typeof X == "object" && (X.$$typeof === p || X.$$typeof === m))
          ue = X.propTypes;
        else
          return;
        if (ue) {
          var Ce = xe(X);
          _e(ue, M.props, "prop", Ce, M);
        } else if (X.PropTypes !== void 0 && !mn) {
          mn = !0;
          var He = xe(X);
          A("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", He || "Unknown");
        }
        typeof X.getDefaultProps == "function" && !X.getDefaultProps.isReactClassApproved && A("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function ai(M) {
      {
        for (var X = Object.keys(M.props), ue = 0; ue < X.length; ue++) {
          var Ce = X[ue];
          if (Ce !== "children" && Ce !== "key") {
            Vr(M), A("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Ce), Vr(null);
            break;
          }
        }
        M.ref !== null && (Vr(M), A("Invalid attribute `ref` supplied to `React.Fragment`."), Vr(null));
      }
    }
    function wn(M, X, ue, Ce, He, Xe) {
      {
        var Ye = G(M);
        if (!Ye) {
          var Ve = "";
          (M === void 0 || typeof M == "object" && M !== null && Object.keys(M).length === 0) && (Ve += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var Dt = nn(He);
          Dt ? Ve += Dt : Ve += vn();
          var Ot;
          M === null ? Ot = "null" : qe(M) ? Ot = "array" : M !== void 0 && M.$$typeof === r ? (Ot = "<" + (xe(M.type) || "Unknown") + " />", Ve = " Did you accidentally export a JSX literal instead of a component?") : Ot = typeof M, A("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ot, Ve);
        }
        var y = gn(M, X, ue, He, Xe);
        if (y == null)
          return y;
        if (Ye) {
          var I = X.children;
          if (I !== void 0)
            if (Ce)
              if (qe(I)) {
                for (var W = 0; W < I.length; W++)
                  oi(I[W], M);
                Object.freeze && Object.freeze(I);
              } else
                A("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              oi(I, M);
        }
        return M === o ? ai(y) : Ni(y), y;
      }
    }
    function Tr(M, X, ue) {
      return wn(M, X, ue, !0);
    }
    function si(M, X, ue) {
      return wn(M, X, ue, !1);
    }
    var Oi = si, Li = Tr;
    jo.Fragment = o, jo.jsx = Oi, jo.jsxs = Li;
  }()), jo;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = I1() : t.exports = j1();
})(Ts);
const ho = Ts.exports.Fragment, D = Ts.exports.jsx, $e = Ts.exports.jsxs, ni = ({
  children: t,
  ...r
}) => /* @__PURE__ */ D("button", {
  className: "userfront-button userfront-button-primary",
  type: "submit",
  ...r,
  children: t || "Submit"
}), kn = ({
  onEvent: t,
  onClick: r,
  children: i,
  ...o
}) => /* @__PURE__ */ D("button", {
  className: "userfront-button userfront-button-secondary",
  type: "button",
  ...o,
  onClick: (l) => {
    t && t({
      type: "back"
    }), r && r(l);
  },
  children: i || "Back"
}), rn = ({
  error: t
}) => {
  const r = ["userfront-error"], i = !!t;
  i && r.push("userfront-has-error");
  const o = (t == null ? void 0 : t.message) || "An unknown error has occurred. Please try again later.";
  return /* @__PURE__ */ D("div", {
    className: r.join(" "),
    role: "alert",
    children: i && /* @__PURE__ */ D("span", {
      className: "userfront-error-text",
      children: o
    })
  });
};
var Oh = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, hd = en.createContext && en.createContext(Oh), ei = globalThis && globalThis.__assign || function() {
  return ei = Object.assign || function(t) {
    for (var r, i = 1, o = arguments.length; i < o; i++) {
      r = arguments[i];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, ei.apply(this, arguments);
}, k1 = globalThis && globalThis.__rest || function(t, r) {
  var i = {};
  for (var o in t)
    Object.prototype.hasOwnProperty.call(t, o) && r.indexOf(o) < 0 && (i[o] = t[o]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(t); s < o.length; s++)
      r.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[s]) && (i[o[s]] = t[o[s]]);
  return i;
};
function Lh(t) {
  return t && t.map(function(r, i) {
    return en.createElement(r.tag, ei({
      key: i
    }, r.attr), Lh(r.child));
  });
}
function xi(t) {
  return function(r) {
    return /* @__PURE__ */ D(D1, {
      ...ei({
        attr: ei({}, t.attr)
      }, r),
      children: Lh(t.child)
    });
  };
}
function D1(t) {
  var r = function(i) {
    var o = t.attr, s = t.size, c = t.title, l = k1(t, ["attr", "size", "title"]), d = s || i.size || "1em", p;
    return i.className && (p = i.className), t.className && (p = (p ? p + " " : "") + t.className), /* @__PURE__ */ $e("svg", {
      ...ei({
        stroke: "currentColor",
        fill: "currentColor",
        strokeWidth: "0"
      }, i.attr, o, l, {
        className: p,
        style: ei(ei({
          color: t.color || i.color
        }, i.style), t.style),
        height: d,
        width: d,
        xmlns: "http://www.w3.org/2000/svg"
      }),
      children: [c && /* @__PURE__ */ D("title", {
        children: c
      }), t.children]
    });
  };
  return hd !== void 0 ? /* @__PURE__ */ D(hd.Consumer, {
    children: function(i) {
      return r(i);
    }
  }) : r(Oh);
}
function R1(t) {
  return xi({ tag: "svg", attr: { viewBox: "0 0 640 512" }, child: [{ tag: "path", attr: { d: "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z" } }] })(t);
}
function P1(t) {
  return xi({ tag: "svg", attr: { viewBox: "0 0 576 512" }, child: [{ tag: "path", attr: { d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z" } }] })(t);
}
function Ci({
  label: t,
  showError: r = !1,
  errorMessage: i = "Required field",
  isPassword: o = !1,
  ...s
} = {}) {
  const [c, l] = Qt(o);
  return /* @__PURE__ */ $e("div", {
    className: "userfront-password-input-container",
    children: [t && /* @__PURE__ */ D("label", {
      htmlFor: s.name,
      children: t
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-input-container",
      children: [/* @__PURE__ */ D("input", {
        type: c ? "password" : "text",
        className: `userfront-input ${r ? "userfront-input-error" : ""}`,
        ...s
      }), o && /* @__PURE__ */ D("div", {
        className: "userfront-password-toggle",
        onClick: () => l(!c),
        children: c ? /* @__PURE__ */ D(P1, {
          size: "15px"
        }) : /* @__PURE__ */ D(R1, {
          size: "15px"
        })
      })]
    }), r && /* @__PURE__ */ D("div", {
      className: "userfront-input-error-message",
      children: i
    })]
  });
}
function F1({
  label: t = "Email address",
  placeholder: r,
  showError: i,
  errorMessage: o = "Please enter your email address"
}) {
  return /* @__PURE__ */ D(Ci, {
    label: t,
    type: "email",
    name: "email",
    placeholder: r,
    showError: i,
    errorMessage: o
  });
}
function U1({
  label: t = "Email address or username",
  placeholder: r,
  showError: i,
  errorMessage: o = "Please enter your email or username"
}) {
  return /* @__PURE__ */ D(Ci, {
    label: t,
    type: "text",
    name: "emailOrUsername",
    placeholder: r,
    showError: i,
    errorMessage: o
  });
}
function z1({
  label: t = "Choose a password",
  showError: r,
  errorMessage: i = "Please enter your password",
  ...o
}) {
  return /* @__PURE__ */ D(Ci, {
    isPassword: !0,
    name: "password",
    "aria-describedby": "userfront-password-rules",
    showError: r,
    errorMessage: i,
    label: t,
    ...o
  });
}
function B1({
  label: t = "Six-digit code from your authenticator app or device",
  placeholder: r,
  showError: i,
  errorMessage: o = "Please enter your six-digit code"
}) {
  return /* @__PURE__ */ D(Ci, {
    label: t,
    type: "tel",
    name: "totpCode",
    placeholder: r,
    showError: i,
    errorMessage: o
  });
}
function W1({
  label: t = "Backup code",
  placeholder: r,
  showError: i,
  errorMessage: o = "Please enter your backup code"
}) {
  return /* @__PURE__ */ D(Ci, {
    label: t,
    type: "tel",
    name: "backupCode",
    placeholder: r,
    showError: i,
    errorMessage: o
  });
}
function q1({
  label: t = "Enter your code",
  placeholder: r,
  showError: i,
  errorMessage: o = "Please enter your verification code"
}) {
  return /* @__PURE__ */ D(Ci, {
    label: t,
    type: "tel",
    name: "verificationCode",
    placeholder: r,
    showError: i,
    errorMessage: o
  });
}
class $t extends ub {
  render() {
    return Ci(this.props);
  }
}
bi($t, "Email", F1), bi($t, "EmailOrUsername", U1), bi($t, "Password", z1), bi($t, "TotpCode", B1), bi($t, "BackupCode", W1), bi($t, "VerificationCode", q1);
const Wa = ({
  onEvent: t,
  allowBack: r,
  error: i
}) => {
  const [o, s] = Qt(!1);
  return /* @__PURE__ */ $e("form", {
    onSubmit: (l) => {
      l.preventDefault();
      const d = l.target.elements.email.value;
      s(!d), !!d && t && !o && t({
        type: "submit",
        email: d
      });
    },
    className: "userfront-form",
    children: [/* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.Email, {
        showError: o
      })
    }), /* @__PURE__ */ D(rn, {
      error: i
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-button-row",
      children: [r && /* @__PURE__ */ D(kn, {
        onEvent: t
      }), /* @__PURE__ */ D(ni, {})]
    })]
  });
};
var pd = function(t) {
  var r = {};
  function i(o) {
    if (r[o])
      return r[o].exports;
    var s = r[o] = { i: o, l: !1, exports: {} };
    return t[o].call(s.exports, s, s.exports, i), s.l = !0, s.exports;
  }
  return i.m = t, i.c = r, i.d = function(o, s, c) {
    i.o(o, s) || Object.defineProperty(o, s, { enumerable: !0, get: c });
  }, i.r = function(o) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(o, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(o, "__esModule", { value: !0 });
  }, i.t = function(o, s) {
    if (1 & s && (o = i(o)), 8 & s || 4 & s && typeof o == "object" && o && o.__esModule)
      return o;
    var c = /* @__PURE__ */ Object.create(null);
    if (i.r(c), Object.defineProperty(c, "default", { enumerable: !0, value: o }), 2 & s && typeof o != "string")
      for (var l in o)
        i.d(c, l, function(d) {
          return o[d];
        }.bind(null, l));
    return c;
  }, i.n = function(o) {
    var s = o && o.__esModule ? function() {
      return o.default;
    } : function() {
      return o;
    };
    return i.d(s, "a", s), s;
  }, i.o = function(o, s) {
    return Object.prototype.hasOwnProperty.call(o, s);
  }, i.p = "", i(i.s = 9);
}([function(t, r) {
  t.exports = en;
}, function(t, r, i) {
  var o;
  /*!
    Copyright (c) 2017 Jed Watson.
    Licensed under the MIT License (MIT), see
    http://jedwatson.github.io/classnames
  */
  (function() {
    var s = {}.hasOwnProperty;
    function c() {
      for (var l = [], d = 0; d < arguments.length; d++) {
        var p = arguments[d];
        if (p) {
          var v = typeof p;
          if (v === "string" || v === "number")
            l.push(p);
          else if (Array.isArray(p) && p.length) {
            var w = c.apply(null, p);
            w && l.push(w);
          } else if (v === "object")
            for (var m in p)
              s.call(p, m) && p[m] && l.push(m);
        }
      }
      return l.join(" ");
    }
    t.exports ? (c.default = c, t.exports = c) : (o = function() {
      return c;
    }.apply(r, [])) === void 0 || (t.exports = o);
  })();
}, function(t, r, i) {
  (function(o) {
    var s = /^\s+|\s+$/g, c = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, d = /^0o[0-7]+$/i, p = parseInt, v = typeof o == "object" && o && o.Object === Object && o, w = typeof self == "object" && self && self.Object === Object && self, m = v || w || Function("return this")(), b = Object.prototype.toString, x = m.Symbol, E = x ? x.prototype : void 0, _ = E ? E.toString : void 0;
    function N(R) {
      if (typeof R == "string")
        return R;
      if (A(R))
        return _ ? _.call(R) : "";
      var F = R + "";
      return F == "0" && 1 / R == -1 / 0 ? "-0" : F;
    }
    function U(R) {
      var F = typeof R;
      return !!R && (F == "object" || F == "function");
    }
    function A(R) {
      return typeof R == "symbol" || function(F) {
        return !!F && typeof F == "object";
      }(R) && b.call(R) == "[object Symbol]";
    }
    function j(R) {
      return R ? (R = function(F) {
        if (typeof F == "number")
          return F;
        if (A(F))
          return NaN;
        if (U(F)) {
          var B = typeof F.valueOf == "function" ? F.valueOf() : F;
          F = U(B) ? B + "" : B;
        }
        if (typeof F != "string")
          return F === 0 ? F : +F;
        F = F.replace(s, "");
        var $ = l.test(F);
        return $ || d.test(F) ? p(F.slice(2), $ ? 2 : 8) : c.test(F) ? NaN : +F;
      }(R)) === 1 / 0 || R === -1 / 0 ? 17976931348623157e292 * (R < 0 ? -1 : 1) : R == R ? R : 0 : R === 0 ? R : 0;
    }
    t.exports = function(R, F, B) {
      var $, H, te, G;
      return R = ($ = R) == null ? "" : N($), H = function(ve) {
        var be = j(ve), xe = be % 1;
        return be == be ? xe ? be - xe : be : 0;
      }(B), te = 0, G = R.length, H == H && (G !== void 0 && (H = H <= G ? H : G), te !== void 0 && (H = H >= te ? H : te)), B = H, F = N(F), R.slice(B, B + F.length) == F;
    };
  }).call(this, i(3));
}, function(t, r) {
  var i;
  i = function() {
    return this;
  }();
  try {
    i = i || new Function("return this")();
  } catch {
    typeof window == "object" && (i = window);
  }
  t.exports = i;
}, function(t, r, i) {
  (function(o) {
    var s = /^\[object .+?Constructor\]$/, c = typeof o == "object" && o && o.Object === Object && o, l = typeof self == "object" && self && self.Object === Object && self, d = c || l || Function("return this")(), p, v = Array.prototype, w = Function.prototype, m = Object.prototype, b = d["__core-js_shared__"], x = (p = /[^.]+$/.exec(b && b.keys && b.keys.IE_PROTO || "")) ? "Symbol(src)_1." + p : "", E = w.toString, _ = m.hasOwnProperty, N = m.toString, U = RegExp("^" + E.call(_).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), A = v.splice, j = ve(d, "Map"), R = ve(Object, "create");
    function F(K) {
      var ie = -1, ae = K ? K.length : 0;
      for (this.clear(); ++ie < ae; ) {
        var se = K[ie];
        this.set(se[0], se[1]);
      }
    }
    function B(K) {
      var ie = -1, ae = K ? K.length : 0;
      for (this.clear(); ++ie < ae; ) {
        var se = K[ie];
        this.set(se[0], se[1]);
      }
    }
    function $(K) {
      var ie = -1, ae = K ? K.length : 0;
      for (this.clear(); ++ie < ae; ) {
        var se = K[ie];
        this.set(se[0], se[1]);
      }
    }
    function H(K, ie) {
      for (var ae, se, Re = K.length; Re--; )
        if ((ae = K[Re][0]) === (se = ie) || ae != ae && se != se)
          return Re;
      return -1;
    }
    function te(K) {
      return !(!xe(K) || (ie = K, x && x in ie)) && (function(ae) {
        var se = xe(ae) ? N.call(ae) : "";
        return se == "[object Function]" || se == "[object GeneratorFunction]";
      }(K) || function(ae) {
        var se = !1;
        if (ae != null && typeof ae.toString != "function")
          try {
            se = !!(ae + "");
          } catch {
          }
        return se;
      }(K) ? U : s).test(function(ae) {
        if (ae != null) {
          try {
            return E.call(ae);
          } catch {
          }
          try {
            return ae + "";
          } catch {
          }
        }
        return "";
      }(K));
      var ie;
    }
    function G(K, ie) {
      var ae, se, Re = K.__data__;
      return ((se = typeof (ae = ie)) == "string" || se == "number" || se == "symbol" || se == "boolean" ? ae !== "__proto__" : ae === null) ? Re[typeof ie == "string" ? "string" : "hash"] : Re.map;
    }
    function ve(K, ie) {
      var ae = function(se, Re) {
        return se == null ? void 0 : se[Re];
      }(K, ie);
      return te(ae) ? ae : void 0;
    }
    function be(K, ie) {
      if (typeof K != "function" || ie && typeof ie != "function")
        throw new TypeError("Expected a function");
      var ae = function() {
        var se = arguments, Re = ie ? ie.apply(this, se) : se[0], ct = ae.cache;
        if (ct.has(Re))
          return ct.get(Re);
        var oe = K.apply(this, se);
        return ae.cache = ct.set(Re, oe), oe;
      };
      return ae.cache = new (be.Cache || $)(), ae;
    }
    function xe(K) {
      var ie = typeof K;
      return !!K && (ie == "object" || ie == "function");
    }
    F.prototype.clear = function() {
      this.__data__ = R ? R(null) : {};
    }, F.prototype.delete = function(K) {
      return this.has(K) && delete this.__data__[K];
    }, F.prototype.get = function(K) {
      var ie = this.__data__;
      if (R) {
        var ae = ie[K];
        return ae === "__lodash_hash_undefined__" ? void 0 : ae;
      }
      return _.call(ie, K) ? ie[K] : void 0;
    }, F.prototype.has = function(K) {
      var ie = this.__data__;
      return R ? ie[K] !== void 0 : _.call(ie, K);
    }, F.prototype.set = function(K, ie) {
      return this.__data__[K] = R && ie === void 0 ? "__lodash_hash_undefined__" : ie, this;
    }, B.prototype.clear = function() {
      this.__data__ = [];
    }, B.prototype.delete = function(K) {
      var ie = this.__data__, ae = H(ie, K);
      return !(ae < 0) && (ae == ie.length - 1 ? ie.pop() : A.call(ie, ae, 1), !0);
    }, B.prototype.get = function(K) {
      var ie = this.__data__, ae = H(ie, K);
      return ae < 0 ? void 0 : ie[ae][1];
    }, B.prototype.has = function(K) {
      return H(this.__data__, K) > -1;
    }, B.prototype.set = function(K, ie) {
      var ae = this.__data__, se = H(ae, K);
      return se < 0 ? ae.push([K, ie]) : ae[se][1] = ie, this;
    }, $.prototype.clear = function() {
      this.__data__ = { hash: new F(), map: new (j || B)(), string: new F() };
    }, $.prototype.delete = function(K) {
      return G(this, K).delete(K);
    }, $.prototype.get = function(K) {
      return G(this, K).get(K);
    }, $.prototype.has = function(K) {
      return G(this, K).has(K);
    }, $.prototype.set = function(K, ie) {
      return G(this, K).set(K, ie), this;
    }, be.Cache = $, t.exports = be;
  }).call(this, i(3));
}, function(t, r, i) {
  (function(o) {
    var s = /^\s+|\s+$/g, c = /^[-+]0x[0-9a-f]+$/i, l = /^0b[01]+$/i, d = /^0o[0-7]+$/i, p = parseInt, v = typeof o == "object" && o && o.Object === Object && o, w = typeof self == "object" && self && self.Object === Object && self, m = v || w || Function("return this")(), b = Object.prototype.toString, x = Math.max, E = Math.min, _ = function() {
      return m.Date.now();
    };
    function N(A) {
      var j = typeof A;
      return !!A && (j == "object" || j == "function");
    }
    function U(A) {
      if (typeof A == "number")
        return A;
      if (function(F) {
        return typeof F == "symbol" || function(B) {
          return !!B && typeof B == "object";
        }(F) && b.call(F) == "[object Symbol]";
      }(A))
        return NaN;
      if (N(A)) {
        var j = typeof A.valueOf == "function" ? A.valueOf() : A;
        A = N(j) ? j + "" : j;
      }
      if (typeof A != "string")
        return A === 0 ? A : +A;
      A = A.replace(s, "");
      var R = l.test(A);
      return R || d.test(A) ? p(A.slice(2), R ? 2 : 8) : c.test(A) ? NaN : +A;
    }
    t.exports = function(A, j, R) {
      var F, B, $, H, te, G, ve = 0, be = !1, xe = !1, K = !0;
      if (typeof A != "function")
        throw new TypeError("Expected a function");
      function ie(Q) {
        var we = F, ke = B;
        return F = B = void 0, ve = Q, H = A.apply(ke, we);
      }
      function ae(Q) {
        return ve = Q, te = setTimeout(Re, j), be ? ie(Q) : H;
      }
      function se(Q) {
        var we = Q - G;
        return G === void 0 || we >= j || we < 0 || xe && Q - ve >= $;
      }
      function Re() {
        var Q = _();
        if (se(Q))
          return ct(Q);
        te = setTimeout(Re, function(we) {
          var ke = j - (we - G);
          return xe ? E(ke, $ - (we - ve)) : ke;
        }(Q));
      }
      function ct(Q) {
        return te = void 0, K && F ? ie(Q) : (F = B = void 0, H);
      }
      function oe() {
        var Q = _(), we = se(Q);
        if (F = arguments, B = this, G = Q, we) {
          if (te === void 0)
            return ae(G);
          if (xe)
            return te = setTimeout(Re, j), ie(G);
        }
        return te === void 0 && (te = setTimeout(Re, j)), H;
      }
      return j = U(j) || 0, N(R) && (be = !!R.leading, $ = (xe = "maxWait" in R) ? x(U(R.maxWait) || 0, j) : $, K = "trailing" in R ? !!R.trailing : K), oe.cancel = function() {
        te !== void 0 && clearTimeout(te), ve = 0, F = G = B = te = void 0;
      }, oe.flush = function() {
        return te === void 0 ? H : ct(_());
      }, oe;
    };
  }).call(this, i(3));
}, function(t, r, i) {
  (function(o, s) {
    var c = "[object Arguments]", l = "[object Map]", d = "[object Object]", p = "[object Set]", v = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, w = /^\w*$/, m = /^\./, b = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, x = /\\(\\)?/g, E = /^\[object .+?Constructor\]$/, _ = /^(?:0|[1-9]\d*)$/, N = {};
    N["[object Float32Array]"] = N["[object Float64Array]"] = N["[object Int8Array]"] = N["[object Int16Array]"] = N["[object Int32Array]"] = N["[object Uint8Array]"] = N["[object Uint8ClampedArray]"] = N["[object Uint16Array]"] = N["[object Uint32Array]"] = !0, N[c] = N["[object Array]"] = N["[object ArrayBuffer]"] = N["[object Boolean]"] = N["[object DataView]"] = N["[object Date]"] = N["[object Error]"] = N["[object Function]"] = N[l] = N["[object Number]"] = N[d] = N["[object RegExp]"] = N[p] = N["[object String]"] = N["[object WeakMap]"] = !1;
    var U = typeof o == "object" && o && o.Object === Object && o, A = typeof self == "object" && self && self.Object === Object && self, j = U || A || Function("return this")(), R = r && !r.nodeType && r, F = R && typeof s == "object" && s && !s.nodeType && s, B = F && F.exports === R && U.process, $ = function() {
      try {
        return B && B.binding("util");
      } catch {
      }
    }(), H = $ && $.isTypedArray;
    function te(y, I, W, re) {
      var he = -1, Me = y ? y.length : 0;
      for (re && Me && (W = y[++he]); ++he < Me; )
        W = I(W, y[he], he, y);
      return W;
    }
    function G(y, I) {
      for (var W = -1, re = y ? y.length : 0; ++W < re; )
        if (I(y[W], W, y))
          return !0;
      return !1;
    }
    function ve(y, I, W, re, he) {
      return he(y, function(Me, De, yt) {
        W = re ? (re = !1, Me) : I(W, Me, De, yt);
      }), W;
    }
    function be(y) {
      var I = !1;
      if (y != null && typeof y.toString != "function")
        try {
          I = !!(y + "");
        } catch {
        }
      return I;
    }
    function xe(y) {
      var I = -1, W = Array(y.size);
      return y.forEach(function(re, he) {
        W[++I] = [he, re];
      }), W;
    }
    function K(y) {
      var I = -1, W = Array(y.size);
      return y.forEach(function(re) {
        W[++I] = re;
      }), W;
    }
    var ie, ae, se, Re = Array.prototype, ct = Function.prototype, oe = Object.prototype, Q = j["__core-js_shared__"], we = (ie = /[^.]+$/.exec(Q && Q.keys && Q.keys.IE_PROTO || "")) ? "Symbol(src)_1." + ie : "", ke = ct.toString, ne = oe.hasOwnProperty, S = oe.toString, Be = RegExp("^" + ke.call(ne).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"), Ue = j.Symbol, Ie = j.Uint8Array, it = oe.propertyIsEnumerable, lt = Re.splice, dt = (ae = Object.keys, se = Object, function(y) {
      return ae(se(y));
    }), ht = nn(j, "DataView"), Nt = nn(j, "Map"), Qe = nn(j, "Promise"), k = nn(j, "Set"), J = nn(j, "WeakMap"), ce = nn(Object, "create"), Oe = Tr(ht), Se = Tr(Nt), _e = Tr(Qe), Ee = Tr(k), qe = Tr(J), de = Ue ? Ue.prototype : void 0, Te = de ? de.valueOf : void 0, je = de ? de.toString : void 0;
    function ge(y) {
      var I = -1, W = y ? y.length : 0;
      for (this.clear(); ++I < W; ) {
        var re = y[I];
        this.set(re[0], re[1]);
      }
    }
    function pe(y) {
      var I = -1, W = y ? y.length : 0;
      for (this.clear(); ++I < W; ) {
        var re = y[I];
        this.set(re[0], re[1]);
      }
    }
    function ot(y) {
      var I = -1, W = y ? y.length : 0;
      for (this.clear(); ++I < W; ) {
        var re = y[I];
        this.set(re[0], re[1]);
      }
    }
    function qt(y) {
      var I = -1, W = y ? y.length : 0;
      for (this.__data__ = new ot(); ++I < W; )
        this.add(y[I]);
    }
    function At(y) {
      this.__data__ = new pe(y);
    }
    function Yt(y, I) {
      var W = M(y) || Li(y) ? function(De, yt) {
        for (var St = -1, at = Array(De); ++St < De; )
          at[St] = yt(St);
        return at;
      }(y.length, String) : [], re = W.length, he = !!re;
      for (var Me in y)
        !I && !ne.call(y, Me) || he && (Me == "length" || ii(Me, re)) || W.push(Me);
      return W;
    }
    function tr(y, I) {
      for (var W = y.length; W--; )
        if (Oi(y[W][0], I))
          return W;
      return -1;
    }
    ge.prototype.clear = function() {
      this.__data__ = ce ? ce(null) : {};
    }, ge.prototype.delete = function(y) {
      return this.has(y) && delete this.__data__[y];
    }, ge.prototype.get = function(y) {
      var I = this.__data__;
      if (ce) {
        var W = I[y];
        return W === "__lodash_hash_undefined__" ? void 0 : W;
      }
      return ne.call(I, y) ? I[y] : void 0;
    }, ge.prototype.has = function(y) {
      var I = this.__data__;
      return ce ? I[y] !== void 0 : ne.call(I, y);
    }, ge.prototype.set = function(y, I) {
      return this.__data__[y] = ce && I === void 0 ? "__lodash_hash_undefined__" : I, this;
    }, pe.prototype.clear = function() {
      this.__data__ = [];
    }, pe.prototype.delete = function(y) {
      var I = this.__data__, W = tr(I, y);
      return !(W < 0) && (W == I.length - 1 ? I.pop() : lt.call(I, W, 1), !0);
    }, pe.prototype.get = function(y) {
      var I = this.__data__, W = tr(I, y);
      return W < 0 ? void 0 : I[W][1];
    }, pe.prototype.has = function(y) {
      return tr(this.__data__, y) > -1;
    }, pe.prototype.set = function(y, I) {
      var W = this.__data__, re = tr(W, y);
      return re < 0 ? W.push([y, I]) : W[re][1] = I, this;
    }, ot.prototype.clear = function() {
      this.__data__ = { hash: new ge(), map: new (Nt || pe)(), string: new ge() };
    }, ot.prototype.delete = function(y) {
      return vn(this, y).delete(y);
    }, ot.prototype.get = function(y) {
      return vn(this, y).get(y);
    }, ot.prototype.has = function(y) {
      return vn(this, y).has(y);
    }, ot.prototype.set = function(y, I) {
      return vn(this, y).set(y, I), this;
    }, qt.prototype.add = qt.prototype.push = function(y) {
      return this.__data__.set(y, "__lodash_hash_undefined__"), this;
    }, qt.prototype.has = function(y) {
      return this.__data__.has(y);
    }, At.prototype.clear = function() {
      this.__data__ = new pe();
    }, At.prototype.delete = function(y) {
      return this.__data__.delete(y);
    }, At.prototype.get = function(y) {
      return this.__data__.get(y);
    }, At.prototype.has = function(y) {
      return this.__data__.has(y);
    }, At.prototype.set = function(y, I) {
      var W = this.__data__;
      if (W instanceof pe) {
        var re = W.__data__;
        if (!Nt || re.length < 199)
          return re.push([y, I]), this;
        W = this.__data__ = new ot(re);
      }
      return W.set(y, I), this;
    };
    var br, xt = (br = function(y, I) {
      return y && Or(y, I, Dt);
    }, function(y, I) {
      if (y == null)
        return y;
      if (!X(y))
        return br(y, I);
      for (var W = y.length, re = -1, he = Object(y); ++re < W && I(he[re], re, he) !== !1; )
        ;
      return y;
    }), Or = function(y) {
      return function(I, W, re) {
        for (var he = -1, Me = Object(I), De = re(I), yt = De.length; yt--; ) {
          var St = De[y ? yt : ++he];
          if (W(Me[St], St, Me) === !1)
            break;
        }
        return I;
      };
    }();
    function qr(y, I) {
      for (var W = 0, re = (I = yn(I, y) ? [I] : mn(I)).length; y != null && W < re; )
        y = y[wn(I[W++])];
      return W && W == re ? y : void 0;
    }
    function pn(y, I) {
      return y != null && I in Object(y);
    }
    function gn(y, I, W, re, he) {
      return y === I || (y == null || I == null || !He(y) && !Xe(I) ? y != y && I != I : function(Me, De, yt, St, at, et) {
        var pr = M(Me), gr = M(De), Ct = "[object Array]", Pt = "[object Array]";
        pr || (Ct = (Ct = Sr(Me)) == c ? d : Ct), gr || (Pt = (Pt = Sr(De)) == c ? d : Pt);
        var rr = Ct == d && !be(Me), on = Pt == d && !be(De), Gr = Ct == Pt;
        if (Gr && !rr)
          return et || (et = new At()), pr || Ve(Me) ? Dn(Me, De, yt, St, at, et) : function(mt, pt, Ii, an, Rn, ur, Lr) {
            switch (Ii) {
              case "[object DataView]":
                if (mt.byteLength != pt.byteLength || mt.byteOffset != pt.byteOffset)
                  return !1;
                mt = mt.buffer, pt = pt.buffer;
              case "[object ArrayBuffer]":
                return !(mt.byteLength != pt.byteLength || !an(new Ie(mt), new Ie(pt)));
              case "[object Boolean]":
              case "[object Date]":
              case "[object Number]":
                return Oi(+mt, +pt);
              case "[object Error]":
                return mt.name == pt.name && mt.message == pt.message;
              case "[object RegExp]":
              case "[object String]":
                return mt == pt + "";
              case l:
                var Ar = xe;
              case p:
                var Sn = 2 & ur;
                if (Ar || (Ar = K), mt.size != pt.size && !Sn)
                  return !1;
                var Kr = Lr.get(mt);
                if (Kr)
                  return Kr == pt;
                ur |= 1, Lr.set(mt, pt);
                var Tn = Dn(Ar(mt), Ar(pt), an, Rn, ur, Lr);
                return Lr.delete(mt), Tn;
              case "[object Symbol]":
                if (Te)
                  return Te.call(mt) == Te.call(pt);
            }
            return !1;
          }(Me, De, Ct, yt, St, at, et);
        if (!(2 & at)) {
          var bn = rr && ne.call(Me, "__wrapped__"), Jo = on && ne.call(De, "__wrapped__");
          if (bn || Jo) {
            var Zo = bn ? Me.value() : Me, Ai = Jo ? De.value() : De;
            return et || (et = new At()), yt(Zo, Ai, St, at, et);
          }
        }
        return Gr ? (et || (et = new At()), function(mt, pt, Ii, an, Rn, ur) {
          var Lr = 2 & Rn, Ar = Dt(mt), Sn = Ar.length, Kr = Dt(pt).length;
          if (Sn != Kr && !Lr)
            return !1;
          for (var Tn = Sn; Tn--; ) {
            var $r = Ar[Tn];
            if (!(Lr ? $r in pt : ne.call(pt, $r)))
              return !1;
          }
          var Xo = ur.get(mt);
          if (Xo && ur.get(pt))
            return Xo == pt;
          var ui = !0;
          ur.set(mt, pt), ur.set(pt, mt);
          for (var ji = Lr; ++Tn < Sn; ) {
            $r = Ar[Tn];
            var ci = mt[$r], li = pt[$r];
            if (an)
              var ea = Lr ? an(li, ci, $r, pt, mt, ur) : an(ci, li, $r, mt, pt, ur);
            if (!(ea === void 0 ? ci === li || Ii(ci, li, an, Rn, ur) : ea)) {
              ui = !1;
              break;
            }
            ji || (ji = $r == "constructor");
          }
          if (ui && !ji) {
            var ki = mt.constructor, Di = pt.constructor;
            ki == Di || !("constructor" in mt) || !("constructor" in pt) || typeof ki == "function" && ki instanceof ki && typeof Di == "function" && Di instanceof Di || (ui = !1);
          }
          return ur.delete(mt), ur.delete(pt), ui;
        }(Me, De, yt, St, at, et)) : !1;
      }(y, I, gn, W, re, he));
    }
    function Yr(y) {
      return !(!He(y) || function(I) {
        return !!we && we in I;
      }(y)) && (ue(y) || be(y) ? Be : E).test(Tr(y));
    }
    function _i(y) {
      return typeof y == "function" ? y : y == null ? Ot : typeof y == "object" ? M(y) ? function(re, he) {
        return yn(re) && oi(he) ? Ni(wn(re), he) : function(Me) {
          var De = function(yt, St, at) {
            var et = yt == null ? void 0 : qr(yt, St);
            return et === void 0 ? at : et;
          }(Me, re);
          return De === void 0 && De === he ? function(yt, St) {
            return yt != null && function(at, et, pr) {
              et = yn(et, at) ? [et] : mn(et);
              for (var gr, Ct = -1, Pt = et.length; ++Ct < Pt; ) {
                var rr = wn(et[Ct]);
                if (!(gr = at != null && pr(at, rr)))
                  break;
                at = at[rr];
              }
              return gr || !!(Pt = at ? at.length : 0) && Ce(Pt) && ii(rr, Pt) && (M(at) || Li(at));
            }(yt, St, pn);
          }(Me, re) : gn(he, De, void 0, 3);
        };
      }(y[0], y[1]) : function(re) {
        var he = function(Me) {
          for (var De = Dt(Me), yt = De.length; yt--; ) {
            var St = De[yt], at = Me[St];
            De[yt] = [St, at, oi(at)];
          }
          return De;
        }(re);
        return he.length == 1 && he[0][2] ? Ni(he[0][0], he[0][1]) : function(Me) {
          return Me === re || function(De, yt, St, at) {
            var et = St.length, pr = et, gr = !at;
            if (De == null)
              return !pr;
            for (De = Object(De); et--; ) {
              var Ct = St[et];
              if (gr && Ct[2] ? Ct[1] !== De[Ct[0]] : !(Ct[0] in De))
                return !1;
            }
            for (; ++et < pr; ) {
              var Pt = (Ct = St[et])[0], rr = De[Pt], on = Ct[1];
              if (gr && Ct[2]) {
                if (rr === void 0 && !(Pt in De))
                  return !1;
              } else {
                var Gr = new At();
                if (at)
                  var bn = at(rr, on, Pt, De, yt, Gr);
                if (!(bn === void 0 ? gn(on, rr, at, 3, Gr) : bn))
                  return !1;
              }
            }
            return !0;
          }(Me, re, he);
        };
      }(y) : yn(I = y) ? (W = wn(I), function(re) {
        return re == null ? void 0 : re[W];
      }) : function(re) {
        return function(he) {
          return qr(he, re);
        };
      }(I);
      var I, W;
    }
    function Vr(y) {
      if (W = (I = y) && I.constructor, re = typeof W == "function" && W.prototype || oe, I !== re)
        return dt(y);
      var I, W, re, he = [];
      for (var Me in Object(y))
        ne.call(y, Me) && Me != "constructor" && he.push(Me);
      return he;
    }
    function mn(y) {
      return M(y) ? y : ai(y);
    }
    function Dn(y, I, W, re, he, Me) {
      var De = 2 & he, yt = y.length, St = I.length;
      if (yt != St && !(De && St > yt))
        return !1;
      var at = Me.get(y);
      if (at && Me.get(I))
        return at == I;
      var et = -1, pr = !0, gr = 1 & he ? new qt() : void 0;
      for (Me.set(y, I), Me.set(I, y); ++et < yt; ) {
        var Ct = y[et], Pt = I[et];
        if (re)
          var rr = De ? re(Pt, Ct, et, I, y, Me) : re(Ct, Pt, et, y, I, Me);
        if (rr !== void 0) {
          if (rr)
            continue;
          pr = !1;
          break;
        }
        if (gr) {
          if (!G(I, function(on, Gr) {
            if (!gr.has(Gr) && (Ct === on || W(Ct, on, re, he, Me)))
              return gr.add(Gr);
          })) {
            pr = !1;
            break;
          }
        } else if (Ct !== Pt && !W(Ct, Pt, re, he, Me)) {
          pr = !1;
          break;
        }
      }
      return Me.delete(y), Me.delete(I), pr;
    }
    function vn(y, I) {
      var W, re, he = y.__data__;
      return ((re = typeof (W = I)) == "string" || re == "number" || re == "symbol" || re == "boolean" ? W !== "__proto__" : W === null) ? he[typeof I == "string" ? "string" : "hash"] : he.map;
    }
    function nn(y, I) {
      var W = function(re, he) {
        return re == null ? void 0 : re[he];
      }(y, I);
      return Yr(W) ? W : void 0;
    }
    var Sr = function(y) {
      return S.call(y);
    };
    function ii(y, I) {
      return !!(I = I == null ? 9007199254740991 : I) && (typeof y == "number" || _.test(y)) && y > -1 && y % 1 == 0 && y < I;
    }
    function yn(y, I) {
      if (M(y))
        return !1;
      var W = typeof y;
      return !(W != "number" && W != "symbol" && W != "boolean" && y != null && !Ye(y)) || w.test(y) || !v.test(y) || I != null && y in Object(I);
    }
    function oi(y) {
      return y == y && !He(y);
    }
    function Ni(y, I) {
      return function(W) {
        return W != null && W[y] === I && (I !== void 0 || y in Object(W));
      };
    }
    (ht && Sr(new ht(new ArrayBuffer(1))) != "[object DataView]" || Nt && Sr(new Nt()) != l || Qe && Sr(Qe.resolve()) != "[object Promise]" || k && Sr(new k()) != p || J && Sr(new J()) != "[object WeakMap]") && (Sr = function(y) {
      var I = S.call(y), W = I == d ? y.constructor : void 0, re = W ? Tr(W) : void 0;
      if (re)
        switch (re) {
          case Oe:
            return "[object DataView]";
          case Se:
            return l;
          case _e:
            return "[object Promise]";
          case Ee:
            return p;
          case qe:
            return "[object WeakMap]";
        }
      return I;
    });
    var ai = si(function(y) {
      var I;
      y = (I = y) == null ? "" : function(re) {
        if (typeof re == "string")
          return re;
        if (Ye(re))
          return je ? je.call(re) : "";
        var he = re + "";
        return he == "0" && 1 / re == -1 / 0 ? "-0" : he;
      }(I);
      var W = [];
      return m.test(y) && W.push(""), y.replace(b, function(re, he, Me, De) {
        W.push(Me ? De.replace(x, "$1") : he || re);
      }), W;
    });
    function wn(y) {
      if (typeof y == "string" || Ye(y))
        return y;
      var I = y + "";
      return I == "0" && 1 / y == -1 / 0 ? "-0" : I;
    }
    function Tr(y) {
      if (y != null) {
        try {
          return ke.call(y);
        } catch {
        }
        try {
          return y + "";
        } catch {
        }
      }
      return "";
    }
    function si(y, I) {
      if (typeof y != "function" || I && typeof I != "function")
        throw new TypeError("Expected a function");
      var W = function() {
        var re = arguments, he = I ? I.apply(this, re) : re[0], Me = W.cache;
        if (Me.has(he))
          return Me.get(he);
        var De = y.apply(this, re);
        return W.cache = Me.set(he, De), De;
      };
      return W.cache = new (si.Cache || ot)(), W;
    }
    function Oi(y, I) {
      return y === I || y != y && I != I;
    }
    function Li(y) {
      return function(I) {
        return Xe(I) && X(I);
      }(y) && ne.call(y, "callee") && (!it.call(y, "callee") || S.call(y) == c);
    }
    si.Cache = ot;
    var M = Array.isArray;
    function X(y) {
      return y != null && Ce(y.length) && !ue(y);
    }
    function ue(y) {
      var I = He(y) ? S.call(y) : "";
      return I == "[object Function]" || I == "[object GeneratorFunction]";
    }
    function Ce(y) {
      return typeof y == "number" && y > -1 && y % 1 == 0 && y <= 9007199254740991;
    }
    function He(y) {
      var I = typeof y;
      return !!y && (I == "object" || I == "function");
    }
    function Xe(y) {
      return !!y && typeof y == "object";
    }
    function Ye(y) {
      return typeof y == "symbol" || Xe(y) && S.call(y) == "[object Symbol]";
    }
    var Ve = H ? function(y) {
      return function(I) {
        return y(I);
      };
    }(H) : function(y) {
      return Xe(y) && Ce(y.length) && !!N[S.call(y)];
    };
    function Dt(y) {
      return X(y) ? Yt(y) : Vr(y);
    }
    function Ot(y) {
      return y;
    }
    s.exports = function(y, I, W) {
      var re = M(y) ? te : ve, he = arguments.length < 3;
      return re(y, _i(I), W, he, xt);
    };
  }).call(this, i(3), i(7)(t));
}, function(t, r) {
  t.exports = function(i) {
    return i.webpackPolyfill || (i.deprecate = function() {
    }, i.paths = [], i.children || (i.children = []), Object.defineProperty(i, "loaded", { enumerable: !0, get: function() {
      return i.l;
    } }), Object.defineProperty(i, "id", { enumerable: !0, get: function() {
      return i.i;
    } }), i.webpackPolyfill = 1), i;
  };
}, function(t, r) {
  String.prototype.padEnd || (String.prototype.padEnd = function(i, o) {
    return i >>= 0, o = String(o !== void 0 ? o : " "), this.length > i ? String(this) : ((i -= this.length) > o.length && (o += o.repeat(i / o.length)), String(this) + o.slice(0, i));
  });
}, function(t, r, i) {
  function o(oe, Q, we) {
    return Q in oe ? Object.defineProperty(oe, Q, { value: we, enumerable: !0, configurable: !0, writable: !0 }) : oe[Q] = we, oe;
  }
  function s(oe) {
    if (Symbol.iterator in Object(oe) || Object.prototype.toString.call(oe) === "[object Arguments]")
      return Array.from(oe);
  }
  function c(oe) {
    return function(Q) {
      if (Array.isArray(Q)) {
        for (var we = 0, ke = new Array(Q.length); we < Q.length; we++)
          ke[we] = Q[we];
        return ke;
      }
    }(oe) || s(oe) || function() {
      throw new TypeError("Invalid attempt to spread non-iterable instance");
    }();
  }
  function l(oe) {
    if (Array.isArray(oe))
      return oe;
  }
  function d() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }
  function p(oe, Q) {
    if (!(oe instanceof Q))
      throw new TypeError("Cannot call a class as a function");
  }
  function v(oe, Q) {
    for (var we = 0; we < Q.length; we++) {
      var ke = Q[we];
      ke.enumerable = ke.enumerable || !1, ke.configurable = !0, "value" in ke && (ke.writable = !0), Object.defineProperty(oe, ke.key, ke);
    }
  }
  function w(oe) {
    return (w = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(Q) {
      return typeof Q;
    } : function(Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : typeof Q;
    })(oe);
  }
  function m(oe) {
    return (m = typeof Symbol == "function" && w(Symbol.iterator) === "symbol" ? function(Q) {
      return w(Q);
    } : function(Q) {
      return Q && typeof Symbol == "function" && Q.constructor === Symbol && Q !== Symbol.prototype ? "symbol" : w(Q);
    })(oe);
  }
  function b(oe) {
    if (oe === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return oe;
  }
  function x(oe) {
    return (x = Object.setPrototypeOf ? Object.getPrototypeOf : function(Q) {
      return Q.__proto__ || Object.getPrototypeOf(Q);
    })(oe);
  }
  function E(oe, Q) {
    return (E = Object.setPrototypeOf || function(we, ke) {
      return we.__proto__ = ke, we;
    })(oe, Q);
  }
  i.r(r);
  var _ = i(0), N = i.n(_), U = i(5), A = i.n(U), j = i(4), R = i.n(j), F = i(6), B = i.n(F), $ = i(2), H = i.n($), te = i(1), G = i.n(te);
  i(8);
  function ve(oe, Q) {
    return l(oe) || function(we, ke) {
      var ne = [], S = !0, Be = !1, Ue = void 0;
      try {
        for (var Ie, it = we[Symbol.iterator](); !(S = (Ie = it.next()).done) && (ne.push(Ie.value), !ke || ne.length !== ke); S = !0)
          ;
      } catch (lt) {
        Be = !0, Ue = lt;
      } finally {
        try {
          S || it.return == null || it.return();
        } finally {
          if (Be)
            throw Ue;
        }
      }
      return ne;
    }(oe, Q) || d();
  }
  var be = [["Afghanistan", ["asia"], "af", "93"], ["Albania", ["europe"], "al", "355"], ["Algeria", ["africa", "north-africa"], "dz", "213"], ["Andorra", ["europe"], "ad", "376"], ["Angola", ["africa"], "ao", "244"], ["Antigua and Barbuda", ["america", "carribean"], "ag", "1268"], ["Argentina", ["america", "south-america"], "ar", "54", "(..) ........", 0, ["11", "221", "223", "261", "264", "2652", "280", "2905", "291", "2920", "2966", "299", "341", "342", "343", "351", "376", "379", "381", "3833", "385", "387", "388"]], ["Armenia", ["asia", "ex-ussr"], "am", "374", ".. ......"], ["Aruba", ["america", "carribean"], "aw", "297"], ["Australia", ["oceania"], "au", "61", "(..) .... ....", 0, ["2", "3", "4", "7", "8", "02", "03", "04", "07", "08"]], ["Austria", ["europe", "eu-union"], "at", "43"], ["Azerbaijan", ["asia", "ex-ussr"], "az", "994", "(..) ... .. .."], ["Bahamas", ["america", "carribean"], "bs", "1242"], ["Bahrain", ["middle-east"], "bh", "973"], ["Bangladesh", ["asia"], "bd", "880"], ["Barbados", ["america", "carribean"], "bb", "1246"], ["Belarus", ["europe", "ex-ussr"], "by", "375", "(..) ... .. .."], ["Belgium", ["europe", "eu-union"], "be", "32", "... .. .. .."], ["Belize", ["america", "central-america"], "bz", "501"], ["Benin", ["africa"], "bj", "229"], ["Bhutan", ["asia"], "bt", "975"], ["Bolivia", ["america", "south-america"], "bo", "591"], ["Bosnia and Herzegovina", ["europe", "ex-yugos"], "ba", "387"], ["Botswana", ["africa"], "bw", "267"], ["Brazil", ["america", "south-america"], "br", "55", "(..) ........."], ["British Indian Ocean Territory", ["asia"], "io", "246"], ["Brunei", ["asia"], "bn", "673"], ["Bulgaria", ["europe", "eu-union"], "bg", "359"], ["Burkina Faso", ["africa"], "bf", "226"], ["Burundi", ["africa"], "bi", "257"], ["Cambodia", ["asia"], "kh", "855"], ["Cameroon", ["africa"], "cm", "237"], ["Canada", ["america", "north-america"], "ca", "1", "(...) ...-....", 1, ["204", "226", "236", "249", "250", "289", "306", "343", "365", "387", "403", "416", "418", "431", "437", "438", "450", "506", "514", "519", "548", "579", "581", "587", "604", "613", "639", "647", "672", "705", "709", "742", "778", "780", "782", "807", "819", "825", "867", "873", "902", "905"]], ["Cape Verde", ["africa"], "cv", "238"], ["Caribbean Netherlands", ["america", "carribean"], "bq", "599", "", 1], ["Central African Republic", ["africa"], "cf", "236"], ["Chad", ["africa"], "td", "235"], ["Chile", ["america", "south-america"], "cl", "56"], ["China", ["asia"], "cn", "86", "..-........."], ["Colombia", ["america", "south-america"], "co", "57", "... ... ...."], ["Comoros", ["africa"], "km", "269"], ["Congo", ["africa"], "cd", "243"], ["Congo", ["africa"], "cg", "242"], ["Costa Rica", ["america", "central-america"], "cr", "506", "....-...."], ["C\xF4te d\u2019Ivoire", ["africa"], "ci", "225", ".. .. .. .."], ["Croatia", ["europe", "eu-union", "ex-yugos"], "hr", "385"], ["Cuba", ["america", "carribean"], "cu", "53"], ["Cura\xE7ao", ["america", "carribean"], "cw", "599", "", 0], ["Cyprus", ["europe", "eu-union"], "cy", "357", ".. ......"], ["Czech Republic", ["europe", "eu-union"], "cz", "420", "... ... ..."], ["Denmark", ["europe", "eu-union", "baltic"], "dk", "45", ".. .. .. .."], ["Djibouti", ["africa"], "dj", "253"], ["Dominica", ["america", "carribean"], "dm", "1767"], ["Dominican Republic", ["america", "carribean"], "do", "1", "", 2, ["809", "829", "849"]], ["Ecuador", ["america", "south-america"], "ec", "593"], ["Egypt", ["africa", "north-africa"], "eg", "20"], ["El Salvador", ["america", "central-america"], "sv", "503", "....-...."], ["Equatorial Guinea", ["africa"], "gq", "240"], ["Eritrea", ["africa"], "er", "291"], ["Estonia", ["europe", "eu-union", "ex-ussr", "baltic"], "ee", "372", ".... ......"], ["Ethiopia", ["africa"], "et", "251"], ["Fiji", ["oceania"], "fj", "679"], ["Finland", ["europe", "eu-union", "baltic"], "fi", "358", ".. ... .. .."], ["France", ["europe", "eu-union"], "fr", "33", ". .. .. .. .."], ["French Guiana", ["america", "south-america"], "gf", "594"], ["French Polynesia", ["oceania"], "pf", "689"], ["Gabon", ["africa"], "ga", "241"], ["Gambia", ["africa"], "gm", "220"], ["Georgia", ["asia", "ex-ussr"], "ge", "995"], ["Germany", ["europe", "eu-union", "baltic"], "de", "49", ".... ........"], ["Ghana", ["africa"], "gh", "233"], ["Greece", ["europe", "eu-union"], "gr", "30"], ["Grenada", ["america", "carribean"], "gd", "1473"], ["Guadeloupe", ["america", "carribean"], "gp", "590", "", 0], ["Guam", ["oceania"], "gu", "1671"], ["Guatemala", ["america", "central-america"], "gt", "502", "....-...."], ["Guinea", ["africa"], "gn", "224"], ["Guinea-Bissau", ["africa"], "gw", "245"], ["Guyana", ["america", "south-america"], "gy", "592"], ["Haiti", ["america", "carribean"], "ht", "509", "....-...."], ["Honduras", ["america", "central-america"], "hn", "504"], ["Hong Kong", ["asia"], "hk", "852", ".... ...."], ["Hungary", ["europe", "eu-union"], "hu", "36"], ["Iceland", ["europe"], "is", "354", "... ...."], ["India", ["asia"], "in", "91", ".....-....."], ["Indonesia", ["asia"], "id", "62"], ["Iran", ["middle-east"], "ir", "98", "... ... ...."], ["Iraq", ["middle-east"], "iq", "964"], ["Ireland", ["europe", "eu-union"], "ie", "353", ".. ......."], ["Israel", ["middle-east"], "il", "972", "... ... ...."], ["Italy", ["europe", "eu-union"], "it", "39", "... .......", 0], ["Jamaica", ["america", "carribean"], "jm", "1876"], ["Japan", ["asia"], "jp", "81", ".. .... ...."], ["Jordan", ["middle-east"], "jo", "962"], ["Kazakhstan", ["asia", "ex-ussr"], "kz", "7", "... ...-..-..", 1, ["310", "311", "312", "313", "315", "318", "321", "324", "325", "326", "327", "336", "7172", "73622"]], ["Kenya", ["africa"], "ke", "254"], ["Kiribati", ["oceania"], "ki", "686"], ["Kosovo", ["europe", "ex-yugos"], "xk", "383"], ["Kuwait", ["middle-east"], "kw", "965"], ["Kyrgyzstan", ["asia", "ex-ussr"], "kg", "996", "... ... ..."], ["Laos", ["asia"], "la", "856"], ["Latvia", ["europe", "eu-union", "ex-ussr", "baltic"], "lv", "371", ".. ... ..."], ["Lebanon", ["middle-east"], "lb", "961"], ["Lesotho", ["africa"], "ls", "266"], ["Liberia", ["africa"], "lr", "231"], ["Libya", ["africa", "north-africa"], "ly", "218"], ["Liechtenstein", ["europe"], "li", "423"], ["Lithuania", ["europe", "eu-union", "ex-ussr", "baltic"], "lt", "370"], ["Luxembourg", ["europe", "eu-union"], "lu", "352"], ["Macau", ["asia"], "mo", "853"], ["Macedonia", ["europe", "ex-yugos"], "mk", "389"], ["Madagascar", ["africa"], "mg", "261"], ["Malawi", ["africa"], "mw", "265"], ["Malaysia", ["asia"], "my", "60", "..-....-...."], ["Maldives", ["asia"], "mv", "960"], ["Mali", ["africa"], "ml", "223"], ["Malta", ["europe", "eu-union"], "mt", "356"], ["Marshall Islands", ["oceania"], "mh", "692"], ["Martinique", ["america", "carribean"], "mq", "596"], ["Mauritania", ["africa"], "mr", "222"], ["Mauritius", ["africa"], "mu", "230"], ["Mexico", ["america", "central-america"], "mx", "52", "... ... ....", 0, ["55", "81", "33", "656", "664", "998", "774", "229"]], ["Micronesia", ["oceania"], "fm", "691"], ["Moldova", ["europe"], "md", "373", "(..) ..-..-.."], ["Monaco", ["europe"], "mc", "377"], ["Mongolia", ["asia"], "mn", "976"], ["Montenegro", ["europe", "ex-yugos"], "me", "382"], ["Morocco", ["africa", "north-africa"], "ma", "212"], ["Mozambique", ["africa"], "mz", "258"], ["Myanmar", ["asia"], "mm", "95"], ["Namibia", ["africa"], "na", "264"], ["Nauru", ["africa"], "nr", "674"], ["Nepal", ["asia"], "np", "977"], ["Netherlands", ["europe", "eu-union"], "nl", "31", ".. ........"], ["New Caledonia", ["oceania"], "nc", "687"], ["New Zealand", ["oceania"], "nz", "64", "...-...-...."], ["Nicaragua", ["america", "central-america"], "ni", "505"], ["Niger", ["africa"], "ne", "227"], ["Nigeria", ["africa"], "ng", "234"], ["North Korea", ["asia"], "kp", "850"], ["Norway", ["europe", "baltic"], "no", "47", "... .. ..."], ["Oman", ["middle-east"], "om", "968"], ["Pakistan", ["asia"], "pk", "92", "...-......."], ["Palau", ["oceania"], "pw", "680"], ["Palestine", ["middle-east"], "ps", "970"], ["Panama", ["america", "central-america"], "pa", "507"], ["Papua New Guinea", ["oceania"], "pg", "675"], ["Paraguay", ["america", "south-america"], "py", "595"], ["Peru", ["america", "south-america"], "pe", "51"], ["Philippines", ["asia"], "ph", "63", ".... ......."], ["Poland", ["europe", "eu-union", "baltic"], "pl", "48", "...-...-..."], ["Portugal", ["europe", "eu-union"], "pt", "351"], ["Puerto Rico", ["america", "carribean"], "pr", "1", "", 3, ["787", "939"]], ["Qatar", ["middle-east"], "qa", "974"], ["R\xE9union", ["africa"], "re", "262"], ["Romania", ["europe", "eu-union"], "ro", "40"], ["Russia", ["europe", "asia", "ex-ussr", "baltic"], "ru", "7", "(...) ...-..-..", 0], ["Rwanda", ["africa"], "rw", "250"], ["Saint Kitts and Nevis", ["america", "carribean"], "kn", "1869"], ["Saint Lucia", ["america", "carribean"], "lc", "1758"], ["Saint Vincent and the Grenadines", ["america", "carribean"], "vc", "1784"], ["Samoa", ["oceania"], "ws", "685"], ["San Marino", ["europe"], "sm", "378"], ["S\xE3o Tom\xE9 and Pr\xEDncipe", ["africa"], "st", "239"], ["Saudi Arabia", ["middle-east"], "sa", "966"], ["Senegal", ["africa"], "sn", "221"], ["Serbia", ["europe", "ex-yugos"], "rs", "381"], ["Seychelles", ["africa"], "sc", "248"], ["Sierra Leone", ["africa"], "sl", "232"], ["Singapore", ["asia"], "sg", "65", "....-...."], ["Slovakia", ["europe", "eu-union"], "sk", "421"], ["Slovenia", ["europe", "eu-union", "ex-yugos"], "si", "386"], ["Solomon Islands", ["oceania"], "sb", "677"], ["Somalia", ["africa"], "so", "252"], ["South Africa", ["africa"], "za", "27"], ["South Korea", ["asia"], "kr", "82", "... .... ...."], ["South Sudan", ["africa", "north-africa"], "ss", "211"], ["Spain", ["europe", "eu-union"], "es", "34", "... ... ..."], ["Sri Lanka", ["asia"], "lk", "94"], ["Sudan", ["africa"], "sd", "249"], ["Suriname", ["america", "south-america"], "sr", "597"], ["Swaziland", ["africa"], "sz", "268"], ["Sweden", ["europe", "eu-union", "baltic"], "se", "46", "(...) ...-..."], ["Switzerland", ["europe"], "ch", "41", ".. ... .. .."], ["Syria", ["middle-east"], "sy", "963"], ["Taiwan", ["asia"], "tw", "886"], ["Tajikistan", ["asia", "ex-ussr"], "tj", "992"], ["Tanzania", ["africa"], "tz", "255"], ["Thailand", ["asia"], "th", "66"], ["Timor-Leste", ["asia"], "tl", "670"], ["Togo", ["africa"], "tg", "228"], ["Tonga", ["oceania"], "to", "676"], ["Trinidad and Tobago", ["america", "carribean"], "tt", "1868"], ["Tunisia", ["africa", "north-africa"], "tn", "216"], ["Turkey", ["europe"], "tr", "90", "... ... .. .."], ["Turkmenistan", ["asia", "ex-ussr"], "tm", "993"], ["Tuvalu", ["asia"], "tv", "688"], ["Uganda", ["africa"], "ug", "256"], ["Ukraine", ["europe", "ex-ussr"], "ua", "380", "(..) ... .. .."], ["United Arab Emirates", ["middle-east"], "ae", "971"], ["United Kingdom", ["europe", "eu-union"], "gb", "44", ".... ......"], ["United States", ["america", "north-america"], "us", "1", "(...) ...-....", 0, ["907", "205", "251", "256", "334", "479", "501", "870", "480", "520", "602", "623", "928", "209", "213", "310", "323", "408", "415", "510", "530", "559", "562", "619", "626", "650", "661", "707", "714", "760", "805", "818", "831", "858", "909", "916", "925", "949", "951", "303", "719", "970", "203", "860", "202", "302", "239", "305", "321", "352", "386", "407", "561", "727", "772", "813", "850", "863", "904", "941", "954", "229", "404", "478", "706", "770", "912", "808", "319", "515", "563", "641", "712", "208", "217", "309", "312", "618", "630", "708", "773", "815", "847", "219", "260", "317", "574", "765", "812", "316", "620", "785", "913", "270", "502", "606", "859", "225", "318", "337", "504", "985", "413", "508", "617", "781", "978", "301", "410", "207", "231", "248", "269", "313", "517", "586", "616", "734", "810", "906", "989", "218", "320", "507", "612", "651", "763", "952", "314", "417", "573", "636", "660", "816", "228", "601", "662", "406", "252", "336", "704", "828", "910", "919", "701", "308", "402", "603", "201", "609", "732", "856", "908", "973", "505", "575", "702", "775", "212", "315", "516", "518", "585", "607", "631", "716", "718", "845", "914", "216", "330", "419", "440", "513", "614", "740", "937", "405", "580", "918", "503", "541", "215", "412", "570", "610", "717", "724", "814", "401", "803", "843", "864", "605", "423", "615", "731", "865", "901", "931", "210", "214", "254", "281", "325", "361", "409", "432", "512", "713", "806", "817", "830", "903", "915", "936", "940", "956", "972", "979", "435", "801", "276", "434", "540", "703", "757", "804", "802", "206", "253", "360", "425", "509", "262", "414", "608", "715", "920", "304", "307"]], ["Uruguay", ["america", "south-america"], "uy", "598"], ["Uzbekistan", ["asia", "ex-ussr"], "uz", "998", ".. ... .. .."], ["Vanuatu", ["oceania"], "vu", "678"], ["Vatican City", ["europe"], "va", "39", ".. .... ....", 1], ["Venezuela", ["america", "south-america"], "ve", "58"], ["Vietnam", ["asia"], "vn", "84"], ["Yemen", ["middle-east"], "ye", "967"], ["Zambia", ["africa"], "zm", "260"], ["Zimbabwe", ["africa"], "zw", "263"]], xe = [["American Samoa", ["oceania"], "as", "1684"], ["Anguilla", ["america", "carribean"], "ai", "1264"], ["Bermuda", ["america", "north-america"], "bm", "1441"], ["British Virgin Islands", ["america", "carribean"], "vg", "1284"], ["Cayman Islands", ["america", "carribean"], "ky", "1345"], ["Cook Islands", ["oceania"], "ck", "682"], ["Falkland Islands", ["america", "south-america"], "fk", "500"], ["Faroe Islands", ["europe"], "fo", "298"], ["Gibraltar", ["europe"], "gi", "350"], ["Greenland", ["america"], "gl", "299"], ["Jersey", ["europe", "eu-union"], "je", "44", ".... ......"], ["Montserrat", ["america", "carribean"], "ms", "1664"], ["Niue", ["asia"], "nu", "683"], ["Norfolk Island", ["oceania"], "nf", "672"], ["Northern Mariana Islands", ["oceania"], "mp", "1670"], ["Saint Barth\xE9lemy", ["america", "carribean"], "bl", "590", "", 1], ["Saint Helena", ["africa"], "sh", "290"], ["Saint Martin", ["america", "carribean"], "mf", "590", "", 2], ["Saint Pierre and Miquelon", ["america", "north-america"], "pm", "508"], ["Sint Maarten", ["america", "carribean"], "sx", "1721"], ["Tokelau", ["oceania"], "tk", "690"], ["Turks and Caicos Islands", ["america", "carribean"], "tc", "1649"], ["U.S. Virgin Islands", ["america", "carribean"], "vi", "1340"], ["Wallis and Futuna", ["oceania"], "wf", "681"]];
  function K(oe, Q, we, ke, ne) {
    return !we || ne ? oe + "".padEnd(Q.length, ".") + " " + ke : oe + "".padEnd(Q.length, ".") + " " + we;
  }
  function ie(oe, Q, we, ke, ne) {
    var S, Be, Ue = [];
    return Be = Q === !0, [(S = []).concat.apply(S, c(oe.map(function(Ie) {
      var it = { name: Ie[0], regions: Ie[1], iso2: Ie[2], countryCode: Ie[3], dialCode: Ie[3], format: K(we, Ie[3], Ie[4], ke, ne), priority: Ie[5] || 0 }, lt = [];
      return Ie[6] && Ie[6].map(function(dt) {
        var ht = function(Nt) {
          for (var Qe = 1; Qe < arguments.length; Qe++) {
            var k = arguments[Qe] != null ? arguments[Qe] : {}, J = Object.keys(k);
            typeof Object.getOwnPropertySymbols == "function" && (J = J.concat(Object.getOwnPropertySymbols(k).filter(function(ce) {
              return Object.getOwnPropertyDescriptor(k, ce).enumerable;
            }))), J.forEach(function(ce) {
              o(Nt, ce, k[ce]);
            });
          }
          return Nt;
        }({}, it);
        ht.dialCode = Ie[3] + dt, ht.isAreaCode = !0, ht.areaCodeLength = dt.length, lt.push(ht);
      }), lt.length > 0 ? (it.mainCode = !0, Be || Q.constructor.name === "Array" && Q.includes(Ie[2]) ? (it.hasAreaCodes = !0, [it].concat(lt)) : (Ue = Ue.concat(lt), [it])) : [it];
    }))), Ue];
  }
  function ae(oe, Q, we, ke) {
    if (we !== null) {
      var ne = Object.keys(we), S = Object.values(we);
      ne.forEach(function(Be, Ue) {
        if (ke)
          return oe.push([Be, S[Ue]]);
        var Ie = oe.findIndex(function(lt) {
          return lt[0] === Be;
        });
        if (Ie === -1) {
          var it = [Be];
          it[Q] = S[Ue], oe.push(it);
        } else
          oe[Ie][Q] = S[Ue];
      });
    }
  }
  function se(oe, Q) {
    return Q.length === 0 ? oe : oe.map(function(we) {
      var ke = Q.findIndex(function(S) {
        return S[0] === we[2];
      });
      if (ke === -1)
        return we;
      var ne = Q[ke];
      return ne[1] && (we[4] = ne[1]), ne[3] && (we[5] = ne[3]), ne[2] && (we[6] = ne[2]), we;
    });
  }
  var Re = function oe(Q, we, ke, ne, S, Be, Ue, Ie, it, lt, dt, ht, Nt, Qe) {
    p(this, oe), this.filterRegions = function(de, Te) {
      if (typeof de == "string") {
        var je = de;
        return Te.filter(function(ge) {
          return ge.regions.some(function(pe) {
            return pe === je;
          });
        });
      }
      return Te.filter(function(ge) {
        return de.map(function(pe) {
          return ge.regions.some(function(ot) {
            return ot === pe;
          });
        }).some(function(pe) {
          return pe;
        });
      });
    }, this.sortTerritories = function(de, Te) {
      var je = [].concat(c(de), c(Te));
      return je.sort(function(ge, pe) {
        return ge.name < pe.name ? -1 : ge.name > pe.name ? 1 : 0;
      }), je;
    }, this.getFilteredCountryList = function(de, Te, je) {
      return de.length === 0 ? Te : je ? de.map(function(ge) {
        var pe = Te.find(function(ot) {
          return ot.iso2 === ge;
        });
        if (pe)
          return pe;
      }).filter(function(ge) {
        return ge;
      }) : Te.filter(function(ge) {
        return de.some(function(pe) {
          return pe === ge.iso2;
        });
      });
    }, this.localizeCountries = function(de, Te, je) {
      for (var ge = 0; ge < de.length; ge++)
        Te[de[ge].iso2] !== void 0 ? de[ge].localName = Te[de[ge].iso2] : Te[de[ge].name] !== void 0 && (de[ge].localName = Te[de[ge].name]);
      return je || de.sort(function(pe, ot) {
        return pe.localName < ot.localName ? -1 : pe.localName > ot.localName ? 1 : 0;
      }), de;
    }, this.getCustomAreas = function(de, Te) {
      for (var je = [], ge = 0; ge < Te.length; ge++) {
        var pe = JSON.parse(JSON.stringify(de));
        pe.dialCode += Te[ge], je.push(pe);
      }
      return je;
    }, this.excludeCountries = function(de, Te) {
      return Te.length === 0 ? de : de.filter(function(je) {
        return !Te.includes(je.iso2);
      });
    };
    var k = function(de, Te, je) {
      var ge = [];
      return ae(ge, 1, de, !0), ae(ge, 3, Te), ae(ge, 2, je), ge;
    }(Ie, it, lt), J = se(JSON.parse(JSON.stringify(be)), k), ce = se(JSON.parse(JSON.stringify(xe)), k), Oe = ve(ie(J, Q, ht, Nt, Qe), 2), Se = Oe[0], _e = Oe[1];
    if (we) {
      var Ee = ve(ie(ce, Q, ht, Nt, Qe), 2), qe = Ee[0];
      Ee[1], Se = this.sortTerritories(qe, Se);
    }
    ke && (Se = this.filterRegions(ke, Se)), this.onlyCountries = this.localizeCountries(this.excludeCountries(this.getFilteredCountryList(ne, Se, Ue.includes("onlyCountries")), Be), dt, Ue.includes("onlyCountries")), this.preferredCountries = S.length === 0 ? [] : this.localizeCountries(this.getFilteredCountryList(S, Se, Ue.includes("preferredCountries")), dt, Ue.includes("preferredCountries")), this.hiddenAreaCodes = this.excludeCountries(this.getFilteredCountryList(ne, _e), Be);
  }, ct = function(oe) {
    function Q(ne) {
      var S;
      p(this, Q), (S = function(k, J) {
        return !J || m(J) !== "object" && typeof J != "function" ? b(k) : J;
      }(this, x(Q).call(this, ne))).getProbableCandidate = R()(function(k) {
        return k && k.length !== 0 ? S.state.onlyCountries.filter(function(J) {
          return H()(J.name.toLowerCase(), k.toLowerCase());
        }, b(b(S)))[0] : null;
      }), S.guessSelectedCountry = R()(function(k, J, ce, Oe) {
        var Se;
        if (S.props.enableAreaCodes === !1 && (Oe.some(function(qe) {
          if (H()(k, qe.dialCode))
            return ce.some(function(de) {
              if (qe.iso2 === de.iso2 && de.mainCode)
                return Se = de, !0;
            }), !0;
        }), Se))
          return Se;
        var _e = ce.find(function(qe) {
          return qe.iso2 == J;
        });
        if (k.trim() === "")
          return _e;
        var Ee = ce.reduce(function(qe, de) {
          return H()(k, de.dialCode) && (de.dialCode.length > qe.dialCode.length || de.dialCode.length === qe.dialCode.length && de.priority < qe.priority) ? de : qe;
        }, { dialCode: "", priority: 10001 }, b(b(S)));
        return Ee.name ? Ee : _e;
      }), S.updateCountry = function(k) {
        var J, ce = S.state.onlyCountries;
        (J = k.indexOf(0) >= "0" && k.indexOf(0) <= "9" ? ce.find(function(Oe) {
          return Oe.dialCode == +k;
        }) : ce.find(function(Oe) {
          return Oe.iso2 == k;
        })) && J.dialCode && S.setState({ selectedCountry: J, formattedNumber: S.props.disableCountryCode ? "" : S.formatNumber(J.dialCode, J) });
      }, S.scrollTo = function(k, J) {
        if (k) {
          var ce = S.dropdownRef;
          if (ce && document.body) {
            var Oe = ce.offsetHeight, Se = ce.getBoundingClientRect().top + document.body.scrollTop, _e = Se + Oe, Ee = k, qe = Ee.getBoundingClientRect(), de = Ee.offsetHeight, Te = qe.top + document.body.scrollTop, je = Te + de, ge = Te - Se + ce.scrollTop, pe = Oe / 2 - de / 2;
            if (S.props.enableSearch ? Te < Se + 32 : Te < Se)
              J && (ge -= pe), ce.scrollTop = ge;
            else if (je > _e) {
              J && (ge += pe);
              var ot = Oe - de;
              ce.scrollTop = ge - ot;
            }
          }
        }
      }, S.scrollToTop = function() {
        var k = S.dropdownRef;
        k && document.body && (k.scrollTop = 0);
      }, S.formatNumber = function(k, J) {
        if (!J)
          return k;
        var ce, Oe = J.format, Se = S.props, _e = Se.disableCountryCode, Ee = Se.enableAreaCodeStretch, qe = Se.enableLongNumbers, de = Se.autoFormat;
        if (_e ? ((ce = Oe.split(" ")).shift(), ce = ce.join(" ")) : Ee && J.isAreaCode ? ((ce = Oe.split(" "))[1] = ce[1].replace(/\.+/, "".padEnd(J.areaCodeLength, ".")), ce = ce.join(" ")) : ce = Oe, !k || k.length === 0)
          return _e ? "" : S.props.prefix;
        if (k && k.length < 2 || !ce || !de)
          return _e ? k : S.props.prefix + k;
        var Te, je = B()(ce, function(ge, pe) {
          if (ge.remainingText.length === 0)
            return ge;
          if (pe !== ".")
            return { formattedText: ge.formattedText + pe, remainingText: ge.remainingText };
          var ot, qt = l(ot = ge.remainingText) || s(ot) || d(), At = qt[0], Yt = qt.slice(1);
          return { formattedText: ge.formattedText + At, remainingText: Yt };
        }, { formattedText: "", remainingText: k.split("") });
        return (Te = qe ? je.formattedText + je.remainingText.join("") : je.formattedText).includes("(") && !Te.includes(")") && (Te += ")"), Te;
      }, S.cursorToEnd = function() {
        var k = S.numberInputRef;
        if (document.activeElement === k) {
          k.focus();
          var J = k.value.length;
          k.value.charAt(J - 1) === ")" && (J -= 1), k.setSelectionRange(J, J);
        }
      }, S.getElement = function(k) {
        return S["flag_no_".concat(k)];
      }, S.getCountryData = function() {
        return S.state.selectedCountry ? { name: S.state.selectedCountry.name || "", dialCode: S.state.selectedCountry.dialCode || "", countryCode: S.state.selectedCountry.iso2 || "", format: S.state.selectedCountry.format || "" } : {};
      }, S.handleFlagDropdownClick = function(k) {
        if (k.preventDefault(), S.state.showDropdown || !S.props.disabled) {
          var J = S.state, ce = J.preferredCountries, Oe = J.onlyCountries, Se = J.selectedCountry, _e = S.concatPreferredCountries(ce, Oe).findIndex(function(Ee) {
            return Ee.dialCode === Se.dialCode && Ee.iso2 === Se.iso2;
          });
          S.setState({ showDropdown: !S.state.showDropdown, highlightCountryIndex: _e }, function() {
            S.state.showDropdown && S.scrollTo(S.getElement(S.state.highlightCountryIndex));
          });
        }
      }, S.handleInput = function(k) {
        var J = k.target.value, ce = S.props, Oe = ce.prefix, Se = ce.onChange, _e = S.props.disableCountryCode ? "" : Oe, Ee = S.state.selectedCountry, qe = S.state.freezeSelection;
        if (!S.props.countryCodeEditable) {
          var de = Oe + (Ee.hasAreaCodes ? S.state.onlyCountries.find(function(xt) {
            return xt.iso2 === Ee.iso2 && xt.mainCode;
          }).dialCode : Ee.dialCode);
          if (J.slice(0, de.length) !== de)
            return;
        }
        if (J === Oe)
          return Se && Se("", S.getCountryData(), k, ""), S.setState({ formattedNumber: "" });
        if (!(J.replace(/\D/g, "").length > 15 && (S.props.enableLongNumbers === !1 || typeof S.props.enableLongNumbers == "number" && J.replace(/\D/g, "").length > S.props.enableLongNumbers)) && J !== S.state.formattedNumber) {
          k.preventDefault ? k.preventDefault() : k.returnValue = !1;
          var Te = S.props.country, je = S.state, ge = je.onlyCountries, pe = je.selectedCountry, ot = je.hiddenAreaCodes;
          if (Se && k.persist(), J.length > 0) {
            var qt = J.replace(/\D/g, "");
            (!S.state.freezeSelection || pe && pe.dialCode.length > qt.length) && (Ee = S.props.disableCountryGuess ? pe : S.guessSelectedCountry(qt.substring(0, 6), Te, ge, ot) || pe, qe = !1), _e = S.formatNumber(qt, Ee), Ee = Ee.dialCode ? Ee : pe;
          }
          var At = k.target.selectionStart, Yt = k.target.selectionStart, tr = S.state.formattedNumber, br = _e.length - tr.length;
          S.setState({ formattedNumber: _e, freezeSelection: qe, selectedCountry: Ee }, function() {
            br > 0 && (Yt -= br), _e.charAt(_e.length - 1) == ")" ? S.numberInputRef.setSelectionRange(_e.length - 1, _e.length - 1) : Yt > 0 && tr.length >= _e.length ? S.numberInputRef.setSelectionRange(Yt, Yt) : At < tr.length && S.numberInputRef.setSelectionRange(At, At), Se && Se(_e.replace(/[^0-9]+/g, ""), S.getCountryData(), k, _e);
          });
        }
      }, S.handleInputClick = function(k) {
        S.setState({ showDropdown: !1 }), S.props.onClick && S.props.onClick(k, S.getCountryData());
      }, S.handleDoubleClick = function(k) {
        var J = k.target.value.length;
        k.target.setSelectionRange(0, J);
      }, S.handleFlagItemClick = function(k, J) {
        var ce = S.state.selectedCountry, Oe = S.state.onlyCountries.find(function(qe) {
          return qe == k;
        });
        if (Oe) {
          var Se = S.state.formattedNumber.replace(" ", "").replace("(", "").replace(")", "").replace("-", ""), _e = Se.length > 1 ? Se.replace(ce.dialCode, Oe.dialCode) : Oe.dialCode, Ee = S.formatNumber(_e.replace(/\D/g, ""), Oe);
          S.setState({ showDropdown: !1, selectedCountry: Oe, freezeSelection: !0, formattedNumber: Ee, searchValue: "" }, function() {
            S.cursorToEnd(), S.props.onChange && S.props.onChange(Ee.replace(/[^0-9]+/g, ""), S.getCountryData(), J, Ee);
          });
        }
      }, S.handleInputFocus = function(k) {
        S.numberInputRef && S.numberInputRef.value === S.props.prefix && S.state.selectedCountry && !S.props.disableCountryCode && S.setState({ formattedNumber: S.props.prefix + S.state.selectedCountry.dialCode }, function() {
          S.props.jumpCursorToEnd && setTimeout(S.cursorToEnd, 0);
        }), S.setState({ placeholder: "" }), S.props.onFocus && S.props.onFocus(k, S.getCountryData()), S.props.jumpCursorToEnd && setTimeout(S.cursorToEnd, 0);
      }, S.handleInputBlur = function(k) {
        k.target.value || S.setState({ placeholder: S.props.placeholder }), S.props.onBlur && S.props.onBlur(k, S.getCountryData());
      }, S.handleInputCopy = function(k) {
        if (S.props.copyNumbersOnly) {
          var J = window.getSelection().toString().replace(/[^0-9]+/g, "");
          k.clipboardData.setData("text/plain", J), k.preventDefault();
        }
      }, S.getHighlightCountryIndex = function(k) {
        var J = S.state.highlightCountryIndex + k;
        return J < 0 || J >= S.state.onlyCountries.length + S.state.preferredCountries.length ? J - k : S.props.enableSearch && J > S.getSearchFilteredCountries().length ? 0 : J;
      }, S.searchCountry = function() {
        var k = S.getProbableCandidate(S.state.queryString) || S.state.onlyCountries[0], J = S.state.onlyCountries.findIndex(function(ce) {
          return ce == k;
        }) + S.state.preferredCountries.length;
        S.scrollTo(S.getElement(J), !0), S.setState({ queryString: "", highlightCountryIndex: J });
      }, S.handleKeydown = function(k) {
        var J = S.props.keys, ce = k.target.className;
        if (ce.includes("selected-flag") && k.which === J.ENTER && !S.state.showDropdown)
          return S.handleFlagDropdownClick(k);
        if (ce.includes("form-control") && (k.which === J.ENTER || k.which === J.ESC))
          return k.target.blur();
        if (S.state.showDropdown && !S.props.disabled && (!ce.includes("search-box") || k.which === J.UP || k.which === J.DOWN || k.which === J.ENTER || k.which === J.ESC && k.target.value === "")) {
          k.preventDefault ? k.preventDefault() : k.returnValue = !1;
          var Oe = function(Se) {
            S.setState({ highlightCountryIndex: S.getHighlightCountryIndex(Se) }, function() {
              S.scrollTo(S.getElement(S.state.highlightCountryIndex), !0);
            });
          };
          switch (k.which) {
            case J.DOWN:
              Oe(1);
              break;
            case J.UP:
              Oe(-1);
              break;
            case J.ENTER:
              S.props.enableSearch ? S.handleFlagItemClick(S.getSearchFilteredCountries()[S.state.highlightCountryIndex] || S.getSearchFilteredCountries()[0], k) : S.handleFlagItemClick([].concat(c(S.state.preferredCountries), c(S.state.onlyCountries))[S.state.highlightCountryIndex], k);
              break;
            case J.ESC:
            case J.TAB:
              S.setState({ showDropdown: !1 }, S.cursorToEnd);
              break;
            default:
              (k.which >= J.A && k.which <= J.Z || k.which === J.SPACE) && S.setState({ queryString: S.state.queryString + String.fromCharCode(k.which) }, S.state.debouncedQueryStingSearcher);
          }
        }
      }, S.handleInputKeyDown = function(k) {
        var J = S.props, ce = J.keys, Oe = J.onEnterKeyPress, Se = J.onKeyDown;
        k.which === ce.ENTER && Oe && Oe(k), Se && Se(k);
      }, S.handleClickOutside = function(k) {
        S.dropdownRef && !S.dropdownContainerRef.contains(k.target) && S.state.showDropdown && S.setState({ showDropdown: !1 });
      }, S.handleSearchChange = function(k) {
        var J = k.currentTarget.value, ce = S.state, Oe = ce.preferredCountries, Se = ce.selectedCountry, _e = 0;
        if (J === "" && Se) {
          var Ee = S.state.onlyCountries;
          _e = S.concatPreferredCountries(Oe, Ee).findIndex(function(qe) {
            return qe == Se;
          }), setTimeout(function() {
            return S.scrollTo(S.getElement(_e));
          }, 100);
        }
        S.setState({ searchValue: J, highlightCountryIndex: _e });
      }, S.concatPreferredCountries = function(k, J) {
        return k.length > 0 ? c(new Set(k.concat(J))) : J;
      }, S.getDropdownCountryName = function(k) {
        return k.localName || k.name;
      }, S.getSearchFilteredCountries = function() {
        var k = S.state, J = k.preferredCountries, ce = k.onlyCountries, Oe = k.searchValue, Se = S.props.enableSearch, _e = S.concatPreferredCountries(J, ce), Ee = Oe.trim().toLowerCase().replace("+", "");
        if (Se && Ee) {
          if (/^\d+$/.test(Ee))
            return _e.filter(function(Te) {
              var je = Te.dialCode;
              return ["".concat(je)].some(function(ge) {
                return ge.toLowerCase().includes(Ee);
              });
            });
          var qe = _e.filter(function(Te) {
            var je = Te.iso2;
            return ["".concat(je)].some(function(ge) {
              return ge.toLowerCase().includes(Ee);
            });
          }), de = _e.filter(function(Te) {
            var je = Te.name, ge = Te.localName;
            return Te.iso2, ["".concat(je), "".concat(ge || "")].some(function(pe) {
              return pe.toLowerCase().includes(Ee);
            });
          });
          return S.scrollToTop(), c(new Set([].concat(qe, de)));
        }
        return _e;
      }, S.getCountryDropdownList = function() {
        var k = S.state, J = k.preferredCountries, ce = k.highlightCountryIndex, Oe = k.showDropdown, Se = k.searchValue, _e = S.props, Ee = _e.disableDropdown, qe = _e.prefix, de = S.props, Te = de.enableSearch, je = de.searchNotFound, ge = de.disableSearchIcon, pe = de.searchClass, ot = de.searchStyle, qt = de.searchPlaceholder, At = de.autocompleteSearch, Yt = S.getSearchFilteredCountries().map(function(xt, Or) {
          var qr = ce === Or, pn = G()({ country: !0, preferred: xt.iso2 === "us" || xt.iso2 === "gb", active: xt.iso2 === "us", highlight: qr }), gn = "flag ".concat(xt.iso2);
          return N.a.createElement("li", Object.assign({ ref: function(Yr) {
            return S["flag_no_".concat(Or)] = Yr;
          }, key: "flag_no_".concat(Or), "data-flag-key": "flag_no_".concat(Or), className: pn, "data-dial-code": "1", tabIndex: Ee ? "-1" : "0", "data-country-code": xt.iso2, onClick: function(Yr) {
            return S.handleFlagItemClick(xt, Yr);
          }, role: "option" }, qr ? { "aria-selected": !0 } : {}), N.a.createElement("div", { className: gn }), N.a.createElement("span", { className: "country-name" }, S.getDropdownCountryName(xt)), N.a.createElement("span", { className: "dial-code" }, xt.format ? S.formatNumber(xt.dialCode, xt) : qe + xt.dialCode));
        }), tr = N.a.createElement("li", { key: "dashes", className: "divider" });
        J.length > 0 && (!Te || Te && !Se.trim()) && Yt.splice(J.length, 0, tr);
        var br = G()(o({ "country-list": !0, hide: !Oe }, S.props.dropdownClass, !0));
        return N.a.createElement("ul", { ref: function(xt) {
          return !Te && xt && xt.focus(), S.dropdownRef = xt;
        }, className: br, style: S.props.dropdownStyle, role: "listbox", tabIndex: "0" }, Te && N.a.createElement("li", { className: G()(o({ search: !0 }, pe, pe)) }, !ge && N.a.createElement("span", { className: G()(o({ "search-emoji": !0 }, "".concat(pe, "-emoji"), pe)), role: "img", "aria-label": "Magnifying glass" }, "\u{1F50E}"), N.a.createElement("input", { className: G()(o({ "search-box": !0 }, "".concat(pe, "-box"), pe)), style: ot, type: "search", placeholder: qt, autoFocus: !0, autoComplete: At ? "on" : "off", value: Se, onChange: S.handleSearchChange })), Yt.length > 0 ? Yt : N.a.createElement("li", { className: "no-entries-message" }, N.a.createElement("span", null, je)));
      };
      var Be, Ue = new Re(ne.enableAreaCodes, ne.enableTerritories, ne.regions, ne.onlyCountries, ne.preferredCountries, ne.excludeCountries, ne.preserveOrder, ne.masks, ne.priority, ne.areaCodes, ne.localization, ne.prefix, ne.defaultMask, ne.alwaysDefaultMask), Ie = Ue.onlyCountries, it = Ue.preferredCountries, lt = Ue.hiddenAreaCodes, dt = ne.value ? ne.value.replace(/\D/g, "") : "";
      Be = ne.disableInitialCountryGuess ? 0 : dt.length > 1 ? S.guessSelectedCountry(dt.substring(0, 6), ne.country, Ie, lt) || 0 : ne.country && Ie.find(function(k) {
        return k.iso2 == ne.country;
      }) || 0;
      var ht, Nt = dt.length < 2 && Be && !H()(dt, Be.dialCode) ? Be.dialCode : "";
      ht = dt === "" && Be === 0 ? "" : S.formatNumber((ne.disableCountryCode ? "" : Nt) + dt, Be.name ? Be : void 0);
      var Qe = Ie.findIndex(function(k) {
        return k == Be;
      });
      return S.state = { showDropdown: ne.showDropdown, formattedNumber: ht, onlyCountries: Ie, preferredCountries: it, hiddenAreaCodes: lt, selectedCountry: Be, highlightCountryIndex: Qe, queryString: "", freezeSelection: !1, debouncedQueryStingSearcher: A()(S.searchCountry, 250), searchValue: "" }, S;
    }
    var we, ke;
    return function(ne, S) {
      if (typeof S != "function" && S !== null)
        throw new TypeError("Super expression must either be null or a function");
      ne.prototype = Object.create(S && S.prototype, { constructor: { value: ne, writable: !0, configurable: !0 } }), S && E(ne, S);
    }(Q, oe), we = Q, (ke = [{ key: "componentDidMount", value: function() {
      document.addEventListener && this.props.enableClickOutside && document.addEventListener("mousedown", this.handleClickOutside), this.props.onMount && this.props.onMount(this.state.formattedNumber.replace(/[^0-9]+/g, ""), this.getCountryData(), this.state.formattedNumber);
    } }, { key: "componentWillUnmount", value: function() {
      document.removeEventListener && this.props.enableClickOutside && document.removeEventListener("mousedown", this.handleClickOutside);
    } }, { key: "componentDidUpdate", value: function(ne, S, Be) {
      ne.country !== this.props.country ? this.updateCountry(this.props.country) : ne.value !== this.props.value && this.updateFormattedNumber(this.props.value);
    } }, { key: "updateFormattedNumber", value: function(ne) {
      if (ne === null)
        return this.setState({ selectedCountry: 0, formattedNumber: "" });
      var S = this.state, Be = S.onlyCountries, Ue = S.selectedCountry, Ie = S.hiddenAreaCodes, it = this.props, lt = it.country, dt = it.prefix;
      if (ne === "")
        return this.setState({ selectedCountry: Ue, formattedNumber: "" });
      var ht, Nt, Qe = ne.replace(/\D/g, "");
      if (Ue && H()(ne, dt + Ue.dialCode))
        Nt = this.formatNumber(Qe, Ue), this.setState({ formattedNumber: Nt });
      else {
        var k = (ht = this.props.disableCountryGuess ? Ue : this.guessSelectedCountry(Qe.substring(0, 6), lt, Be, Ie) || Ue) && H()(Qe, dt + ht.dialCode) ? ht.dialCode : "";
        Nt = this.formatNumber((this.props.disableCountryCode ? "" : k) + Qe, ht || void 0), this.setState({ selectedCountry: ht, formattedNumber: Nt });
      }
    } }, { key: "render", value: function() {
      var ne, S, Be, Ue = this, Ie = this.state, it = Ie.onlyCountries, lt = Ie.selectedCountry, dt = Ie.showDropdown, ht = Ie.formattedNumber, Nt = Ie.hiddenAreaCodes, Qe = this.props, k = Qe.disableDropdown, J = Qe.renderStringAsFlag, ce = Qe.isValid, Oe = Qe.defaultErrorMessage, Se = Qe.specialLabel;
      if (typeof ce == "boolean")
        S = ce;
      else {
        var _e = ce(ht.replace(/\D/g, ""), lt, it, Nt);
        typeof _e == "boolean" ? (S = _e) === !1 && (Be = Oe) : (S = !1, Be = _e);
      }
      var Ee = G()((o(ne = {}, this.props.containerClass, !0), o(ne, "react-tel-input", !0), ne)), qe = G()({ arrow: !0, up: dt }), de = G()(o({ "form-control": !0, "invalid-number": !S, open: dt }, this.props.inputClass, !0)), Te = G()({ "selected-flag": !0, open: dt }), je = G()(o({ "flag-dropdown": !0, "invalid-number": !S, open: dt }, this.props.buttonClass, !0)), ge = "flag ".concat(lt && lt.iso2);
      return N.a.createElement("div", { className: "".concat(Ee, " ").concat(this.props.className), style: this.props.style || this.props.containerStyle, onKeyDown: this.handleKeydown }, Se && N.a.createElement("div", { className: "special-label" }, Se), Be && N.a.createElement("div", { className: "invalid-number-message" }, Be), N.a.createElement("input", Object.assign({ className: de, style: this.props.inputStyle, onChange: this.handleInput, onClick: this.handleInputClick, onDoubleClick: this.handleDoubleClick, onFocus: this.handleInputFocus, onBlur: this.handleInputBlur, onCopy: this.handleInputCopy, value: ht, onKeyDown: this.handleInputKeyDown, placeholder: this.props.placeholder, disabled: this.props.disabled, type: "tel" }, this.props.inputProps, { ref: function(pe) {
        Ue.numberInputRef = pe, typeof Ue.props.inputProps.ref == "function" ? Ue.props.inputProps.ref(pe) : typeof Ue.props.inputProps.ref == "object" && (Ue.props.inputProps.ref.current = pe);
      } })), N.a.createElement("div", { className: je, style: this.props.buttonStyle, ref: function(pe) {
        return Ue.dropdownContainerRef = pe;
      } }, J ? N.a.createElement("div", { className: Te }, J) : N.a.createElement("div", { onClick: k ? void 0 : this.handleFlagDropdownClick, className: Te, title: lt ? "".concat(lt.localName || lt.name, ": + ").concat(lt.dialCode) : "", tabIndex: k ? "-1" : "0", role: "button", "aria-haspopup": "listbox", "aria-expanded": !!dt || void 0 }, N.a.createElement("div", { className: ge }, !k && N.a.createElement("div", { className: qe }))), dt && this.getCountryDropdownList()));
    } }]) && v(we.prototype, ke), Q;
  }(N.a.Component);
  ct.defaultProps = { country: "", value: "", onlyCountries: [], preferredCountries: [], excludeCountries: [], placeholder: "1 (702) 123-4567", searchPlaceholder: "search", searchNotFound: "No entries to show", flagsImagePath: "./flags.png", disabled: !1, containerStyle: {}, inputStyle: {}, buttonStyle: {}, dropdownStyle: {}, searchStyle: {}, containerClass: "", inputClass: "", buttonClass: "", dropdownClass: "", searchClass: "", className: "", autoFormat: !0, enableAreaCodes: !1, enableTerritories: !1, disableCountryCode: !1, disableDropdown: !1, enableLongNumbers: !1, countryCodeEditable: !0, enableSearch: !1, disableSearchIcon: !1, disableInitialCountryGuess: !1, disableCountryGuess: !1, regions: "", inputProps: {}, localization: {}, masks: null, priority: null, areaCodes: null, preserveOrder: [], defaultMask: "... ... ... ... ..", alwaysDefaultMask: !1, prefix: "+", copyNumbersOnly: !0, renderStringAsFlag: "", autocompleteSearch: !1, jumpCursorToEnd: !0, enableAreaCodeStretch: !1, enableClickOutside: !0, showDropdown: !1, isValid: !0, defaultErrorMessage: "", specialLabel: "Phone", onEnterKeyPress: null, keys: { UP: 38, DOWN: 40, RIGHT: 39, LEFT: 37, ENTER: 13, ESC: 27, PLUS: 43, A: 65, Z: 90, SPACE: 32, TAB: 9 } }, r.default = ct;
}]), $d;
const Y1 = ($d = pd.default) != null ? $d : pd, V1 = ({
  ...t
}) => {
  const [r, i] = Qt("");
  return /* @__PURE__ */ $e(ho, {
    children: [/* @__PURE__ */ D(Y1, {
      country: "us",
      value: r,
      onChange: (s, c, l, d) => {
        i(`+${s}`);
      }
    }), /* @__PURE__ */ D("input", {
      type: "hidden",
      value: r,
      ...t
    })]
  });
}, gd = ({
  onEvent: t,
  allowBack: r,
  error: i
}) => /* @__PURE__ */ $e("form", {
  onSubmit: (s) => {
    s.preventDefault(), t({
      type: "submit",
      phoneNumber: s.target.elements.phoneNumber.value
    });
  },
  className: "userfront-form",
  children: [/* @__PURE__ */ $e("div", {
    className: "userfront-form-row",
    children: [/* @__PURE__ */ D("label", {
      htmlFor: "phoneNumber",
      children: "Mobile phone number"
    }), /* @__PURE__ */ D(V1, {
      name: "phoneNumber"
    })]
  }), /* @__PURE__ */ D(rn, {
    error: i
  }), /* @__PURE__ */ $e("div", {
    className: "userfront-button-row",
    children: [r && /* @__PURE__ */ D(kn, {
      onEvent: t
    }), /* @__PURE__ */ D(ni, {})]
  })]
}), qa = ({
  onEvent: t,
  error: r
}) => {
  const [i, o] = Qt(!1);
  return /* @__PURE__ */ $e("form", {
    onSubmit: (c) => {
      c.preventDefault();
      const l = c.target.elements.verificationCode.value;
      o(!l), l && t({
        type: "submit",
        verificationCode: l
      });
    },
    className: "userfront-form",
    children: [/* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.VerificationCode, {
        showError: i
      })
    }), /* @__PURE__ */ D(rn, {
      error: r
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-button-row",
      children: [/* @__PURE__ */ D(kn, {
        onEvent: t
      }), /* @__PURE__ */ D(ni, {})]
    })]
  });
}, G1 = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIuMTUyIDYuODk2Yy0uOTQ4IDAtMi40MTUtMS4wNzgtMy45Ni0xLjA0LTIuMDQuMDI3LTMuOTEgMS4xODMtNC45NjEgMy4wMTQtMi4xMTcgMy42NzUtLjU0NiA5LjEwMyAxLjUxOSAxMi4wOSAxLjAxMyAxLjQ1NCAyLjIwOCAzLjA5IDMuNzkyIDMuMDM5IDEuNTItLjA2NSAyLjA5LS45ODcgMy45MzUtLjk4NyAxLjgzMSAwIDIuMzUuOTg3IDMuOTYuOTQ4IDEuNjM3LS4wMjYgMi42NzYtMS40OCAzLjY3Ni0yLjk0OCAxLjE1Ni0xLjY4OCAxLjYzNi0zLjMyNSAxLjY2Mi0zLjQxNS0uMDM5LS4wMTMtMy4xODItMS4yMjEtMy4yMi00Ljg1Ny0uMDI2LTMuMDQgMi40OC00LjQ5NCAyLjU5Ny00LjU1OS0xLjQyOS0yLjA5LTMuNjIzLTIuMzI0LTQuMzktMi4zNzYtMi0uMTU2LTMuNjc1IDEuMDktNC42MSAxLjA5ek0xNS41MyAzLjgzYy44NDMtMS4wMTIgMS40LTIuNDI3IDEuMjQ1LTMuODMtMS4yMDcuMDUyLTIuNjYyLjgwNS0zLjUzMiAxLjgxOC0uNzguODk2LTEuNDU0IDIuMzM4LTEuMjczIDMuNzE0IDEuMzM4LjEwNCAyLjcxNS0uNjg4IDMuNTU5LTEuNzAxIi8+PC9zdmc+", K1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI1OS4yNDIiIGhlaWdodD0iNDcuMjcxIiB2aWV3Qm94PSIwIDAgNTkuMjQyIDQ3LjI3MSI+PHBhdGggZmlsbD0iIzAwNzJjNiIgZD0iTTMyLjM2OCwwLDE0LjksMTUuMTQ1LDAsNDEuODk1SDEzLjQzN1ptMi4zMjMsMy41NDNMMjcuMjM3LDI0LjU1MSw0MS41MjgsNDIuNTA3LDEzLjgsNDcuMjcxSDU5LjI0MloiLz48L3N2Zz4=", $1 = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIiPjxnIGZpbGwtcnVsZT0ibm9uemVybyI+PHBhdGggZD0iTTUxMiAyNTZDNTEyIDExNC42MTUgMzk3LjM4NSAwIDI1NiAwUzAgMTE0LjYxNSAwIDI1NmMwIDEyNy43NzcgOTMuNjE2IDIzMy42ODUgMjE2IDI1Mi44OVYzMzBoLTY1di03NGg2NXYtNTYuNGMwLTY0LjE2IDM4LjIxOS05OS42IDk2LjY5NS05OS42IDI4LjAwOSAwIDU3LjMwNSA1IDU3LjMwNSA1djYzaC0zMi4yODFDMzA1LjkxOCAxNjggMjk2IDE4Ny43MzMgMjk2IDIwNy45NzhWMjU2aDcxbC0xMS4zNSA3NEgyOTZ2MTc4Ljg5QzQxOC4zODUgNDg5LjY4NSA1MTIgMzgzLjc3NyA1MTIgMjU2eiIgZmlsbD0iIzE4NzdmMiIvPjxwYXRoIGQ9Ik0zNTUuNjUgMzMwTDM2NyAyNTZoLTcxdi00OC4wMjJjMC0yMC4yNDUgOS45MTctMzkuOTc4IDQxLjcxOS0zOS45NzhIMzcwdi02M3MtMjkuMjk3LTUtNTcuMzA1LTVDMjU0LjIxOSAxMDAgMjE2IDEzNS40NCAyMTYgMTk5LjZWMjU2aC02NXY3NGg2NXYxNzguODlhMjU3LjkxMiAyNTcuOTEyIDAgMDA0MCAzLjExYzEzLjYwOCAwIDI2Ljk2Ni0xLjA2NSA0MC0zLjExVjMzMGg1OS42NXoiIGZpbGw9IiNmZmYiLz48L2c+PC9zdmc+", Q1 = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgaGVpZ2h0PSI1MTIiIHdpZHRoPSI1MTIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMjk2LjEzMyAzNTQuMTc0YzQ5Ljg4NS01Ljg5MSAxMDIuOTQyLTI0LjAyOSAxMDIuOTQyLTExMC4xOTIgMC0yNC40OS04LjYyNC00NC40NDgtMjIuNjctNTkuODY5IDIuMjY2LTUuODkgOS41MTUtMjguMTE0LTIuNzM0LTU4Ljk0NyAwIDAtMTguMTM5LTUuODk4LTYwLjc1OSAyMi42NjktMTguMTM5LTQuOTgzLTM4LjA5LTguMTYzLTU2LjY4Mi04LjE2My0xOS4wNTMgMC0zOS4wMTEgMy4xOC01Ni42OTcgOC4xNjMtNDMuMDgyLTI4LjU2Ny02MS4yMi0yMi42NjktNjEuMjItMjIuNjY5LTEyLjI0MSAzMC44MzMtNC45ODMgNTMuMDU3LTIuNzE4IDU4Ljk0Ny0xNC4wNjEgMTUuNDItMjIuNjc3IDM1LjM3OS0yMi42NzcgNTkuODY5IDAgODYuMTYzIDUzLjA1NyAxMDQuMzAxIDEwMi45NDIgMTEwLjE5Mi02LjM0NCA1LjQ1Mi0xMi4yNDEgMTUuODczLTE0LjUwNyAzMC4zODctMTIuNzAyIDUuNDM4LTQ1LjgwOCAxNS44NzMtNjUuNzU4LTE4LjU5MiAwIDAtMTEuNzk1LTIxLjMxLTM0LjAxMi0yMi42NjkgMCAwLTIyLjIyNC0uNDUzLTEuODEzIDEzLjU5MiAwIDAgMTQuOTYgNi44MTIgMjQuOTQzIDMyLjY1MyAwIDAgMTMuNiA0My4wODkgNzYuMTc5IDI5LjQ4djM4LjU0M2MwIDUuOTA2LTQuNTMgMTIuNzAyLTE1Ljg2NSAxMC44OUM5Ni4xMzkgNDM4Ljk3NyAzMi4yIDM1NC42MjYgMzIuMiAyNTUuNzdjMC0xMjMuODA3IDEwMC4yMTYtMjI0LjAyMiAyMjQuMDMtMjI0LjAyMiAxMjMuMzQ3IDAgMjI0LjAyMyAxMDAuMjE2IDIyMy41NyAyMjQuMDIyIDAgOTguODU2LTYzLjk0NiAxODIuNzU0LTE1Mi44MjggMjEyLjY4OC0xMS4zNDIgMi4yNjYtMTUuODczLTQuNTMtMTUuODczLTEwLjg5VjM5NS40NWMuMDAxLTIwLjg3My02LjgxMS0zNC40NjUtMTQuOTY2LTQxLjI3NnpNNTEyIDI1Ni4yM0M1MTIgMTE0LjczIDM5Ny4yNjMgMCAyNTYuMjMgMCAxMTQuNzMgMCAwIDExNC43MyAwIDI1Ni4yMyAwIDM5Ny4yNjMgMTE0LjczIDUxMiAyNTYuMjMgNTEyIDM5Ny4yNjMgNTEyIDUxMiAzOTcuMjYzIDUxMiAyNTYuMjN6IiBmaWxsPSIjMEQyNjM2IiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=", H1 = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPHBhdGggZD0iTTE5LjYgMTAuMjI3YzAtLjcwOS0uMDY0LTEuMzktLjE4Mi0yLjA0NUgxMHYzLjg2OGg1LjM4MmE0LjYgNC42IDAgMDEtMS45OTYgMy4wMTh2Mi41MWgzLjIzMmMxLjg5MS0xLjc0MiAyLjk4Mi00LjMwNSAyLjk4Mi03LjM1eiIgZmlsbD0iIzQyODVGNCIgLz4KICAgIDxwYXRoIGQ9Ik0xMCAyMGMyLjcgMCA0Ljk2NC0uODk1IDYuNjE4LTIuNDIzbC0zLjIzMi0yLjUwOWMtLjg5NS42LTIuMDQuOTU1LTMuMzg2Ljk1NS0yLjYwNSAwLTQuODEtMS43Ni01LjU5NS00LjEyM0gxLjA2NHYyLjU5QTkuOTk2IDkuOTk2IDAgMDAxMCAyMHoiIGZpbGw9IiMzNEE4NTMiIC8+CiAgICA8cGF0aCBkPSJNNC40MDUgMTEuOWMtLjItLjYtLjMxNC0xLjI0LS4zMTQtMS45IDAtLjY2LjExNC0xLjMuMzE0LTEuOVY1LjUxSDEuMDY0QTkuOTk2IDkuOTk2IDAgMDAwIDEwYzAgMS42MTQuMzg2IDMuMTQgMS4wNjQgNC40OWwzLjM0LTIuNTl6IiBmaWxsPSIjRkJCQzA1IiAvPgogICAgPHBhdGggZD0iTTEwIDMuOTc3YzEuNDY4IDAgMi43ODYuNTA1IDMuODIzIDEuNDk2bDIuODY4LTIuODY4QzE0Ljk1OS45OSAxMi42OTUgMCAxMCAwIDYuMDkgMCAyLjcxIDIuMjQgMS4wNjQgNS41MWwzLjM0IDIuNTlDNS4xOTIgNS43MzYgNy4zOTYgMy45NzcgMTAgMy45Nzd6IiBmaWxsPSIjRUE0MzM1IiAvPgogICAgPHBhdGggZD0iTTAgMGgyMHYyMEgweiIgLz4KICA8L2c+Cjwvc3ZnPg==", J1 = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLW1pdGVybGltaXQ9IjIiPjxwYXRoIGQ9Ik01MTIgNjRjMC0zNS4zMjMtMjguNjc3LTY0LTY0LTY0SDY0QzI4LjY3NyAwIDAgMjguNjc3IDAgNjR2Mzg0YzAgMzUuMzIzIDI4LjY3NyA2NCA2NCA2NGgzODRjMzUuMzIzIDAgNjQtMjguNjc3IDY0LTY0VjY0eiIgZmlsbD0iIzI4NjdiMiIvPjxnIGZpbGw9IiNmZmYiPjxwYXRoIGQ9Ik02MS4wNTMgMTc4LjY2N2g4NS43NnYyNTcuOTYyaC04NS43NnoiLz48cGF0aCBkPSJNMTA0LjUxMiA1NC4yOEM3NS4xNzEgNTQuMjggNTYgNzMuNTcgNTYgOTguODUzYzAgMjQuNzUyIDE4LjU4OCA0NC41NzQgNDcuMzc3IDQ0LjU3NGguNTU0YzI5LjkwMyAwIDQ4LjUxNi0xOS44MjIgNDguNTE2LTQ0LjU3NC0uNTU1LTI1LjI4My0xOC42MTEtNDQuNTczLTQ3LjkzNS00NC41NzN6TTM1Ny4yNzggMTcyLjYwMWMtNDUuNDkgMC02NS44NjYgMjUuMDE3LTc3LjI3NiA0Mi41ODl2LTM2LjUyM2gtODUuNzM4YzEuMTM3IDI0LjE5NyAwIDI1Ny45NjEgMCAyNTcuOTYxaDg1LjczN1YyOTIuNTY0YzAtNy43MTEuNTU0LTE1LjQyIDIuODI3LTIwLjkzMSA2LjE4OC0xNS40IDIwLjMwNS0zMS4zNTIgNDMuOTkzLTMxLjM1MiAzMS4wMTIgMCA0My40MzYgMjMuNjY0IDQzLjQzNiA1OC4zMjd2MTM4LjAyaDg1Ljc0MXYtMTQ3LjkzYzAtNzkuMjM3LTQyLjMwNS0xMTYuMDk3LTk4LjcyLTExNi4wOTd6IiBmaWxsLXJ1bGU9Im5vbnplcm8iLz48L2c+PC9zdmc+", Z1 = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCIgd2lkdGg9Ijk2IiBoZWlnaHQ9Ijk2Ij48cGF0aCBmaWxsPSIjMDNBOUY0IiBkPSJNNDIgMTIuNDI5YTE0Ljk3OCAxNC45NzggMCAwMS00LjI0NyAxLjE2MiA3LjM4IDcuMzggMCAwMDMuMjUxLTQuMDU4IDE0LjgyOSAxNC44MjkgMCAwMS00LjY5MyAxLjc3NkE3LjM3NyA3LjM3NyAwIDAwMzAuOTI2IDljLTQuMDggMC03LjM4NyAzLjI3OC03LjM4NyA3LjMyIDAgLjU3Mi4wNjcgMS4xMjkuMTkzIDEuNjdhMjEuMDUgMjEuMDUgMCAwMS0xNS4yMjQtNy42NTQgNy4yMyA3LjIzIDAgMDAtMSAzLjY4NmMwIDIuNTQxIDEuMzAxIDQuNzc4IDMuMjg1IDYuMDk2YTcuNTIgNy41MiAwIDAxLTMuMzQ5LS45MTR2LjA4NmMwIDMuNTUxIDIuNTQ3IDYuNTA4IDUuOTIzIDcuMTgxYTcuMzQ2IDcuMzQ2IDAgMDEtMS45NDEuMjYzYy0uNDc3IDAtLjk0Mi0uMDU0LTEuMzkyLS4xMzUuOTQgMi45MDIgMy42NjcgNS4wMjMgNi44OTggNS4wODZhMTQuOTI1IDE0LjkyNSAwIDAxLTkuMTc0IDMuMTM0IDE0LjYxIDE0LjYxIDAgMDEtMS43NjEtLjEwNEEyMS4xMDkgMjEuMTA5IDAgMDAxNy4zMjEgMzhjMTMuNTg1IDAgMjEuMDE3LTExLjE1NiAyMS4wMTctMjAuODM0IDAtLjMxNy0uMDEtLjYzMy0uMDI1LS45NDVBMTQuNTMyIDE0LjUzMiAwIDAwNDIgMTIuNDI5Ii8+PC9zdmc+", X1 = "data:image/svg+xml;base64,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";
function eS(t) {
  return xi({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" } }, { tag: "path", attr: { d: "M2 17h20v2H2v-2zm1.15-4.05L4 11.47l.85 1.48 1.3-.75-.85-1.48H7v-1.5H5.3l.85-1.47L4.85 7 4 8.47 3.15 7l-1.3.75.85 1.47H1v1.5h1.7l-.85 1.48 1.3.75zm6.7-.75l1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H15v-1.5h-1.7l.85-1.47-1.3-.75L12 8.47 11.15 7l-1.3.75.85 1.47H9v1.5h1.7l-.85 1.48zM23 9.22h-1.7l.85-1.47-1.3-.75L20 8.47 19.15 7l-1.3.75.85 1.47H17v1.5h1.7l-.85 1.48 1.3.75.85-1.48.85 1.48 1.3-.75-.85-1.48H23v-1.5z" } }] })(t);
}
function tS(t) {
  return xi({ tag: "svg", attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" } }, { tag: "path", attr: { d: "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h8v-2H4V8l8 5 8-5v5h2V6c0-1.1-.9-2-2-2zm-8 7L4 6h16l-8 5zm5.34 11l-3.54-3.54 1.41-1.41 2.12 2.12 4.24-4.24L23 16.34 17.34 22z" } }] })(t);
}
function rS(t) {
  return xi({ tag: "svg", attr: { viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { stroke: "none", d: "M0 0h24v24H0z", fill: "none" } }, { tag: "path", attr: { d: "M11 3h10v8h-3l-4 2v-2h-3z" } }, { tag: "path", attr: { d: "M15 16v4a1 1 0 0 1 -1 1h-8a1 1 0 0 1 -1 -1v-14a1 1 0 0 1 1 -1h2" } }, { tag: "path", attr: { d: "M10 18v.01" } }] })(t);
}
function nS(t) {
  return xi({ tag: "svg", attr: { viewBox: "0 0 24 24", strokeWidth: "2", stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { stroke: "none", d: "M0 0h24v24H0z", fill: "none" } }, { tag: "path", attr: { d: "M9 15l6 -6" } }, { tag: "path", attr: { d: "M11 6l.463 -.536a5 5 0 0 1 7.071 7.072l-.534 .464" } }, { tag: "path", attr: { d: "M13 18l-.397 .534a5.068 5.068 0 0 1 -7.127 0a4.972 4.972 0 0 1 0 -7.071l.524 -.463" } }] })(t);
}
function iS(t) {
  return xi({ tag: "svg", attr: { version: "1.2", baseProfile: "tiny", viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { d: "M4 18c-.552 0-1-.448-1-1v-6.382l-.553.276c-.495.248-1.095.046-1.342-.447-.247-.494-.046-1.094.448-1.342l2-1c.31-.155.678-.139.973.044.294.183.474.504.474.851v8c0 .552-.448 1-1 1zM13 18h-5c-.404 0-.769-.244-.924-.617-.155-.374-.069-.804.217-1.09l4-4c.254-.254.394-.591.394-.95 0-.358-.14-.695-.394-.949-.508-.508-1.39-.508-1.9.001-.253.252-.393.589-.393.948 0 .552-.448 1-1 1s-1-.448-1-1c0-.894.348-1.733.98-2.364 1.265-1.263 3.464-1.263 4.727.001.632.631.979 1.471.979 2.363 0 .893-.348 1.733-.979 2.364l-2.293 2.293h2.586c.552 0 1 .448 1 1s-.448 1-1 1zM20.955 12.377c.338-.457.545-1.016.545-1.627 0-1.517-1.234-2.75-2.75-2.75-1.031 0-1.966.569-2.44 1.484-.254.49-.063 1.094.428 1.348.49.254 1.094.062 1.348-.428.128-.249.383-.404.664-.404.414 0 .75.336.75.75s-.336.75-.75.75c-.552 0-1 .448-1 1s.448 1 1 1c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25-1.25-.561-1.25-1.25c0-.552-.448-1-1-1s-1 .448-1 1c0 1.792 1.458 3.25 3.25 3.25s3.25-1.458 3.25-3.25c0-.939-.406-1.779-1.045-2.373z" } }] })(t);
}
const oS = ({
  children: t,
  ...r
}) => /* @__PURE__ */ D("button", {
  ...r,
  children: t
}), Kn = ({
  logo: t
}) => /* @__PURE__ */ D("img", {
  src: t,
  alt: "",
  className: "userfront-button-icon",
  width: "32px",
  height: "32px"
}), aS = (t) => {
  switch (t.strategy) {
    case "password":
      return {
        logo: /* @__PURE__ */ D(eS, {
          className: "userfront-button-icon",
          size: "32px"
        }),
        text: "Username and password"
      };
    case "link":
      return {
        logo: /* @__PURE__ */ D(nS, {
          className: "userfront-button-icon",
          size: "32px"
        }),
        text: "Email me a link"
      };
    case "totp":
      return {
        logo: /* @__PURE__ */ D(iS, {
          className: "userfront-button-icon",
          size: "32px"
        }),
        text: "Use an authenticator app"
      };
    case "apple":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: G1
        }),
        text: "Apple"
      };
    case "azure":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: K1
        }),
        text: "Azure"
      };
    case "facebook":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: $1
        }),
        text: "Facebook"
      };
    case "github":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: Q1
        }),
        text: "Github"
      };
    case "google":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: H1
        }),
        text: "Google"
      };
    case "linkedin":
    case "linkedIn":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: J1
        }),
        text: "LinkedIn"
      };
    case "twitter":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: Z1
        }),
        text: "Twitter"
      };
    case "okta":
      return {
        logo: /* @__PURE__ */ D(Kn, {
          logo: X1
        }),
        text: "Okta"
      };
    case "verificationCode":
      switch (t.channel) {
        case "email":
          return {
            logo: /* @__PURE__ */ D(tS, {
              className: "userfront-button-icon",
              size: "32px"
            }),
            text: "Email me a code"
          };
        case "sms":
          return {
            logo: /* @__PURE__ */ D(rS, {
              className: "userfront-button-icon",
              size: "32px"
            }),
            text: "Text me a code"
          };
      }
    default:
      return {
        logo: null,
        text: t.strategy
      };
  }
}, md = ({
  factor: t,
  children: r,
  ...i
}) => {
  if (!t)
    return /* @__PURE__ */ D(oS, {
      ...i,
      children: r
    });
  const {
    logo: o,
    text: s
  } = aS(t);
  return /* @__PURE__ */ D("button", {
    ...i,
    className: "userfront-button userfront-button-secondary",
    children: /* @__PURE__ */ $e("span", {
      className: "userfront-icon-button-content",
      children: [o, /* @__PURE__ */ D("span", {
        className: "userfront-icon-button-text",
        children: `${s}`
      })]
    })
  });
}, Ah = ({
  onEvent: t,
  allowBack: r,
  collectUsername: i = !1,
  requirePasswordConfirmation: o = !1,
  error: s
}) => {
  const [c, l] = Qt(!1), [d, p] = Qt(!1);
  return /* @__PURE__ */ $e("form", {
    onSubmit: (w) => {
      w.preventDefault();
      const m = w.target.elements;
      if (l(!m.email.value), p(!m.password.value), !m.email.value || !m.password.value)
        return;
      const b = o ? m.confirmPassword.value : m.password.value;
      if (t) {
        const x = {
          type: "submit",
          email: m.email.value,
          password: m.password.value,
          confirmPassword: b
        };
        i && (x.username = m.username.value), t(x);
      }
    },
    className: "userfront-form",
    children: [i && /* @__PURE__ */ $e("div", {
      className: "userfront-form-row",
      children: [/* @__PURE__ */ D("label", {
        htmlFor: "username",
        children: "Username"
      }), /* @__PURE__ */ D("input", {
        className: "userfront-input",
        type: "text",
        name: "username"
      })]
    }), /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.Email, {
        label: "Email address",
        showError: c
      })
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-form-row",
      children: [/* @__PURE__ */ D($t.Password, {
        label: "Choose a password",
        showError: d
      }), /* @__PURE__ */ D("span", {
        className: "userfront-secondary-text",
        id: "userfront-password-rules",
        children: "At least 16 characters OR at least 8 characters including a number and a letter."
      })]
    }), o && /* @__PURE__ */ $e("div", {
      className: "userfront-form-row",
      children: [/* @__PURE__ */ D("label", {
        htmlFor: "confirmPassword",
        children: "Confirm your password"
      }), /* @__PURE__ */ D("input", {
        className: "userfront-input",
        type: "password",
        name: "confirmPassword"
      })]
    }), /* @__PURE__ */ D(rn, {
      error: s
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-button-row",
      children: [r && /* @__PURE__ */ D(kn, {
        onEvent: t
      }), /* @__PURE__ */ D(ni, {})]
    })]
  });
}, Ih = ({
  onEvent: t,
  allowBack: r,
  error: i
}) => {
  const [o, s] = Qt(!1), [c, l] = Qt(!1);
  return /* @__PURE__ */ $e("form", {
    onSubmit: (p) => {
      p.preventDefault();
      const v = p.target.elements;
      s(!v.emailOrUsername.value), l(!v.password.value), !(!v.emailOrUsername.value || !v.password.value) && t && t({
        type: "submit",
        emailOrUsername: v.emailOrUsername.value,
        password: v.password.value
      });
    },
    className: "userfront-form",
    children: [/* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.EmailOrUsername, {
        showError: o
      })
    }), /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.Password, {
        label: "Password",
        showError: c
      })
    }), /* @__PURE__ */ D(rn, {
      error: i
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-button-row",
      children: [r && /* @__PURE__ */ D(kn, {
        onEvent: t
      }), /* @__PURE__ */ D(ni, {})]
    })]
  });
}, vd = ({
  text: t
}) => t ? /* @__PURE__ */ $e("div", {
  className: "userfront-divider-split",
  children: [/* @__PURE__ */ D("div", {
    className: "userfront-divider"
  }), /* @__PURE__ */ D("span", {
    className: "userfront-divider-text",
    children: t
  }), /* @__PURE__ */ D("div", {
    className: "userfront-divider"
  })]
}) : /* @__PURE__ */ D("div", {
  className: "userfront-divider"
});
let sS = "console", uS = null;
const cS = (...t) => console.log(t), lS = (...t) => {
  switch (sS) {
    case "console":
      return cS(...t);
    case "custom":
      return uS;
    default:
      return;
  }
}, Pu = (t) => `${t.channel}-${t.strategy}`, ko = ({
  flow: t,
  isCompact: r = !1,
  onEvent: i,
  allowedSecondFactors: o,
  isSecondFactor: s = !1,
  isLogin: c = !1,
  error: l
}) => {
  const d = i || ((x) => lS("event", x)), p = s ? o : t.firstFactors, v = [], w = (x) => {
    d({
      factor: x,
      type: "selectFactor"
    });
  };
  let m = !1;
  const b = c ? Ih : Ah;
  for (let x = 0; x < p.length; x++) {
    const E = p[x];
    E.strategy !== "password" ? v.push(/* @__PURE__ */ D(md, {
      factor: E,
      onClick: () => w(E)
    }, Pu(E))) : r ? v.push(/* @__PURE__ */ D(md, {
      factor: E,
      onClick: () => w(E)
    }, Pu(E))) : (m = !0, x !== 0 && v.push(/* @__PURE__ */ D(vd, {
      text: "OR"
    }, "before_password")), v.push(/* @__PURE__ */ D(b, {
      onEvent: d,
      allowBack: !1,
      error: l
    }, Pu(E))), x < p.length - 1 && v.push(/* @__PURE__ */ D(vd, {
      text: "OR"
    }, "after_password")));
  }
  return /* @__PURE__ */ $e(ho, {
    children: [v, !m && /* @__PURE__ */ D(rn, {
      error: l
    })]
  });
}, yd = (t) => /* @__PURE__ */ D("button", {
  className: "userfront-button userfront-button-subtle",
  ...t
}), wd = ({
  showEmailOrUsername: t = !1,
  useBackupCode: r = !1,
  onEvent: i,
  allowBack: o,
  error: s
}) => {
  const [c, l] = Qt(!1), [d, p] = Qt(!1), [v, w] = Qt(!1), m = (E) => {
    var N, U;
    E.preventDefault();
    const _ = E.target.elements;
    if (!(t && (l(!_.emailOrUsername.value), !_.emailOrUsername.value)))
      if (r) {
        if (w(!_.backupCode.value), !_.backupCode.value)
          return;
        const A = {
          type: "submit",
          backupCode: _.backupCode.value
        };
        (N = _.emailOrUsername) != null && N.value && (A.emailOrUsername = _.emailOrUsername.value), i(A);
      } else {
        if (p(!_.totpCode.value), !_.totpCode.value)
          return;
        const A = {
          type: "submit",
          totpCode: _.totpCode.value
        };
        (U = E.target.elements.emailOrUsername) != null && U.value && (A.emailOrUsername = emailOrUsername.value), i(A);
      }
  }, b = (E) => {
    E.preventDefault(), i({
      type: "useBackupCode",
      useBackupCode: !1
    });
  }, x = (E) => {
    E.preventDefault(), i({
      type: "useBackupCode",
      useBackupCode: !0
    });
  };
  return /* @__PURE__ */ $e("form", {
    onSubmit: m,
    className: "userfront-form",
    children: [t && /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.EmailOrUsername, {
        showError: c
      })
    }), r ? /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.BackupCode, {
        showError: v
      })
    }) : /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.TotpCode, {
        showError: d
      })
    }), /* @__PURE__ */ D(rn, {
      error: s
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-button-row",
      children: [o && /* @__PURE__ */ D(kn, {
        onEvent: i
      }), /* @__PURE__ */ D(ni, {})]
    }), r ? /* @__PURE__ */ D(yd, {
      onClick: b,
      children: "Use a code from your authenticator app or device"
    }) : /* @__PURE__ */ D(yd, {
      onClick: x,
      children: "Use a backup code"
    })]
  });
}, Fu = ({
  qrCode: t,
  onEvent: r,
  allowBack: i,
  error: o
}) => {
  const [s, c] = Qt(!1);
  return /* @__PURE__ */ $e(ho, {
    children: [/* @__PURE__ */ D("p", {
      children: "1. Scan this QR code with your authenticator app"
    }), /* @__PURE__ */ D("img", {
      src: t,
      width: "100px",
      height: "100px"
    }), /* @__PURE__ */ D("p", {
      children: "2. Enter the six-digit code below"
    }), /* @__PURE__ */ $e("form", {
      onSubmit: (d) => {
        d.preventDefault();
        const p = d.target.elements.totpCode.value;
        c(!p), p && r({
          type: "submit",
          totpCode: p
        });
      },
      className: "userfront-form",
      children: [/* @__PURE__ */ D("div", {
        className: "userfront-form-row",
        children: /* @__PURE__ */ D($t.TotpCode, {
          label: "Six-digit code",
          showError: s
        })
      }), /* @__PURE__ */ D(rn, {
        error: o
      }), /* @__PURE__ */ $e("div", {
        className: "userfront-button-row",
        children: [i && /* @__PURE__ */ D(kn, {
          onEvent: r
        }), /* @__PURE__ */ D(ni, {})]
      })]
    })]
  });
}, jh = ({
  children: t,
  ...r
}) => /* @__PURE__ */ D("button", {
  className: "userfront-button userfront-button-subtle",
  ...r,
  children: t || "Retry"
}), fS = ({
  onEvent: t,
  allowBack: r,
  error: i
}) => /* @__PURE__ */ $e("div", {
  children: [/* @__PURE__ */ D("p", {
    children: "We could not retrieve your authenticator information. Please choose a different method or try again."
  }), /* @__PURE__ */ D(rn, {
    error: i
  }), r && /* @__PURE__ */ D(kn, {
    onEvent: t
  }), /* @__PURE__ */ D(jh, {
    onClick: () => {
      t({
        type: "retry"
      });
    },
    children: "Retry"
  })]
}), kh = (t) => /* @__PURE__ */ D("button", {
  className: "userfront-button userfront-button-primary",
  type: "submit",
  ...t,
  children: "Continue"
}), dS = ({
  backupCodes: t,
  onEvent: r
}) => {
  const i = (o) => {
    o.preventDefault(), r({
      type: "finish"
    });
  };
  return /* @__PURE__ */ $e(ho, {
    children: [/* @__PURE__ */ D("p", {
      children: "These are your backup codes. Each of these codes can be used once to log in, in place of the code from your authenticator app or device. Write these codes down and store them in a safe place."
    }), /* @__PURE__ */ D("ul", {
      children: t.map((o) => /* @__PURE__ */ D("li", {
        children: o
      }, o))
    }), /* @__PURE__ */ D(kh, {
      onClick: i,
      children: "Finish"
    })]
  });
};
var ti = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
(function(t, r) {
  (function() {
    var i, o = "4.17.21", s = 200, c = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", l = "Expected a function", d = "Invalid `variable` option passed into `_.template`", p = "__lodash_hash_undefined__", v = 500, w = "__lodash_placeholder__", m = 1, b = 2, x = 4, E = 1, _ = 2, N = 1, U = 2, A = 4, j = 8, R = 16, F = 32, B = 64, $ = 128, H = 256, te = 512, G = 30, ve = "...", be = 800, xe = 16, K = 1, ie = 2, ae = 3, se = 1 / 0, Re = 9007199254740991, ct = 17976931348623157e292, oe = 0 / 0, Q = 4294967295, we = Q - 1, ke = Q >>> 1, ne = [
      ["ary", $],
      ["bind", N],
      ["bindKey", U],
      ["curry", j],
      ["curryRight", R],
      ["flip", te],
      ["partial", F],
      ["partialRight", B],
      ["rearg", H]
    ], S = "[object Arguments]", Be = "[object Array]", Ue = "[object AsyncFunction]", Ie = "[object Boolean]", it = "[object Date]", lt = "[object DOMException]", dt = "[object Error]", ht = "[object Function]", Nt = "[object GeneratorFunction]", Qe = "[object Map]", k = "[object Number]", J = "[object Null]", ce = "[object Object]", Oe = "[object Promise]", Se = "[object Proxy]", _e = "[object RegExp]", Ee = "[object Set]", qe = "[object String]", de = "[object Symbol]", Te = "[object Undefined]", je = "[object WeakMap]", ge = "[object WeakSet]", pe = "[object ArrayBuffer]", ot = "[object DataView]", qt = "[object Float32Array]", At = "[object Float64Array]", Yt = "[object Int8Array]", tr = "[object Int16Array]", br = "[object Int32Array]", xt = "[object Uint8Array]", Or = "[object Uint8ClampedArray]", qr = "[object Uint16Array]", pn = "[object Uint32Array]", gn = /\b__p \+= '';/g, Yr = /\b(__p \+=) '' \+/g, _i = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Vr = /&(?:amp|lt|gt|quot|#39);/g, mn = /[&<>"']/g, Dn = RegExp(Vr.source), vn = RegExp(mn.source), nn = /<%-([\s\S]+?)%>/g, Sr = /<%([\s\S]+?)%>/g, ii = /<%=([\s\S]+?)%>/g, yn = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, oi = /^\w*$/, Ni = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, ai = /[\\^$.*+?()[\]{}|]/g, wn = RegExp(ai.source), Tr = /^\s+/, si = /\s/, Oi = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Li = /\{\n\/\* \[wrapped with (.+)\] \*/, M = /,? & /, X = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ue = /[()=,{}\[\]\/\s]/, Ce = /\\(\\)?/g, He = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, Xe = /\w*$/, Ye = /^[-+]0x[0-9a-f]+$/i, Ve = /^0b[01]+$/i, Dt = /^\[object .+?Constructor\]$/, Ot = /^0o[0-7]+$/i, y = /^(?:0|[1-9]\d*)$/, I = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, W = /($^)/, re = /['\n\r\u2028\u2029\\]/g, he = "\\ud800-\\udfff", Me = "\\u0300-\\u036f", De = "\\ufe20-\\ufe2f", yt = "\\u20d0-\\u20ff", St = Me + De + yt, at = "\\u2700-\\u27bf", et = "a-z\\xdf-\\xf6\\xf8-\\xff", pr = "\\xac\\xb1\\xd7\\xf7", gr = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", Ct = "\\u2000-\\u206f", Pt = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rr = "A-Z\\xc0-\\xd6\\xd8-\\xde", on = "\\ufe0e\\ufe0f", Gr = pr + gr + Ct + Pt, bn = "['\u2019]", Jo = "[" + he + "]", Zo = "[" + Gr + "]", Ai = "[" + St + "]", mt = "\\d+", pt = "[" + at + "]", Ii = "[" + et + "]", an = "[^" + he + Gr + mt + at + et + rr + "]", Rn = "\\ud83c[\\udffb-\\udfff]", ur = "(?:" + Ai + "|" + Rn + ")", Lr = "[^" + he + "]", Ar = "(?:\\ud83c[\\udde6-\\uddff]){2}", Sn = "[\\ud800-\\udbff][\\udc00-\\udfff]", Kr = "[" + rr + "]", Tn = "\\u200d", $r = "(?:" + Ii + "|" + an + ")", Xo = "(?:" + Kr + "|" + an + ")", ui = "(?:" + bn + "(?:d|ll|m|re|s|t|ve))?", ji = "(?:" + bn + "(?:D|LL|M|RE|S|T|VE))?", ci = ur + "?", li = "[" + on + "]?", ea = "(?:" + Tn + "(?:" + [Lr, Ar, Sn].join("|") + ")" + li + ci + ")*", ki = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Di = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", Rc = li + ci + ea, hp = "(?:" + [pt, Ar, Sn].join("|") + ")" + Rc, pp = "(?:" + [Lr + Ai + "?", Ai, Ar, Sn, Jo].join("|") + ")", gp = RegExp(bn, "g"), mp = RegExp(Ai, "g"), Ms = RegExp(Rn + "(?=" + Rn + ")|" + pp + Rc, "g"), vp = RegExp([
      Kr + "?" + Ii + "+" + ui + "(?=" + [Zo, Kr, "$"].join("|") + ")",
      Xo + "+" + ji + "(?=" + [Zo, Kr + $r, "$"].join("|") + ")",
      Kr + "?" + $r + "+" + ui,
      Kr + "+" + ji,
      Di,
      ki,
      mt,
      hp
    ].join("|"), "g"), yp = RegExp("[" + Tn + he + St + on + "]"), wp = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, bp = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], Sp = -1, Lt = {};
    Lt[qt] = Lt[At] = Lt[Yt] = Lt[tr] = Lt[br] = Lt[xt] = Lt[Or] = Lt[qr] = Lt[pn] = !0, Lt[S] = Lt[Be] = Lt[pe] = Lt[Ie] = Lt[ot] = Lt[it] = Lt[dt] = Lt[ht] = Lt[Qe] = Lt[k] = Lt[ce] = Lt[_e] = Lt[Ee] = Lt[qe] = Lt[je] = !1;
    var _t = {};
    _t[S] = _t[Be] = _t[pe] = _t[ot] = _t[Ie] = _t[it] = _t[qt] = _t[At] = _t[Yt] = _t[tr] = _t[br] = _t[Qe] = _t[k] = _t[ce] = _t[_e] = _t[Ee] = _t[qe] = _t[de] = _t[xt] = _t[Or] = _t[qr] = _t[pn] = !0, _t[dt] = _t[ht] = _t[je] = !1;
    var Tp = {
      \u00C0: "A",
      \u00C1: "A",
      \u00C2: "A",
      \u00C3: "A",
      \u00C4: "A",
      \u00C5: "A",
      \u00E0: "a",
      \u00E1: "a",
      \u00E2: "a",
      \u00E3: "a",
      \u00E4: "a",
      \u00E5: "a",
      \u00C7: "C",
      \u00E7: "c",
      \u00D0: "D",
      \u00F0: "d",
      \u00C8: "E",
      \u00C9: "E",
      \u00CA: "E",
      \u00CB: "E",
      \u00E8: "e",
      \u00E9: "e",
      \u00EA: "e",
      \u00EB: "e",
      \u00CC: "I",
      \u00CD: "I",
      \u00CE: "I",
      \u00CF: "I",
      \u00EC: "i",
      \u00ED: "i",
      \u00EE: "i",
      \u00EF: "i",
      \u00D1: "N",
      \u00F1: "n",
      \u00D2: "O",
      \u00D3: "O",
      \u00D4: "O",
      \u00D5: "O",
      \u00D6: "O",
      \u00D8: "O",
      \u00F2: "o",
      \u00F3: "o",
      \u00F4: "o",
      \u00F5: "o",
      \u00F6: "o",
      \u00F8: "o",
      \u00D9: "U",
      \u00DA: "U",
      \u00DB: "U",
      \u00DC: "U",
      \u00F9: "u",
      \u00FA: "u",
      \u00FB: "u",
      \u00FC: "u",
      \u00DD: "Y",
      \u00FD: "y",
      \u00FF: "y",
      \u00C6: "Ae",
      \u00E6: "ae",
      \u00DE: "Th",
      \u00FE: "th",
      \u00DF: "ss",
      \u0100: "A",
      \u0102: "A",
      \u0104: "A",
      \u0101: "a",
      \u0103: "a",
      \u0105: "a",
      \u0106: "C",
      \u0108: "C",
      \u010A: "C",
      \u010C: "C",
      \u0107: "c",
      \u0109: "c",
      \u010B: "c",
      \u010D: "c",
      \u010E: "D",
      \u0110: "D",
      \u010F: "d",
      \u0111: "d",
      \u0112: "E",
      \u0114: "E",
      \u0116: "E",
      \u0118: "E",
      \u011A: "E",
      \u0113: "e",
      \u0115: "e",
      \u0117: "e",
      \u0119: "e",
      \u011B: "e",
      \u011C: "G",
      \u011E: "G",
      \u0120: "G",
      \u0122: "G",
      \u011D: "g",
      \u011F: "g",
      \u0121: "g",
      \u0123: "g",
      \u0124: "H",
      \u0126: "H",
      \u0125: "h",
      \u0127: "h",
      \u0128: "I",
      \u012A: "I",
      \u012C: "I",
      \u012E: "I",
      \u0130: "I",
      \u0129: "i",
      \u012B: "i",
      \u012D: "i",
      \u012F: "i",
      \u0131: "i",
      \u0134: "J",
      \u0135: "j",
      \u0136: "K",
      \u0137: "k",
      \u0138: "k",
      \u0139: "L",
      \u013B: "L",
      \u013D: "L",
      \u013F: "L",
      \u0141: "L",
      \u013A: "l",
      \u013C: "l",
      \u013E: "l",
      \u0140: "l",
      \u0142: "l",
      \u0143: "N",
      \u0145: "N",
      \u0147: "N",
      \u014A: "N",
      \u0144: "n",
      \u0146: "n",
      \u0148: "n",
      \u014B: "n",
      \u014C: "O",
      \u014E: "O",
      \u0150: "O",
      \u014D: "o",
      \u014F: "o",
      \u0151: "o",
      \u0154: "R",
      \u0156: "R",
      \u0158: "R",
      \u0155: "r",
      \u0157: "r",
      \u0159: "r",
      \u015A: "S",
      \u015C: "S",
      \u015E: "S",
      \u0160: "S",
      \u015B: "s",
      \u015D: "s",
      \u015F: "s",
      \u0161: "s",
      \u0162: "T",
      \u0164: "T",
      \u0166: "T",
      \u0163: "t",
      \u0165: "t",
      \u0167: "t",
      \u0168: "U",
      \u016A: "U",
      \u016C: "U",
      \u016E: "U",
      \u0170: "U",
      \u0172: "U",
      \u0169: "u",
      \u016B: "u",
      \u016D: "u",
      \u016F: "u",
      \u0171: "u",
      \u0173: "u",
      \u0174: "W",
      \u0175: "w",
      \u0176: "Y",
      \u0177: "y",
      \u0178: "Y",
      \u0179: "Z",
      \u017B: "Z",
      \u017D: "Z",
      \u017A: "z",
      \u017C: "z",
      \u017E: "z",
      \u0132: "IJ",
      \u0133: "ij",
      \u0152: "Oe",
      \u0153: "oe",
      \u0149: "'n",
      \u017F: "s"
    }, Mp = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, Ep = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, xp = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, Cp = parseFloat, _p = parseInt, Pc = typeof Ao == "object" && Ao && Ao.Object === Object && Ao, Np = typeof self == "object" && self && self.Object === Object && self, Jt = Pc || Np || Function("return this")(), Es = r && !r.nodeType && r, fi = Es && !0 && t && !t.nodeType && t, Fc = fi && fi.exports === Es, xs = Fc && Pc.process, Ir = function() {
      try {
        var O = fi && fi.require && fi.require("util").types;
        return O || xs && xs.binding && xs.binding("util");
      } catch {
      }
    }(), Uc = Ir && Ir.isArrayBuffer, zc = Ir && Ir.isDate, Bc = Ir && Ir.isMap, Wc = Ir && Ir.isRegExp, qc = Ir && Ir.isSet, Yc = Ir && Ir.isTypedArray;
    function Mr(O, z, P) {
      switch (P.length) {
        case 0:
          return O.call(z);
        case 1:
          return O.call(z, P[0]);
        case 2:
          return O.call(z, P[0], P[1]);
        case 3:
          return O.call(z, P[0], P[1], P[2]);
      }
      return O.apply(z, P);
    }
    function Op(O, z, P, me) {
      for (var Pe = -1, gt = O == null ? 0 : O.length; ++Pe < gt; ) {
        var Gt = O[Pe];
        z(me, Gt, P(Gt), O);
      }
      return me;
    }
    function jr(O, z) {
      for (var P = -1, me = O == null ? 0 : O.length; ++P < me && z(O[P], P, O) !== !1; )
        ;
      return O;
    }
    function Lp(O, z) {
      for (var P = O == null ? 0 : O.length; P-- && z(O[P], P, O) !== !1; )
        ;
      return O;
    }
    function Vc(O, z) {
      for (var P = -1, me = O == null ? 0 : O.length; ++P < me; )
        if (!z(O[P], P, O))
          return !1;
      return !0;
    }
    function Pn(O, z) {
      for (var P = -1, me = O == null ? 0 : O.length, Pe = 0, gt = []; ++P < me; ) {
        var Gt = O[P];
        z(Gt, P, O) && (gt[Pe++] = Gt);
      }
      return gt;
    }
    function ta(O, z) {
      var P = O == null ? 0 : O.length;
      return !!P && Ri(O, z, 0) > -1;
    }
    function Cs(O, z, P) {
      for (var me = -1, Pe = O == null ? 0 : O.length; ++me < Pe; )
        if (P(z, O[me]))
          return !0;
      return !1;
    }
    function It(O, z) {
      for (var P = -1, me = O == null ? 0 : O.length, Pe = Array(me); ++P < me; )
        Pe[P] = z(O[P], P, O);
      return Pe;
    }
    function Fn(O, z) {
      for (var P = -1, me = z.length, Pe = O.length; ++P < me; )
        O[Pe + P] = z[P];
      return O;
    }
    function _s(O, z, P, me) {
      var Pe = -1, gt = O == null ? 0 : O.length;
      for (me && gt && (P = O[++Pe]); ++Pe < gt; )
        P = z(P, O[Pe], Pe, O);
      return P;
    }
    function Ap(O, z, P, me) {
      var Pe = O == null ? 0 : O.length;
      for (me && Pe && (P = O[--Pe]); Pe--; )
        P = z(P, O[Pe], Pe, O);
      return P;
    }
    function Ns(O, z) {
      for (var P = -1, me = O == null ? 0 : O.length; ++P < me; )
        if (z(O[P], P, O))
          return !0;
      return !1;
    }
    var Ip = Os("length");
    function jp(O) {
      return O.split("");
    }
    function kp(O) {
      return O.match(X) || [];
    }
    function Gc(O, z, P) {
      var me;
      return P(O, function(Pe, gt, Gt) {
        if (z(Pe, gt, Gt))
          return me = gt, !1;
      }), me;
    }
    function ra(O, z, P, me) {
      for (var Pe = O.length, gt = P + (me ? 1 : -1); me ? gt-- : ++gt < Pe; )
        if (z(O[gt], gt, O))
          return gt;
      return -1;
    }
    function Ri(O, z, P) {
      return z === z ? Gp(O, z, P) : ra(O, Kc, P);
    }
    function Dp(O, z, P, me) {
      for (var Pe = P - 1, gt = O.length; ++Pe < gt; )
        if (me(O[Pe], z))
          return Pe;
      return -1;
    }
    function Kc(O) {
      return O !== O;
    }
    function $c(O, z) {
      var P = O == null ? 0 : O.length;
      return P ? As(O, z) / P : oe;
    }
    function Os(O) {
      return function(z) {
        return z == null ? i : z[O];
      };
    }
    function Ls(O) {
      return function(z) {
        return O == null ? i : O[z];
      };
    }
    function Qc(O, z, P, me, Pe) {
      return Pe(O, function(gt, Gt, Mt) {
        P = me ? (me = !1, gt) : z(P, gt, Gt, Mt);
      }), P;
    }
    function Rp(O, z) {
      var P = O.length;
      for (O.sort(z); P--; )
        O[P] = O[P].value;
      return O;
    }
    function As(O, z) {
      for (var P, me = -1, Pe = O.length; ++me < Pe; ) {
        var gt = z(O[me]);
        gt !== i && (P = P === i ? gt : P + gt);
      }
      return P;
    }
    function Is(O, z) {
      for (var P = -1, me = Array(O); ++P < O; )
        me[P] = z(P);
      return me;
    }
    function Pp(O, z) {
      return It(z, function(P) {
        return [P, O[P]];
      });
    }
    function Hc(O) {
      return O && O.slice(0, el(O) + 1).replace(Tr, "");
    }
    function Er(O) {
      return function(z) {
        return O(z);
      };
    }
    function js(O, z) {
      return It(z, function(P) {
        return O[P];
      });
    }
    function go(O, z) {
      return O.has(z);
    }
    function Jc(O, z) {
      for (var P = -1, me = O.length; ++P < me && Ri(z, O[P], 0) > -1; )
        ;
      return P;
    }
    function Zc(O, z) {
      for (var P = O.length; P-- && Ri(z, O[P], 0) > -1; )
        ;
      return P;
    }
    function Fp(O, z) {
      for (var P = O.length, me = 0; P--; )
        O[P] === z && ++me;
      return me;
    }
    var Up = Ls(Tp), zp = Ls(Mp);
    function Bp(O) {
      return "\\" + xp[O];
    }
    function Wp(O, z) {
      return O == null ? i : O[z];
    }
    function Pi(O) {
      return yp.test(O);
    }
    function qp(O) {
      return wp.test(O);
    }
    function Yp(O) {
      for (var z, P = []; !(z = O.next()).done; )
        P.push(z.value);
      return P;
    }
    function ks(O) {
      var z = -1, P = Array(O.size);
      return O.forEach(function(me, Pe) {
        P[++z] = [Pe, me];
      }), P;
    }
    function Xc(O, z) {
      return function(P) {
        return O(z(P));
      };
    }
    function Un(O, z) {
      for (var P = -1, me = O.length, Pe = 0, gt = []; ++P < me; ) {
        var Gt = O[P];
        (Gt === z || Gt === w) && (O[P] = w, gt[Pe++] = P);
      }
      return gt;
    }
    function na(O) {
      var z = -1, P = Array(O.size);
      return O.forEach(function(me) {
        P[++z] = me;
      }), P;
    }
    function Vp(O) {
      var z = -1, P = Array(O.size);
      return O.forEach(function(me) {
        P[++z] = [me, me];
      }), P;
    }
    function Gp(O, z, P) {
      for (var me = P - 1, Pe = O.length; ++me < Pe; )
        if (O[me] === z)
          return me;
      return -1;
    }
    function Kp(O, z, P) {
      for (var me = P + 1; me--; )
        if (O[me] === z)
          return me;
      return me;
    }
    function Fi(O) {
      return Pi(O) ? Qp(O) : Ip(O);
    }
    function Qr(O) {
      return Pi(O) ? Hp(O) : jp(O);
    }
    function el(O) {
      for (var z = O.length; z-- && si.test(O.charAt(z)); )
        ;
      return z;
    }
    var $p = Ls(Ep);
    function Qp(O) {
      for (var z = Ms.lastIndex = 0; Ms.test(O); )
        ++z;
      return z;
    }
    function Hp(O) {
      return O.match(Ms) || [];
    }
    function Jp(O) {
      return O.match(vp) || [];
    }
    var Zp = function O(z) {
      z = z == null ? Jt : Ui.defaults(Jt.Object(), z, Ui.pick(Jt, bp));
      var P = z.Array, me = z.Date, Pe = z.Error, gt = z.Function, Gt = z.Math, Mt = z.Object, Ds = z.RegExp, Xp = z.String, kr = z.TypeError, ia = P.prototype, eg = gt.prototype, zi = Mt.prototype, oa = z["__core-js_shared__"], aa = eg.toString, wt = zi.hasOwnProperty, tg = 0, tl = function() {
        var e = /[^.]+$/.exec(oa && oa.keys && oa.keys.IE_PROTO || "");
        return e ? "Symbol(src)_1." + e : "";
      }(), sa = zi.toString, rg = aa.call(Mt), ng = Jt._, ig = Ds(
        "^" + aa.call(wt).replace(ai, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), ua = Fc ? z.Buffer : i, zn = z.Symbol, ca = z.Uint8Array, rl = ua ? ua.allocUnsafe : i, la = Xc(Mt.getPrototypeOf, Mt), nl = Mt.create, il = zi.propertyIsEnumerable, fa = ia.splice, ol = zn ? zn.isConcatSpreadable : i, mo = zn ? zn.iterator : i, di = zn ? zn.toStringTag : i, da = function() {
        try {
          var e = vi(Mt, "defineProperty");
          return e({}, "", {}), e;
        } catch {
        }
      }(), og = z.clearTimeout !== Jt.clearTimeout && z.clearTimeout, ag = me && me.now !== Jt.Date.now && me.now, sg = z.setTimeout !== Jt.setTimeout && z.setTimeout, ha = Gt.ceil, pa = Gt.floor, Rs = Mt.getOwnPropertySymbols, ug = ua ? ua.isBuffer : i, al = z.isFinite, cg = ia.join, lg = Xc(Mt.keys, Mt), Kt = Gt.max, nr = Gt.min, fg = me.now, dg = z.parseInt, sl = Gt.random, hg = ia.reverse, Ps = vi(z, "DataView"), vo = vi(z, "Map"), Fs = vi(z, "Promise"), Bi = vi(z, "Set"), yo = vi(z, "WeakMap"), wo = vi(Mt, "create"), ga = yo && new yo(), Wi = {}, pg = yi(Ps), gg = yi(vo), mg = yi(Fs), vg = yi(Bi), yg = yi(yo), ma = zn ? zn.prototype : i, bo = ma ? ma.valueOf : i, ul = ma ? ma.toString : i;
      function h(e) {
        if (Rt(e) && !Fe(e) && !(e instanceof Ze)) {
          if (e instanceof Dr)
            return e;
          if (wt.call(e, "__wrapped__"))
            return lf(e);
        }
        return new Dr(e);
      }
      var qi = function() {
        function e() {
        }
        return function(n) {
          if (!jt(n))
            return {};
          if (nl)
            return nl(n);
          e.prototype = n;
          var a = new e();
          return e.prototype = i, a;
        };
      }();
      function va() {
      }
      function Dr(e, n) {
        this.__wrapped__ = e, this.__actions__ = [], this.__chain__ = !!n, this.__index__ = 0, this.__values__ = i;
      }
      h.templateSettings = {
        escape: nn,
        evaluate: Sr,
        interpolate: ii,
        variable: "",
        imports: {
          _: h
        }
      }, h.prototype = va.prototype, h.prototype.constructor = h, Dr.prototype = qi(va.prototype), Dr.prototype.constructor = Dr;
      function Ze(e) {
        this.__wrapped__ = e, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function wg() {
        var e = new Ze(this.__wrapped__);
        return e.__actions__ = mr(this.__actions__), e.__dir__ = this.__dir__, e.__filtered__ = this.__filtered__, e.__iteratees__ = mr(this.__iteratees__), e.__takeCount__ = this.__takeCount__, e.__views__ = mr(this.__views__), e;
      }
      function bg() {
        if (this.__filtered__) {
          var e = new Ze(this);
          e.__dir__ = -1, e.__filtered__ = !0;
        } else
          e = this.clone(), e.__dir__ *= -1;
        return e;
      }
      function Sg() {
        var e = this.__wrapped__.value(), n = this.__dir__, a = Fe(e), u = n < 0, f = a ? e.length : 0, g = jm(0, f, this.__views__), T = g.start, C = g.end, L = C - T, q = u ? C : T - 1, Y = this.__iteratees__, Z = Y.length, fe = 0, ye = nr(L, this.__takeCount__);
        if (!a || !u && f == L && ye == L)
          return Il(e, this.__actions__);
        var Le = [];
        e:
          for (; L-- && fe < ye; ) {
            q += n;
            for (var Ge = -1, Ae = e[q]; ++Ge < Z; ) {
              var Je = Y[Ge], tt = Je.iteratee, _r = Je.type, fr = tt(Ae);
              if (_r == ie)
                Ae = fr;
              else if (!fr) {
                if (_r == K)
                  continue e;
                break e;
              }
            }
            Le[fe++] = Ae;
          }
        return Le;
      }
      Ze.prototype = qi(va.prototype), Ze.prototype.constructor = Ze;
      function hi(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.clear(); ++n < a; ) {
          var u = e[n];
          this.set(u[0], u[1]);
        }
      }
      function Tg() {
        this.__data__ = wo ? wo(null) : {}, this.size = 0;
      }
      function Mg(e) {
        var n = this.has(e) && delete this.__data__[e];
        return this.size -= n ? 1 : 0, n;
      }
      function Eg(e) {
        var n = this.__data__;
        if (wo) {
          var a = n[e];
          return a === p ? i : a;
        }
        return wt.call(n, e) ? n[e] : i;
      }
      function xg(e) {
        var n = this.__data__;
        return wo ? n[e] !== i : wt.call(n, e);
      }
      function Cg(e, n) {
        var a = this.__data__;
        return this.size += this.has(e) ? 0 : 1, a[e] = wo && n === i ? p : n, this;
      }
      hi.prototype.clear = Tg, hi.prototype.delete = Mg, hi.prototype.get = Eg, hi.prototype.has = xg, hi.prototype.set = Cg;
      function Mn(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.clear(); ++n < a; ) {
          var u = e[n];
          this.set(u[0], u[1]);
        }
      }
      function _g() {
        this.__data__ = [], this.size = 0;
      }
      function Ng(e) {
        var n = this.__data__, a = ya(n, e);
        if (a < 0)
          return !1;
        var u = n.length - 1;
        return a == u ? n.pop() : fa.call(n, a, 1), --this.size, !0;
      }
      function Og(e) {
        var n = this.__data__, a = ya(n, e);
        return a < 0 ? i : n[a][1];
      }
      function Lg(e) {
        return ya(this.__data__, e) > -1;
      }
      function Ag(e, n) {
        var a = this.__data__, u = ya(a, e);
        return u < 0 ? (++this.size, a.push([e, n])) : a[u][1] = n, this;
      }
      Mn.prototype.clear = _g, Mn.prototype.delete = Ng, Mn.prototype.get = Og, Mn.prototype.has = Lg, Mn.prototype.set = Ag;
      function En(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.clear(); ++n < a; ) {
          var u = e[n];
          this.set(u[0], u[1]);
        }
      }
      function Ig() {
        this.size = 0, this.__data__ = {
          hash: new hi(),
          map: new (vo || Mn)(),
          string: new hi()
        };
      }
      function jg(e) {
        var n = La(this, e).delete(e);
        return this.size -= n ? 1 : 0, n;
      }
      function kg(e) {
        return La(this, e).get(e);
      }
      function Dg(e) {
        return La(this, e).has(e);
      }
      function Rg(e, n) {
        var a = La(this, e), u = a.size;
        return a.set(e, n), this.size += a.size == u ? 0 : 1, this;
      }
      En.prototype.clear = Ig, En.prototype.delete = jg, En.prototype.get = kg, En.prototype.has = Dg, En.prototype.set = Rg;
      function pi(e) {
        var n = -1, a = e == null ? 0 : e.length;
        for (this.__data__ = new En(); ++n < a; )
          this.add(e[n]);
      }
      function Pg(e) {
        return this.__data__.set(e, p), this;
      }
      function Fg(e) {
        return this.__data__.has(e);
      }
      pi.prototype.add = pi.prototype.push = Pg, pi.prototype.has = Fg;
      function Hr(e) {
        var n = this.__data__ = new Mn(e);
        this.size = n.size;
      }
      function Ug() {
        this.__data__ = new Mn(), this.size = 0;
      }
      function zg(e) {
        var n = this.__data__, a = n.delete(e);
        return this.size = n.size, a;
      }
      function Bg(e) {
        return this.__data__.get(e);
      }
      function Wg(e) {
        return this.__data__.has(e);
      }
      function qg(e, n) {
        var a = this.__data__;
        if (a instanceof Mn) {
          var u = a.__data__;
          if (!vo || u.length < s - 1)
            return u.push([e, n]), this.size = ++a.size, this;
          a = this.__data__ = new En(u);
        }
        return a.set(e, n), this.size = a.size, this;
      }
      Hr.prototype.clear = Ug, Hr.prototype.delete = zg, Hr.prototype.get = Bg, Hr.prototype.has = Wg, Hr.prototype.set = qg;
      function cl(e, n) {
        var a = Fe(e), u = !a && wi(e), f = !a && !u && Vn(e), g = !a && !u && !f && Ki(e), T = a || u || f || g, C = T ? Is(e.length, Xp) : [], L = C.length;
        for (var q in e)
          (n || wt.call(e, q)) && !(T && (q == "length" || f && (q == "offset" || q == "parent") || g && (q == "buffer" || q == "byteLength" || q == "byteOffset") || Nn(q, L))) && C.push(q);
        return C;
      }
      function ll(e) {
        var n = e.length;
        return n ? e[Qs(0, n - 1)] : i;
      }
      function Yg(e, n) {
        return Aa(mr(e), gi(n, 0, e.length));
      }
      function Vg(e) {
        return Aa(mr(e));
      }
      function Us(e, n, a) {
        (a !== i && !Jr(e[n], a) || a === i && !(n in e)) && xn(e, n, a);
      }
      function So(e, n, a) {
        var u = e[n];
        (!(wt.call(e, n) && Jr(u, a)) || a === i && !(n in e)) && xn(e, n, a);
      }
      function ya(e, n) {
        for (var a = e.length; a--; )
          if (Jr(e[a][0], n))
            return a;
        return -1;
      }
      function Gg(e, n, a, u) {
        return Bn(e, function(f, g, T) {
          n(u, f, a(f), T);
        }), u;
      }
      function fl(e, n) {
        return e && un(n, Ht(n), e);
      }
      function Kg(e, n) {
        return e && un(n, yr(n), e);
      }
      function xn(e, n, a) {
        n == "__proto__" && da ? da(e, n, {
          configurable: !0,
          enumerable: !0,
          value: a,
          writable: !0
        }) : e[n] = a;
      }
      function zs(e, n) {
        for (var a = -1, u = n.length, f = P(u), g = e == null; ++a < u; )
          f[a] = g ? i : bu(e, n[a]);
        return f;
      }
      function gi(e, n, a) {
        return e === e && (a !== i && (e = e <= a ? e : a), n !== i && (e = e >= n ? e : n)), e;
      }
      function Rr(e, n, a, u, f, g) {
        var T, C = n & m, L = n & b, q = n & x;
        if (a && (T = f ? a(e, u, f, g) : a(e)), T !== i)
          return T;
        if (!jt(e))
          return e;
        var Y = Fe(e);
        if (Y) {
          if (T = Dm(e), !C)
            return mr(e, T);
        } else {
          var Z = ir(e), fe = Z == ht || Z == Nt;
          if (Vn(e))
            return Dl(e, C);
          if (Z == ce || Z == S || fe && !f) {
            if (T = L || fe ? {} : ef(e), !C)
              return L ? Em(e, Kg(T, e)) : Mm(e, fl(T, e));
          } else {
            if (!_t[Z])
              return f ? e : {};
            T = Rm(e, Z, C);
          }
        }
        g || (g = new Hr());
        var ye = g.get(e);
        if (ye)
          return ye;
        g.set(e, T), Lf(e) ? e.forEach(function(Ae) {
          T.add(Rr(Ae, n, a, Ae, e, g));
        }) : Nf(e) && e.forEach(function(Ae, Je) {
          T.set(Je, Rr(Ae, n, a, Je, e, g));
        });
        var Le = q ? L ? au : ou : L ? yr : Ht, Ge = Y ? i : Le(e);
        return jr(Ge || e, function(Ae, Je) {
          Ge && (Je = Ae, Ae = e[Je]), So(T, Je, Rr(Ae, n, a, Je, e, g));
        }), T;
      }
      function $g(e) {
        var n = Ht(e);
        return function(a) {
          return dl(a, e, n);
        };
      }
      function dl(e, n, a) {
        var u = a.length;
        if (e == null)
          return !u;
        for (e = Mt(e); u--; ) {
          var f = a[u], g = n[f], T = e[f];
          if (T === i && !(f in e) || !g(T))
            return !1;
        }
        return !0;
      }
      function hl(e, n, a) {
        if (typeof e != "function")
          throw new kr(l);
        return No(function() {
          e.apply(i, a);
        }, n);
      }
      function To(e, n, a, u) {
        var f = -1, g = ta, T = !0, C = e.length, L = [], q = n.length;
        if (!C)
          return L;
        a && (n = It(n, Er(a))), u ? (g = Cs, T = !1) : n.length >= s && (g = go, T = !1, n = new pi(n));
        e:
          for (; ++f < C; ) {
            var Y = e[f], Z = a == null ? Y : a(Y);
            if (Y = u || Y !== 0 ? Y : 0, T && Z === Z) {
              for (var fe = q; fe--; )
                if (n[fe] === Z)
                  continue e;
              L.push(Y);
            } else
              g(n, Z, u) || L.push(Y);
          }
        return L;
      }
      var Bn = zl(sn), pl = zl(Ws, !0);
      function Qg(e, n) {
        var a = !0;
        return Bn(e, function(u, f, g) {
          return a = !!n(u, f, g), a;
        }), a;
      }
      function wa(e, n, a) {
        for (var u = -1, f = e.length; ++u < f; ) {
          var g = e[u], T = n(g);
          if (T != null && (C === i ? T === T && !Cr(T) : a(T, C)))
            var C = T, L = g;
        }
        return L;
      }
      function Hg(e, n, a, u) {
        var f = e.length;
        for (a = We(a), a < 0 && (a = -a > f ? 0 : f + a), u = u === i || u > f ? f : We(u), u < 0 && (u += f), u = a > u ? 0 : If(u); a < u; )
          e[a++] = n;
        return e;
      }
      function gl(e, n) {
        var a = [];
        return Bn(e, function(u, f, g) {
          n(u, f, g) && a.push(u);
        }), a;
      }
      function Zt(e, n, a, u, f) {
        var g = -1, T = e.length;
        for (a || (a = Fm), f || (f = []); ++g < T; ) {
          var C = e[g];
          n > 0 && a(C) ? n > 1 ? Zt(C, n - 1, a, u, f) : Fn(f, C) : u || (f[f.length] = C);
        }
        return f;
      }
      var Bs = Bl(), ml = Bl(!0);
      function sn(e, n) {
        return e && Bs(e, n, Ht);
      }
      function Ws(e, n) {
        return e && ml(e, n, Ht);
      }
      function ba(e, n) {
        return Pn(n, function(a) {
          return On(e[a]);
        });
      }
      function mi(e, n) {
        n = qn(n, e);
        for (var a = 0, u = n.length; e != null && a < u; )
          e = e[cn(n[a++])];
        return a && a == u ? e : i;
      }
      function vl(e, n, a) {
        var u = n(e);
        return Fe(e) ? u : Fn(u, a(e));
      }
      function cr(e) {
        return e == null ? e === i ? Te : J : di && di in Mt(e) ? Im(e) : Vm(e);
      }
      function qs(e, n) {
        return e > n;
      }
      function Jg(e, n) {
        return e != null && wt.call(e, n);
      }
      function Zg(e, n) {
        return e != null && n in Mt(e);
      }
      function Xg(e, n, a) {
        return e >= nr(n, a) && e < Kt(n, a);
      }
      function Ys(e, n, a) {
        for (var u = a ? Cs : ta, f = e[0].length, g = e.length, T = g, C = P(g), L = 1 / 0, q = []; T--; ) {
          var Y = e[T];
          T && n && (Y = It(Y, Er(n))), L = nr(Y.length, L), C[T] = !a && (n || f >= 120 && Y.length >= 120) ? new pi(T && Y) : i;
        }
        Y = e[0];
        var Z = -1, fe = C[0];
        e:
          for (; ++Z < f && q.length < L; ) {
            var ye = Y[Z], Le = n ? n(ye) : ye;
            if (ye = a || ye !== 0 ? ye : 0, !(fe ? go(fe, Le) : u(q, Le, a))) {
              for (T = g; --T; ) {
                var Ge = C[T];
                if (!(Ge ? go(Ge, Le) : u(e[T], Le, a)))
                  continue e;
              }
              fe && fe.push(Le), q.push(ye);
            }
          }
        return q;
      }
      function em(e, n, a, u) {
        return sn(e, function(f, g, T) {
          n(u, a(f), g, T);
        }), u;
      }
      function Mo(e, n, a) {
        n = qn(n, e), e = of(e, n);
        var u = e == null ? e : e[cn(Fr(n))];
        return u == null ? i : Mr(u, e, a);
      }
      function yl(e) {
        return Rt(e) && cr(e) == S;
      }
      function tm(e) {
        return Rt(e) && cr(e) == pe;
      }
      function rm(e) {
        return Rt(e) && cr(e) == it;
      }
      function Eo(e, n, a, u, f) {
        return e === n ? !0 : e == null || n == null || !Rt(e) && !Rt(n) ? e !== e && n !== n : nm(e, n, a, u, Eo, f);
      }
      function nm(e, n, a, u, f, g) {
        var T = Fe(e), C = Fe(n), L = T ? Be : ir(e), q = C ? Be : ir(n);
        L = L == S ? ce : L, q = q == S ? ce : q;
        var Y = L == ce, Z = q == ce, fe = L == q;
        if (fe && Vn(e)) {
          if (!Vn(n))
            return !1;
          T = !0, Y = !1;
        }
        if (fe && !Y)
          return g || (g = new Hr()), T || Ki(e) ? Jl(e, n, a, u, f, g) : Lm(e, n, L, a, u, f, g);
        if (!(a & E)) {
          var ye = Y && wt.call(e, "__wrapped__"), Le = Z && wt.call(n, "__wrapped__");
          if (ye || Le) {
            var Ge = ye ? e.value() : e, Ae = Le ? n.value() : n;
            return g || (g = new Hr()), f(Ge, Ae, a, u, g);
          }
        }
        return fe ? (g || (g = new Hr()), Am(e, n, a, u, f, g)) : !1;
      }
      function im(e) {
        return Rt(e) && ir(e) == Qe;
      }
      function Vs(e, n, a, u) {
        var f = a.length, g = f, T = !u;
        if (e == null)
          return !g;
        for (e = Mt(e); f--; ) {
          var C = a[f];
          if (T && C[2] ? C[1] !== e[C[0]] : !(C[0] in e))
            return !1;
        }
        for (; ++f < g; ) {
          C = a[f];
          var L = C[0], q = e[L], Y = C[1];
          if (T && C[2]) {
            if (q === i && !(L in e))
              return !1;
          } else {
            var Z = new Hr();
            if (u)
              var fe = u(q, Y, L, e, n, Z);
            if (!(fe === i ? Eo(Y, q, E | _, u, Z) : fe))
              return !1;
          }
        }
        return !0;
      }
      function wl(e) {
        if (!jt(e) || zm(e))
          return !1;
        var n = On(e) ? ig : Dt;
        return n.test(yi(e));
      }
      function om(e) {
        return Rt(e) && cr(e) == _e;
      }
      function am(e) {
        return Rt(e) && ir(e) == Ee;
      }
      function sm(e) {
        return Rt(e) && Pa(e.length) && !!Lt[cr(e)];
      }
      function bl(e) {
        return typeof e == "function" ? e : e == null ? wr : typeof e == "object" ? Fe(e) ? Ml(e[0], e[1]) : Tl(e) : qf(e);
      }
      function Gs(e) {
        if (!_o(e))
          return lg(e);
        var n = [];
        for (var a in Mt(e))
          wt.call(e, a) && a != "constructor" && n.push(a);
        return n;
      }
      function um(e) {
        if (!jt(e))
          return Ym(e);
        var n = _o(e), a = [];
        for (var u in e)
          u == "constructor" && (n || !wt.call(e, u)) || a.push(u);
        return a;
      }
      function Ks(e, n) {
        return e < n;
      }
      function Sl(e, n) {
        var a = -1, u = vr(e) ? P(e.length) : [];
        return Bn(e, function(f, g, T) {
          u[++a] = n(f, g, T);
        }), u;
      }
      function Tl(e) {
        var n = uu(e);
        return n.length == 1 && n[0][2] ? rf(n[0][0], n[0][1]) : function(a) {
          return a === e || Vs(a, e, n);
        };
      }
      function Ml(e, n) {
        return lu(e) && tf(n) ? rf(cn(e), n) : function(a) {
          var u = bu(a, e);
          return u === i && u === n ? Su(a, e) : Eo(n, u, E | _);
        };
      }
      function Sa(e, n, a, u, f) {
        e !== n && Bs(n, function(g, T) {
          if (f || (f = new Hr()), jt(g))
            cm(e, n, T, a, Sa, u, f);
          else {
            var C = u ? u(du(e, T), g, T + "", e, n, f) : i;
            C === i && (C = g), Us(e, T, C);
          }
        }, yr);
      }
      function cm(e, n, a, u, f, g, T) {
        var C = du(e, a), L = du(n, a), q = T.get(L);
        if (q) {
          Us(e, a, q);
          return;
        }
        var Y = g ? g(C, L, a + "", e, n, T) : i, Z = Y === i;
        if (Z) {
          var fe = Fe(L), ye = !fe && Vn(L), Le = !fe && !ye && Ki(L);
          Y = L, fe || ye || Le ? Fe(C) ? Y = C : Ft(C) ? Y = mr(C) : ye ? (Z = !1, Y = Dl(L, !0)) : Le ? (Z = !1, Y = Rl(L, !0)) : Y = [] : Oo(L) || wi(L) ? (Y = C, wi(C) ? Y = jf(C) : (!jt(C) || On(C)) && (Y = ef(L))) : Z = !1;
        }
        Z && (T.set(L, Y), f(Y, L, u, g, T), T.delete(L)), Us(e, a, Y);
      }
      function El(e, n) {
        var a = e.length;
        if (!!a)
          return n += n < 0 ? a : 0, Nn(n, a) ? e[n] : i;
      }
      function xl(e, n, a) {
        n.length ? n = It(n, function(g) {
          return Fe(g) ? function(T) {
            return mi(T, g.length === 1 ? g[0] : g);
          } : g;
        }) : n = [wr];
        var u = -1;
        n = It(n, Er(Ne()));
        var f = Sl(e, function(g, T, C) {
          var L = It(n, function(q) {
            return q(g);
          });
          return { criteria: L, index: ++u, value: g };
        });
        return Rp(f, function(g, T) {
          return Tm(g, T, a);
        });
      }
      function lm(e, n) {
        return Cl(e, n, function(a, u) {
          return Su(e, u);
        });
      }
      function Cl(e, n, a) {
        for (var u = -1, f = n.length, g = {}; ++u < f; ) {
          var T = n[u], C = mi(e, T);
          a(C, T) && xo(g, qn(T, e), C);
        }
        return g;
      }
      function fm(e) {
        return function(n) {
          return mi(n, e);
        };
      }
      function $s(e, n, a, u) {
        var f = u ? Dp : Ri, g = -1, T = n.length, C = e;
        for (e === n && (n = mr(n)), a && (C = It(e, Er(a))); ++g < T; )
          for (var L = 0, q = n[g], Y = a ? a(q) : q; (L = f(C, Y, L, u)) > -1; )
            C !== e && fa.call(C, L, 1), fa.call(e, L, 1);
        return e;
      }
      function _l(e, n) {
        for (var a = e ? n.length : 0, u = a - 1; a--; ) {
          var f = n[a];
          if (a == u || f !== g) {
            var g = f;
            Nn(f) ? fa.call(e, f, 1) : Zs(e, f);
          }
        }
        return e;
      }
      function Qs(e, n) {
        return e + pa(sl() * (n - e + 1));
      }
      function dm(e, n, a, u) {
        for (var f = -1, g = Kt(ha((n - e) / (a || 1)), 0), T = P(g); g--; )
          T[u ? g : ++f] = e, e += a;
        return T;
      }
      function Hs(e, n) {
        var a = "";
        if (!e || n < 1 || n > Re)
          return a;
        do
          n % 2 && (a += e), n = pa(n / 2), n && (e += e);
        while (n);
        return a;
      }
      function Ke(e, n) {
        return hu(nf(e, n, wr), e + "");
      }
      function hm(e) {
        return ll($i(e));
      }
      function pm(e, n) {
        var a = $i(e);
        return Aa(a, gi(n, 0, a.length));
      }
      function xo(e, n, a, u) {
        if (!jt(e))
          return e;
        n = qn(n, e);
        for (var f = -1, g = n.length, T = g - 1, C = e; C != null && ++f < g; ) {
          var L = cn(n[f]), q = a;
          if (L === "__proto__" || L === "constructor" || L === "prototype")
            return e;
          if (f != T) {
            var Y = C[L];
            q = u ? u(Y, L, C) : i, q === i && (q = jt(Y) ? Y : Nn(n[f + 1]) ? [] : {});
          }
          So(C, L, q), C = C[L];
        }
        return e;
      }
      var Nl = ga ? function(e, n) {
        return ga.set(e, n), e;
      } : wr, gm = da ? function(e, n) {
        return da(e, "toString", {
          configurable: !0,
          enumerable: !1,
          value: Mu(n),
          writable: !0
        });
      } : wr;
      function mm(e) {
        return Aa($i(e));
      }
      function Pr(e, n, a) {
        var u = -1, f = e.length;
        n < 0 && (n = -n > f ? 0 : f + n), a = a > f ? f : a, a < 0 && (a += f), f = n > a ? 0 : a - n >>> 0, n >>>= 0;
        for (var g = P(f); ++u < f; )
          g[u] = e[u + n];
        return g;
      }
      function vm(e, n) {
        var a;
        return Bn(e, function(u, f, g) {
          return a = n(u, f, g), !a;
        }), !!a;
      }
      function Ta(e, n, a) {
        var u = 0, f = e == null ? u : e.length;
        if (typeof n == "number" && n === n && f <= ke) {
          for (; u < f; ) {
            var g = u + f >>> 1, T = e[g];
            T !== null && !Cr(T) && (a ? T <= n : T < n) ? u = g + 1 : f = g;
          }
          return f;
        }
        return Js(e, n, wr, a);
      }
      function Js(e, n, a, u) {
        var f = 0, g = e == null ? 0 : e.length;
        if (g === 0)
          return 0;
        n = a(n);
        for (var T = n !== n, C = n === null, L = Cr(n), q = n === i; f < g; ) {
          var Y = pa((f + g) / 2), Z = a(e[Y]), fe = Z !== i, ye = Z === null, Le = Z === Z, Ge = Cr(Z);
          if (T)
            var Ae = u || Le;
          else
            q ? Ae = Le && (u || fe) : C ? Ae = Le && fe && (u || !ye) : L ? Ae = Le && fe && !ye && (u || !Ge) : ye || Ge ? Ae = !1 : Ae = u ? Z <= n : Z < n;
          Ae ? f = Y + 1 : g = Y;
        }
        return nr(g, we);
      }
      function Ol(e, n) {
        for (var a = -1, u = e.length, f = 0, g = []; ++a < u; ) {
          var T = e[a], C = n ? n(T) : T;
          if (!a || !Jr(C, L)) {
            var L = C;
            g[f++] = T === 0 ? 0 : T;
          }
        }
        return g;
      }
      function Ll(e) {
        return typeof e == "number" ? e : Cr(e) ? oe : +e;
      }
      function xr(e) {
        if (typeof e == "string")
          return e;
        if (Fe(e))
          return It(e, xr) + "";
        if (Cr(e))
          return ul ? ul.call(e) : "";
        var n = e + "";
        return n == "0" && 1 / e == -se ? "-0" : n;
      }
      function Wn(e, n, a) {
        var u = -1, f = ta, g = e.length, T = !0, C = [], L = C;
        if (a)
          T = !1, f = Cs;
        else if (g >= s) {
          var q = n ? null : Nm(e);
          if (q)
            return na(q);
          T = !1, f = go, L = new pi();
        } else
          L = n ? [] : C;
        e:
          for (; ++u < g; ) {
            var Y = e[u], Z = n ? n(Y) : Y;
            if (Y = a || Y !== 0 ? Y : 0, T && Z === Z) {
              for (var fe = L.length; fe--; )
                if (L[fe] === Z)
                  continue e;
              n && L.push(Z), C.push(Y);
            } else
              f(L, Z, a) || (L !== C && L.push(Z), C.push(Y));
          }
        return C;
      }
      function Zs(e, n) {
        return n = qn(n, e), e = of(e, n), e == null || delete e[cn(Fr(n))];
      }
      function Al(e, n, a, u) {
        return xo(e, n, a(mi(e, n)), u);
      }
      function Ma(e, n, a, u) {
        for (var f = e.length, g = u ? f : -1; (u ? g-- : ++g < f) && n(e[g], g, e); )
          ;
        return a ? Pr(e, u ? 0 : g, u ? g + 1 : f) : Pr(e, u ? g + 1 : 0, u ? f : g);
      }
      function Il(e, n) {
        var a = e;
        return a instanceof Ze && (a = a.value()), _s(n, function(u, f) {
          return f.func.apply(f.thisArg, Fn([u], f.args));
        }, a);
      }
      function Xs(e, n, a) {
        var u = e.length;
        if (u < 2)
          return u ? Wn(e[0]) : [];
        for (var f = -1, g = P(u); ++f < u; )
          for (var T = e[f], C = -1; ++C < u; )
            C != f && (g[f] = To(g[f] || T, e[C], n, a));
        return Wn(Zt(g, 1), n, a);
      }
      function jl(e, n, a) {
        for (var u = -1, f = e.length, g = n.length, T = {}; ++u < f; ) {
          var C = u < g ? n[u] : i;
          a(T, e[u], C);
        }
        return T;
      }
      function eu(e) {
        return Ft(e) ? e : [];
      }
      function tu(e) {
        return typeof e == "function" ? e : wr;
      }
      function qn(e, n) {
        return Fe(e) ? e : lu(e, n) ? [e] : cf(vt(e));
      }
      var ym = Ke;
      function Yn(e, n, a) {
        var u = e.length;
        return a = a === i ? u : a, !n && a >= u ? e : Pr(e, n, a);
      }
      var kl = og || function(e) {
        return Jt.clearTimeout(e);
      };
      function Dl(e, n) {
        if (n)
          return e.slice();
        var a = e.length, u = rl ? rl(a) : new e.constructor(a);
        return e.copy(u), u;
      }
      function ru(e) {
        var n = new e.constructor(e.byteLength);
        return new ca(n).set(new ca(e)), n;
      }
      function wm(e, n) {
        var a = n ? ru(e.buffer) : e.buffer;
        return new e.constructor(a, e.byteOffset, e.byteLength);
      }
      function bm(e) {
        var n = new e.constructor(e.source, Xe.exec(e));
        return n.lastIndex = e.lastIndex, n;
      }
      function Sm(e) {
        return bo ? Mt(bo.call(e)) : {};
      }
      function Rl(e, n) {
        var a = n ? ru(e.buffer) : e.buffer;
        return new e.constructor(a, e.byteOffset, e.length);
      }
      function Pl(e, n) {
        if (e !== n) {
          var a = e !== i, u = e === null, f = e === e, g = Cr(e), T = n !== i, C = n === null, L = n === n, q = Cr(n);
          if (!C && !q && !g && e > n || g && T && L && !C && !q || u && T && L || !a && L || !f)
            return 1;
          if (!u && !g && !q && e < n || q && a && f && !u && !g || C && a && f || !T && f || !L)
            return -1;
        }
        return 0;
      }
      function Tm(e, n, a) {
        for (var u = -1, f = e.criteria, g = n.criteria, T = f.length, C = a.length; ++u < T; ) {
          var L = Pl(f[u], g[u]);
          if (L) {
            if (u >= C)
              return L;
            var q = a[u];
            return L * (q == "desc" ? -1 : 1);
          }
        }
        return e.index - n.index;
      }
      function Fl(e, n, a, u) {
        for (var f = -1, g = e.length, T = a.length, C = -1, L = n.length, q = Kt(g - T, 0), Y = P(L + q), Z = !u; ++C < L; )
          Y[C] = n[C];
        for (; ++f < T; )
          (Z || f < g) && (Y[a[f]] = e[f]);
        for (; q--; )
          Y[C++] = e[f++];
        return Y;
      }
      function Ul(e, n, a, u) {
        for (var f = -1, g = e.length, T = -1, C = a.length, L = -1, q = n.length, Y = Kt(g - C, 0), Z = P(Y + q), fe = !u; ++f < Y; )
          Z[f] = e[f];
        for (var ye = f; ++L < q; )
          Z[ye + L] = n[L];
        for (; ++T < C; )
          (fe || f < g) && (Z[ye + a[T]] = e[f++]);
        return Z;
      }
      function mr(e, n) {
        var a = -1, u = e.length;
        for (n || (n = P(u)); ++a < u; )
          n[a] = e[a];
        return n;
      }
      function un(e, n, a, u) {
        var f = !a;
        a || (a = {});
        for (var g = -1, T = n.length; ++g < T; ) {
          var C = n[g], L = u ? u(a[C], e[C], C, a, e) : i;
          L === i && (L = e[C]), f ? xn(a, C, L) : So(a, C, L);
        }
        return a;
      }
      function Mm(e, n) {
        return un(e, cu(e), n);
      }
      function Em(e, n) {
        return un(e, Zl(e), n);
      }
      function Ea(e, n) {
        return function(a, u) {
          var f = Fe(a) ? Op : Gg, g = n ? n() : {};
          return f(a, e, Ne(u, 2), g);
        };
      }
      function Yi(e) {
        return Ke(function(n, a) {
          var u = -1, f = a.length, g = f > 1 ? a[f - 1] : i, T = f > 2 ? a[2] : i;
          for (g = e.length > 3 && typeof g == "function" ? (f--, g) : i, T && lr(a[0], a[1], T) && (g = f < 3 ? i : g, f = 1), n = Mt(n); ++u < f; ) {
            var C = a[u];
            C && e(n, C, u, g);
          }
          return n;
        });
      }
      function zl(e, n) {
        return function(a, u) {
          if (a == null)
            return a;
          if (!vr(a))
            return e(a, u);
          for (var f = a.length, g = n ? f : -1, T = Mt(a); (n ? g-- : ++g < f) && u(T[g], g, T) !== !1; )
            ;
          return a;
        };
      }
      function Bl(e) {
        return function(n, a, u) {
          for (var f = -1, g = Mt(n), T = u(n), C = T.length; C--; ) {
            var L = T[e ? C : ++f];
            if (a(g[L], L, g) === !1)
              break;
          }
          return n;
        };
      }
      function xm(e, n, a) {
        var u = n & N, f = Co(e);
        function g() {
          var T = this && this !== Jt && this instanceof g ? f : e;
          return T.apply(u ? a : this, arguments);
        }
        return g;
      }
      function Wl(e) {
        return function(n) {
          n = vt(n);
          var a = Pi(n) ? Qr(n) : i, u = a ? a[0] : n.charAt(0), f = a ? Yn(a, 1).join("") : n.slice(1);
          return u[e]() + f;
        };
      }
      function Vi(e) {
        return function(n) {
          return _s(Bf(zf(n).replace(gp, "")), e, "");
        };
      }
      function Co(e) {
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return new e();
            case 1:
              return new e(n[0]);
            case 2:
              return new e(n[0], n[1]);
            case 3:
              return new e(n[0], n[1], n[2]);
            case 4:
              return new e(n[0], n[1], n[2], n[3]);
            case 5:
              return new e(n[0], n[1], n[2], n[3], n[4]);
            case 6:
              return new e(n[0], n[1], n[2], n[3], n[4], n[5]);
            case 7:
              return new e(n[0], n[1], n[2], n[3], n[4], n[5], n[6]);
          }
          var a = qi(e.prototype), u = e.apply(a, n);
          return jt(u) ? u : a;
        };
      }
      function Cm(e, n, a) {
        var u = Co(e);
        function f() {
          for (var g = arguments.length, T = P(g), C = g, L = Gi(f); C--; )
            T[C] = arguments[C];
          var q = g < 3 && T[0] !== L && T[g - 1] !== L ? [] : Un(T, L);
          if (g -= q.length, g < a)
            return Kl(
              e,
              n,
              xa,
              f.placeholder,
              i,
              T,
              q,
              i,
              i,
              a - g
            );
          var Y = this && this !== Jt && this instanceof f ? u : e;
          return Mr(Y, this, T);
        }
        return f;
      }
      function ql(e) {
        return function(n, a, u) {
          var f = Mt(n);
          if (!vr(n)) {
            var g = Ne(a, 3);
            n = Ht(n), a = function(C) {
              return g(f[C], C, f);
            };
          }
          var T = e(n, a, u);
          return T > -1 ? f[g ? n[T] : T] : i;
        };
      }
      function Yl(e) {
        return _n(function(n) {
          var a = n.length, u = a, f = Dr.prototype.thru;
          for (e && n.reverse(); u--; ) {
            var g = n[u];
            if (typeof g != "function")
              throw new kr(l);
            if (f && !T && Oa(g) == "wrapper")
              var T = new Dr([], !0);
          }
          for (u = T ? u : a; ++u < a; ) {
            g = n[u];
            var C = Oa(g), L = C == "wrapper" ? su(g) : i;
            L && fu(L[0]) && L[1] == ($ | j | F | H) && !L[4].length && L[9] == 1 ? T = T[Oa(L[0])].apply(T, L[3]) : T = g.length == 1 && fu(g) ? T[C]() : T.thru(g);
          }
          return function() {
            var q = arguments, Y = q[0];
            if (T && q.length == 1 && Fe(Y))
              return T.plant(Y).value();
            for (var Z = 0, fe = a ? n[Z].apply(this, q) : Y; ++Z < a; )
              fe = n[Z].call(this, fe);
            return fe;
          };
        });
      }
      function xa(e, n, a, u, f, g, T, C, L, q) {
        var Y = n & $, Z = n & N, fe = n & U, ye = n & (j | R), Le = n & te, Ge = fe ? i : Co(e);
        function Ae() {
          for (var Je = arguments.length, tt = P(Je), _r = Je; _r--; )
            tt[_r] = arguments[_r];
          if (ye)
            var fr = Gi(Ae), Nr = Fp(tt, fr);
          if (u && (tt = Fl(tt, u, f, ye)), g && (tt = Ul(tt, g, T, ye)), Je -= Nr, ye && Je < q) {
            var Ut = Un(tt, fr);
            return Kl(
              e,
              n,
              xa,
              Ae.placeholder,
              a,
              tt,
              Ut,
              C,
              L,
              q - Je
            );
          }
          var Zr = Z ? a : this, An = fe ? Zr[e] : e;
          return Je = tt.length, C ? tt = Gm(tt, C) : Le && Je > 1 && tt.reverse(), Y && L < Je && (tt.length = L), this && this !== Jt && this instanceof Ae && (An = Ge || Co(An)), An.apply(Zr, tt);
        }
        return Ae;
      }
      function Vl(e, n) {
        return function(a, u) {
          return em(a, e, n(u), {});
        };
      }
      function Ca(e, n) {
        return function(a, u) {
          var f;
          if (a === i && u === i)
            return n;
          if (a !== i && (f = a), u !== i) {
            if (f === i)
              return u;
            typeof a == "string" || typeof u == "string" ? (a = xr(a), u = xr(u)) : (a = Ll(a), u = Ll(u)), f = e(a, u);
          }
          return f;
        };
      }
      function nu(e) {
        return _n(function(n) {
          return n = It(n, Er(Ne())), Ke(function(a) {
            var u = this;
            return e(n, function(f) {
              return Mr(f, u, a);
            });
          });
        });
      }
      function _a(e, n) {
        n = n === i ? " " : xr(n);
        var a = n.length;
        if (a < 2)
          return a ? Hs(n, e) : n;
        var u = Hs(n, ha(e / Fi(n)));
        return Pi(n) ? Yn(Qr(u), 0, e).join("") : u.slice(0, e);
      }
      function _m(e, n, a, u) {
        var f = n & N, g = Co(e);
        function T() {
          for (var C = -1, L = arguments.length, q = -1, Y = u.length, Z = P(Y + L), fe = this && this !== Jt && this instanceof T ? g : e; ++q < Y; )
            Z[q] = u[q];
          for (; L--; )
            Z[q++] = arguments[++C];
          return Mr(fe, f ? a : this, Z);
        }
        return T;
      }
      function Gl(e) {
        return function(n, a, u) {
          return u && typeof u != "number" && lr(n, a, u) && (a = u = i), n = Ln(n), a === i ? (a = n, n = 0) : a = Ln(a), u = u === i ? n < a ? 1 : -1 : Ln(u), dm(n, a, u, e);
        };
      }
      function Na(e) {
        return function(n, a) {
          return typeof n == "string" && typeof a == "string" || (n = Ur(n), a = Ur(a)), e(n, a);
        };
      }
      function Kl(e, n, a, u, f, g, T, C, L, q) {
        var Y = n & j, Z = Y ? T : i, fe = Y ? i : T, ye = Y ? g : i, Le = Y ? i : g;
        n |= Y ? F : B, n &= ~(Y ? B : F), n & A || (n &= ~(N | U));
        var Ge = [
          e,
          n,
          f,
          ye,
          Z,
          Le,
          fe,
          C,
          L,
          q
        ], Ae = a.apply(i, Ge);
        return fu(e) && af(Ae, Ge), Ae.placeholder = u, sf(Ae, e, n);
      }
      function iu(e) {
        var n = Gt[e];
        return function(a, u) {
          if (a = Ur(a), u = u == null ? 0 : nr(We(u), 292), u && al(a)) {
            var f = (vt(a) + "e").split("e"), g = n(f[0] + "e" + (+f[1] + u));
            return f = (vt(g) + "e").split("e"), +(f[0] + "e" + (+f[1] - u));
          }
          return n(a);
        };
      }
      var Nm = Bi && 1 / na(new Bi([, -0]))[1] == se ? function(e) {
        return new Bi(e);
      } : Cu;
      function $l(e) {
        return function(n) {
          var a = ir(n);
          return a == Qe ? ks(n) : a == Ee ? Vp(n) : Pp(n, e(n));
        };
      }
      function Cn(e, n, a, u, f, g, T, C) {
        var L = n & U;
        if (!L && typeof e != "function")
          throw new kr(l);
        var q = u ? u.length : 0;
        if (q || (n &= ~(F | B), u = f = i), T = T === i ? T : Kt(We(T), 0), C = C === i ? C : We(C), q -= f ? f.length : 0, n & B) {
          var Y = u, Z = f;
          u = f = i;
        }
        var fe = L ? i : su(e), ye = [
          e,
          n,
          a,
          u,
          f,
          Y,
          Z,
          g,
          T,
          C
        ];
        if (fe && qm(ye, fe), e = ye[0], n = ye[1], a = ye[2], u = ye[3], f = ye[4], C = ye[9] = ye[9] === i ? L ? 0 : e.length : Kt(ye[9] - q, 0), !C && n & (j | R) && (n &= ~(j | R)), !n || n == N)
          var Le = xm(e, n, a);
        else
          n == j || n == R ? Le = Cm(e, n, C) : (n == F || n == (N | F)) && !f.length ? Le = _m(e, n, a, u) : Le = xa.apply(i, ye);
        var Ge = fe ? Nl : af;
        return sf(Ge(Le, ye), e, n);
      }
      function Ql(e, n, a, u) {
        return e === i || Jr(e, zi[a]) && !wt.call(u, a) ? n : e;
      }
      function Hl(e, n, a, u, f, g) {
        return jt(e) && jt(n) && (g.set(n, e), Sa(e, n, i, Hl, g), g.delete(n)), e;
      }
      function Om(e) {
        return Oo(e) ? i : e;
      }
      function Jl(e, n, a, u, f, g) {
        var T = a & E, C = e.length, L = n.length;
        if (C != L && !(T && L > C))
          return !1;
        var q = g.get(e), Y = g.get(n);
        if (q && Y)
          return q == n && Y == e;
        var Z = -1, fe = !0, ye = a & _ ? new pi() : i;
        for (g.set(e, n), g.set(n, e); ++Z < C; ) {
          var Le = e[Z], Ge = n[Z];
          if (u)
            var Ae = T ? u(Ge, Le, Z, n, e, g) : u(Le, Ge, Z, e, n, g);
          if (Ae !== i) {
            if (Ae)
              continue;
            fe = !1;
            break;
          }
          if (ye) {
            if (!Ns(n, function(Je, tt) {
              if (!go(ye, tt) && (Le === Je || f(Le, Je, a, u, g)))
                return ye.push(tt);
            })) {
              fe = !1;
              break;
            }
          } else if (!(Le === Ge || f(Le, Ge, a, u, g))) {
            fe = !1;
            break;
          }
        }
        return g.delete(e), g.delete(n), fe;
      }
      function Lm(e, n, a, u, f, g, T) {
        switch (a) {
          case ot:
            if (e.byteLength != n.byteLength || e.byteOffset != n.byteOffset)
              return !1;
            e = e.buffer, n = n.buffer;
          case pe:
            return !(e.byteLength != n.byteLength || !g(new ca(e), new ca(n)));
          case Ie:
          case it:
          case k:
            return Jr(+e, +n);
          case dt:
            return e.name == n.name && e.message == n.message;
          case _e:
          case qe:
            return e == n + "";
          case Qe:
            var C = ks;
          case Ee:
            var L = u & E;
            if (C || (C = na), e.size != n.size && !L)
              return !1;
            var q = T.get(e);
            if (q)
              return q == n;
            u |= _, T.set(e, n);
            var Y = Jl(C(e), C(n), u, f, g, T);
            return T.delete(e), Y;
          case de:
            if (bo)
              return bo.call(e) == bo.call(n);
        }
        return !1;
      }
      function Am(e, n, a, u, f, g) {
        var T = a & E, C = ou(e), L = C.length, q = ou(n), Y = q.length;
        if (L != Y && !T)
          return !1;
        for (var Z = L; Z--; ) {
          var fe = C[Z];
          if (!(T ? fe in n : wt.call(n, fe)))
            return !1;
        }
        var ye = g.get(e), Le = g.get(n);
        if (ye && Le)
          return ye == n && Le == e;
        var Ge = !0;
        g.set(e, n), g.set(n, e);
        for (var Ae = T; ++Z < L; ) {
          fe = C[Z];
          var Je = e[fe], tt = n[fe];
          if (u)
            var _r = T ? u(tt, Je, fe, n, e, g) : u(Je, tt, fe, e, n, g);
          if (!(_r === i ? Je === tt || f(Je, tt, a, u, g) : _r)) {
            Ge = !1;
            break;
          }
          Ae || (Ae = fe == "constructor");
        }
        if (Ge && !Ae) {
          var fr = e.constructor, Nr = n.constructor;
          fr != Nr && "constructor" in e && "constructor" in n && !(typeof fr == "function" && fr instanceof fr && typeof Nr == "function" && Nr instanceof Nr) && (Ge = !1);
        }
        return g.delete(e), g.delete(n), Ge;
      }
      function _n(e) {
        return hu(nf(e, i, hf), e + "");
      }
      function ou(e) {
        return vl(e, Ht, cu);
      }
      function au(e) {
        return vl(e, yr, Zl);
      }
      var su = ga ? function(e) {
        return ga.get(e);
      } : Cu;
      function Oa(e) {
        for (var n = e.name + "", a = Wi[n], u = wt.call(Wi, n) ? a.length : 0; u--; ) {
          var f = a[u], g = f.func;
          if (g == null || g == e)
            return f.name;
        }
        return n;
      }
      function Gi(e) {
        var n = wt.call(h, "placeholder") ? h : e;
        return n.placeholder;
      }
      function Ne() {
        var e = h.iteratee || Eu;
        return e = e === Eu ? bl : e, arguments.length ? e(arguments[0], arguments[1]) : e;
      }
      function La(e, n) {
        var a = e.__data__;
        return Um(n) ? a[typeof n == "string" ? "string" : "hash"] : a.map;
      }
      function uu(e) {
        for (var n = Ht(e), a = n.length; a--; ) {
          var u = n[a], f = e[u];
          n[a] = [u, f, tf(f)];
        }
        return n;
      }
      function vi(e, n) {
        var a = Wp(e, n);
        return wl(a) ? a : i;
      }
      function Im(e) {
        var n = wt.call(e, di), a = e[di];
        try {
          e[di] = i;
          var u = !0;
        } catch {
        }
        var f = sa.call(e);
        return u && (n ? e[di] = a : delete e[di]), f;
      }
      var cu = Rs ? function(e) {
        return e == null ? [] : (e = Mt(e), Pn(Rs(e), function(n) {
          return il.call(e, n);
        }));
      } : _u, Zl = Rs ? function(e) {
        for (var n = []; e; )
          Fn(n, cu(e)), e = la(e);
        return n;
      } : _u, ir = cr;
      (Ps && ir(new Ps(new ArrayBuffer(1))) != ot || vo && ir(new vo()) != Qe || Fs && ir(Fs.resolve()) != Oe || Bi && ir(new Bi()) != Ee || yo && ir(new yo()) != je) && (ir = function(e) {
        var n = cr(e), a = n == ce ? e.constructor : i, u = a ? yi(a) : "";
        if (u)
          switch (u) {
            case pg:
              return ot;
            case gg:
              return Qe;
            case mg:
              return Oe;
            case vg:
              return Ee;
            case yg:
              return je;
          }
        return n;
      });
      function jm(e, n, a) {
        for (var u = -1, f = a.length; ++u < f; ) {
          var g = a[u], T = g.size;
          switch (g.type) {
            case "drop":
              e += T;
              break;
            case "dropRight":
              n -= T;
              break;
            case "take":
              n = nr(n, e + T);
              break;
            case "takeRight":
              e = Kt(e, n - T);
              break;
          }
        }
        return { start: e, end: n };
      }
      function km(e) {
        var n = e.match(Li);
        return n ? n[1].split(M) : [];
      }
      function Xl(e, n, a) {
        n = qn(n, e);
        for (var u = -1, f = n.length, g = !1; ++u < f; ) {
          var T = cn(n[u]);
          if (!(g = e != null && a(e, T)))
            break;
          e = e[T];
        }
        return g || ++u != f ? g : (f = e == null ? 0 : e.length, !!f && Pa(f) && Nn(T, f) && (Fe(e) || wi(e)));
      }
      function Dm(e) {
        var n = e.length, a = new e.constructor(n);
        return n && typeof e[0] == "string" && wt.call(e, "index") && (a.index = e.index, a.input = e.input), a;
      }
      function ef(e) {
        return typeof e.constructor == "function" && !_o(e) ? qi(la(e)) : {};
      }
      function Rm(e, n, a) {
        var u = e.constructor;
        switch (n) {
          case pe:
            return ru(e);
          case Ie:
          case it:
            return new u(+e);
          case ot:
            return wm(e, a);
          case qt:
          case At:
          case Yt:
          case tr:
          case br:
          case xt:
          case Or:
          case qr:
          case pn:
            return Rl(e, a);
          case Qe:
            return new u();
          case k:
          case qe:
            return new u(e);
          case _e:
            return bm(e);
          case Ee:
            return new u();
          case de:
            return Sm(e);
        }
      }
      function Pm(e, n) {
        var a = n.length;
        if (!a)
          return e;
        var u = a - 1;
        return n[u] = (a > 1 ? "& " : "") + n[u], n = n.join(a > 2 ? ", " : " "), e.replace(Oi, `{
/* [wrapped with ` + n + `] */
`);
      }
      function Fm(e) {
        return Fe(e) || wi(e) || !!(ol && e && e[ol]);
      }
      function Nn(e, n) {
        var a = typeof e;
        return n = n == null ? Re : n, !!n && (a == "number" || a != "symbol" && y.test(e)) && e > -1 && e % 1 == 0 && e < n;
      }
      function lr(e, n, a) {
        if (!jt(a))
          return !1;
        var u = typeof n;
        return (u == "number" ? vr(a) && Nn(n, a.length) : u == "string" && n in a) ? Jr(a[n], e) : !1;
      }
      function lu(e, n) {
        if (Fe(e))
          return !1;
        var a = typeof e;
        return a == "number" || a == "symbol" || a == "boolean" || e == null || Cr(e) ? !0 : oi.test(e) || !yn.test(e) || n != null && e in Mt(n);
      }
      function Um(e) {
        var n = typeof e;
        return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
      }
      function fu(e) {
        var n = Oa(e), a = h[n];
        if (typeof a != "function" || !(n in Ze.prototype))
          return !1;
        if (e === a)
          return !0;
        var u = su(a);
        return !!u && e === u[0];
      }
      function zm(e) {
        return !!tl && tl in e;
      }
      var Bm = oa ? On : Nu;
      function _o(e) {
        var n = e && e.constructor, a = typeof n == "function" && n.prototype || zi;
        return e === a;
      }
      function tf(e) {
        return e === e && !jt(e);
      }
      function rf(e, n) {
        return function(a) {
          return a == null ? !1 : a[e] === n && (n !== i || e in Mt(a));
        };
      }
      function Wm(e) {
        var n = Da(e, function(u) {
          return a.size === v && a.clear(), u;
        }), a = n.cache;
        return n;
      }
      function qm(e, n) {
        var a = e[1], u = n[1], f = a | u, g = f < (N | U | $), T = u == $ && a == j || u == $ && a == H && e[7].length <= n[8] || u == ($ | H) && n[7].length <= n[8] && a == j;
        if (!(g || T))
          return e;
        u & N && (e[2] = n[2], f |= a & N ? 0 : A);
        var C = n[3];
        if (C) {
          var L = e[3];
          e[3] = L ? Fl(L, C, n[4]) : C, e[4] = L ? Un(e[3], w) : n[4];
        }
        return C = n[5], C && (L = e[5], e[5] = L ? Ul(L, C, n[6]) : C, e[6] = L ? Un(e[5], w) : n[6]), C = n[7], C && (e[7] = C), u & $ && (e[8] = e[8] == null ? n[8] : nr(e[8], n[8])), e[9] == null && (e[9] = n[9]), e[0] = n[0], e[1] = f, e;
      }
      function Ym(e) {
        var n = [];
        if (e != null)
          for (var a in Mt(e))
            n.push(a);
        return n;
      }
      function Vm(e) {
        return sa.call(e);
      }
      function nf(e, n, a) {
        return n = Kt(n === i ? e.length - 1 : n, 0), function() {
          for (var u = arguments, f = -1, g = Kt(u.length - n, 0), T = P(g); ++f < g; )
            T[f] = u[n + f];
          f = -1;
          for (var C = P(n + 1); ++f < n; )
            C[f] = u[f];
          return C[n] = a(T), Mr(e, this, C);
        };
      }
      function of(e, n) {
        return n.length < 2 ? e : mi(e, Pr(n, 0, -1));
      }
      function Gm(e, n) {
        for (var a = e.length, u = nr(n.length, a), f = mr(e); u--; ) {
          var g = n[u];
          e[u] = Nn(g, a) ? f[g] : i;
        }
        return e;
      }
      function du(e, n) {
        if (!(n === "constructor" && typeof e[n] == "function") && n != "__proto__")
          return e[n];
      }
      var af = uf(Nl), No = sg || function(e, n) {
        return Jt.setTimeout(e, n);
      }, hu = uf(gm);
      function sf(e, n, a) {
        var u = n + "";
        return hu(e, Pm(u, Km(km(u), a)));
      }
      function uf(e) {
        var n = 0, a = 0;
        return function() {
          var u = fg(), f = xe - (u - a);
          if (a = u, f > 0) {
            if (++n >= be)
              return arguments[0];
          } else
            n = 0;
          return e.apply(i, arguments);
        };
      }
      function Aa(e, n) {
        var a = -1, u = e.length, f = u - 1;
        for (n = n === i ? u : n; ++a < n; ) {
          var g = Qs(a, f), T = e[g];
          e[g] = e[a], e[a] = T;
        }
        return e.length = n, e;
      }
      var cf = Wm(function(e) {
        var n = [];
        return e.charCodeAt(0) === 46 && n.push(""), e.replace(Ni, function(a, u, f, g) {
          n.push(f ? g.replace(Ce, "$1") : u || a);
        }), n;
      });
      function cn(e) {
        if (typeof e == "string" || Cr(e))
          return e;
        var n = e + "";
        return n == "0" && 1 / e == -se ? "-0" : n;
      }
      function yi(e) {
        if (e != null) {
          try {
            return aa.call(e);
          } catch {
          }
          try {
            return e + "";
          } catch {
          }
        }
        return "";
      }
      function Km(e, n) {
        return jr(ne, function(a) {
          var u = "_." + a[0];
          n & a[1] && !ta(e, u) && e.push(u);
        }), e.sort();
      }
      function lf(e) {
        if (e instanceof Ze)
          return e.clone();
        var n = new Dr(e.__wrapped__, e.__chain__);
        return n.__actions__ = mr(e.__actions__), n.__index__ = e.__index__, n.__values__ = e.__values__, n;
      }
      function $m(e, n, a) {
        (a ? lr(e, n, a) : n === i) ? n = 1 : n = Kt(We(n), 0);
        var u = e == null ? 0 : e.length;
        if (!u || n < 1)
          return [];
        for (var f = 0, g = 0, T = P(ha(u / n)); f < u; )
          T[g++] = Pr(e, f, f += n);
        return T;
      }
      function Qm(e) {
        for (var n = -1, a = e == null ? 0 : e.length, u = 0, f = []; ++n < a; ) {
          var g = e[n];
          g && (f[u++] = g);
        }
        return f;
      }
      function Hm() {
        var e = arguments.length;
        if (!e)
          return [];
        for (var n = P(e - 1), a = arguments[0], u = e; u--; )
          n[u - 1] = arguments[u];
        return Fn(Fe(a) ? mr(a) : [a], Zt(n, 1));
      }
      var Jm = Ke(function(e, n) {
        return Ft(e) ? To(e, Zt(n, 1, Ft, !0)) : [];
      }), Zm = Ke(function(e, n) {
        var a = Fr(n);
        return Ft(a) && (a = i), Ft(e) ? To(e, Zt(n, 1, Ft, !0), Ne(a, 2)) : [];
      }), Xm = Ke(function(e, n) {
        var a = Fr(n);
        return Ft(a) && (a = i), Ft(e) ? To(e, Zt(n, 1, Ft, !0), i, a) : [];
      });
      function ev(e, n, a) {
        var u = e == null ? 0 : e.length;
        return u ? (n = a || n === i ? 1 : We(n), Pr(e, n < 0 ? 0 : n, u)) : [];
      }
      function tv(e, n, a) {
        var u = e == null ? 0 : e.length;
        return u ? (n = a || n === i ? 1 : We(n), n = u - n, Pr(e, 0, n < 0 ? 0 : n)) : [];
      }
      function rv(e, n) {
        return e && e.length ? Ma(e, Ne(n, 3), !0, !0) : [];
      }
      function nv(e, n) {
        return e && e.length ? Ma(e, Ne(n, 3), !0) : [];
      }
      function iv(e, n, a, u) {
        var f = e == null ? 0 : e.length;
        return f ? (a && typeof a != "number" && lr(e, n, a) && (a = 0, u = f), Hg(e, n, a, u)) : [];
      }
      function ff(e, n, a) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var f = a == null ? 0 : We(a);
        return f < 0 && (f = Kt(u + f, 0)), ra(e, Ne(n, 3), f);
      }
      function df(e, n, a) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var f = u - 1;
        return a !== i && (f = We(a), f = a < 0 ? Kt(u + f, 0) : nr(f, u - 1)), ra(e, Ne(n, 3), f, !0);
      }
      function hf(e) {
        var n = e == null ? 0 : e.length;
        return n ? Zt(e, 1) : [];
      }
      function ov(e) {
        var n = e == null ? 0 : e.length;
        return n ? Zt(e, se) : [];
      }
      function av(e, n) {
        var a = e == null ? 0 : e.length;
        return a ? (n = n === i ? 1 : We(n), Zt(e, n)) : [];
      }
      function sv(e) {
        for (var n = -1, a = e == null ? 0 : e.length, u = {}; ++n < a; ) {
          var f = e[n];
          u[f[0]] = f[1];
        }
        return u;
      }
      function pf(e) {
        return e && e.length ? e[0] : i;
      }
      function uv(e, n, a) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var f = a == null ? 0 : We(a);
        return f < 0 && (f = Kt(u + f, 0)), Ri(e, n, f);
      }
      function cv(e) {
        var n = e == null ? 0 : e.length;
        return n ? Pr(e, 0, -1) : [];
      }
      var lv = Ke(function(e) {
        var n = It(e, eu);
        return n.length && n[0] === e[0] ? Ys(n) : [];
      }), fv = Ke(function(e) {
        var n = Fr(e), a = It(e, eu);
        return n === Fr(a) ? n = i : a.pop(), a.length && a[0] === e[0] ? Ys(a, Ne(n, 2)) : [];
      }), dv = Ke(function(e) {
        var n = Fr(e), a = It(e, eu);
        return n = typeof n == "function" ? n : i, n && a.pop(), a.length && a[0] === e[0] ? Ys(a, i, n) : [];
      });
      function hv(e, n) {
        return e == null ? "" : cg.call(e, n);
      }
      function Fr(e) {
        var n = e == null ? 0 : e.length;
        return n ? e[n - 1] : i;
      }
      function pv(e, n, a) {
        var u = e == null ? 0 : e.length;
        if (!u)
          return -1;
        var f = u;
        return a !== i && (f = We(a), f = f < 0 ? Kt(u + f, 0) : nr(f, u - 1)), n === n ? Kp(e, n, f) : ra(e, Kc, f, !0);
      }
      function gv(e, n) {
        return e && e.length ? El(e, We(n)) : i;
      }
      var mv = Ke(gf);
      function gf(e, n) {
        return e && e.length && n && n.length ? $s(e, n) : e;
      }
      function vv(e, n, a) {
        return e && e.length && n && n.length ? $s(e, n, Ne(a, 2)) : e;
      }
      function yv(e, n, a) {
        return e && e.length && n && n.length ? $s(e, n, i, a) : e;
      }
      var wv = _n(function(e, n) {
        var a = e == null ? 0 : e.length, u = zs(e, n);
        return _l(e, It(n, function(f) {
          return Nn(f, a) ? +f : f;
        }).sort(Pl)), u;
      });
      function bv(e, n) {
        var a = [];
        if (!(e && e.length))
          return a;
        var u = -1, f = [], g = e.length;
        for (n = Ne(n, 3); ++u < g; ) {
          var T = e[u];
          n(T, u, e) && (a.push(T), f.push(u));
        }
        return _l(e, f), a;
      }
      function pu(e) {
        return e == null ? e : hg.call(e);
      }
      function Sv(e, n, a) {
        var u = e == null ? 0 : e.length;
        return u ? (a && typeof a != "number" && lr(e, n, a) ? (n = 0, a = u) : (n = n == null ? 0 : We(n), a = a === i ? u : We(a)), Pr(e, n, a)) : [];
      }
      function Tv(e, n) {
        return Ta(e, n);
      }
      function Mv(e, n, a) {
        return Js(e, n, Ne(a, 2));
      }
      function Ev(e, n) {
        var a = e == null ? 0 : e.length;
        if (a) {
          var u = Ta(e, n);
          if (u < a && Jr(e[u], n))
            return u;
        }
        return -1;
      }
      function xv(e, n) {
        return Ta(e, n, !0);
      }
      function Cv(e, n, a) {
        return Js(e, n, Ne(a, 2), !0);
      }
      function _v(e, n) {
        var a = e == null ? 0 : e.length;
        if (a) {
          var u = Ta(e, n, !0) - 1;
          if (Jr(e[u], n))
            return u;
        }
        return -1;
      }
      function Nv(e) {
        return e && e.length ? Ol(e) : [];
      }
      function Ov(e, n) {
        return e && e.length ? Ol(e, Ne(n, 2)) : [];
      }
      function Lv(e) {
        var n = e == null ? 0 : e.length;
        return n ? Pr(e, 1, n) : [];
      }
      function Av(e, n, a) {
        return e && e.length ? (n = a || n === i ? 1 : We(n), Pr(e, 0, n < 0 ? 0 : n)) : [];
      }
      function Iv(e, n, a) {
        var u = e == null ? 0 : e.length;
        return u ? (n = a || n === i ? 1 : We(n), n = u - n, Pr(e, n < 0 ? 0 : n, u)) : [];
      }
      function jv(e, n) {
        return e && e.length ? Ma(e, Ne(n, 3), !1, !0) : [];
      }
      function kv(e, n) {
        return e && e.length ? Ma(e, Ne(n, 3)) : [];
      }
      var Dv = Ke(function(e) {
        return Wn(Zt(e, 1, Ft, !0));
      }), Rv = Ke(function(e) {
        var n = Fr(e);
        return Ft(n) && (n = i), Wn(Zt(e, 1, Ft, !0), Ne(n, 2));
      }), Pv = Ke(function(e) {
        var n = Fr(e);
        return n = typeof n == "function" ? n : i, Wn(Zt(e, 1, Ft, !0), i, n);
      });
      function Fv(e) {
        return e && e.length ? Wn(e) : [];
      }
      function Uv(e, n) {
        return e && e.length ? Wn(e, Ne(n, 2)) : [];
      }
      function zv(e, n) {
        return n = typeof n == "function" ? n : i, e && e.length ? Wn(e, i, n) : [];
      }
      function gu(e) {
        if (!(e && e.length))
          return [];
        var n = 0;
        return e = Pn(e, function(a) {
          if (Ft(a))
            return n = Kt(a.length, n), !0;
        }), Is(n, function(a) {
          return It(e, Os(a));
        });
      }
      function mf(e, n) {
        if (!(e && e.length))
          return [];
        var a = gu(e);
        return n == null ? a : It(a, function(u) {
          return Mr(n, i, u);
        });
      }
      var Bv = Ke(function(e, n) {
        return Ft(e) ? To(e, n) : [];
      }), Wv = Ke(function(e) {
        return Xs(Pn(e, Ft));
      }), qv = Ke(function(e) {
        var n = Fr(e);
        return Ft(n) && (n = i), Xs(Pn(e, Ft), Ne(n, 2));
      }), Yv = Ke(function(e) {
        var n = Fr(e);
        return n = typeof n == "function" ? n : i, Xs(Pn(e, Ft), i, n);
      }), Vv = Ke(gu);
      function Gv(e, n) {
        return jl(e || [], n || [], So);
      }
      function Kv(e, n) {
        return jl(e || [], n || [], xo);
      }
      var $v = Ke(function(e) {
        var n = e.length, a = n > 1 ? e[n - 1] : i;
        return a = typeof a == "function" ? (e.pop(), a) : i, mf(e, a);
      });
      function vf(e) {
        var n = h(e);
        return n.__chain__ = !0, n;
      }
      function Qv(e, n) {
        return n(e), e;
      }
      function Ia(e, n) {
        return n(e);
      }
      var Hv = _n(function(e) {
        var n = e.length, a = n ? e[0] : 0, u = this.__wrapped__, f = function(g) {
          return zs(g, e);
        };
        return n > 1 || this.__actions__.length || !(u instanceof Ze) || !Nn(a) ? this.thru(f) : (u = u.slice(a, +a + (n ? 1 : 0)), u.__actions__.push({
          func: Ia,
          args: [f],
          thisArg: i
        }), new Dr(u, this.__chain__).thru(function(g) {
          return n && !g.length && g.push(i), g;
        }));
      });
      function Jv() {
        return vf(this);
      }
      function Zv() {
        return new Dr(this.value(), this.__chain__);
      }
      function Xv() {
        this.__values__ === i && (this.__values__ = Af(this.value()));
        var e = this.__index__ >= this.__values__.length, n = e ? i : this.__values__[this.__index__++];
        return { done: e, value: n };
      }
      function ey() {
        return this;
      }
      function ty(e) {
        for (var n, a = this; a instanceof va; ) {
          var u = lf(a);
          u.__index__ = 0, u.__values__ = i, n ? f.__wrapped__ = u : n = u;
          var f = u;
          a = a.__wrapped__;
        }
        return f.__wrapped__ = e, n;
      }
      function ry() {
        var e = this.__wrapped__;
        if (e instanceof Ze) {
          var n = e;
          return this.__actions__.length && (n = new Ze(this)), n = n.reverse(), n.__actions__.push({
            func: Ia,
            args: [pu],
            thisArg: i
          }), new Dr(n, this.__chain__);
        }
        return this.thru(pu);
      }
      function ny() {
        return Il(this.__wrapped__, this.__actions__);
      }
      var iy = Ea(function(e, n, a) {
        wt.call(e, a) ? ++e[a] : xn(e, a, 1);
      });
      function oy(e, n, a) {
        var u = Fe(e) ? Vc : Qg;
        return a && lr(e, n, a) && (n = i), u(e, Ne(n, 3));
      }
      function ay(e, n) {
        var a = Fe(e) ? Pn : gl;
        return a(e, Ne(n, 3));
      }
      var sy = ql(ff), uy = ql(df);
      function cy(e, n) {
        return Zt(ja(e, n), 1);
      }
      function ly(e, n) {
        return Zt(ja(e, n), se);
      }
      function fy(e, n, a) {
        return a = a === i ? 1 : We(a), Zt(ja(e, n), a);
      }
      function yf(e, n) {
        var a = Fe(e) ? jr : Bn;
        return a(e, Ne(n, 3));
      }
      function wf(e, n) {
        var a = Fe(e) ? Lp : pl;
        return a(e, Ne(n, 3));
      }
      var dy = Ea(function(e, n, a) {
        wt.call(e, a) ? e[a].push(n) : xn(e, a, [n]);
      });
      function hy(e, n, a, u) {
        e = vr(e) ? e : $i(e), a = a && !u ? We(a) : 0;
        var f = e.length;
        return a < 0 && (a = Kt(f + a, 0)), Fa(e) ? a <= f && e.indexOf(n, a) > -1 : !!f && Ri(e, n, a) > -1;
      }
      var py = Ke(function(e, n, a) {
        var u = -1, f = typeof n == "function", g = vr(e) ? P(e.length) : [];
        return Bn(e, function(T) {
          g[++u] = f ? Mr(n, T, a) : Mo(T, n, a);
        }), g;
      }), gy = Ea(function(e, n, a) {
        xn(e, a, n);
      });
      function ja(e, n) {
        var a = Fe(e) ? It : Sl;
        return a(e, Ne(n, 3));
      }
      function my(e, n, a, u) {
        return e == null ? [] : (Fe(n) || (n = n == null ? [] : [n]), a = u ? i : a, Fe(a) || (a = a == null ? [] : [a]), xl(e, n, a));
      }
      var vy = Ea(function(e, n, a) {
        e[a ? 0 : 1].push(n);
      }, function() {
        return [[], []];
      });
      function yy(e, n, a) {
        var u = Fe(e) ? _s : Qc, f = arguments.length < 3;
        return u(e, Ne(n, 4), a, f, Bn);
      }
      function wy(e, n, a) {
        var u = Fe(e) ? Ap : Qc, f = arguments.length < 3;
        return u(e, Ne(n, 4), a, f, pl);
      }
      function by(e, n) {
        var a = Fe(e) ? Pn : gl;
        return a(e, Ra(Ne(n, 3)));
      }
      function Sy(e) {
        var n = Fe(e) ? ll : hm;
        return n(e);
      }
      function Ty(e, n, a) {
        (a ? lr(e, n, a) : n === i) ? n = 1 : n = We(n);
        var u = Fe(e) ? Yg : pm;
        return u(e, n);
      }
      function My(e) {
        var n = Fe(e) ? Vg : mm;
        return n(e);
      }
      function Ey(e) {
        if (e == null)
          return 0;
        if (vr(e))
          return Fa(e) ? Fi(e) : e.length;
        var n = ir(e);
        return n == Qe || n == Ee ? e.size : Gs(e).length;
      }
      function xy(e, n, a) {
        var u = Fe(e) ? Ns : vm;
        return a && lr(e, n, a) && (n = i), u(e, Ne(n, 3));
      }
      var Cy = Ke(function(e, n) {
        if (e == null)
          return [];
        var a = n.length;
        return a > 1 && lr(e, n[0], n[1]) ? n = [] : a > 2 && lr(n[0], n[1], n[2]) && (n = [n[0]]), xl(e, Zt(n, 1), []);
      }), ka = ag || function() {
        return Jt.Date.now();
      };
      function _y(e, n) {
        if (typeof n != "function")
          throw new kr(l);
        return e = We(e), function() {
          if (--e < 1)
            return n.apply(this, arguments);
        };
      }
      function bf(e, n, a) {
        return n = a ? i : n, n = e && n == null ? e.length : n, Cn(e, $, i, i, i, i, n);
      }
      function Sf(e, n) {
        var a;
        if (typeof n != "function")
          throw new kr(l);
        return e = We(e), function() {
          return --e > 0 && (a = n.apply(this, arguments)), e <= 1 && (n = i), a;
        };
      }
      var mu = Ke(function(e, n, a) {
        var u = N;
        if (a.length) {
          var f = Un(a, Gi(mu));
          u |= F;
        }
        return Cn(e, u, n, a, f);
      }), Tf = Ke(function(e, n, a) {
        var u = N | U;
        if (a.length) {
          var f = Un(a, Gi(Tf));
          u |= F;
        }
        return Cn(n, u, e, a, f);
      });
      function Mf(e, n, a) {
        n = a ? i : n;
        var u = Cn(e, j, i, i, i, i, i, n);
        return u.placeholder = Mf.placeholder, u;
      }
      function Ef(e, n, a) {
        n = a ? i : n;
        var u = Cn(e, R, i, i, i, i, i, n);
        return u.placeholder = Ef.placeholder, u;
      }
      function xf(e, n, a) {
        var u, f, g, T, C, L, q = 0, Y = !1, Z = !1, fe = !0;
        if (typeof e != "function")
          throw new kr(l);
        n = Ur(n) || 0, jt(a) && (Y = !!a.leading, Z = "maxWait" in a, g = Z ? Kt(Ur(a.maxWait) || 0, n) : g, fe = "trailing" in a ? !!a.trailing : fe);
        function ye(Ut) {
          var Zr = u, An = f;
          return u = f = i, q = Ut, T = e.apply(An, Zr), T;
        }
        function Le(Ut) {
          return q = Ut, C = No(Je, n), Y ? ye(Ut) : T;
        }
        function Ge(Ut) {
          var Zr = Ut - L, An = Ut - q, Yf = n - Zr;
          return Z ? nr(Yf, g - An) : Yf;
        }
        function Ae(Ut) {
          var Zr = Ut - L, An = Ut - q;
          return L === i || Zr >= n || Zr < 0 || Z && An >= g;
        }
        function Je() {
          var Ut = ka();
          if (Ae(Ut))
            return tt(Ut);
          C = No(Je, Ge(Ut));
        }
        function tt(Ut) {
          return C = i, fe && u ? ye(Ut) : (u = f = i, T);
        }
        function _r() {
          C !== i && kl(C), q = 0, u = L = f = C = i;
        }
        function fr() {
          return C === i ? T : tt(ka());
        }
        function Nr() {
          var Ut = ka(), Zr = Ae(Ut);
          if (u = arguments, f = this, L = Ut, Zr) {
            if (C === i)
              return Le(L);
            if (Z)
              return kl(C), C = No(Je, n), ye(L);
          }
          return C === i && (C = No(Je, n)), T;
        }
        return Nr.cancel = _r, Nr.flush = fr, Nr;
      }
      var Ny = Ke(function(e, n) {
        return hl(e, 1, n);
      }), Oy = Ke(function(e, n, a) {
        return hl(e, Ur(n) || 0, a);
      });
      function Ly(e) {
        return Cn(e, te);
      }
      function Da(e, n) {
        if (typeof e != "function" || n != null && typeof n != "function")
          throw new kr(l);
        var a = function() {
          var u = arguments, f = n ? n.apply(this, u) : u[0], g = a.cache;
          if (g.has(f))
            return g.get(f);
          var T = e.apply(this, u);
          return a.cache = g.set(f, T) || g, T;
        };
        return a.cache = new (Da.Cache || En)(), a;
      }
      Da.Cache = En;
      function Ra(e) {
        if (typeof e != "function")
          throw new kr(l);
        return function() {
          var n = arguments;
          switch (n.length) {
            case 0:
              return !e.call(this);
            case 1:
              return !e.call(this, n[0]);
            case 2:
              return !e.call(this, n[0], n[1]);
            case 3:
              return !e.call(this, n[0], n[1], n[2]);
          }
          return !e.apply(this, n);
        };
      }
      function Ay(e) {
        return Sf(2, e);
      }
      var Iy = ym(function(e, n) {
        n = n.length == 1 && Fe(n[0]) ? It(n[0], Er(Ne())) : It(Zt(n, 1), Er(Ne()));
        var a = n.length;
        return Ke(function(u) {
          for (var f = -1, g = nr(u.length, a); ++f < g; )
            u[f] = n[f].call(this, u[f]);
          return Mr(e, this, u);
        });
      }), vu = Ke(function(e, n) {
        var a = Un(n, Gi(vu));
        return Cn(e, F, i, n, a);
      }), Cf = Ke(function(e, n) {
        var a = Un(n, Gi(Cf));
        return Cn(e, B, i, n, a);
      }), jy = _n(function(e, n) {
        return Cn(e, H, i, i, i, n);
      });
      function ky(e, n) {
        if (typeof e != "function")
          throw new kr(l);
        return n = n === i ? n : We(n), Ke(e, n);
      }
      function Dy(e, n) {
        if (typeof e != "function")
          throw new kr(l);
        return n = n == null ? 0 : Kt(We(n), 0), Ke(function(a) {
          var u = a[n], f = Yn(a, 0, n);
          return u && Fn(f, u), Mr(e, this, f);
        });
      }
      function Ry(e, n, a) {
        var u = !0, f = !0;
        if (typeof e != "function")
          throw new kr(l);
        return jt(a) && (u = "leading" in a ? !!a.leading : u, f = "trailing" in a ? !!a.trailing : f), xf(e, n, {
          leading: u,
          maxWait: n,
          trailing: f
        });
      }
      function Py(e) {
        return bf(e, 1);
      }
      function Fy(e, n) {
        return vu(tu(n), e);
      }
      function Uy() {
        if (!arguments.length)
          return [];
        var e = arguments[0];
        return Fe(e) ? e : [e];
      }
      function zy(e) {
        return Rr(e, x);
      }
      function By(e, n) {
        return n = typeof n == "function" ? n : i, Rr(e, x, n);
      }
      function Wy(e) {
        return Rr(e, m | x);
      }
      function qy(e, n) {
        return n = typeof n == "function" ? n : i, Rr(e, m | x, n);
      }
      function Yy(e, n) {
        return n == null || dl(e, n, Ht(n));
      }
      function Jr(e, n) {
        return e === n || e !== e && n !== n;
      }
      var Vy = Na(qs), Gy = Na(function(e, n) {
        return e >= n;
      }), wi = yl(function() {
        return arguments;
      }()) ? yl : function(e) {
        return Rt(e) && wt.call(e, "callee") && !il.call(e, "callee");
      }, Fe = P.isArray, Ky = Uc ? Er(Uc) : tm;
      function vr(e) {
        return e != null && Pa(e.length) && !On(e);
      }
      function Ft(e) {
        return Rt(e) && vr(e);
      }
      function $y(e) {
        return e === !0 || e === !1 || Rt(e) && cr(e) == Ie;
      }
      var Vn = ug || Nu, Qy = zc ? Er(zc) : rm;
      function Hy(e) {
        return Rt(e) && e.nodeType === 1 && !Oo(e);
      }
      function Jy(e) {
        if (e == null)
          return !0;
        if (vr(e) && (Fe(e) || typeof e == "string" || typeof e.splice == "function" || Vn(e) || Ki(e) || wi(e)))
          return !e.length;
        var n = ir(e);
        if (n == Qe || n == Ee)
          return !e.size;
        if (_o(e))
          return !Gs(e).length;
        for (var a in e)
          if (wt.call(e, a))
            return !1;
        return !0;
      }
      function Zy(e, n) {
        return Eo(e, n);
      }
      function Xy(e, n, a) {
        a = typeof a == "function" ? a : i;
        var u = a ? a(e, n) : i;
        return u === i ? Eo(e, n, i, a) : !!u;
      }
      function yu(e) {
        if (!Rt(e))
          return !1;
        var n = cr(e);
        return n == dt || n == lt || typeof e.message == "string" && typeof e.name == "string" && !Oo(e);
      }
      function ew(e) {
        return typeof e == "number" && al(e);
      }
      function On(e) {
        if (!jt(e))
          return !1;
        var n = cr(e);
        return n == ht || n == Nt || n == Ue || n == Se;
      }
      function _f(e) {
        return typeof e == "number" && e == We(e);
      }
      function Pa(e) {
        return typeof e == "number" && e > -1 && e % 1 == 0 && e <= Re;
      }
      function jt(e) {
        var n = typeof e;
        return e != null && (n == "object" || n == "function");
      }
      function Rt(e) {
        return e != null && typeof e == "object";
      }
      var Nf = Bc ? Er(Bc) : im;
      function tw(e, n) {
        return e === n || Vs(e, n, uu(n));
      }
      function rw(e, n, a) {
        return a = typeof a == "function" ? a : i, Vs(e, n, uu(n), a);
      }
      function nw(e) {
        return Of(e) && e != +e;
      }
      function iw(e) {
        if (Bm(e))
          throw new Pe(c);
        return wl(e);
      }
      function ow(e) {
        return e === null;
      }
      function aw(e) {
        return e == null;
      }
      function Of(e) {
        return typeof e == "number" || Rt(e) && cr(e) == k;
      }
      function Oo(e) {
        if (!Rt(e) || cr(e) != ce)
          return !1;
        var n = la(e);
        if (n === null)
          return !0;
        var a = wt.call(n, "constructor") && n.constructor;
        return typeof a == "function" && a instanceof a && aa.call(a) == rg;
      }
      var wu = Wc ? Er(Wc) : om;
      function sw(e) {
        return _f(e) && e >= -Re && e <= Re;
      }
      var Lf = qc ? Er(qc) : am;
      function Fa(e) {
        return typeof e == "string" || !Fe(e) && Rt(e) && cr(e) == qe;
      }
      function Cr(e) {
        return typeof e == "symbol" || Rt(e) && cr(e) == de;
      }
      var Ki = Yc ? Er(Yc) : sm;
      function uw(e) {
        return e === i;
      }
      function cw(e) {
        return Rt(e) && ir(e) == je;
      }
      function lw(e) {
        return Rt(e) && cr(e) == ge;
      }
      var fw = Na(Ks), dw = Na(function(e, n) {
        return e <= n;
      });
      function Af(e) {
        if (!e)
          return [];
        if (vr(e))
          return Fa(e) ? Qr(e) : mr(e);
        if (mo && e[mo])
          return Yp(e[mo]());
        var n = ir(e), a = n == Qe ? ks : n == Ee ? na : $i;
        return a(e);
      }
      function Ln(e) {
        if (!e)
          return e === 0 ? e : 0;
        if (e = Ur(e), e === se || e === -se) {
          var n = e < 0 ? -1 : 1;
          return n * ct;
        }
        return e === e ? e : 0;
      }
      function We(e) {
        var n = Ln(e), a = n % 1;
        return n === n ? a ? n - a : n : 0;
      }
      function If(e) {
        return e ? gi(We(e), 0, Q) : 0;
      }
      function Ur(e) {
        if (typeof e == "number")
          return e;
        if (Cr(e))
          return oe;
        if (jt(e)) {
          var n = typeof e.valueOf == "function" ? e.valueOf() : e;
          e = jt(n) ? n + "" : n;
        }
        if (typeof e != "string")
          return e === 0 ? e : +e;
        e = Hc(e);
        var a = Ve.test(e);
        return a || Ot.test(e) ? _p(e.slice(2), a ? 2 : 8) : Ye.test(e) ? oe : +e;
      }
      function jf(e) {
        return un(e, yr(e));
      }
      function hw(e) {
        return e ? gi(We(e), -Re, Re) : e === 0 ? e : 0;
      }
      function vt(e) {
        return e == null ? "" : xr(e);
      }
      var pw = Yi(function(e, n) {
        if (_o(n) || vr(n)) {
          un(n, Ht(n), e);
          return;
        }
        for (var a in n)
          wt.call(n, a) && So(e, a, n[a]);
      }), kf = Yi(function(e, n) {
        un(n, yr(n), e);
      }), Ua = Yi(function(e, n, a, u) {
        un(n, yr(n), e, u);
      }), gw = Yi(function(e, n, a, u) {
        un(n, Ht(n), e, u);
      }), mw = _n(zs);
      function vw(e, n) {
        var a = qi(e);
        return n == null ? a : fl(a, n);
      }
      var yw = Ke(function(e, n) {
        e = Mt(e);
        var a = -1, u = n.length, f = u > 2 ? n[2] : i;
        for (f && lr(n[0], n[1], f) && (u = 1); ++a < u; )
          for (var g = n[a], T = yr(g), C = -1, L = T.length; ++C < L; ) {
            var q = T[C], Y = e[q];
            (Y === i || Jr(Y, zi[q]) && !wt.call(e, q)) && (e[q] = g[q]);
          }
        return e;
      }), ww = Ke(function(e) {
        return e.push(i, Hl), Mr(Df, i, e);
      });
      function bw(e, n) {
        return Gc(e, Ne(n, 3), sn);
      }
      function Sw(e, n) {
        return Gc(e, Ne(n, 3), Ws);
      }
      function Tw(e, n) {
        return e == null ? e : Bs(e, Ne(n, 3), yr);
      }
      function Mw(e, n) {
        return e == null ? e : ml(e, Ne(n, 3), yr);
      }
      function Ew(e, n) {
        return e && sn(e, Ne(n, 3));
      }
      function xw(e, n) {
        return e && Ws(e, Ne(n, 3));
      }
      function Cw(e) {
        return e == null ? [] : ba(e, Ht(e));
      }
      function _w(e) {
        return e == null ? [] : ba(e, yr(e));
      }
      function bu(e, n, a) {
        var u = e == null ? i : mi(e, n);
        return u === i ? a : u;
      }
      function Nw(e, n) {
        return e != null && Xl(e, n, Jg);
      }
      function Su(e, n) {
        return e != null && Xl(e, n, Zg);
      }
      var Ow = Vl(function(e, n, a) {
        n != null && typeof n.toString != "function" && (n = sa.call(n)), e[n] = a;
      }, Mu(wr)), Lw = Vl(function(e, n, a) {
        n != null && typeof n.toString != "function" && (n = sa.call(n)), wt.call(e, n) ? e[n].push(a) : e[n] = [a];
      }, Ne), Aw = Ke(Mo);
      function Ht(e) {
        return vr(e) ? cl(e) : Gs(e);
      }
      function yr(e) {
        return vr(e) ? cl(e, !0) : um(e);
      }
      function Iw(e, n) {
        var a = {};
        return n = Ne(n, 3), sn(e, function(u, f, g) {
          xn(a, n(u, f, g), u);
        }), a;
      }
      function jw(e, n) {
        var a = {};
        return n = Ne(n, 3), sn(e, function(u, f, g) {
          xn(a, f, n(u, f, g));
        }), a;
      }
      var kw = Yi(function(e, n, a) {
        Sa(e, n, a);
      }), Df = Yi(function(e, n, a, u) {
        Sa(e, n, a, u);
      }), Dw = _n(function(e, n) {
        var a = {};
        if (e == null)
          return a;
        var u = !1;
        n = It(n, function(g) {
          return g = qn(g, e), u || (u = g.length > 1), g;
        }), un(e, au(e), a), u && (a = Rr(a, m | b | x, Om));
        for (var f = n.length; f--; )
          Zs(a, n[f]);
        return a;
      });
      function Rw(e, n) {
        return Rf(e, Ra(Ne(n)));
      }
      var Pw = _n(function(e, n) {
        return e == null ? {} : lm(e, n);
      });
      function Rf(e, n) {
        if (e == null)
          return {};
        var a = It(au(e), function(u) {
          return [u];
        });
        return n = Ne(n), Cl(e, a, function(u, f) {
          return n(u, f[0]);
        });
      }
      function Fw(e, n, a) {
        n = qn(n, e);
        var u = -1, f = n.length;
        for (f || (f = 1, e = i); ++u < f; ) {
          var g = e == null ? i : e[cn(n[u])];
          g === i && (u = f, g = a), e = On(g) ? g.call(e) : g;
        }
        return e;
      }
      function Uw(e, n, a) {
        return e == null ? e : xo(e, n, a);
      }
      function zw(e, n, a, u) {
        return u = typeof u == "function" ? u : i, e == null ? e : xo(e, n, a, u);
      }
      var Pf = $l(Ht), Ff = $l(yr);
      function Bw(e, n, a) {
        var u = Fe(e), f = u || Vn(e) || Ki(e);
        if (n = Ne(n, 4), a == null) {
          var g = e && e.constructor;
          f ? a = u ? new g() : [] : jt(e) ? a = On(g) ? qi(la(e)) : {} : a = {};
        }
        return (f ? jr : sn)(e, function(T, C, L) {
          return n(a, T, C, L);
        }), a;
      }
      function Ww(e, n) {
        return e == null ? !0 : Zs(e, n);
      }
      function qw(e, n, a) {
        return e == null ? e : Al(e, n, tu(a));
      }
      function Yw(e, n, a, u) {
        return u = typeof u == "function" ? u : i, e == null ? e : Al(e, n, tu(a), u);
      }
      function $i(e) {
        return e == null ? [] : js(e, Ht(e));
      }
      function Vw(e) {
        return e == null ? [] : js(e, yr(e));
      }
      function Gw(e, n, a) {
        return a === i && (a = n, n = i), a !== i && (a = Ur(a), a = a === a ? a : 0), n !== i && (n = Ur(n), n = n === n ? n : 0), gi(Ur(e), n, a);
      }
      function Kw(e, n, a) {
        return n = Ln(n), a === i ? (a = n, n = 0) : a = Ln(a), e = Ur(e), Xg(e, n, a);
      }
      function $w(e, n, a) {
        if (a && typeof a != "boolean" && lr(e, n, a) && (n = a = i), a === i && (typeof n == "boolean" ? (a = n, n = i) : typeof e == "boolean" && (a = e, e = i)), e === i && n === i ? (e = 0, n = 1) : (e = Ln(e), n === i ? (n = e, e = 0) : n = Ln(n)), e > n) {
          var u = e;
          e = n, n = u;
        }
        if (a || e % 1 || n % 1) {
          var f = sl();
          return nr(e + f * (n - e + Cp("1e-" + ((f + "").length - 1))), n);
        }
        return Qs(e, n);
      }
      var Qw = Vi(function(e, n, a) {
        return n = n.toLowerCase(), e + (a ? Uf(n) : n);
      });
      function Uf(e) {
        return Tu(vt(e).toLowerCase());
      }
      function zf(e) {
        return e = vt(e), e && e.replace(I, Up).replace(mp, "");
      }
      function Hw(e, n, a) {
        e = vt(e), n = xr(n);
        var u = e.length;
        a = a === i ? u : gi(We(a), 0, u);
        var f = a;
        return a -= n.length, a >= 0 && e.slice(a, f) == n;
      }
      function Jw(e) {
        return e = vt(e), e && vn.test(e) ? e.replace(mn, zp) : e;
      }
      function Zw(e) {
        return e = vt(e), e && wn.test(e) ? e.replace(ai, "\\$&") : e;
      }
      var Xw = Vi(function(e, n, a) {
        return e + (a ? "-" : "") + n.toLowerCase();
      }), e0 = Vi(function(e, n, a) {
        return e + (a ? " " : "") + n.toLowerCase();
      }), t0 = Wl("toLowerCase");
      function r0(e, n, a) {
        e = vt(e), n = We(n);
        var u = n ? Fi(e) : 0;
        if (!n || u >= n)
          return e;
        var f = (n - u) / 2;
        return _a(pa(f), a) + e + _a(ha(f), a);
      }
      function n0(e, n, a) {
        e = vt(e), n = We(n);
        var u = n ? Fi(e) : 0;
        return n && u < n ? e + _a(n - u, a) : e;
      }
      function i0(e, n, a) {
        e = vt(e), n = We(n);
        var u = n ? Fi(e) : 0;
        return n && u < n ? _a(n - u, a) + e : e;
      }
      function o0(e, n, a) {
        return a || n == null ? n = 0 : n && (n = +n), dg(vt(e).replace(Tr, ""), n || 0);
      }
      function a0(e, n, a) {
        return (a ? lr(e, n, a) : n === i) ? n = 1 : n = We(n), Hs(vt(e), n);
      }
      function s0() {
        var e = arguments, n = vt(e[0]);
        return e.length < 3 ? n : n.replace(e[1], e[2]);
      }
      var u0 = Vi(function(e, n, a) {
        return e + (a ? "_" : "") + n.toLowerCase();
      });
      function c0(e, n, a) {
        return a && typeof a != "number" && lr(e, n, a) && (n = a = i), a = a === i ? Q : a >>> 0, a ? (e = vt(e), e && (typeof n == "string" || n != null && !wu(n)) && (n = xr(n), !n && Pi(e)) ? Yn(Qr(e), 0, a) : e.split(n, a)) : [];
      }
      var l0 = Vi(function(e, n, a) {
        return e + (a ? " " : "") + Tu(n);
      });
      function f0(e, n, a) {
        return e = vt(e), a = a == null ? 0 : gi(We(a), 0, e.length), n = xr(n), e.slice(a, a + n.length) == n;
      }
      function d0(e, n, a) {
        var u = h.templateSettings;
        a && lr(e, n, a) && (n = i), e = vt(e), n = Ua({}, n, u, Ql);
        var f = Ua({}, n.imports, u.imports, Ql), g = Ht(f), T = js(f, g), C, L, q = 0, Y = n.interpolate || W, Z = "__p += '", fe = Ds(
          (n.escape || W).source + "|" + Y.source + "|" + (Y === ii ? He : W).source + "|" + (n.evaluate || W).source + "|$",
          "g"
        ), ye = "//# sourceURL=" + (wt.call(n, "sourceURL") ? (n.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++Sp + "]") + `
`;
        e.replace(fe, function(Ae, Je, tt, _r, fr, Nr) {
          return tt || (tt = _r), Z += e.slice(q, Nr).replace(re, Bp), Je && (C = !0, Z += `' +
__e(` + Je + `) +
'`), fr && (L = !0, Z += `';
` + fr + `;
__p += '`), tt && (Z += `' +
((__t = (` + tt + `)) == null ? '' : __t) +
'`), q = Nr + Ae.length, Ae;
        }), Z += `';
`;
        var Le = wt.call(n, "variable") && n.variable;
        if (!Le)
          Z = `with (obj) {
` + Z + `
}
`;
        else if (ue.test(Le))
          throw new Pe(d);
        Z = (L ? Z.replace(gn, "") : Z).replace(Yr, "$1").replace(_i, "$1;"), Z = "function(" + (Le || "obj") + `) {
` + (Le ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (C ? ", __e = _.escape" : "") + (L ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + Z + `return __p
}`;
        var Ge = Wf(function() {
          return gt(g, ye + "return " + Z).apply(i, T);
        });
        if (Ge.source = Z, yu(Ge))
          throw Ge;
        return Ge;
      }
      function h0(e) {
        return vt(e).toLowerCase();
      }
      function p0(e) {
        return vt(e).toUpperCase();
      }
      function g0(e, n, a) {
        if (e = vt(e), e && (a || n === i))
          return Hc(e);
        if (!e || !(n = xr(n)))
          return e;
        var u = Qr(e), f = Qr(n), g = Jc(u, f), T = Zc(u, f) + 1;
        return Yn(u, g, T).join("");
      }
      function m0(e, n, a) {
        if (e = vt(e), e && (a || n === i))
          return e.slice(0, el(e) + 1);
        if (!e || !(n = xr(n)))
          return e;
        var u = Qr(e), f = Zc(u, Qr(n)) + 1;
        return Yn(u, 0, f).join("");
      }
      function v0(e, n, a) {
        if (e = vt(e), e && (a || n === i))
          return e.replace(Tr, "");
        if (!e || !(n = xr(n)))
          return e;
        var u = Qr(e), f = Jc(u, Qr(n));
        return Yn(u, f).join("");
      }
      function y0(e, n) {
        var a = G, u = ve;
        if (jt(n)) {
          var f = "separator" in n ? n.separator : f;
          a = "length" in n ? We(n.length) : a, u = "omission" in n ? xr(n.omission) : u;
        }
        e = vt(e);
        var g = e.length;
        if (Pi(e)) {
          var T = Qr(e);
          g = T.length;
        }
        if (a >= g)
          return e;
        var C = a - Fi(u);
        if (C < 1)
          return u;
        var L = T ? Yn(T, 0, C).join("") : e.slice(0, C);
        if (f === i)
          return L + u;
        if (T && (C += L.length - C), wu(f)) {
          if (e.slice(C).search(f)) {
            var q, Y = L;
            for (f.global || (f = Ds(f.source, vt(Xe.exec(f)) + "g")), f.lastIndex = 0; q = f.exec(Y); )
              var Z = q.index;
            L = L.slice(0, Z === i ? C : Z);
          }
        } else if (e.indexOf(xr(f), C) != C) {
          var fe = L.lastIndexOf(f);
          fe > -1 && (L = L.slice(0, fe));
        }
        return L + u;
      }
      function w0(e) {
        return e = vt(e), e && Dn.test(e) ? e.replace(Vr, $p) : e;
      }
      var b0 = Vi(function(e, n, a) {
        return e + (a ? " " : "") + n.toUpperCase();
      }), Tu = Wl("toUpperCase");
      function Bf(e, n, a) {
        return e = vt(e), n = a ? i : n, n === i ? qp(e) ? Jp(e) : kp(e) : e.match(n) || [];
      }
      var Wf = Ke(function(e, n) {
        try {
          return Mr(e, i, n);
        } catch (a) {
          return yu(a) ? a : new Pe(a);
        }
      }), S0 = _n(function(e, n) {
        return jr(n, function(a) {
          a = cn(a), xn(e, a, mu(e[a], e));
        }), e;
      });
      function T0(e) {
        var n = e == null ? 0 : e.length, a = Ne();
        return e = n ? It(e, function(u) {
          if (typeof u[1] != "function")
            throw new kr(l);
          return [a(u[0]), u[1]];
        }) : [], Ke(function(u) {
          for (var f = -1; ++f < n; ) {
            var g = e[f];
            if (Mr(g[0], this, u))
              return Mr(g[1], this, u);
          }
        });
      }
      function M0(e) {
        return $g(Rr(e, m));
      }
      function Mu(e) {
        return function() {
          return e;
        };
      }
      function E0(e, n) {
        return e == null || e !== e ? n : e;
      }
      var x0 = Yl(), C0 = Yl(!0);
      function wr(e) {
        return e;
      }
      function Eu(e) {
        return bl(typeof e == "function" ? e : Rr(e, m));
      }
      function _0(e) {
        return Tl(Rr(e, m));
      }
      function N0(e, n) {
        return Ml(e, Rr(n, m));
      }
      var O0 = Ke(function(e, n) {
        return function(a) {
          return Mo(a, e, n);
        };
      }), L0 = Ke(function(e, n) {
        return function(a) {
          return Mo(e, a, n);
        };
      });
      function xu(e, n, a) {
        var u = Ht(n), f = ba(n, u);
        a == null && !(jt(n) && (f.length || !u.length)) && (a = n, n = e, e = this, f = ba(n, Ht(n)));
        var g = !(jt(a) && "chain" in a) || !!a.chain, T = On(e);
        return jr(f, function(C) {
          var L = n[C];
          e[C] = L, T && (e.prototype[C] = function() {
            var q = this.__chain__;
            if (g || q) {
              var Y = e(this.__wrapped__), Z = Y.__actions__ = mr(this.__actions__);
              return Z.push({ func: L, args: arguments, thisArg: e }), Y.__chain__ = q, Y;
            }
            return L.apply(e, Fn([this.value()], arguments));
          });
        }), e;
      }
      function A0() {
        return Jt._ === this && (Jt._ = ng), this;
      }
      function Cu() {
      }
      function I0(e) {
        return e = We(e), Ke(function(n) {
          return El(n, e);
        });
      }
      var j0 = nu(It), k0 = nu(Vc), D0 = nu(Ns);
      function qf(e) {
        return lu(e) ? Os(cn(e)) : fm(e);
      }
      function R0(e) {
        return function(n) {
          return e == null ? i : mi(e, n);
        };
      }
      var P0 = Gl(), F0 = Gl(!0);
      function _u() {
        return [];
      }
      function Nu() {
        return !1;
      }
      function U0() {
        return {};
      }
      function z0() {
        return "";
      }
      function B0() {
        return !0;
      }
      function W0(e, n) {
        if (e = We(e), e < 1 || e > Re)
          return [];
        var a = Q, u = nr(e, Q);
        n = Ne(n), e -= Q;
        for (var f = Is(u, n); ++a < e; )
          n(a);
        return f;
      }
      function q0(e) {
        return Fe(e) ? It(e, cn) : Cr(e) ? [e] : mr(cf(vt(e)));
      }
      function Y0(e) {
        var n = ++tg;
        return vt(e) + n;
      }
      var V0 = Ca(function(e, n) {
        return e + n;
      }, 0), G0 = iu("ceil"), K0 = Ca(function(e, n) {
        return e / n;
      }, 1), $0 = iu("floor");
      function Q0(e) {
        return e && e.length ? wa(e, wr, qs) : i;
      }
      function H0(e, n) {
        return e && e.length ? wa(e, Ne(n, 2), qs) : i;
      }
      function J0(e) {
        return $c(e, wr);
      }
      function Z0(e, n) {
        return $c(e, Ne(n, 2));
      }
      function X0(e) {
        return e && e.length ? wa(e, wr, Ks) : i;
      }
      function eb(e, n) {
        return e && e.length ? wa(e, Ne(n, 2), Ks) : i;
      }
      var tb = Ca(function(e, n) {
        return e * n;
      }, 1), rb = iu("round"), nb = Ca(function(e, n) {
        return e - n;
      }, 0);
      function ib(e) {
        return e && e.length ? As(e, wr) : 0;
      }
      function ob(e, n) {
        return e && e.length ? As(e, Ne(n, 2)) : 0;
      }
      return h.after = _y, h.ary = bf, h.assign = pw, h.assignIn = kf, h.assignInWith = Ua, h.assignWith = gw, h.at = mw, h.before = Sf, h.bind = mu, h.bindAll = S0, h.bindKey = Tf, h.castArray = Uy, h.chain = vf, h.chunk = $m, h.compact = Qm, h.concat = Hm, h.cond = T0, h.conforms = M0, h.constant = Mu, h.countBy = iy, h.create = vw, h.curry = Mf, h.curryRight = Ef, h.debounce = xf, h.defaults = yw, h.defaultsDeep = ww, h.defer = Ny, h.delay = Oy, h.difference = Jm, h.differenceBy = Zm, h.differenceWith = Xm, h.drop = ev, h.dropRight = tv, h.dropRightWhile = rv, h.dropWhile = nv, h.fill = iv, h.filter = ay, h.flatMap = cy, h.flatMapDeep = ly, h.flatMapDepth = fy, h.flatten = hf, h.flattenDeep = ov, h.flattenDepth = av, h.flip = Ly, h.flow = x0, h.flowRight = C0, h.fromPairs = sv, h.functions = Cw, h.functionsIn = _w, h.groupBy = dy, h.initial = cv, h.intersection = lv, h.intersectionBy = fv, h.intersectionWith = dv, h.invert = Ow, h.invertBy = Lw, h.invokeMap = py, h.iteratee = Eu, h.keyBy = gy, h.keys = Ht, h.keysIn = yr, h.map = ja, h.mapKeys = Iw, h.mapValues = jw, h.matches = _0, h.matchesProperty = N0, h.memoize = Da, h.merge = kw, h.mergeWith = Df, h.method = O0, h.methodOf = L0, h.mixin = xu, h.negate = Ra, h.nthArg = I0, h.omit = Dw, h.omitBy = Rw, h.once = Ay, h.orderBy = my, h.over = j0, h.overArgs = Iy, h.overEvery = k0, h.overSome = D0, h.partial = vu, h.partialRight = Cf, h.partition = vy, h.pick = Pw, h.pickBy = Rf, h.property = qf, h.propertyOf = R0, h.pull = mv, h.pullAll = gf, h.pullAllBy = vv, h.pullAllWith = yv, h.pullAt = wv, h.range = P0, h.rangeRight = F0, h.rearg = jy, h.reject = by, h.remove = bv, h.rest = ky, h.reverse = pu, h.sampleSize = Ty, h.set = Uw, h.setWith = zw, h.shuffle = My, h.slice = Sv, h.sortBy = Cy, h.sortedUniq = Nv, h.sortedUniqBy = Ov, h.split = c0, h.spread = Dy, h.tail = Lv, h.take = Av, h.takeRight = Iv, h.takeRightWhile = jv, h.takeWhile = kv, h.tap = Qv, h.throttle = Ry, h.thru = Ia, h.toArray = Af, h.toPairs = Pf, h.toPairsIn = Ff, h.toPath = q0, h.toPlainObject = jf, h.transform = Bw, h.unary = Py, h.union = Dv, h.unionBy = Rv, h.unionWith = Pv, h.uniq = Fv, h.uniqBy = Uv, h.uniqWith = zv, h.unset = Ww, h.unzip = gu, h.unzipWith = mf, h.update = qw, h.updateWith = Yw, h.values = $i, h.valuesIn = Vw, h.without = Bv, h.words = Bf, h.wrap = Fy, h.xor = Wv, h.xorBy = qv, h.xorWith = Yv, h.zip = Vv, h.zipObject = Gv, h.zipObjectDeep = Kv, h.zipWith = $v, h.entries = Pf, h.entriesIn = Ff, h.extend = kf, h.extendWith = Ua, xu(h, h), h.add = V0, h.attempt = Wf, h.camelCase = Qw, h.capitalize = Uf, h.ceil = G0, h.clamp = Gw, h.clone = zy, h.cloneDeep = Wy, h.cloneDeepWith = qy, h.cloneWith = By, h.conformsTo = Yy, h.deburr = zf, h.defaultTo = E0, h.divide = K0, h.endsWith = Hw, h.eq = Jr, h.escape = Jw, h.escapeRegExp = Zw, h.every = oy, h.find = sy, h.findIndex = ff, h.findKey = bw, h.findLast = uy, h.findLastIndex = df, h.findLastKey = Sw, h.floor = $0, h.forEach = yf, h.forEachRight = wf, h.forIn = Tw, h.forInRight = Mw, h.forOwn = Ew, h.forOwnRight = xw, h.get = bu, h.gt = Vy, h.gte = Gy, h.has = Nw, h.hasIn = Su, h.head = pf, h.identity = wr, h.includes = hy, h.indexOf = uv, h.inRange = Kw, h.invoke = Aw, h.isArguments = wi, h.isArray = Fe, h.isArrayBuffer = Ky, h.isArrayLike = vr, h.isArrayLikeObject = Ft, h.isBoolean = $y, h.isBuffer = Vn, h.isDate = Qy, h.isElement = Hy, h.isEmpty = Jy, h.isEqual = Zy, h.isEqualWith = Xy, h.isError = yu, h.isFinite = ew, h.isFunction = On, h.isInteger = _f, h.isLength = Pa, h.isMap = Nf, h.isMatch = tw, h.isMatchWith = rw, h.isNaN = nw, h.isNative = iw, h.isNil = aw, h.isNull = ow, h.isNumber = Of, h.isObject = jt, h.isObjectLike = Rt, h.isPlainObject = Oo, h.isRegExp = wu, h.isSafeInteger = sw, h.isSet = Lf, h.isString = Fa, h.isSymbol = Cr, h.isTypedArray = Ki, h.isUndefined = uw, h.isWeakMap = cw, h.isWeakSet = lw, h.join = hv, h.kebabCase = Xw, h.last = Fr, h.lastIndexOf = pv, h.lowerCase = e0, h.lowerFirst = t0, h.lt = fw, h.lte = dw, h.max = Q0, h.maxBy = H0, h.mean = J0, h.meanBy = Z0, h.min = X0, h.minBy = eb, h.stubArray = _u, h.stubFalse = Nu, h.stubObject = U0, h.stubString = z0, h.stubTrue = B0, h.multiply = tb, h.nth = gv, h.noConflict = A0, h.noop = Cu, h.now = ka, h.pad = r0, h.padEnd = n0, h.padStart = i0, h.parseInt = o0, h.random = $w, h.reduce = yy, h.reduceRight = wy, h.repeat = a0, h.replace = s0, h.result = Fw, h.round = rb, h.runInContext = O, h.sample = Sy, h.size = Ey, h.snakeCase = u0, h.some = xy, h.sortedIndex = Tv, h.sortedIndexBy = Mv, h.sortedIndexOf = Ev, h.sortedLastIndex = xv, h.sortedLastIndexBy = Cv, h.sortedLastIndexOf = _v, h.startCase = l0, h.startsWith = f0, h.subtract = nb, h.sum = ib, h.sumBy = ob, h.template = d0, h.times = W0, h.toFinite = Ln, h.toInteger = We, h.toLength = If, h.toLower = h0, h.toNumber = Ur, h.toSafeInteger = hw, h.toString = vt, h.toUpper = p0, h.trim = g0, h.trimEnd = m0, h.trimStart = v0, h.truncate = y0, h.unescape = w0, h.uniqueId = Y0, h.upperCase = b0, h.upperFirst = Tu, h.each = yf, h.eachRight = wf, h.first = pf, xu(h, function() {
        var e = {};
        return sn(h, function(n, a) {
          wt.call(h.prototype, a) || (e[a] = n);
        }), e;
      }(), { chain: !1 }), h.VERSION = o, jr(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(e) {
        h[e].placeholder = h;
      }), jr(["drop", "take"], function(e, n) {
        Ze.prototype[e] = function(a) {
          a = a === i ? 1 : Kt(We(a), 0);
          var u = this.__filtered__ && !n ? new Ze(this) : this.clone();
          return u.__filtered__ ? u.__takeCount__ = nr(a, u.__takeCount__) : u.__views__.push({
            size: nr(a, Q),
            type: e + (u.__dir__ < 0 ? "Right" : "")
          }), u;
        }, Ze.prototype[e + "Right"] = function(a) {
          return this.reverse()[e](a).reverse();
        };
      }), jr(["filter", "map", "takeWhile"], function(e, n) {
        var a = n + 1, u = a == K || a == ae;
        Ze.prototype[e] = function(f) {
          var g = this.clone();
          return g.__iteratees__.push({
            iteratee: Ne(f, 3),
            type: a
          }), g.__filtered__ = g.__filtered__ || u, g;
        };
      }), jr(["head", "last"], function(e, n) {
        var a = "take" + (n ? "Right" : "");
        Ze.prototype[e] = function() {
          return this[a](1).value()[0];
        };
      }), jr(["initial", "tail"], function(e, n) {
        var a = "drop" + (n ? "" : "Right");
        Ze.prototype[e] = function() {
          return this.__filtered__ ? new Ze(this) : this[a](1);
        };
      }), Ze.prototype.compact = function() {
        return this.filter(wr);
      }, Ze.prototype.find = function(e) {
        return this.filter(e).head();
      }, Ze.prototype.findLast = function(e) {
        return this.reverse().find(e);
      }, Ze.prototype.invokeMap = Ke(function(e, n) {
        return typeof e == "function" ? new Ze(this) : this.map(function(a) {
          return Mo(a, e, n);
        });
      }), Ze.prototype.reject = function(e) {
        return this.filter(Ra(Ne(e)));
      }, Ze.prototype.slice = function(e, n) {
        e = We(e);
        var a = this;
        return a.__filtered__ && (e > 0 || n < 0) ? new Ze(a) : (e < 0 ? a = a.takeRight(-e) : e && (a = a.drop(e)), n !== i && (n = We(n), a = n < 0 ? a.dropRight(-n) : a.take(n - e)), a);
      }, Ze.prototype.takeRightWhile = function(e) {
        return this.reverse().takeWhile(e).reverse();
      }, Ze.prototype.toArray = function() {
        return this.take(Q);
      }, sn(Ze.prototype, function(e, n) {
        var a = /^(?:filter|find|map|reject)|While$/.test(n), u = /^(?:head|last)$/.test(n), f = h[u ? "take" + (n == "last" ? "Right" : "") : n], g = u || /^find/.test(n);
        !f || (h.prototype[n] = function() {
          var T = this.__wrapped__, C = u ? [1] : arguments, L = T instanceof Ze, q = C[0], Y = L || Fe(T), Z = function(Je) {
            var tt = f.apply(h, Fn([Je], C));
            return u && fe ? tt[0] : tt;
          };
          Y && a && typeof q == "function" && q.length != 1 && (L = Y = !1);
          var fe = this.__chain__, ye = !!this.__actions__.length, Le = g && !fe, Ge = L && !ye;
          if (!g && Y) {
            T = Ge ? T : new Ze(this);
            var Ae = e.apply(T, C);
            return Ae.__actions__.push({ func: Ia, args: [Z], thisArg: i }), new Dr(Ae, fe);
          }
          return Le && Ge ? e.apply(this, C) : (Ae = this.thru(Z), Le ? u ? Ae.value()[0] : Ae.value() : Ae);
        });
      }), jr(["pop", "push", "shift", "sort", "splice", "unshift"], function(e) {
        var n = ia[e], a = /^(?:push|sort|unshift)$/.test(e) ? "tap" : "thru", u = /^(?:pop|shift)$/.test(e);
        h.prototype[e] = function() {
          var f = arguments;
          if (u && !this.__chain__) {
            var g = this.value();
            return n.apply(Fe(g) ? g : [], f);
          }
          return this[a](function(T) {
            return n.apply(Fe(T) ? T : [], f);
          });
        };
      }), sn(Ze.prototype, function(e, n) {
        var a = h[n];
        if (a) {
          var u = a.name + "";
          wt.call(Wi, u) || (Wi[u] = []), Wi[u].push({ name: n, func: a });
        }
      }), Wi[xa(i, U).name] = [{
        name: "wrapper",
        func: i
      }], Ze.prototype.clone = wg, Ze.prototype.reverse = bg, Ze.prototype.value = Sg, h.prototype.at = Hv, h.prototype.chain = Jv, h.prototype.commit = Zv, h.prototype.next = Xv, h.prototype.plant = ty, h.prototype.reverse = ry, h.prototype.toJSON = h.prototype.valueOf = h.prototype.value = ny, h.prototype.first = h.prototype.head, mo && (h.prototype[mo] = ey), h;
    }, Ui = Zp();
    fi ? ((fi.exports = Ui)._ = Ui, Es._ = Ui) : Jt._ = Ui;
  }).call(Ao);
})(ti, ti.exports);
let hr = Nh, Dh = !1;
const Rh = (t) => {
  hr = t, Dh = !0;
}, Ph = async (t) => {
  if (!t)
    return console.warn(
      "Tried to read a key from the Userfront object, but no key was provided."
    ), Promise.reject();
  if (ti.exports.get(hr, t))
    return ti.exports.get(hr, t);
  console.warn(
    `Tried to read key ${t} from the Userfront object, but no such key was found in the object or object.store.`
  );
}, hS = (t) => {
  if (!t)
    throw console.warn(
      "Tried to read a key from the Userfront object, but no key was provided."
    ), new Error();
  if (ti.exports.get(hr, t))
    return ti.exports.get(hr, t);
  console.warn(
    `Tried to read key ${t} from the Userfront object, but no such key was found in the object or object.store.`
  );
}, Wt = async ({ method: t, args: r = [] }) => {
  var o;
  if (t === "init" && !!hr)
    return hr.init(...r);
  if (!hr || !((o = hr.store) != null && o.tenantId))
    return console.warn(
      "Tried to call a Userfront method before the Userfront service was initialized."
    ), Promise.reject();
  const i = ti.exports.get(hr, t);
  if (!i || typeof i != "function")
    return console.warn(`Method ${t} not found on Userfront object.`), Promise.reject();
  try {
    const s = await i(...r);
    return Dh ? s : new Promise((c) => {
      setTimeout(() => c(s), 1);
    });
  } catch (s) {
    return console.warn(
      `Method ${t} on Userfront object threw. Error: ${s.message}`
    ), Promise.reject(s);
  }
}, pS = ({ method: t, args: r = [] }) => {
  var o;
  if (t === "init" && !!hr)
    return hr.init(...r);
  if (!hr || !((o = hr.store) != null && o.tenantId))
    throw console.warn(
      "Tried to call a Userfront method before the Userfront service was initialized."
    ), new Error();
  const i = ti.exports.get(hr, t);
  if (!i || typeof i != "function")
    throw console.warn(`Method ${t} not found on Userfront object.`), new Error();
  try {
    return i(...r);
  } catch (s) {
    throw console.warn(
      `Method ${t} on Userfront object threw. Error: ${s.message}`
    ), s;
  }
}, gS = ({
  mode: t
}) => {
  const [r, i] = Qt(""), o = t === "test";
  return fc(() => {
    o && (async () => {
      const c = await Ph("mode");
      i((c == null ? void 0 : c.reason) || "");
    })();
  }, [o]), o ? /* @__PURE__ */ D("div", {
    className: "userfront-test-mode-notice",
    children: /* @__PURE__ */ $e("span", {
      className: "userfront-test-mode-text",
      children: ["Test Mode: ", r]
    })
  }) : null;
}, mS = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAuUlEQVR4Ab3MgQbCUBiG4TBACBCGIcAuYBi6hzCE0EWEMHQBAYYuYQgwwDCELiB0GWE4+HtxwH7nOGfRywMfvsU/ynDFGy/UWCO4Ai0MZGLEDTmcrTBAAt2RQNVAItVQ9ZBI/dyjFtWvRy0S7OOP9MkOZrKrOoi1xeA9ARqoLhCrxBK18wQ4QlVArA9KkPPEIAXpnpOzXp8AaOGsgAQYkcHbCeKDCkGdHQcGB0RV4gGxOuSY3QYpvH0BsMWaAAsRtG8AAAAASUVORK5CYII=", vS = ({
  mode: t
}) => /* @__PURE__ */ $e(ho, {
  children: [/* @__PURE__ */ $e("a", {
    className: "userfront-secured",
    href: "https://www.userfront.com",
    target: "_blank",
    rel: "noopener",
    children: [/* @__PURE__ */ D("img", {
      src: mS,
      className: "userfront-secured-icon"
    }), "Secured by Userfront"]
  }), /* @__PURE__ */ D(gS, {
    mode: t
  })]
}), yS = ({
  text: t
}) => /* @__PURE__ */ D("p", {
  children: t
}), Uu = ({
  error: t,
  message: r = "An unhandled error occurred. Please try again later."
}) => /* @__PURE__ */ $e("div", {
  children: [r && /* @__PURE__ */ D("p", {
    children: r
  }), t && /* @__PURE__ */ D(rn, {
    error: t
  })]
}), Ji = ({
  redirect: t
}) => /* @__PURE__ */ $e(ho, {
  children: [/* @__PURE__ */ $e("p", {
    children: ["You're logged in!", t && "If you aren't redirected, click the button below to continue."]
  }), t && /* @__PURE__ */ D(kh, {
    href: t
  })]
}), wS = ({
  message: t
}) => {
  const r = ["userfront-info-message"], i = !!t;
  return i && r.push("userfront-has-info-message"), /* @__PURE__ */ D("div", {
    className: r.join(" "),
    role: "alert",
    children: i && /* @__PURE__ */ D("span", {
      className: "userfront-info-message-text",
      children: t
    })
  });
}, bd = ({
  onEvent: t,
  user: r,
  message: i
}) => {
  const o = () => {
    t({
      type: "resend"
    });
  };
  return /* @__PURE__ */ $e("div", {
    children: [/* @__PURE__ */ $e("p", {
      children: ["A link has been sent to ", r.email, "."]
    }), /* @__PURE__ */ D(wS, {
      message: i
    }), /* @__PURE__ */ $e("div", {
      className: "userfront-button-row",
      children: [/* @__PURE__ */ D(kn, {
        onEvent: t
      }), /* @__PURE__ */ D(jh, {
        onClick: o,
        children: "Resend"
      })]
    })]
  });
}, Sd = () => /* @__PURE__ */ D("div", {
  className: "userfront-placeholder"
}), bS = () => /* @__PURE__ */ D("p", {
  children: "You're logged in!"
}), Td = ({
  onEvent: t,
  requireExistingPassword: r = !1,
  requirePasswordConfirmation: i = !0,
  error: o
}) => {
  const [s, c] = Qt(!1), [l, d] = Qt(!1), [p, v] = Qt(!1);
  return /* @__PURE__ */ $e("form", {
    onSubmit: (m) => {
      var E;
      m.preventDefault();
      const b = m.target.elements;
      c(r ? !b.password.value : !1), d(!b.newPassword.value), v(i ? !b.confirmNewPassword.value : !1);
      const x = i ? b.confirmNewPassword.value : b.newPassword.value;
      if (t) {
        const _ = {
          type: "submit",
          password: b.newPassword.value,
          confirmPassword: x,
          existingPassword: (E = b.password) == null ? void 0 : E.value
        };
        t(_);
      }
    },
    className: "userfront-form",
    children: [r && /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.Password, {
        name: "password",
        label: "Enter your current password",
        showError: s,
        errorMessage: "Please enter your current password"
      })
    }), /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.Password, {
        name: "newPassword",
        label: "Choose a new password",
        showError: l,
        errorMessage: "Please enter a new password"
      })
    }), i && /* @__PURE__ */ D("div", {
      className: "userfront-form-row",
      children: /* @__PURE__ */ D($t.Password, {
        name: "confirmNewPassword",
        label: "Confirm your new password",
        showError: p,
        errorMessage: "Please confirm your new password"
      })
    }), /* @__PURE__ */ D(rn, {
      error: o
    }), /* @__PURE__ */ D("div", {
      className: "userfront-button-row",
      children: /* @__PURE__ */ D(ni, {})
    })]
  });
}, SS = () => /* @__PURE__ */ D("p", {
  children: "Your new password has been set."
});
var Ti = [], TS = function() {
  return Ti.some(function(t) {
    return t.activeTargets.length > 0;
  });
}, MS = function() {
  return Ti.some(function(t) {
    return t.skippedTargets.length > 0;
  });
}, Md = "ResizeObserver loop completed with undelivered notifications.", ES = function() {
  var t;
  typeof ErrorEvent == "function" ? t = new ErrorEvent("error", {
    message: Md
  }) : (t = document.createEvent("Event"), t.initEvent("error", !1, !1), t.message = Md), window.dispatchEvent(t);
}, Go;
(function(t) {
  t.BORDER_BOX = "border-box", t.CONTENT_BOX = "content-box", t.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box";
})(Go || (Go = {}));
var Mi = function(t) {
  return Object.freeze(t);
}, xS = function() {
  function t(r, i) {
    this.inlineSize = r, this.blockSize = i, Mi(this);
  }
  return t;
}(), Fh = function() {
  function t(r, i, o, s) {
    return this.x = r, this.y = i, this.width = o, this.height = s, this.top = this.y, this.left = this.x, this.bottom = this.top + this.height, this.right = this.left + this.width, Mi(this);
  }
  return t.prototype.toJSON = function() {
    var r = this, i = r.x, o = r.y, s = r.top, c = r.right, l = r.bottom, d = r.left, p = r.width, v = r.height;
    return { x: i, y: o, top: s, right: c, bottom: l, left: d, width: p, height: v };
  }, t.fromRect = function(r) {
    return new t(r.x, r.y, r.width, r.height);
  }, t;
}(), Mc = function(t) {
  return t instanceof SVGElement && "getBBox" in t;
}, Uh = function(t) {
  if (Mc(t)) {
    var r = t.getBBox(), i = r.width, o = r.height;
    return !i && !o;
  }
  var s = t, c = s.offsetWidth, l = s.offsetHeight;
  return !(c || l || t.getClientRects().length);
}, Ed = function(t) {
  var r;
  if (t instanceof Element)
    return !0;
  var i = (r = t == null ? void 0 : t.ownerDocument) === null || r === void 0 ? void 0 : r.defaultView;
  return !!(i && t instanceof i.Element);
}, CS = function(t) {
  switch (t.tagName) {
    case "INPUT":
      if (t.type !== "image")
        break;
    case "VIDEO":
    case "AUDIO":
    case "EMBED":
    case "OBJECT":
    case "CANVAS":
    case "IFRAME":
    case "IMG":
      return !0;
  }
  return !1;
}, Bo = typeof window < "u" ? window : {}, Ya = /* @__PURE__ */ new WeakMap(), xd = /auto|scroll/, _S = /^tb|vertical/, NS = /msie|trident/i.test(Bo.navigator && Bo.navigator.userAgent), ln = function(t) {
  return parseFloat(t || "0");
}, oo = function(t, r, i) {
  return t === void 0 && (t = 0), r === void 0 && (r = 0), i === void 0 && (i = !1), new xS((i ? r : t) || 0, (i ? t : r) || 0);
}, Cd = Mi({
  devicePixelContentBoxSize: oo(),
  borderBoxSize: oo(),
  contentBoxSize: oo(),
  contentRect: new Fh(0, 0, 0, 0)
}), zh = function(t, r) {
  if (r === void 0 && (r = !1), Ya.has(t) && !r)
    return Ya.get(t);
  if (Uh(t))
    return Ya.set(t, Cd), Cd;
  var i = getComputedStyle(t), o = Mc(t) && t.ownerSVGElement && t.getBBox(), s = !NS && i.boxSizing === "border-box", c = _S.test(i.writingMode || ""), l = !o && xd.test(i.overflowY || ""), d = !o && xd.test(i.overflowX || ""), p = o ? 0 : ln(i.paddingTop), v = o ? 0 : ln(i.paddingRight), w = o ? 0 : ln(i.paddingBottom), m = o ? 0 : ln(i.paddingLeft), b = o ? 0 : ln(i.borderTopWidth), x = o ? 0 : ln(i.borderRightWidth), E = o ? 0 : ln(i.borderBottomWidth), _ = o ? 0 : ln(i.borderLeftWidth), N = m + v, U = p + w, A = _ + x, j = b + E, R = d ? t.offsetHeight - j - t.clientHeight : 0, F = l ? t.offsetWidth - A - t.clientWidth : 0, B = s ? N + A : 0, $ = s ? U + j : 0, H = o ? o.width : ln(i.width) - B - F, te = o ? o.height : ln(i.height) - $ - R, G = H + N + F + A, ve = te + U + R + j, be = Mi({
    devicePixelContentBoxSize: oo(Math.round(H * devicePixelRatio), Math.round(te * devicePixelRatio), c),
    borderBoxSize: oo(G, ve, c),
    contentBoxSize: oo(H, te, c),
    contentRect: new Fh(m, p, H, te)
  });
  return Ya.set(t, be), be;
}, Bh = function(t, r, i) {
  var o = zh(t, i), s = o.borderBoxSize, c = o.contentBoxSize, l = o.devicePixelContentBoxSize;
  switch (r) {
    case Go.DEVICE_PIXEL_CONTENT_BOX:
      return l;
    case Go.BORDER_BOX:
      return s;
    default:
      return c;
  }
}, OS = function() {
  function t(r) {
    var i = zh(r);
    this.target = r, this.contentRect = i.contentRect, this.borderBoxSize = Mi([i.borderBoxSize]), this.contentBoxSize = Mi([i.contentBoxSize]), this.devicePixelContentBoxSize = Mi([i.devicePixelContentBoxSize]);
  }
  return t;
}(), Wh = function(t) {
  if (Uh(t))
    return 1 / 0;
  for (var r = 0, i = t.parentNode; i; )
    r += 1, i = i.parentNode;
  return r;
}, LS = function() {
  var t = 1 / 0, r = [];
  Ti.forEach(function(l) {
    if (l.activeTargets.length !== 0) {
      var d = [];
      l.activeTargets.forEach(function(v) {
        var w = new OS(v.target), m = Wh(v.target);
        d.push(w), v.lastReportedSize = Bh(v.target, v.observedBox), m < t && (t = m);
      }), r.push(function() {
        l.callback.call(l.observer, d, l.observer);
      }), l.activeTargets.splice(0, l.activeTargets.length);
    }
  });
  for (var i = 0, o = r; i < o.length; i++) {
    var s = o[i];
    s();
  }
  return t;
}, _d = function(t) {
  Ti.forEach(function(i) {
    i.activeTargets.splice(0, i.activeTargets.length), i.skippedTargets.splice(0, i.skippedTargets.length), i.observationTargets.forEach(function(s) {
      s.isActive() && (Wh(s.target) > t ? i.activeTargets.push(s) : i.skippedTargets.push(s));
    });
  });
}, AS = function() {
  var t = 0;
  for (_d(t); TS(); )
    t = LS(), _d(t);
  return MS() && ES(), t > 0;
}, zu, qh = [], IS = function() {
  return qh.splice(0).forEach(function(t) {
    return t();
  });
}, jS = function(t) {
  if (!zu) {
    var r = 0, i = document.createTextNode(""), o = { characterData: !0 };
    new MutationObserver(function() {
      return IS();
    }).observe(i, o), zu = function() {
      i.textContent = "".concat(r ? r-- : r++);
    };
  }
  qh.push(t), zu();
}, kS = function(t) {
  jS(function() {
    requestAnimationFrame(t);
  });
}, rs = 0, DS = function() {
  return !!rs;
}, RS = 250, PS = { attributes: !0, characterData: !0, childList: !0, subtree: !0 }, Nd = [
  "resize",
  "load",
  "transitionend",
  "animationend",
  "animationstart",
  "animationiteration",
  "keyup",
  "keydown",
  "mouseup",
  "mousedown",
  "mouseover",
  "mouseout",
  "blur",
  "focus"
], Od = function(t) {
  return t === void 0 && (t = 0), Date.now() + t;
}, Bu = !1, FS = function() {
  function t() {
    var r = this;
    this.stopped = !0, this.listener = function() {
      return r.schedule();
    };
  }
  return t.prototype.run = function(r) {
    var i = this;
    if (r === void 0 && (r = RS), !Bu) {
      Bu = !0;
      var o = Od(r);
      kS(function() {
        var s = !1;
        try {
          s = AS();
        } finally {
          if (Bu = !1, r = o - Od(), !DS())
            return;
          s ? i.run(1e3) : r > 0 ? i.run(r) : i.start();
        }
      });
    }
  }, t.prototype.schedule = function() {
    this.stop(), this.run();
  }, t.prototype.observe = function() {
    var r = this, i = function() {
      return r.observer && r.observer.observe(document.body, PS);
    };
    document.body ? i() : Bo.addEventListener("DOMContentLoaded", i);
  }, t.prototype.start = function() {
    var r = this;
    this.stopped && (this.stopped = !1, this.observer = new MutationObserver(this.listener), this.observe(), Nd.forEach(function(i) {
      return Bo.addEventListener(i, r.listener, !0);
    }));
  }, t.prototype.stop = function() {
    var r = this;
    this.stopped || (this.observer && this.observer.disconnect(), Nd.forEach(function(i) {
      return Bo.removeEventListener(i, r.listener, !0);
    }), this.stopped = !0);
  }, t;
}(), rc = new FS(), Ld = function(t) {
  !rs && t > 0 && rc.start(), rs += t, !rs && rc.stop();
}, US = function(t) {
  return !Mc(t) && !CS(t) && getComputedStyle(t).display === "inline";
}, zS = function() {
  function t(r, i) {
    this.target = r, this.observedBox = i || Go.CONTENT_BOX, this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }
  return t.prototype.isActive = function() {
    var r = Bh(this.target, this.observedBox, !0);
    return US(this.target) && (this.lastReportedSize = r), this.lastReportedSize.inlineSize !== r.inlineSize || this.lastReportedSize.blockSize !== r.blockSize;
  }, t;
}(), BS = function() {
  function t(r, i) {
    this.activeTargets = [], this.skippedTargets = [], this.observationTargets = [], this.observer = r, this.callback = i;
  }
  return t;
}(), Va = /* @__PURE__ */ new WeakMap(), Ad = function(t, r) {
  for (var i = 0; i < t.length; i += 1)
    if (t[i].target === r)
      return i;
  return -1;
}, Ga = function() {
  function t() {
  }
  return t.connect = function(r, i) {
    var o = new BS(r, i);
    Va.set(r, o);
  }, t.observe = function(r, i, o) {
    var s = Va.get(r), c = s.observationTargets.length === 0;
    Ad(s.observationTargets, i) < 0 && (c && Ti.push(s), s.observationTargets.push(new zS(i, o && o.box)), Ld(1), rc.schedule());
  }, t.unobserve = function(r, i) {
    var o = Va.get(r), s = Ad(o.observationTargets, i), c = o.observationTargets.length === 1;
    s >= 0 && (c && Ti.splice(Ti.indexOf(o), 1), o.observationTargets.splice(s, 1), Ld(-1));
  }, t.disconnect = function(r) {
    var i = this, o = Va.get(r);
    o.observationTargets.slice().forEach(function(s) {
      return i.unobserve(r, s.target);
    }), o.activeTargets.splice(0, o.activeTargets.length);
  }, t;
}(), WS = function() {
  function t(r) {
    if (arguments.length === 0)
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    if (typeof r != "function")
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    Ga.connect(this, r);
  }
  return t.prototype.observe = function(r, i) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Ed(r))
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Ga.observe(this, r, i);
  }, t.prototype.unobserve = function(r) {
    if (arguments.length === 0)
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    if (!Ed(r))
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    Ga.unobserve(this, r);
  }, t.prototype.disconnect = function() {
    Ga.disconnect(this);
  }, t.toString = function() {
    return "function ResizeObserver () { [polyfill code] }";
  }, t;
}();
const qS = en[typeof document < "u" && document.createElement !== void 0 ? "useLayoutEffect" : "useEffect"], YS = qS, VS = (t) => {
  const r = $u.useRef(t);
  return $u.useEffect(() => {
    r.current = t;
  }), r;
}, GS = VS, KS = typeof window < "u" && "ResizeObserver" in window ? window.ResizeObserver : WS;
function $S() {
}
function QS(t, r) {
  const i = JS(), o = GS(r);
  return YS(() => {
    let s = !1;
    const c = t && "current" in t ? t.current : t;
    if (!c)
      return $S;
    function l(d, p) {
      s || o.current(d, p);
    }
    return i.subscribe(c, l), () => {
      s = !0, i.unsubscribe(c, l);
    };
  }, [t, i, o]), i.observer;
}
function HS() {
  let t = !1, r = [];
  const i = /* @__PURE__ */ new Map(), o = new KS((s, c) => {
    r = r.concat(s);
    function l() {
      const d = /* @__PURE__ */ new Set();
      for (let p = 0; p < r.length; p++) {
        if (d.has(r[p].target))
          continue;
        d.add(r[p].target);
        const v = i.get(r[p].target);
        v == null || v.forEach((w) => w(r[p], c));
      }
      r = [], t = !1;
    }
    t || window.requestAnimationFrame(l), t = !0;
  });
  return {
    observer: o,
    subscribe(s, c) {
      var l;
      o.observe(s);
      const d = (l = i.get(s)) !== null && l !== void 0 ? l : [];
      d.push(c), i.set(s, d);
    },
    unsubscribe(s, c) {
      var l;
      const d = (l = i.get(s)) !== null && l !== void 0 ? l : [];
      if (d.length === 1) {
        o.unobserve(s), i.delete(s);
        return;
      }
      const p = d.indexOf(c);
      p !== -1 && d.splice(p, 1), i.set(s, d);
    }
  };
}
let Wu;
const JS = () => Wu || (Wu = HS()), ZS = (t) => {
  const [r, i] = Qt();
  return Qd(() => {
    t && i(t.getBoundingClientRect().width);
  }, [t]), QS(t, (o) => {
    i(o.contentRect.width);
  }), r <= 250 ? "userfront-tiny" : r <= 350 ? "userfront-small" : r <= 500 ? "userfront-medium" : "userfront-large";
}, Br = {
  emailLink: {
    channel: "email",
    strategy: "link",
    name: "emailLink",
    testIs: "isEmailLink",
    testOnlyFirst: "hasOnlyEmailLinkFirstFactor",
    testOnlySecond: "hasOnlyEmailLinkSecondFactor",
    viewContext: {
      type: "emailLink",
      message: ""
    }
  },
  emailCode: {
    channel: "email",
    strategy: "verificationCode",
    name: "emailCode",
    testIs: "isEmailCode",
    testOnlyFirst: "hasOnlyEmailCodeFirstFactor",
    testOnlySecond: "hasOnlyEmailCodeSecondFactor",
    viewContext: {
      type: "emailCode",
      code: ""
    }
  },
  smsCode: {
    channel: "sms",
    strategy: "verificationCode",
    name: "smsCode",
    testIs: "isSmsCode",
    testOnlyFirst: "hasOnlySmsCodeFirstFactor",
    testOnlySecond: "hasOnlySmsCodeSecondFactor",
    viewContext: {
      type: "smsCode",
      phoneNumber: "",
      code: ""
    }
  },
  password: {
    channel: "email",
    strategy: "password",
    name: "password",
    testIs: "isPassword",
    testOnlyFirst: "hasOnlyPasswordFirstFactor",
    testOnlySecond: "hasOnlyPasswordSecondFactor",
    viewContext: {
      type: "password",
      password: ""
    }
  },
  totp: {
    channel: "authenticator",
    strategy: "totp",
    name: "totpCode",
    testIs: "isTotp",
    testOnlyFirst: "hasOnlyTotpFirstFactor",
    testOnlySecond: "hasOnlyTotpSecondFactor",
    viewContext: {
      type: "totp",
      totpCode: "",
      showEmailOrUsername: !1,
      useBackupCode: !1,
      backupCode: "",
      qrCode: "",
      backupCodes: [],
      isMfaRequired: !1,
      allowedSecondFactors: []
    }
  },
  ssoProvider: {
    channel: "email",
    strategy: "",
    name: "ssoProvider",
    testIs: "isSsoProvider",
    testOnlyFirst: "hasOnlySsoProviderFirstFactor",
    testOnlySecond: "hasOnlySsoProviderSecondFactor",
    viewContext: {}
  }
}, fn = ({
  channel: t,
  strategy: r,
  secondFactor: i
}) => {
  const o = { channel: t, strategy: r };
  return (s) => {
    var l, d;
    let c;
    return i ? c = (l = s.allowedSecondFactors) == null ? void 0 : l[0] : c = (d = s.config.flow) == null ? void 0 : d.firstFactors[0], c.channel === o.channel && c.strategy === o.strategy;
  };
}, XS = (t) => typeof t != "string" || t.length === 0, sr = (t) => typeof t == "string" && t.length > 0, ro = (t, r) => t.channel === r.channel && t.strategy === r.strategy, Yh = (t) => {
  if (!t)
    return "";
  if (ns(t))
    return "ssoProvider";
  let r;
  for (r in Br)
    if (ro(t, Br[r]))
      return r;
  return "";
}, Id = (t) => ({
  statusCode: 0,
  message: t,
  error: {
    type: "missing_flow_error"
  }
}), eT = {
  statusCode: 0,
  message: "UNHANDLED ERROR",
  error: {
    type: "unhandled_error"
  }
}, tT = [
  "apple",
  "azure",
  "google",
  "github",
  "twitter",
  "facebook",
  "linkedin",
  "okta"
], ns = (t) => t.channel === "email" && tT.includes(t.strategy), rT = (t, r) => {
  var i;
  return !!((i = r.data) != null && i.isMfaRequired);
}, nT = (t) => t.view.isMfaRequired, iT = (t) => t.isSecondFactor, oT = (t, r) => t.action === "use" ? !0 : r.password === r.confirmPassword, aT = (t) => XS(t.config.tenantId), sT = (t) => !t.config.shouldFetchFlow && t.config.flow == null, Vh = (t) => t.config.flow == null, uT = (t, r) => {
  var o, s;
  const i = (s = (o = r.data) == null ? void 0 : o.authentication) == null ? void 0 : s.firstFactors;
  return !Array.isArray(i) || i.length === 0 ? Vh(t) : !1;
}, cT = (t) => !t.config.shouldFetchFlow, lT = (t) => t.activeFactor == null, Gh = (t) => !!(t.query.token && t.query.uuid), cs = () => {
  var t;
  return !!((t = hS("tokens")) != null && t.accessToken);
}, fT = (t) => cs() || Gh(t), dT = (t) => t.config.type === "reset", hT = (t) => t.action === "setup", ze = {
  login: {
    title: "Log in",
    done: "Logged in",
    secondFactor: {
      setup: {
        title: "Set up a second factor"
      },
      use: {
        title: "Log in"
      }
    },
    email: {
      link: {
        title: "Email me a link",
        checkEmail: "Check your email"
      },
      code: {
        title: "Email me a code",
        checkEmail: "Check your email",
        enterCode: "Enter your verification code"
      }
    },
    sms: {
      code: {
        title: "Text me a code",
        enterCode: "Enter your verification code"
      }
    },
    totp: {
      use: {
        title: "Enter your six-digit code",
        backupCode: "Enter a backup code",
        success: {
          title: "Verified"
        }
      },
      setup: {
        title: "Set up two-factor authentication",
        backupCode: "Save your backup codes",
        success: {
          title: "Added authenticator to your account"
        }
      }
    }
  },
  signup: {
    title: "Sign up",
    done: "Signed up",
    secondFactor: {
      setup: {
        title: "Sign up"
      }
    },
    email: {
      link: {
        title: "Email me a link",
        checkEmail: "Check your email"
      },
      code: {
        title: "Email me a code",
        checkEmail: "Check your email",
        enterCode: "Enter your verification code"
      }
    },
    sms: {
      code: {
        title: "Text me a code",
        enterCode: "Enter your verification code"
      }
    },
    totp: {
      setup: {
        title: "Set up two-factor authentication",
        success: {
          title: "Signed up"
        }
      }
    }
  },
  reset: {
    title: "Reset your password",
    requestResetTitle: "Reset your password",
    setNewPasswordTitle: "Set a new password",
    done: "Password reset",
    secondFactor: {
      setup: {
        title: "Set up a second factor"
      },
      use: {
        title: "Enter your second factor"
      }
    },
    email: {
      link: {
        title: "Reset your password",
        checkEmail: "Check your email"
      }
    },
    totp: {
      use: {
        title: "Enter your six-digit authenticator code",
        backupCode: "Enter a backup code",
        success: {
          title: "Your password was reset"
        }
      }
    },
    sms: {
      code: {
        title: "Text me a code",
        enterCode: "Enter your verification code"
      }
    }
  },
  general: {
    disabled: "Authentication is disabled",
    redirecting: "Redirecting...",
    unhandledError: "Oops, something went wrong",
    verified: "Verified",
    welcome: "Welcome"
  }
}, pT = (t) => {
  var l;
  let r = "";
  if (typeof t.value == "object") {
    const d = Object.keys(t.value)[0], p = t.value[d];
    r = `${d}.${p}`;
  } else
    r = t.value;
  const i = (l = t.context.config.flow) == null ? void 0 : l.firstFactors, o = t.context.config.type, s = t.context.action, c = o === "login" ? Ih : Ah;
  switch (r) {
    case "init":
    case "getGlobalTenantId":
    case "initUserfront":
    case "initFlow":
    case "initForm":
    case "beginFlow":
    case "showPreviewAndFetchFlow":
    case "showPlaceholderAndFetchFlow":
    case "initPasswordReset":
      return i ? {
        title: ze[o].title,
        Component: ko,
        props: {
          isPlaceholder: !!t.context.config.flow,
          isCompact: t.context.config.compact,
          loadingFactor: t.context.activeFactor,
          flow: t.context.config.flow,
          isSecondFactor: !1,
          tenantId: t.context.tenantId,
          isLogin: o === "login"
        }
      } : {
        Component: Sd
      };
    case "handleLoginWithLink":
      return {
        Component: Sd
      };
    case "noFirstFactors":
    case "disabled":
      return {
        title: ze.general.disabled,
        Component: Uu,
        props: {
          message: "Please contact an administrator for assistance"
        }
      };
    case "selectFirstFactor.showForm":
      return {
        title: ze[o].title,
        Component: ko,
        props: {
          isCompact: t.context.config.compact,
          flow: t.context.config.flow,
          isSecondFactor: !1,
          tenantId: t.context.tenantId,
          isLogin: o === "login"
        }
      };
    case "selectFirstFactor.send":
      return {
        title: ze[o].title,
        Component: ko,
        props: {
          isCompact: t.context.config.compact,
          flow: t.context.config.flow,
          isSecondFactor: !1,
          tenantId: t.context.tenantId,
          submittingPassword: !0,
          isLogin: o === "login"
        }
      };
    case "beginSecondFactor":
    case "selectSecondFactor.showForm":
      return {
        title: ze[o].secondFactor[s].title,
        Component: ko,
        props: {
          isCompact: t.context.config.compact,
          flow: t.context.config.flow,
          isSecondFactor: !0,
          allowedSecondFactors: t.context.allowedSecondFactors,
          tenantId: t.context.tenantId
        }
      };
    case "selectSecondFactor.send":
      return {
        title: ze[o].secondFactor[s].title,
        Component: ko,
        props: {
          isCompact: t.context.config.compact,
          flow: t.context.config.flow,
          isSecondFactor: !0,
          allowedSecondFactors: t.context.allowedSecondFactors,
          tenantId: t.context.tenantId,
          submittingPassword: !0
        }
      };
    case "ssoProvider":
      return {
        title: ze.general.redirecting,
        Component: yS,
        props: {
          text: ""
        }
      };
    case "emailLink.showForm":
      return {
        title: ze[o].email.link.title,
        Component: Wa,
        props: {
          errorMessage: t.context.errorMessage
        }
      };
    case "emailLink.send":
      return {
        title: ze[o].email.link.title,
        Component: Wa,
        props: {
          isLoading: !0
        }
      };
    case "emailLink.showEmailSent":
      return {
        title: ze[o].email.link.checkEmail,
        Component: bd,
        props: {
          message: t.context.view.message
        }
      };
    case "emailLink.resend":
      return {
        title: ze[o].email.link.checkEmail,
        Component: bd,
        props: {
          message: t.context.view.message
        }
      };
    case "emailCode.showForm":
      return {
        title: ze[o].email.code.title,
        Component: Wa,
        props: {}
      };
    case "emailCode.send":
      return {
        title: ze[o].email.code.title,
        Component: Wa,
        props: {
          isLoading: !0
        }
      };
    case "emailCode.showCodeForm":
      return {
        title: ze[o].email.code.enterCode,
        Component: qa,
        props: {}
      };
    case "emailCode.verifyCode":
      return {
        title: ze[o].email.code.enterCode,
        Component: qa,
        props: {
          isLoading: !0
        }
      };
    case "emailCode.showCodeVerified":
      return {
        title: ze.general.verified,
        Component: Ji,
        props: {}
      };
    case "smsCode.showForm":
      return {
        title: ze[o].sms.code.title,
        Component: gd,
        props: {}
      };
    case "smsCode.send":
      return {
        title: ze[o].sms.code.title,
        Component: gd,
        props: {
          isLoading: !0
        }
      };
    case "smsCode.showCodeForm":
      return {
        title: ze[o].sms.code.enterCode,
        Component: qa,
        props: {}
      };
    case "smsCode.verifyCode":
      return {
        title: ze[o].sms.code.enterCode,
        Component: qa,
        props: {
          isLoading: !0
        }
      };
    case "smsCode.showCodeVerified":
      return {
        title: ze.general.verified,
        Component: Ji,
        props: {}
      };
    case "password.showForm":
      return {
        title: ze[o].title,
        Component: c,
        props: {}
      };
    case "password.send":
      return {
        title: ze[o].title,
        Component: c,
        props: {
          isLoading: !0
        }
      };
    case "password.showPasswordSet":
      return {
        title: ze[o].done,
        Component: Ji
      };
    case "useTotpCode.showForm": {
      const d = t.context.view.useBackupCode;
      return {
        title: d ? ze[o].totp[s].backupCode : ze[o].totp[s].title,
        Component: wd,
        props: {
          errorMessage: t.context.errorMessage,
          useBackupCode: d,
          showEmailOrUsername: t.context.view.showEmailOrUsername
        }
      };
    }
    case "useTotpCode.send": {
      const d = t.context.view.useBackupCode;
      return {
        title: d ? ze[o].totp[s].backupCode : ze[o].totp[s].title,
        Component: wd,
        props: {
          isLoading: !0,
          useBackupCode: d,
          showEmailOrUsername: t.context.view.showEmailOrUsername
        }
      };
    }
    case "useTotpCode.showTotpSuccess":
      return {
        title: ze[o].totp[s].success.title,
        Component: Ji,
        props: {}
      };
    case "setUpTotp.getQrCode":
      return {
        title: ze[o].totp[s].title,
        Component: Fu,
        props: {
          qrCode: t.context.view.qrCode || ""
        }
      };
    case "setUpTotp.showQrCode":
      return {
        title: ze[o].totp[s].title,
        Component: Fu,
        props: {
          qrCode: t.context.view.qrCode || ""
        }
      };
    case "setUpTotp.confirmTotpCode":
      return {
        title: ze[o].totp[s].title,
        Component: Fu,
        props: {
          qrCode: t.context.view.qrCode || ""
        }
      };
    case "setUpTotp.showBackupCodes":
      return {
        title: ze[o].totp[s].backupCode,
        Component: dS,
        props: {
          backupCodes: t.context.view.backupCodes || []
        }
      };
    case "setUpTotp.showTotpSetupComplete":
      return {
        title: ze[o].totp[s].success.title,
        Component: Ji,
        props: {}
      };
    case "setUpTotp.showErrorMessage":
      return {
        title: ze.general.unhandledError,
        Component: fS,
        props: {}
      };
    case "missingFlowInDevModeError":
    case "missingFlowInLocalModeError":
    case "missingFlowFromServerError":
    case "unhandledError":
      return {
        title: ze.general.unhandledError,
        Component: Uu,
        props: {}
      };
    case "finish":
      return {
        title: ze[o].done,
        Component: Ji,
        props: {}
      };
    case "setNewPassword.showForm":
      return {
        title: ze.reset.setNewPasswordTitle,
        Component: Td,
        props: {
          requireExistingPassword: cs()
        }
      };
    case "setNewPassword.send":
      return {
        title: ze.reset.setNewPasswordTitle,
        Component: Td,
        props: {
          requireExistingPassword: cs(),
          isLoading: !0
        }
      };
    case "setNewPassword.showNewPasswordSet":
      return {
        title: ze.reset.done,
        Component: SS
      };
    case "alreadyLoggedIn":
      return {
        title: ze.general.welcome,
        Component: bS
      };
    default:
      return {
        title: ze.general.unhandledError,
        Component: Uu,
        props: {}
      };
  }
}, Ec = ({
  theme: t,
  state: r,
  isDemo: i = !1,
  demoMode: o = "live",
  onEvent: s
}) => {
  var A;
  const [c, l] = Qt(), d = ZS(c), {
    Component: p,
    props: v,
    title: w
  } = pT(r), m = {
    allowBack: r.context.allowBack,
    isSecondFactor: r.context.isSecondFactor,
    error: r.context.error,
    user: r.context.user,
    type: r.context.config.type
  }, b = t == null ? void 0 : t.colors, x = {
    "--userfront-light-color": (b == null ? void 0 : b.light) || "#ffffff",
    "--userfront-dark-color": (b == null ? void 0 : b.dark) || "#5e72e4",
    "--userfront-accent-color": (b == null ? void 0 : b.accent) || "#13a0ff"
  };
  b != null && b.lightBackground && (x["--userfront-light-background-color"] = b.lightBackground), b != null && b.darkBackground && (x["--userfront-dark-background-color"] = b.darkBackground), t != null && t.fontFamily && (x["--userfront-font-family"] = t.fontFamily);
  let E = "userfront-light-scheme";
  (t == null ? void 0 : t.colorScheme) === "dark" && (E = "userfront-dark-scheme"), (t == null ? void 0 : t.colorScheme) === "auto" && (E = "userfront-auto-scheme"), (t == null ? void 0 : t.size) === "compact" && (x["--userfront-em-size"] = "14px", x["--userfront-spacing"] = "0.5em"), (t == null ? void 0 : t.size) === "mini" && (x["--userfront-em-size"] = "12px", x["--userfront-spacing"] = "0.5em", x["--userfront-container-width"] = "250px"), (t == null ? void 0 : t.size) === "spaced" && (x["--userfront-em-size"] = "14px", x["--userfront-spacing"] = "20px"), (t == null ? void 0 : t.size) === "large" && (x["--userfront-em-size"] = "20px", x["--userfront-spacing"] = "18px");
  const _ = {
    gradientButtons: "userfront-gradient-buttons",
    hideSecuredMessage: "userfront-hide-branding",
    raisedButtons: "userfront-raised-buttons",
    dottedOutlines: "userfront-dotted-outlines"
  }, N = (t == null ? void 0 : t.extras) || {};
  let U = "";
  return Object.entries(N).filter(([j, R]) => Boolean(R)).forEach(([j]) => {
    j in _ ? U += ` ${_[j]}` : U += ` userfront-${j}`;
  }), U = U.trim(), /* @__PURE__ */ $e("div", {
    ref: l,
    className: `userfront-toolkit userfront-container ${d} ${E} ${U}`,
    style: x,
    children: [/* @__PURE__ */ D("h2", {
      children: w
    }), /* @__PURE__ */ D(p, {
      onEvent: s,
      ...m,
      ...v
    }), /* @__PURE__ */ D("div", {
      children: /* @__PURE__ */ D(vS, {
        mode: i ? o : (A = r.context.config) == null ? void 0 : A.mode
      })
    })]
  });
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var le = function() {
  return le = Object.assign || function(r) {
    for (var i, o = 1, s = arguments.length; o < s; o++) {
      i = arguments[o];
      for (var c in i)
        Object.prototype.hasOwnProperty.call(i, c) && (r[c] = i[c]);
    }
    return r;
  }, le.apply(this, arguments);
};
function xc(t, r) {
  var i = {};
  for (var o in t)
    Object.prototype.hasOwnProperty.call(t, o) && r.indexOf(o) < 0 && (i[o] = t[o]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(t); s < o.length; s++)
      r.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[s]) && (i[o[s]] = t[o[s]]);
  return i;
}
function nt(t) {
  var r = typeof Symbol == "function" && Symbol.iterator, i = r && t[r], o = 0;
  if (i)
    return i.call(t);
  if (t && typeof t.length == "number")
    return {
      next: function() {
        return t && o >= t.length && (t = void 0), { value: t && t[o++], done: !t };
      }
    };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function rt(t, r) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var o = i.call(t), s, c = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(s = o.next()).done; )
      c.push(s.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return c;
}
function Et(t, r, i) {
  if (i || arguments.length === 2)
    for (var o = 0, s = r.length, c; o < s; o++)
      (c || !(o in r)) && (c || (c = Array.prototype.slice.call(r, 0, o)), c[o] = r[o]);
  return t.concat(c || Array.prototype.slice.call(r));
}
var bt;
(function(t) {
  t.Start = "xstate.start", t.Stop = "xstate.stop", t.Raise = "xstate.raise", t.Send = "xstate.send", t.Cancel = "xstate.cancel", t.NullEvent = "", t.Assign = "xstate.assign", t.After = "xstate.after", t.DoneState = "done.state", t.DoneInvoke = "done.invoke", t.Log = "xstate.log", t.Init = "xstate.init", t.Invoke = "xstate.invoke", t.ErrorExecution = "error.execution", t.ErrorCommunication = "error.communication", t.ErrorPlatform = "error.platform", t.ErrorCustom = "xstate.error", t.Update = "xstate.update", t.Pure = "xstate.pure", t.Choose = "xstate.choose";
})(bt || (bt = {}));
var ri;
(function(t) {
  t.Parent = "#_parent", t.Internal = "#_internal";
})(ri || (ri = {}));
var nc = bt.Start, Cc = bt.Stop, co = bt.Raise, lo = bt.Send, Kh = bt.Cancel, gT = bt.NullEvent, _c = bt.Assign;
bt.After;
bt.DoneState;
var $h = bt.Log, mT = bt.Init, ic = bt.Invoke;
bt.ErrorExecution;
var jd = bt.ErrorPlatform, vT = bt.ErrorCustom, Qh = bt.Update, yT = bt.Choose, wT = bt.Pure, Hh = ".", kd = {}, oc = "xstate.guard", bT = "", Bt = process.env.NODE_ENV === "production", Ka;
function Nc(t, r, i) {
  i === void 0 && (i = Hh);
  var o = Wo(t, i), s = Wo(r, i);
  return ft(s) ? ft(o) ? s === o : !1 : ft(o) ? o in s : Object.keys(o).every(function(c) {
    return c in s ? Nc(o[c], s[c]) : !1;
  });
}
function Jh(t) {
  try {
    return ft(t) || typeof t == "number" ? "".concat(t) : t.type;
  } catch {
    throw new Error("Events must be strings or objects with a string event.type property.");
  }
}
function ac(t, r) {
  try {
    return po(t) ? t : t.toString().split(r);
  } catch {
    throw new Error("'".concat(t, "' is not a valid state path."));
  }
}
function ST(t) {
  return typeof t == "object" && "value" in t && "context" in t && "event" in t && "_event" in t;
}
function Wo(t, r) {
  if (ST(t))
    return t.value;
  if (po(t))
    return ls(t);
  if (typeof t != "string")
    return t;
  var i = ac(t, r);
  return ls(i);
}
function ls(t) {
  if (t.length === 1)
    return t[0];
  for (var r = {}, i = r, o = 0; o < t.length - 1; o++)
    o === t.length - 2 ? i[t[o]] = t[o + 1] : (i[t[o]] = {}, i = i[t[o]]);
  return r;
}
function Ro(t, r) {
  for (var i = {}, o = Object.keys(t), s = 0; s < o.length; s++) {
    var c = o[s];
    i[c] = r(t[c], c, t, s);
  }
  return i;
}
function Dd(t, r, i) {
  var o, s, c = {};
  try {
    for (var l = nt(Object.keys(t)), d = l.next(); !d.done; d = l.next()) {
      var p = d.value, v = t[p];
      !i(v) || (c[p] = r(v, p, t));
    }
  } catch (w) {
    o = {
      error: w
    };
  } finally {
    try {
      d && !d.done && (s = l.return) && s.call(l);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return c;
}
var TT = function(t) {
  return function(r) {
    var i, o, s = r;
    try {
      for (var c = nt(t), l = c.next(); !l.done; l = c.next()) {
        var d = l.value;
        s = s[d];
      }
    } catch (p) {
      i = {
        error: p
      };
    } finally {
      try {
        l && !l.done && (o = c.return) && o.call(c);
      } finally {
        if (i)
          throw i.error;
      }
    }
    return s;
  };
};
function MT(t, r) {
  return function(i) {
    var o, s, c = i;
    try {
      for (var l = nt(t), d = l.next(); !d.done; d = l.next()) {
        var p = d.value;
        c = c[r][p];
      }
    } catch (v) {
      o = {
        error: v
      };
    } finally {
      try {
        d && !d.done && (s = l.return) && s.call(l);
      } finally {
        if (o)
          throw o.error;
      }
    }
    return c;
  };
}
function is(t) {
  if (!t)
    return [[]];
  if (ft(t))
    return [[t]];
  var r = kt(Object.keys(t).map(function(i) {
    var o = t[i];
    return typeof o != "string" && (!o || !Object.keys(o).length) ? [[i]] : is(t[i]).map(function(s) {
      return [i].concat(s);
    });
  }));
  return r;
}
function kt(t) {
  var r;
  return (r = []).concat.apply(r, Et([], rt(t), !1));
}
function Zh(t) {
  return po(t) ? t : [t];
}
function Xr(t) {
  return t === void 0 ? [] : Zh(t);
}
function fs(t, r, i) {
  var o, s;
  if (Tt(t))
    return t(r, i.data);
  var c = {};
  try {
    for (var l = nt(Object.keys(t)), d = l.next(); !d.done; d = l.next()) {
      var p = d.value, v = t[p];
      Tt(v) ? c[p] = v(r, i.data) : c[p] = v;
    }
  } catch (w) {
    o = {
      error: w
    };
  } finally {
    try {
      d && !d.done && (s = l.return) && s.call(l);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return c;
}
function ET(t) {
  return /^(done|error)\./.test(t);
}
function Rd(t) {
  return !!(t instanceof Promise || t !== null && (Tt(t) || typeof t == "object") && Tt(t.then));
}
function xT(t) {
  return t !== null && typeof t == "object" && "transition" in t && typeof t.transition == "function";
}
function CT(t, r) {
  var i, o, s = rt([[], []], 2), c = s[0], l = s[1];
  try {
    for (var d = nt(t), p = d.next(); !p.done; p = d.next()) {
      var v = p.value;
      r(v) ? c.push(v) : l.push(v);
    }
  } catch (w) {
    i = {
      error: w
    };
  } finally {
    try {
      p && !p.done && (o = d.return) && o.call(d);
    } finally {
      if (i)
        throw i.error;
    }
  }
  return [c, l];
}
function Xh(t, r) {
  return Ro(t.states, function(i, o) {
    if (!!i) {
      var s = (ft(r) ? void 0 : r[o]) || (i ? i.current : void 0);
      if (!!s)
        return {
          current: s,
          states: Xh(i, s)
        };
    }
  });
}
function _T(t, r) {
  return {
    current: r,
    states: Xh(t, r)
  };
}
function Pd(t, r, i, o) {
  Bt || er(!!t, "Attempting to update undefined context");
  var s = t && i.reduce(function(c, l) {
    var d, p, v = l.assignment, w = {
      state: o,
      action: l,
      _event: r
    }, m = {};
    if (Tt(v))
      m = v(c, r.data, w);
    else
      try {
        for (var b = nt(Object.keys(v)), x = b.next(); !x.done; x = b.next()) {
          var E = x.value, _ = v[E];
          m[E] = Tt(_) ? _(c, r.data, w) : _;
        }
      } catch (N) {
        d = {
          error: N
        };
      } finally {
        try {
          x && !x.done && (p = b.return) && p.call(b);
        } finally {
          if (d)
            throw d.error;
        }
      }
    return Object.assign({}, c, m);
  }, t);
  return s;
}
var er = function() {
};
Bt || (er = function(t, r) {
  var i = t instanceof Error ? t : void 0;
  if (!(!i && t) && console !== void 0) {
    var o = ["Warning: ".concat(r)];
    i && o.push(i), console.warn.apply(console, o);
  }
});
function po(t) {
  return Array.isArray(t);
}
function Tt(t) {
  return typeof t == "function";
}
function ft(t) {
  return typeof t == "string";
}
function ep(t, r) {
  if (!!t)
    return ft(t) ? {
      type: oc,
      name: t,
      predicate: r ? r[t] : void 0
    } : Tt(t) ? {
      type: oc,
      name: t.name,
      predicate: t
    } : t;
}
function NT(t) {
  try {
    return "subscribe" in t && Tt(t.subscribe);
  } catch {
    return !1;
  }
}
var Hn = /* @__PURE__ */ function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
Ka = {}, Ka[Hn] = function() {
  return this;
}, Ka[Symbol.observable] = function() {
  return this;
};
function Ei(t) {
  return !!t && "__xstatenode" in t;
}
function OT(t) {
  return !!t && typeof t.send == "function";
}
function Oc(t, r) {
  return ft(t) || typeof t == "number" ? le({
    type: t
  }, r) : t;
}
function Xt(t, r) {
  if (!ft(t) && "$$type" in t && t.$$type === "scxml")
    return t;
  var i = Oc(t);
  return le({
    name: i.type,
    data: i,
    $$type: "scxml",
    type: "external"
  }, r);
}
function Zi(t, r) {
  var i = Zh(r).map(function(o) {
    return typeof o > "u" || typeof o == "string" || Ei(o) ? {
      target: o,
      event: t
    } : le(le({}, o), {
      event: t
    });
  });
  return i;
}
function LT(t) {
  if (!(t === void 0 || t === bT))
    return Xr(t);
}
function AT(t, r, i) {
  if (!Bt) {
    var o = t.stack ? " Stacktrace was '".concat(t.stack, "'") : "";
    if (t === r)
      console.error("Missing onError handler for invocation '".concat(i, "', error was '").concat(t, "'.").concat(o));
    else {
      var s = r.stack ? " Stacktrace was '".concat(r.stack, "'") : "";
      console.error("Missing onError handler and/or unhandled exception/promise rejection for invocation '".concat(i, "'. ") + "Original error: '".concat(t, "'. ").concat(o, " Current error is '").concat(r, "'.").concat(s));
    }
  }
}
function tp(t, r, i, o, s) {
  var c = t.options.guards, l = {
    state: s,
    cond: r,
    _event: o
  };
  if (r.type === oc)
    return ((c == null ? void 0 : c[r.name]) || r.predicate)(i, o.data, l);
  var d = c == null ? void 0 : c[r.type];
  if (!d)
    throw new Error("Guard '".concat(r.type, "' is not implemented on machine '").concat(t.id, "'."));
  return d(i, o.data, l);
}
function rp(t) {
  return typeof t == "string" ? {
    type: t
  } : t;
}
function os(t, r, i) {
  var o = function() {
  }, s = typeof t == "object", c = s ? t : null;
  return {
    next: ((s ? t.next : t) || o).bind(c),
    error: ((s ? t.error : r) || o).bind(c),
    complete: ((s ? t.complete : i) || o).bind(c)
  };
}
function $a(t, r) {
  return "".concat(t, ":invocation[").concat(r, "]");
}
var ao = /* @__PURE__ */ Xt({
  type: mT
});
function sc(t, r) {
  return r && r[t] || void 0;
}
function Ko(t, r) {
  var i;
  if (ft(t) || typeof t == "number") {
    var o = sc(t, r);
    Tt(o) ? i = {
      type: t,
      exec: o
    } : o ? i = o : i = {
      type: t,
      exec: void 0
    };
  } else if (Tt(t))
    i = {
      type: t.name || t.toString(),
      exec: t
    };
  else {
    var o = sc(t.type, r);
    if (Tt(o))
      i = le(le({}, t), {
        exec: o
      });
    else if (o) {
      var s = o.type || t.type;
      i = le(le(le({}, o), t), {
        type: s
      });
    } else
      i = t;
  }
  return i;
}
var Jn = function(t, r) {
  if (!t)
    return [];
  var i = po(t) ? t : [t];
  return i.map(function(o) {
    return Ko(o, r);
  });
};
function Lc(t) {
  var r = Ko(t);
  return le(le({
    id: ft(t) ? t : r.id
  }, r), {
    type: r.type
  });
}
function IT(t) {
  return ft(t) ? {
    type: co,
    event: t
  } : Ac(t, {
    to: ri.Internal
  });
}
function jT(t) {
  return {
    type: co,
    _event: Xt(t.event)
  };
}
function Ac(t, r) {
  return {
    to: r ? r.to : void 0,
    type: lo,
    event: Tt(t) ? t : Oc(t),
    delay: r ? r.delay : void 0,
    id: r && r.id !== void 0 ? r.id : Tt(t) ? t.name : Jh(t)
  };
}
function kT(t, r, i, o) {
  var s = {
    _event: i
  }, c = Xt(Tt(t.event) ? t.event(r, i.data, s) : t.event), l;
  if (ft(t.delay)) {
    var d = o && o[t.delay];
    l = Tt(d) ? d(r, i.data, s) : d;
  } else
    l = Tt(t.delay) ? t.delay(r, i.data, s) : t.delay;
  var p = Tt(t.to) ? t.to(r, i.data, s) : t.to;
  return le(le({}, t), {
    to: p,
    _event: c,
    event: c.data,
    delay: l
  });
}
var DT = function(t, r, i) {
  return le(le({}, t), {
    value: ft(t.expr) ? t.expr : t.expr(r, i.data, {
      _event: i
    })
  });
}, RT = function(t) {
  return {
    type: Kh,
    sendId: t
  };
};
function PT(t) {
  var r = Lc(t);
  return {
    type: bt.Start,
    activity: r,
    exec: void 0
  };
}
function FT(t) {
  var r = Tt(t) ? t : Lc(t);
  return {
    type: bt.Stop,
    activity: r,
    exec: void 0
  };
}
function UT(t, r, i) {
  var o = Tt(t.activity) ? t.activity(r, i.data) : t.activity, s = typeof o == "string" ? {
    id: o
  } : o, c = {
    type: bt.Stop,
    activity: s
  };
  return c;
}
var zT = function(t) {
  return {
    type: _c,
    assignment: t
  };
};
function BT(t, r) {
  var i = r ? "#".concat(r) : "";
  return "".concat(bt.After, "(").concat(t, ")").concat(i);
}
function Qa(t, r) {
  var i = "".concat(bt.DoneState, ".").concat(t), o = {
    type: i,
    data: r
  };
  return o.toString = function() {
    return i;
  }, o;
}
function as(t, r) {
  var i = "".concat(bt.DoneInvoke, ".").concat(t), o = {
    type: i,
    data: r
  };
  return o.toString = function() {
    return i;
  }, o;
}
function Po(t, r) {
  var i = "".concat(bt.ErrorPlatform, ".").concat(t), o = {
    type: i,
    data: r
  };
  return o.toString = function() {
    return i;
  }, o;
}
function WT(t) {
  return {
    type: bt.Choose,
    conds: t
  };
}
var qT = function(t) {
  var r, i, o = [];
  try {
    for (var s = nt(t), c = s.next(); !c.done; c = s.next())
      for (var l = c.value, d = 0; d < l.length; ) {
        if (l[d].type === _c) {
          o.push(l[d]), l.splice(d, 1);
          continue;
        }
        d++;
      }
  } catch (p) {
    r = {
      error: p
    };
  } finally {
    try {
      c && !c.done && (i = s.return) && i.call(s);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return o;
};
function ds(t, r, i, o, s, c, l) {
  l === void 0 && (l = !1);
  var d = l ? [] : qT(s), p = d.length ? Pd(i, o, d, r) : i, v = l ? [i] : void 0, w = [];
  function m(E) {
    var _;
    switch (E.type) {
      case co:
        return jT(E);
      case lo:
        var N = kT(E, p, o, t.options.delays);
        return Bt || er(
          !ft(E.delay) || typeof N.delay == "number",
          "No delay reference for delay expression '".concat(E.delay, "' was found on machine '").concat(t.id, "'")
        ), c && N.to !== ri.Internal && w.push(N), N;
      case $h: {
        var U = DT(E, p, o);
        return c == null || c(U, p, o), U;
      }
      case yT: {
        var A = E, j = (_ = A.conds.find(function(xe) {
          var K = ep(xe.cond, t.options.guards);
          return !K || tp(t, K, p, o, c ? void 0 : r);
        })) === null || _ === void 0 ? void 0 : _.actions;
        if (!j)
          return [];
        var R = rt(ds(t, r, p, o, [Jn(Xr(j), t.options.actions)], c, l), 2), F = R[0], B = R[1];
        return p = B, v == null || v.push(p), F;
      }
      case wT: {
        var j = E.get(p, o.data);
        if (!j)
          return [];
        var $ = rt(ds(t, r, p, o, [Jn(Xr(j), t.options.actions)], c, l), 2), H = $[0], te = $[1];
        return p = te, v == null || v.push(p), H;
      }
      case Cc: {
        var U = UT(E, p, o);
        return c == null || c(U, i, o), U;
      }
      case _c: {
        p = Pd(p, o, [E], c ? void 0 : r), v == null || v.push(p);
        break;
      }
      default:
        var G = Ko(E, t.options.actions), ve = G.exec;
        if (c)
          c(G, p, o);
        else if (ve && v) {
          var be = v.length - 1;
          G = le(le({}, G), {
            exec: function(xe) {
              for (var K = [], ie = 1; ie < arguments.length; ie++)
                K[ie - 1] = arguments[ie];
              ve.apply(void 0, Et([v[be]], rt(K), !1));
            }
          });
        }
        return G;
    }
  }
  function b(E) {
    var _, N, U = [];
    try {
      for (var A = nt(E), j = A.next(); !j.done; j = A.next()) {
        var R = j.value, F = m(R);
        F && (U = U.concat(F));
      }
    } catch (B) {
      _ = {
        error: B
      };
    } finally {
      try {
        j && !j.done && (N = A.return) && N.call(A);
      } finally {
        if (_)
          throw _.error;
      }
    }
    return w.forEach(function(B) {
      c(B, p, o);
    }), w.length = 0, U;
  }
  var x = kt(s.map(b));
  return [x, p];
}
var no = function(t, r) {
  var i = r(t);
  return i;
};
function np(t) {
  var r;
  return r = {
    id: t,
    send: function() {
    },
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    getSnapshot: function() {
    },
    toJSON: function() {
      return {
        id: t
      };
    }
  }, r[Hn] = function() {
    return this;
  }, r;
}
function YT(t, r, i, o) {
  var s, c = rp(t.src), l = (s = r == null ? void 0 : r.options.services) === null || s === void 0 ? void 0 : s[c.type], d = t.data ? fs(t.data, i, o) : void 0, p = l ? ip(l, t.id, d) : np(t.id);
  return p.meta = t, p;
}
function ip(t, r, i) {
  var o = np(r);
  if (o.deferred = !0, Ei(t)) {
    var s = o.state = no(void 0, function() {
      return (i ? t.withContext(i) : t).initialState;
    });
    o.getSnapshot = function() {
      return s;
    };
  }
  return o;
}
function VT(t) {
  try {
    return typeof t.send == "function";
  } catch {
    return !1;
  }
}
function GT(t) {
  return VT(t) && "id" in t;
}
function KT(t) {
  var r;
  return le((r = {
    subscribe: function() {
      return {
        unsubscribe: function() {
        }
      };
    },
    id: "anonymous",
    getSnapshot: function() {
    }
  }, r[Hn] = function() {
    return this;
  }, r), t);
}
var hs = function(t) {
  return t.type === "atomic" || t.type === "final";
};
function op(t) {
  return Object.keys(t.states).map(function(r) {
    return t.states[r];
  });
}
function $o(t) {
  return op(t).filter(function(r) {
    return r.type !== "history";
  });
}
function ap(t) {
  var r = [t];
  return hs(t) ? r : r.concat(kt($o(t).map(ap)));
}
function Fo(t, r) {
  var i, o, s, c, l, d, p, v, w = new Set(t), m = uc(w), b = new Set(r);
  try {
    for (var x = nt(b), E = x.next(); !E.done; E = x.next())
      for (var _ = E.value, N = _.parent; N && !b.has(N); )
        b.add(N), N = N.parent;
  } catch (te) {
    i = {
      error: te
    };
  } finally {
    try {
      E && !E.done && (o = x.return) && o.call(x);
    } finally {
      if (i)
        throw i.error;
    }
  }
  var U = uc(b);
  try {
    for (var A = nt(b), j = A.next(); !j.done; j = A.next()) {
      var _ = j.value;
      if (_.type === "compound" && (!U.get(_) || !U.get(_).length))
        m.get(_) ? m.get(_).forEach(function(G) {
          return b.add(G);
        }) : _.initialStateNodes.forEach(function(G) {
          return b.add(G);
        });
      else if (_.type === "parallel")
        try {
          for (var R = (l = void 0, nt($o(_))), F = R.next(); !F.done; F = R.next()) {
            var B = F.value;
            b.has(B) || (b.add(B), m.get(B) ? m.get(B).forEach(function(G) {
              return b.add(G);
            }) : B.initialStateNodes.forEach(function(G) {
              return b.add(G);
            }));
          }
        } catch (G) {
          l = {
            error: G
          };
        } finally {
          try {
            F && !F.done && (d = R.return) && d.call(R);
          } finally {
            if (l)
              throw l.error;
          }
        }
    }
  } catch (te) {
    s = {
      error: te
    };
  } finally {
    try {
      j && !j.done && (c = A.return) && c.call(A);
    } finally {
      if (s)
        throw s.error;
    }
  }
  try {
    for (var $ = nt(b), H = $.next(); !H.done; H = $.next())
      for (var _ = H.value, N = _.parent; N && !b.has(N); )
        b.add(N), N = N.parent;
  } catch (te) {
    p = {
      error: te
    };
  } finally {
    try {
      H && !H.done && (v = $.return) && v.call($);
    } finally {
      if (p)
        throw p.error;
    }
  }
  return b;
}
function sp(t, r) {
  var i = r.get(t);
  if (!i)
    return {};
  if (t.type === "compound") {
    var o = i[0];
    if (o) {
      if (hs(o))
        return o.key;
    } else
      return {};
  }
  var s = {};
  return i.forEach(function(c) {
    s[c.key] = sp(c, r);
  }), s;
}
function uc(t) {
  var r, i, o = /* @__PURE__ */ new Map();
  try {
    for (var s = nt(t), c = s.next(); !c.done; c = s.next()) {
      var l = c.value;
      o.has(l) || o.set(l, []), l.parent && (o.has(l.parent) || o.set(l.parent, []), o.get(l.parent).push(l));
    }
  } catch (d) {
    r = {
      error: d
    };
  } finally {
    try {
      c && !c.done && (i = s.return) && i.call(s);
    } finally {
      if (r)
        throw r.error;
    }
  }
  return o;
}
function $T(t, r) {
  var i = Fo([t], r);
  return sp(t, uc(i));
}
function Uo(t, r) {
  return Array.isArray(t) ? t.some(function(i) {
    return i === r;
  }) : t instanceof Set ? t.has(r) : !1;
}
function QT(t) {
  return Et([], rt(new Set(kt(Et([], rt(t.map(function(r) {
    return r.ownEvents;
  })), !1)))), !1);
}
function ss(t, r) {
  return r.type === "compound" ? $o(r).some(function(i) {
    return i.type === "final" && Uo(t, i);
  }) : r.type === "parallel" ? $o(r).every(function(i) {
    return ss(t, i);
  }) : !1;
}
function HT(t) {
  return t === void 0 && (t = []), t.reduce(function(r, i) {
    return i.meta !== void 0 && (r[i.id] = i.meta), r;
  }, {});
}
function Fd(t) {
  return new Set(kt(t.map(function(r) {
    return r.tags;
  })));
}
function up(t, r) {
  if (t === r)
    return !0;
  if (t === void 0 || r === void 0)
    return !1;
  if (ft(t) || ft(r))
    return t === r;
  var i = Object.keys(t), o = Object.keys(r);
  return i.length === o.length && i.every(function(s) {
    return up(t[s], r[s]);
  });
}
function JT(t) {
  return typeof t != "object" || t === null ? !1 : "value" in t && "_event" in t;
}
function ZT(t, r) {
  var i = t.exec, o = le(le({}, t), {
    exec: i !== void 0 ? function() {
      return i(r.context, r.event, {
        action: t,
        state: r,
        _event: r._event
      });
    } : void 0
  });
  return o;
}
var zr = /* @__PURE__ */ function() {
  function t(r) {
    var i = this, o;
    this.actions = [], this.activities = kd, this.meta = {}, this.events = [], this.value = r.value, this.context = r.context, this._event = r._event, this._sessionid = r._sessionid, this.event = this._event.data, this.historyValue = r.historyValue, this.history = r.history, this.actions = r.actions || [], this.activities = r.activities || kd, this.meta = HT(r.configuration), this.events = r.events || [], this.matches = this.matches.bind(this), this.toStrings = this.toStrings.bind(this), this.configuration = r.configuration, this.transitions = r.transitions, this.children = r.children, this.done = !!r.done, this.tags = (o = Array.isArray(r.tags) ? new Set(r.tags) : r.tags) !== null && o !== void 0 ? o : /* @__PURE__ */ new Set(), this.machine = r.machine, Object.defineProperty(this, "nextEvents", {
      get: function() {
        return QT(i.configuration);
      }
    });
  }
  return t.from = function(r, i) {
    if (r instanceof t)
      return r.context !== i ? new t({
        value: r.value,
        context: i,
        _event: r._event,
        _sessionid: null,
        historyValue: r.historyValue,
        history: r.history,
        actions: [],
        activities: r.activities,
        meta: {},
        events: [],
        configuration: [],
        transitions: [],
        children: {}
      }) : r;
    var o = ao;
    return new t({
      value: r,
      context: i,
      _event: o,
      _sessionid: null,
      historyValue: void 0,
      history: void 0,
      actions: [],
      activities: void 0,
      meta: void 0,
      events: [],
      configuration: [],
      transitions: [],
      children: {}
    });
  }, t.create = function(r) {
    return new t(r);
  }, t.inert = function(r, i) {
    if (r instanceof t) {
      if (!r.actions.length)
        return r;
      var o = ao;
      return new t({
        value: r.value,
        context: i,
        _event: o,
        _sessionid: null,
        historyValue: r.historyValue,
        history: r.history,
        activities: r.activities,
        configuration: r.configuration,
        transitions: [],
        children: {}
      });
    }
    return t.from(r, i);
  }, t.prototype.toStrings = function(r, i) {
    var o = this;
    if (r === void 0 && (r = this.value), i === void 0 && (i = "."), ft(r))
      return [r];
    var s = Object.keys(r);
    return s.concat.apply(s, Et([], rt(s.map(function(c) {
      return o.toStrings(r[c], i).map(function(l) {
        return c + i + l;
      });
    })), !1));
  }, t.prototype.toJSON = function() {
    var r = this;
    r.configuration, r.transitions;
    var i = r.tags;
    r.machine;
    var o = xc(r, ["configuration", "transitions", "tags", "machine"]);
    return le(le({}, o), {
      tags: Array.from(i)
    });
  }, t.prototype.matches = function(r) {
    return Nc(r, this.value);
  }, t.prototype.hasTag = function(r) {
    return this.tags.has(r);
  }, t.prototype.can = function(r) {
    var i;
    Bt && er(!!this.machine, "state.can(...) used outside of a machine-created State object; this will always return false.");
    var o = (i = this.machine) === null || i === void 0 ? void 0 : i.getTransitionData(this, r);
    return !!(o != null && o.transitions.length) && o.transitions.some(function(s) {
      return s.target !== void 0 || s.actions.length;
    });
  }, t;
}(), XT = {
  deferEvents: !1
}, Ud = /* @__PURE__ */ function() {
  function t(r) {
    this.processingEvent = !1, this.queue = [], this.initialized = !1, this.options = le(le({}, XT), r);
  }
  return t.prototype.initialize = function(r) {
    if (this.initialized = !0, r) {
      if (!this.options.deferEvents) {
        this.schedule(r);
        return;
      }
      this.process(r);
    }
    this.flushEvents();
  }, t.prototype.schedule = function(r) {
    if (!this.initialized || this.processingEvent) {
      this.queue.push(r);
      return;
    }
    if (this.queue.length !== 0)
      throw new Error("Event queue should be empty when it is not processing events");
    this.process(r), this.flushEvents();
  }, t.prototype.clear = function() {
    this.queue = [];
  }, t.prototype.flushEvents = function() {
    for (var r = this.queue.shift(); r; )
      this.process(r), r = this.queue.shift();
  }, t.prototype.process = function(r) {
    this.processingEvent = !0;
    try {
      r();
    } catch (i) {
      throw this.clear(), i;
    } finally {
      this.processingEvent = !1;
    }
  }, t;
}(), qu = /* @__PURE__ */ new Map(), eM = 0, Ha = {
  bookId: function() {
    return "x:".concat(eM++);
  },
  register: function(t, r) {
    return qu.set(t, r), t;
  },
  get: function(t) {
    return qu.get(t);
  },
  free: function(t) {
    qu.delete(t);
  }
};
function Ic() {
  if (typeof globalThis < "u")
    return globalThis;
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  Bt || console.warn("XState could not find a global object in this environment. Please let the maintainers know and raise an issue here: https://github.com/statelyai/xstate/issues");
}
function tM() {
  var t = Ic();
  if (t && "__xstate__" in t)
    return t.__xstate__;
}
function rM(t) {
  if (!!Ic()) {
    var r = tM();
    r && r.register(t);
  }
}
function nM(t, r) {
  r === void 0 && (r = {});
  var i = t.initialState, o = /* @__PURE__ */ new Set(), s = [], c = !1, l = function() {
    if (!c) {
      for (c = !0; s.length > 0; ) {
        var v = s.shift();
        i = t.transition(i, v, p), o.forEach(function(w) {
          return w.next(i);
        });
      }
      c = !1;
    }
  }, d = KT({
    id: r.id,
    send: function(v) {
      s.push(v), l();
    },
    getSnapshot: function() {
      return i;
    },
    subscribe: function(v, w, m) {
      var b = os(v, w, m);
      return o.add(b), b.next(i), {
        unsubscribe: function() {
          o.delete(b);
        }
      };
    }
  }), p = {
    parent: r.parent,
    self: d,
    id: r.id || "anonymous",
    observers: o
  };
  return i = t.start ? t.start(p) : i, d;
}
var iM = {
  sync: !1,
  autoForward: !1
}, zt;
(function(t) {
  t[t.NotStarted = 0] = "NotStarted", t[t.Running = 1] = "Running", t[t.Stopped = 2] = "Stopped";
})(zt || (zt = {}));
var oM = /* @__PURE__ */ function() {
  function t(r, i) {
    i === void 0 && (i = t.defaultOptions);
    var o = this;
    this.machine = r, this.delayedEventsMap = {}, this.listeners = /* @__PURE__ */ new Set(), this.contextListeners = /* @__PURE__ */ new Set(), this.stopListeners = /* @__PURE__ */ new Set(), this.doneListeners = /* @__PURE__ */ new Set(), this.eventListeners = /* @__PURE__ */ new Set(), this.sendListeners = /* @__PURE__ */ new Set(), this.initialized = !1, this.status = zt.NotStarted, this.children = /* @__PURE__ */ new Map(), this.forwardTo = /* @__PURE__ */ new Set(), this._outgoingQueue = [], this.init = this.start, this.send = function(w, m) {
      if (po(w))
        return o.batch(w), o.state;
      var b = Xt(Oc(w, m));
      if (o.status === zt.Stopped)
        return Bt || er(!1, 'Event "'.concat(b.name, '" was sent to stopped service "').concat(o.machine.id, `". This service has already reached its final state, and will not transition.
Event: `).concat(JSON.stringify(b.data))), o.state;
      if (o.status !== zt.Running && !o.options.deferEvents)
        throw new Error('Event "'.concat(b.name, '" was sent to uninitialized service "').concat(
          o.machine.id,
          `". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.
Event: `
        ).concat(JSON.stringify(b.data)));
      return o.scheduler.schedule(function() {
        o.forward(b);
        var x = o._nextState(b);
        o.update(x, b);
      }), o._state;
    }, this.sendTo = function(w, m, b) {
      var x = o.parent && (m === ri.Parent || o.parent.id === m), E = x ? o.parent : ft(m) ? o.children.get(m) || Ha.get(m) : OT(m) ? m : void 0;
      if (!E) {
        if (!x)
          throw new Error("Unable to send event to child '".concat(m, "' from service '").concat(o.id, "'."));
        Bt || er(!1, "Service '".concat(o.id, "' has no parent: unable to send event ").concat(w.type));
        return;
      }
      if ("machine" in E) {
        if (o.status !== zt.Stopped || o.parent !== E || o.state.done) {
          var _ = le(le({}, w), {
            name: w.name === vT ? "".concat(Po(o.id)) : w.name,
            origin: o.sessionId
          });
          !b && o.machine.config.predictableActionArguments ? o._outgoingQueue.push([E, _]) : E.send(_);
        }
      } else
        !b && o.machine.config.predictableActionArguments ? o._outgoingQueue.push([E, w.data]) : E.send(w.data);
    }, this._exec = function(w, m, b, x) {
      x === void 0 && (x = o.machine.options.actions);
      var E = w.exec || sc(w.type, x), _ = Tt(E) ? E : E ? E.exec : w.exec;
      if (_)
        try {
          return _(m, b.data, o.machine.config.predictableActionArguments ? {
            action: w,
            _event: b
          } : {
            action: w,
            state: o.state,
            _event: b
          });
        } catch (be) {
          throw o.parent && o.parent.send({
            type: "xstate.error",
            data: be
          }), be;
        }
      switch (w.type) {
        case lo:
          var N = w;
          if (typeof N.delay == "number") {
            o.defer(N);
            return;
          } else
            N.to ? o.sendTo(N._event, N.to, b === ao) : o.send(N._event);
          break;
        case Kh:
          o.cancel(w.sendId);
          break;
        case nc: {
          if (o.status !== zt.Running)
            return;
          var U = w.activity;
          if (!o.machine.config.predictableActionArguments && !o.state.activities[U.id || U.type])
            break;
          if (U.type === bt.Invoke) {
            var A = rp(U.src), j = o.machine.options.services ? o.machine.options.services[A.type] : void 0, R = U.id, F = U.data;
            Bt || er(
              !("forward" in U),
              "`forward` property is deprecated (found in invocation of '".concat(U.src, "' in in machine '").concat(o.machine.id, "'). ") + "Please use `autoForward` instead."
            );
            var B = "autoForward" in U ? U.autoForward : !!U.forward;
            if (!j) {
              Bt || er(!1, "No service found for invocation '".concat(U.src, "' in machine '").concat(o.machine.id, "'."));
              return;
            }
            var $ = F ? fs(F, m, b) : void 0;
            if (typeof j == "string")
              return;
            var H = Tt(j) ? j(m, b.data, {
              data: $,
              src: A,
              meta: U.meta
            }) : j;
            if (!H)
              return;
            var te = void 0;
            Ei(H) && (H = $ ? H.withContext($) : H, te = {
              autoForward: B
            }), o.spawn(H, R, te);
          } else
            o.spawnActivity(U);
          break;
        }
        case Cc: {
          o.stopChild(w.activity.id);
          break;
        }
        case $h:
          var G = w.label, ve = w.value;
          G ? o.logger(G, ve) : o.logger(ve);
          break;
        default:
          Bt || er(!1, "No implementation found for action type '".concat(w.type, "'"));
          break;
      }
    };
    var s = le(le({}, t.defaultOptions), i), c = s.clock, l = s.logger, d = s.parent, p = s.id, v = p !== void 0 ? p : r.id;
    this.id = v, this.logger = l, this.clock = c, this.parent = d, this.options = s, this.scheduler = new Ud({
      deferEvents: this.options.deferEvents
    }), this.sessionId = Ha.bookId();
  }
  return Object.defineProperty(t.prototype, "initialState", {
    get: function() {
      var r = this;
      return this._initialState ? this._initialState : no(this, function() {
        return r._initialState = r.machine.initialState, r._initialState;
      });
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "state", {
    get: function() {
      return Bt || er(this.status !== zt.NotStarted, "Attempted to read state from uninitialized service '".concat(this.id, "'. Make sure the service is started first.")), this._state;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.execute = function(r, i) {
    var o, s;
    try {
      for (var c = nt(r.actions), l = c.next(); !l.done; l = c.next()) {
        var d = l.value;
        this.exec(d, r, i);
      }
    } catch (p) {
      o = {
        error: p
      };
    } finally {
      try {
        l && !l.done && (s = c.return) && s.call(c);
      } finally {
        if (o)
          throw o.error;
      }
    }
  }, t.prototype.update = function(r, i) {
    var o, s, c, l, d, p, v, w, m = this;
    if (r._sessionid = this.sessionId, this._state = r, (!this.machine.config.predictableActionArguments || i === ao) && this.options.execute)
      this.execute(this.state);
    else
      for (var b = void 0; b = this._outgoingQueue.shift(); )
        b[0].send(b[1]);
    if (this.children.forEach(function(te) {
      m.state.children[te.id] = te;
    }), this.devTools && this.devTools.send(i.data, r), r.event)
      try {
        for (var x = nt(this.eventListeners), E = x.next(); !E.done; E = x.next()) {
          var _ = E.value;
          _(r.event);
        }
      } catch (te) {
        o = {
          error: te
        };
      } finally {
        try {
          E && !E.done && (s = x.return) && s.call(x);
        } finally {
          if (o)
            throw o.error;
        }
      }
    try {
      for (var N = nt(this.listeners), U = N.next(); !U.done; U = N.next()) {
        var _ = U.value;
        _(r, r.event);
      }
    } catch (te) {
      c = {
        error: te
      };
    } finally {
      try {
        U && !U.done && (l = N.return) && l.call(N);
      } finally {
        if (c)
          throw c.error;
      }
    }
    try {
      for (var A = nt(this.contextListeners), j = A.next(); !j.done; j = A.next()) {
        var R = j.value;
        R(this.state.context, this.state.history ? this.state.history.context : void 0);
      }
    } catch (te) {
      d = {
        error: te
      };
    } finally {
      try {
        j && !j.done && (p = A.return) && p.call(A);
      } finally {
        if (d)
          throw d.error;
      }
    }
    if (this.state.done) {
      var F = r.configuration.find(function(te) {
        return te.type === "final" && te.parent === m.machine;
      }), B = F && F.doneData ? fs(F.doneData, r.context, i) : void 0;
      try {
        for (var $ = nt(this.doneListeners), H = $.next(); !H.done; H = $.next()) {
          var _ = H.value;
          _(as(this.id, B));
        }
      } catch (te) {
        v = {
          error: te
        };
      } finally {
        try {
          H && !H.done && (w = $.return) && w.call($);
        } finally {
          if (v)
            throw v.error;
        }
      }
      this._stop(), this._stopChildren();
    }
  }, t.prototype.onTransition = function(r) {
    return this.listeners.add(r), this.status === zt.Running && r(this.state, this.state.event), this;
  }, t.prototype.subscribe = function(r, i, o) {
    var s = this, c = os(r, i, o);
    this.listeners.add(c.next), this.status !== zt.NotStarted && c.next(this.state);
    var l = function() {
      s.doneListeners.delete(l), s.stopListeners.delete(l), c.complete();
    };
    return this.status === zt.Stopped ? c.complete() : (this.onDone(l), this.onStop(l)), {
      unsubscribe: function() {
        s.listeners.delete(c.next), s.doneListeners.delete(l), s.stopListeners.delete(l);
      }
    };
  }, t.prototype.onEvent = function(r) {
    return this.eventListeners.add(r), this;
  }, t.prototype.onSend = function(r) {
    return this.sendListeners.add(r), this;
  }, t.prototype.onChange = function(r) {
    return this.contextListeners.add(r), this;
  }, t.prototype.onStop = function(r) {
    return this.stopListeners.add(r), this;
  }, t.prototype.onDone = function(r) {
    return this.doneListeners.add(r), this;
  }, t.prototype.off = function(r) {
    return this.listeners.delete(r), this.eventListeners.delete(r), this.sendListeners.delete(r), this.stopListeners.delete(r), this.doneListeners.delete(r), this.contextListeners.delete(r), this;
  }, t.prototype.start = function(r) {
    var i = this;
    if (this.status === zt.Running)
      return this;
    this.machine._init(), Ha.register(this.sessionId, this), this.initialized = !0, this.status = zt.Running;
    var o = r === void 0 ? this.initialState : no(this, function() {
      return JT(r) ? i.machine.resolveState(r) : i.machine.resolveState(zr.from(r, i.machine.context));
    });
    return this.options.devTools && this.attachDev(), this.scheduler.initialize(function() {
      i.update(o, ao);
    }), this;
  }, t.prototype._stopChildren = function() {
    this.children.forEach(function(r) {
      Tt(r.stop) && r.stop();
    }), this.children.clear();
  }, t.prototype._stop = function() {
    var r, i, o, s, c, l, d, p, v, w;
    try {
      for (var m = nt(this.listeners), b = m.next(); !b.done; b = m.next()) {
        var x = b.value;
        this.listeners.delete(x);
      }
    } catch ($) {
      r = {
        error: $
      };
    } finally {
      try {
        b && !b.done && (i = m.return) && i.call(m);
      } finally {
        if (r)
          throw r.error;
      }
    }
    try {
      for (var E = nt(this.stopListeners), _ = E.next(); !_.done; _ = E.next()) {
        var x = _.value;
        x(), this.stopListeners.delete(x);
      }
    } catch ($) {
      o = {
        error: $
      };
    } finally {
      try {
        _ && !_.done && (s = E.return) && s.call(E);
      } finally {
        if (o)
          throw o.error;
      }
    }
    try {
      for (var N = nt(this.contextListeners), U = N.next(); !U.done; U = N.next()) {
        var x = U.value;
        this.contextListeners.delete(x);
      }
    } catch ($) {
      c = {
        error: $
      };
    } finally {
      try {
        U && !U.done && (l = N.return) && l.call(N);
      } finally {
        if (c)
          throw c.error;
      }
    }
    try {
      for (var A = nt(this.doneListeners), j = A.next(); !j.done; j = A.next()) {
        var x = j.value;
        this.doneListeners.delete(x);
      }
    } catch ($) {
      d = {
        error: $
      };
    } finally {
      try {
        j && !j.done && (p = A.return) && p.call(A);
      } finally {
        if (d)
          throw d.error;
      }
    }
    if (!this.initialized)
      return this;
    this.initialized = !1, this.status = zt.Stopped, this._initialState = void 0;
    try {
      for (var R = nt(Object.keys(this.delayedEventsMap)), F = R.next(); !F.done; F = R.next()) {
        var B = F.value;
        this.clock.clearTimeout(this.delayedEventsMap[B]);
      }
    } catch ($) {
      v = {
        error: $
      };
    } finally {
      try {
        F && !F.done && (w = R.return) && w.call(R);
      } finally {
        if (v)
          throw v.error;
      }
    }
    this.scheduler.clear(), this.scheduler = new Ud({
      deferEvents: this.options.deferEvents
    });
  }, t.prototype.stop = function() {
    var r = this, i = this.scheduler;
    return this._stop(), i.schedule(function() {
      var o = Xt({
        type: "xstate.stop"
      }), s = no(r, function() {
        var c = kt(Et([], rt(r.state.configuration), !1).sort(function(w, m) {
          return m.order - w.order;
        }).map(function(w) {
          return Jn(w.onExit, r.machine.options.actions);
        })), l = rt(ds(r.machine, r.state, r.state.context, o, [c], r.machine.config.predictableActionArguments ? r._exec : void 0, r.machine.config.predictableActionArguments || r.machine.config.preserveActionOrder), 2), d = l[0], p = l[1], v = new zr({
          value: r.state.value,
          context: p,
          _event: o,
          _sessionid: r.sessionId,
          historyValue: void 0,
          history: r.state,
          actions: d.filter(function(w) {
            return w.type !== co && (w.type !== lo || !!w.to && w.to !== ri.Internal);
          }),
          activities: {},
          events: [],
          configuration: [],
          transitions: [],
          children: {},
          done: r.state.done,
          tags: r.state.tags,
          machine: r.machine
        });
        return v.changed = !0, v;
      });
      r.update(s, o), r._stopChildren(), Ha.free(r.sessionId);
    }), this;
  }, t.prototype.batch = function(r) {
    var i = this;
    if (this.status === zt.NotStarted && this.options.deferEvents)
      Bt || er(!1, "".concat(r.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, `" and are deferred. Make sure .start() is called for this service.
Event: `).concat(JSON.stringify(event)));
    else if (this.status !== zt.Running)
      throw new Error(
        "".concat(r.length, ' event(s) were sent to uninitialized service "').concat(this.machine.id, '". Make sure .start() is called for this service, or set { deferEvents: true } in the service options.')
      );
    if (!!r.length) {
      var o = !!this.machine.config.predictableActionArguments && this._exec;
      this.scheduler.schedule(function() {
        var s, c, l = i.state, d = !1, p = [], v = function(x) {
          var E = Xt(x);
          i.forward(E), l = no(i, function() {
            return i.machine.transition(l, E, void 0, o || void 0);
          }), p.push.apply(p, Et([], rt(i.machine.config.predictableActionArguments ? l.actions : l.actions.map(function(_) {
            return ZT(_, l);
          })), !1)), d = d || !!l.changed;
        };
        try {
          for (var w = nt(r), m = w.next(); !m.done; m = w.next()) {
            var b = m.value;
            v(b);
          }
        } catch (x) {
          s = {
            error: x
          };
        } finally {
          try {
            m && !m.done && (c = w.return) && c.call(w);
          } finally {
            if (s)
              throw s.error;
          }
        }
        l.changed = d, l.actions = p, i.update(l, Xt(r[r.length - 1]));
      });
    }
  }, t.prototype.sender = function(r) {
    return this.send.bind(this, r);
  }, t.prototype._nextState = function(r, i) {
    var o = this;
    i === void 0 && (i = !!this.machine.config.predictableActionArguments && this._exec);
    var s = Xt(r);
    if (s.name.indexOf(jd) === 0 && !this.state.nextEvents.some(function(l) {
      return l.indexOf(jd) === 0;
    }))
      throw s.data.data;
    var c = no(this, function() {
      return o.machine.transition(o.state, s, void 0, i || void 0);
    });
    return c;
  }, t.prototype.nextState = function(r) {
    return this._nextState(r, !1);
  }, t.prototype.forward = function(r) {
    var i, o;
    try {
      for (var s = nt(this.forwardTo), c = s.next(); !c.done; c = s.next()) {
        var l = c.value, d = this.children.get(l);
        if (!d)
          throw new Error("Unable to forward event '".concat(r, "' from interpreter '").concat(this.id, "' to nonexistant child '").concat(l, "'."));
        d.send(r);
      }
    } catch (p) {
      i = {
        error: p
      };
    } finally {
      try {
        c && !c.done && (o = s.return) && o.call(s);
      } finally {
        if (i)
          throw i.error;
      }
    }
  }, t.prototype.defer = function(r) {
    var i = this;
    this.delayedEventsMap[r.id] = this.clock.setTimeout(function() {
      r.to ? i.sendTo(r._event, r.to, !0) : i.send(r._event);
    }, r.delay);
  }, t.prototype.cancel = function(r) {
    this.clock.clearTimeout(this.delayedEventsMap[r]), delete this.delayedEventsMap[r];
  }, t.prototype.exec = function(r, i, o) {
    o === void 0 && (o = this.machine.options.actions), this._exec(r, i.context, i._event, o);
  }, t.prototype.removeChild = function(r) {
    var i;
    this.children.delete(r), this.forwardTo.delete(r), (i = this.state) === null || i === void 0 || delete i.children[r];
  }, t.prototype.stopChild = function(r) {
    var i = this.children.get(r);
    !i || (this.removeChild(r), Tt(i.stop) && i.stop());
  }, t.prototype.spawn = function(r, i, o) {
    if (this.status !== zt.Running)
      return ip(r, i);
    if (Rd(r))
      return this.spawnPromise(Promise.resolve(r), i);
    if (Tt(r))
      return this.spawnCallback(r, i);
    if (GT(r))
      return this.spawnActor(r, i);
    if (NT(r))
      return this.spawnObservable(r, i);
    if (Ei(r))
      return this.spawnMachine(r, le(le({}, o), {
        id: i
      }));
    if (xT(r))
      return this.spawnBehavior(r, i);
    throw new Error('Unable to spawn entity "'.concat(i, '" of type "').concat(typeof r, '".'));
  }, t.prototype.spawnMachine = function(r, i) {
    var o = this;
    i === void 0 && (i = {});
    var s = new t(r, le(le({}, this.options), {
      parent: this,
      id: i.id || r.id
    })), c = le(le({}, iM), i);
    c.sync && s.onTransition(function(d) {
      o.send(Qh, {
        state: d,
        id: s.id
      });
    });
    var l = s;
    return this.children.set(s.id, l), c.autoForward && this.forwardTo.add(s.id), s.onDone(function(d) {
      o.removeChild(s.id), o.send(Xt(d, {
        origin: s.id
      }));
    }).start(), l;
  }, t.prototype.spawnBehavior = function(r, i) {
    var o = nM(r, {
      id: i,
      parent: this
    });
    return this.children.set(i, o), o;
  }, t.prototype.spawnPromise = function(r, i) {
    var o, s = this, c = !1, l;
    r.then(function(p) {
      c || (l = p, s.removeChild(i), s.send(Xt(as(i, p), {
        origin: i
      })));
    }, function(p) {
      if (!c) {
        s.removeChild(i);
        var v = Po(i, p);
        try {
          s.send(Xt(v, {
            origin: i
          }));
        } catch (w) {
          AT(p, w, i), s.devTools && s.devTools.send(v, s.state), s.machine.strict && s.stop();
        }
      }
    });
    var d = (o = {
      id: i,
      send: function() {
      },
      subscribe: function(p, v, w) {
        var m = os(p, v, w), b = !1;
        return r.then(function(x) {
          b || (m.next(x), !b && m.complete());
        }, function(x) {
          b || m.error(x);
        }), {
          unsubscribe: function() {
            return b = !0;
          }
        };
      },
      stop: function() {
        c = !0;
      },
      toJSON: function() {
        return {
          id: i
        };
      },
      getSnapshot: function() {
        return l;
      }
    }, o[Hn] = function() {
      return this;
    }, o);
    return this.children.set(i, d), d;
  }, t.prototype.spawnCallback = function(r, i) {
    var o, s = this, c = !1, l = /* @__PURE__ */ new Set(), d = /* @__PURE__ */ new Set(), p, v = function(b) {
      p = b, d.forEach(function(x) {
        return x(b);
      }), !c && s.send(Xt(b, {
        origin: i
      }));
    }, w;
    try {
      w = r(v, function(b) {
        l.add(b);
      });
    } catch (b) {
      this.send(Po(i, b));
    }
    if (Rd(w))
      return this.spawnPromise(w, i);
    var m = (o = {
      id: i,
      send: function(b) {
        return l.forEach(function(x) {
          return x(b);
        });
      },
      subscribe: function(b) {
        var x = os(b);
        return d.add(x.next), {
          unsubscribe: function() {
            d.delete(x.next);
          }
        };
      },
      stop: function() {
        c = !0, Tt(w) && w();
      },
      toJSON: function() {
        return {
          id: i
        };
      },
      getSnapshot: function() {
        return p;
      }
    }, o[Hn] = function() {
      return this;
    }, o);
    return this.children.set(i, m), m;
  }, t.prototype.spawnObservable = function(r, i) {
    var o, s = this, c, l = r.subscribe(function(p) {
      c = p, s.send(Xt(p, {
        origin: i
      }));
    }, function(p) {
      s.removeChild(i), s.send(Xt(Po(i, p), {
        origin: i
      }));
    }, function() {
      s.removeChild(i), s.send(Xt(as(i), {
        origin: i
      }));
    }), d = (o = {
      id: i,
      send: function() {
      },
      subscribe: function(p, v, w) {
        return r.subscribe(p, v, w);
      },
      stop: function() {
        return l.unsubscribe();
      },
      getSnapshot: function() {
        return c;
      },
      toJSON: function() {
        return {
          id: i
        };
      }
    }, o[Hn] = function() {
      return this;
    }, o);
    return this.children.set(i, d), d;
  }, t.prototype.spawnActor = function(r, i) {
    return this.children.set(i, r), r;
  }, t.prototype.spawnActivity = function(r) {
    var i = this.machine.options && this.machine.options.activities ? this.machine.options.activities[r.type] : void 0;
    if (!i) {
      Bt || er(!1, "No implementation found for activity '".concat(r.type, "'"));
      return;
    }
    var o = i(this.state.context, r);
    this.spawnEffect(r.id, o);
  }, t.prototype.spawnEffect = function(r, i) {
    var o;
    this.children.set(r, (o = {
      id: r,
      send: function() {
      },
      subscribe: function() {
        return {
          unsubscribe: function() {
          }
        };
      },
      stop: i || void 0,
      getSnapshot: function() {
      },
      toJSON: function() {
        return {
          id: r
        };
      }
    }, o[Hn] = function() {
      return this;
    }, o));
  }, t.prototype.attachDev = function() {
    var r = Ic();
    if (this.options.devTools && r) {
      if (r.__REDUX_DEVTOOLS_EXTENSION__) {
        var i = typeof this.options.devTools == "object" ? this.options.devTools : void 0;
        this.devTools = r.__REDUX_DEVTOOLS_EXTENSION__.connect(le(le({
          name: this.id,
          autoPause: !0,
          stateSanitizer: function(o) {
            return {
              value: o.value,
              context: o.context,
              actions: o.actions
            };
          }
        }, i), {
          features: le({
            jump: !1,
            skip: !1
          }, i ? i.features : void 0)
        }), this.machine), this.devTools.init(this.state);
      }
      rM(this);
    }
  }, t.prototype.toJSON = function() {
    return {
      id: this.id
    };
  }, t.prototype[Hn] = function() {
    return this;
  }, t.prototype.getSnapshot = function() {
    return this.status === zt.NotStarted ? this.initialState : this._state;
  }, t.defaultOptions = {
    execute: !0,
    deferEvents: !0,
    clock: {
      setTimeout: function(r, i) {
        return setTimeout(r, i);
      },
      clearTimeout: function(r) {
        return clearTimeout(r);
      }
    },
    logger: /* @__PURE__ */ console.log.bind(console),
    devTools: !1
  }, t.interpret = cp, t;
}();
function cp(t, r) {
  var i = new oM(t, r);
  return i;
}
function aM(t) {
  if (typeof t == "string") {
    var r = {
      type: t
    };
    return r.toString = function() {
      return t;
    }, r;
  }
  return t;
}
function Ja(t) {
  return le(le({
    type: ic
  }, t), {
    toJSON: function() {
      t.onDone, t.onError;
      var r = xc(t, ["onDone", "onError"]);
      return le(le({}, r), {
        type: ic,
        src: aM(t.src)
      });
    }
  });
}
var io = "", cc = "#", Do = "*", Xi = {}, eo = function(t) {
  return t[0] === cc;
}, sM = function() {
  return {
    actions: {},
    guards: {},
    services: {},
    activities: {},
    delays: {}
  };
}, uM = function(t, r, i) {
  var o = i.slice(0, -1).some(function(c) {
    return !("cond" in c) && !("in" in c) && (ft(c.target) || Ei(c.target));
  }), s = r === io ? "the transient event" : "event '".concat(r, "'");
  er(!o, "One or more transitions for ".concat(s, " on state '").concat(t.id, "' are unreachable. ") + "Make sure that the default transition is the last one defined.");
}, cM = /* @__PURE__ */ function() {
  function t(r, i, o, s) {
    o === void 0 && (o = "context" in r ? r.context : void 0);
    var c = this, l;
    this.config = r, this._context = o, this.order = -1, this.__xstatenode = !0, this.__cache = {
      events: void 0,
      relativeValue: /* @__PURE__ */ new Map(),
      initialStateValue: void 0,
      initialState: void 0,
      on: void 0,
      transitions: void 0,
      candidates: {},
      delayedTransitions: void 0
    }, this.idMap = {}, this.tags = [], this.options = Object.assign(sM(), i), this.parent = s == null ? void 0 : s.parent, this.key = this.config.key || (s == null ? void 0 : s.key) || this.config.id || "(machine)", this.machine = this.parent ? this.parent.machine : this, this.path = this.parent ? this.parent.path.concat(this.key) : [], this.delimiter = this.config.delimiter || (this.parent ? this.parent.delimiter : Hh), this.id = this.config.id || Et([this.machine.key], rt(this.path), !1).join(this.delimiter), this.version = this.parent ? this.parent.version : this.config.version, this.type = this.config.type || (this.config.parallel ? "parallel" : this.config.states && Object.keys(this.config.states).length ? "compound" : this.config.history ? "history" : "atomic"), this.schema = this.parent ? this.machine.schema : (l = this.config.schema) !== null && l !== void 0 ? l : {}, this.description = this.config.description, Bt || er(!("parallel" in this.config), 'The "parallel" property is deprecated and will be removed in version 4.1. '.concat(this.config.parallel ? "Replace with `type: 'parallel'`" : "Use `type: '".concat(this.type, "'`"), " in the config for state node '").concat(this.id, "' instead.")), this.initial = this.config.initial, this.states = this.config.states ? Ro(this.config.states, function(v, w) {
      var m, b = new t(v, {}, void 0, {
        parent: c,
        key: w
      });
      return Object.assign(c.idMap, le((m = {}, m[b.id] = b, m), b.idMap)), b;
    }) : Xi;
    var d = 0;
    function p(v) {
      var w, m;
      v.order = d++;
      try {
        for (var b = nt(op(v)), x = b.next(); !x.done; x = b.next()) {
          var E = x.value;
          p(E);
        }
      } catch (_) {
        w = {
          error: _
        };
      } finally {
        try {
          x && !x.done && (m = b.return) && m.call(b);
        } finally {
          if (w)
            throw w.error;
        }
      }
    }
    p(this), this.history = this.config.history === !0 ? "shallow" : this.config.history || !1, this._transient = !!this.config.always || (this.config.on ? Array.isArray(this.config.on) ? this.config.on.some(function(v) {
      var w = v.event;
      return w === io;
    }) : io in this.config.on : !1), this.strict = !!this.config.strict, this.onEntry = Xr(this.config.entry || this.config.onEntry).map(function(v) {
      return Ko(v);
    }), this.onExit = Xr(this.config.exit || this.config.onExit).map(function(v) {
      return Ko(v);
    }), this.meta = this.config.meta, this.doneData = this.type === "final" ? this.config.data : void 0, this.invoke = Xr(this.config.invoke).map(function(v, w) {
      var m, b;
      if (Ei(v)) {
        var x = $a(c.id, w);
        return c.machine.options.services = le((m = {}, m[x] = v, m), c.machine.options.services), Ja({
          src: x,
          id: x
        });
      } else if (ft(v.src)) {
        var x = v.id || $a(c.id, w);
        return Ja(le(le({}, v), {
          id: x,
          src: v.src
        }));
      } else if (Ei(v.src) || Tt(v.src)) {
        var x = v.id || $a(c.id, w);
        return c.machine.options.services = le((b = {}, b[x] = v.src, b), c.machine.options.services), Ja(le(le({
          id: x
        }, v), {
          src: x
        }));
      } else {
        var E = v.src;
        return Ja(le(le({
          id: $a(c.id, w)
        }, v), {
          src: E
        }));
      }
    }), this.activities = Xr(this.config.activities).concat(this.invoke).map(function(v) {
      return Lc(v);
    }), this.transition = this.transition.bind(this), this.tags = Xr(this.config.tags);
  }
  return t.prototype._init = function() {
    this.__cache.transitions || ap(this).forEach(function(r) {
      return r.on;
    });
  }, t.prototype.withConfig = function(r, i) {
    var o = this.options, s = o.actions, c = o.activities, l = o.guards, d = o.services, p = o.delays;
    return new t(this.config, {
      actions: le(le({}, s), r.actions),
      activities: le(le({}, c), r.activities),
      guards: le(le({}, l), r.guards),
      services: le(le({}, d), r.services),
      delays: le(le({}, p), r.delays)
    }, i != null ? i : this.context);
  }, t.prototype.withContext = function(r) {
    return new t(this.config, this.options, r);
  }, Object.defineProperty(t.prototype, "context", {
    get: function() {
      return Tt(this._context) ? this._context() : this._context;
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "definition", {
    get: function() {
      return {
        id: this.id,
        key: this.key,
        version: this.version,
        context: this.context,
        type: this.type,
        initial: this.initial,
        history: this.history,
        states: Ro(this.states, function(r) {
          return r.definition;
        }),
        on: this.on,
        transitions: this.transitions,
        entry: this.onEntry,
        exit: this.onExit,
        activities: this.activities || [],
        meta: this.meta,
        order: this.order || -1,
        data: this.doneData,
        invoke: this.invoke,
        description: this.description,
        tags: this.tags
      };
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.toJSON = function() {
    return this.definition;
  }, Object.defineProperty(t.prototype, "on", {
    get: function() {
      if (this.__cache.on)
        return this.__cache.on;
      var r = this.transitions;
      return this.__cache.on = r.reduce(function(i, o) {
        return i[o.eventType] = i[o.eventType] || [], i[o.eventType].push(o), i;
      }, {});
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "after", {
    get: function() {
      return this.__cache.delayedTransitions || (this.__cache.delayedTransitions = this.getDelayedTransitions(), this.__cache.delayedTransitions);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "transitions", {
    get: function() {
      return this.__cache.transitions || (this.__cache.transitions = this.formatTransitions(), this.__cache.transitions);
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getCandidates = function(r) {
    if (this.__cache.candidates[r])
      return this.__cache.candidates[r];
    var i = r === io, o = this.transitions.filter(function(s) {
      var c = s.eventType === r;
      return i ? c : c || s.eventType === Do;
    });
    return this.__cache.candidates[r] = o, o;
  }, t.prototype.getDelayedTransitions = function() {
    var r = this, i = this.config.after;
    if (!i)
      return [];
    var o = function(c, l) {
      var d = Tt(c) ? "".concat(r.id, ":delay[").concat(l, "]") : c, p = BT(d, r.id);
      return r.onEntry.push(Ac(p, {
        delay: c
      })), r.onExit.push(RT(p)), p;
    }, s = po(i) ? i.map(function(c, l) {
      var d = o(c.delay, l);
      return le(le({}, c), {
        event: d
      });
    }) : kt(Object.keys(i).map(function(c, l) {
      var d = i[c], p = ft(d) ? {
        target: d
      } : d, v = isNaN(+c) ? c : +c, w = o(v, l);
      return Xr(p).map(function(m) {
        return le(le({}, m), {
          event: w,
          delay: v
        });
      });
    }));
    return s.map(function(c) {
      var l = c.delay;
      return le(le({}, r.formatTransition(c)), {
        delay: l
      });
    });
  }, t.prototype.getStateNodes = function(r) {
    var i, o = this;
    if (!r)
      return [];
    var s = r instanceof zr ? r.value : Wo(r, this.delimiter);
    if (ft(s)) {
      var c = this.getStateNode(s).initial;
      return c !== void 0 ? this.getStateNodes((i = {}, i[s] = c, i)) : [this, this.states[s]];
    }
    var l = Object.keys(s), d = [this];
    return d.push.apply(d, Et([], rt(kt(l.map(function(p) {
      return o.getStateNode(p).getStateNodes(s[p]);
    }))), !1)), d;
  }, t.prototype.handles = function(r) {
    var i = Jh(r);
    return this.events.includes(i);
  }, t.prototype.resolveState = function(r) {
    var i = r instanceof zr ? r : zr.create(r), o = Array.from(Fo([], this.getStateNodes(i.value)));
    return new zr(le(le({}, i), {
      value: this.resolve(i.value),
      configuration: o,
      done: ss(o, this),
      tags: Fd(o),
      machine: this.machine
    }));
  }, t.prototype.transitionLeafNode = function(r, i, o) {
    var s = this.getStateNode(r), c = s.next(i, o);
    return !c || !c.transitions.length ? this.next(i, o) : c;
  }, t.prototype.transitionCompoundNode = function(r, i, o) {
    var s = Object.keys(r), c = this.getStateNode(s[0]), l = c._transition(r[s[0]], i, o);
    return !l || !l.transitions.length ? this.next(i, o) : l;
  }, t.prototype.transitionParallelNode = function(r, i, o) {
    var s, c, l = {};
    try {
      for (var d = nt(Object.keys(r)), p = d.next(); !p.done; p = d.next()) {
        var v = p.value, w = r[v];
        if (!!w) {
          var m = this.getStateNode(v), b = m._transition(w, i, o);
          b && (l[v] = b);
        }
      }
    } catch (A) {
      s = {
        error: A
      };
    } finally {
      try {
        p && !p.done && (c = d.return) && c.call(d);
      } finally {
        if (s)
          throw s.error;
      }
    }
    var x = Object.keys(l).map(function(A) {
      return l[A];
    }), E = kt(x.map(function(A) {
      return A.transitions;
    })), _ = x.some(function(A) {
      return A.transitions.length > 0;
    });
    if (!_)
      return this.next(i, o);
    var N = kt(x.map(function(A) {
      return A.entrySet;
    })), U = kt(Object.keys(l).map(function(A) {
      return l[A].configuration;
    }));
    return {
      transitions: E,
      entrySet: N,
      exitSet: kt(x.map(function(A) {
        return A.exitSet;
      })),
      configuration: U,
      source: i,
      actions: kt(Object.keys(l).map(function(A) {
        return l[A].actions;
      }))
    };
  }, t.prototype._transition = function(r, i, o) {
    return ft(r) ? this.transitionLeafNode(r, i, o) : Object.keys(r).length === 1 ? this.transitionCompoundNode(r, i, o) : this.transitionParallelNode(r, i, o);
  }, t.prototype.getTransitionData = function(r, i) {
    return this._transition(r.value, r, Xt(i));
  }, t.prototype.next = function(r, i) {
    var o, s, c = this, l = i.name, d = [], p = [], v;
    try {
      for (var w = nt(this.getCandidates(l)), m = w.next(); !m.done; m = w.next()) {
        var b = m.value, x = b.cond, E = b.in, _ = r.context, N = E ? ft(E) && eo(E) ? r.matches(Wo(this.getStateNodeById(E).path, this.delimiter)) : Nc(Wo(E, this.delimiter), TT(this.path.slice(0, -2))(r.value)) : !0, U = !1;
        try {
          U = !x || tp(this.machine, x, _, i, r);
        } catch (F) {
          throw new Error("Unable to evaluate guard '".concat(x.name || x.type, "' in transition for event '").concat(l, "' in state node '").concat(this.id, `':
`).concat(F.message));
        }
        if (U && N) {
          b.target !== void 0 && (p = b.target), d.push.apply(d, Et([], rt(b.actions), !1)), v = b;
          break;
        }
      }
    } catch (F) {
      o = {
        error: F
      };
    } finally {
      try {
        m && !m.done && (s = w.return) && s.call(w);
      } finally {
        if (o)
          throw o.error;
      }
    }
    if (!!v) {
      if (!p.length)
        return {
          transitions: [v],
          entrySet: [],
          exitSet: [],
          configuration: r.value ? [this] : [],
          source: r,
          actions: d
        };
      var A = kt(p.map(function(F) {
        return c.getRelativeStateNodes(F, r.historyValue);
      })), j = !!v.internal, R = [];
      return j || p.forEach(function(F) {
        R.push.apply(R, Et([], rt(c.getExternalReentryNodes(F)), !1));
      }), {
        transitions: [v],
        entrySet: R,
        exitSet: j ? [] : [this],
        configuration: A,
        source: r,
        actions: d
      };
    }
  }, t.prototype.getExternalReentryNodes = function(r) {
    for (var i = [], o = rt(r.order > this.order ? [r, this] : [this, r], 2), s = o[0], c = o[1]; s && s !== c; )
      i.push(s), s = s.parent;
    return s !== c ? [] : (i.push(c), i);
  }, t.prototype.getActions = function(r, i, o, s, c, l, d) {
    var p, v, w, m, b = this, x = Fo([], l ? this.getStateNodes(l.value) : [this]);
    try {
      for (var E = nt(r), _ = E.next(); !_.done; _ = E.next()) {
        var N = _.value;
        (!Uo(x, N) || Uo(o.entrySet, N.parent)) && o.entrySet.push(N);
      }
    } catch (G) {
      p = {
        error: G
      };
    } finally {
      try {
        _ && !_.done && (v = E.return) && v.call(E);
      } finally {
        if (p)
          throw p.error;
      }
    }
    try {
      for (var U = nt(x), A = U.next(); !A.done; A = U.next()) {
        var N = A.value;
        (!Uo(r, N) || Uo(o.exitSet, N.parent)) && o.exitSet.push(N);
      }
    } catch (G) {
      w = {
        error: G
      };
    } finally {
      try {
        A && !A.done && (m = U.return) && m.call(U);
      } finally {
        if (w)
          throw w.error;
      }
    }
    var j = kt(o.entrySet.map(function(G) {
      var ve = [];
      if (G.type !== "final")
        return ve;
      var be = G.parent;
      if (!be.parent)
        return ve;
      ve.push(
        Qa(G.id, G.doneData),
        Qa(be.id, G.doneData ? fs(G.doneData, s, c) : void 0)
      );
      var xe = be.parent;
      return xe.type === "parallel" && $o(xe).every(function(K) {
        return ss(o.configuration, K);
      }) && ve.push(Qa(xe.id)), ve;
    }));
    o.exitSet.sort(function(G, ve) {
      return ve.order - G.order;
    }), o.entrySet.sort(function(G, ve) {
      return G.order - ve.order;
    });
    var R = new Set(o.entrySet), F = new Set(o.exitSet), B = Array.from(R).map(function(G) {
      var ve = G.onEntry, be = G.activities.map(function(xe) {
        return PT(xe);
      });
      return Jn(d ? Et(Et([], rt(ve), !1), rt(be), !1) : Et(Et([], rt(be), !1), rt(ve), !1), b.machine.options.actions);
    }).concat([j.map(IT)]), $ = Array.from(F).map(function(G) {
      return Jn(Et(Et([], rt(G.onExit), !1), rt(G.activities.map(function(ve) {
        return FT(ve);
      })), !1), b.machine.options.actions);
    }), H = $.concat([Jn(o.actions, this.machine.options.actions)]).concat(B);
    if (i) {
      var te = Jn(kt(Et([], rt(r), !1).sort(function(G, ve) {
        return ve.order - G.order;
      }).map(function(G) {
        return G.onExit;
      })), this.machine.options.actions).filter(function(G) {
        return G.type !== co && (G.type !== lo || !!G.to && G.to !== ri.Internal);
      });
      return H.concat([te]);
    }
    return H;
  }, t.prototype.transition = function(r, i, o, s) {
    r === void 0 && (r = this.initialState);
    var c = Xt(i), l;
    if (r instanceof zr)
      l = o === void 0 ? r : this.resolveState(zr.from(r, o));
    else {
      var d = ft(r) ? this.resolve(ls(this.getResolvedPath(r))) : this.resolve(r), p = o != null ? o : this.machine.context;
      l = this.resolveState(zr.from(d, p));
    }
    if (!Bt && c.name === Do)
      throw new Error("An event cannot have the wildcard type ('".concat(Do, "')"));
    if (this.strict && !this.events.includes(c.name) && !ET(c.name))
      throw new Error("Machine '".concat(this.id, "' does not accept event '").concat(c.name, "'"));
    var v = this._transition(l.value, l, c) || {
      transitions: [],
      configuration: [],
      entrySet: [],
      exitSet: [],
      source: l,
      actions: []
    }, w = Fo([], this.getStateNodes(l.value)), m = v.configuration.length ? Fo(w, v.configuration) : w;
    return v.configuration = Et([], rt(m), !1), this.resolveTransition(v, l, l.context, s, c);
  }, t.prototype.resolveRaisedTransition = function(r, i, o, s) {
    var c, l = r.actions;
    return r = this.transition(r, i, void 0, s), r._event = o, r.event = o.data, (c = r.actions).unshift.apply(c, Et([], rt(l), !1)), r;
  }, t.prototype.resolveTransition = function(r, i, o, s, c) {
    var l, d, p, v, w = this;
    c === void 0 && (c = ao);
    var m = r.configuration, b = !i || r.transitions.length > 0, x = b ? r.configuration : i ? i.configuration : [], E = ss(x, this), _ = b ? $T(this.machine, m) : void 0, N = i ? i.historyValue ? i.historyValue : r.source ? this.machine.historyValue(i.value) : void 0 : void 0, U = this.getActions(new Set(x), E, r, o, c, i, s), A = i ? le({}, i.activities) : {};
    try {
      for (var j = nt(U), R = j.next(); !R.done; R = j.next()) {
        var F = R.value;
        try {
          for (var B = (p = void 0, nt(F)), $ = B.next(); !$.done; $ = B.next()) {
            var H = $.value;
            H.type === nc ? A[H.activity.id || H.activity.type] = H : H.type === Cc && (A[H.activity.id || H.activity.type] = !1);
          }
        } catch (ne) {
          p = {
            error: ne
          };
        } finally {
          try {
            $ && !$.done && (v = B.return) && v.call(B);
          } finally {
            if (p)
              throw p.error;
          }
        }
      }
    } catch (ne) {
      l = {
        error: ne
      };
    } finally {
      try {
        R && !R.done && (d = j.return) && d.call(j);
      } finally {
        if (l)
          throw l.error;
      }
    }
    var te = rt(ds(this, i, o, c, U, s, this.machine.config.predictableActionArguments || this.machine.config.preserveActionOrder), 2), G = te[0], ve = te[1], be = rt(CT(G, function(ne) {
      return ne.type === co || ne.type === lo && ne.to === ri.Internal;
    }), 2), xe = be[0], K = be[1], ie = G.filter(function(ne) {
      var S;
      return ne.type === nc && ((S = ne.activity) === null || S === void 0 ? void 0 : S.type) === ic;
    }), ae = ie.reduce(function(ne, S) {
      return ne[S.activity.id] = YT(S.activity, w.machine, ve, c), ne;
    }, i ? le({}, i.children) : {}), se = new zr({
      value: _ || i.value,
      context: ve,
      _event: c,
      _sessionid: i ? i._sessionid : null,
      historyValue: _ ? N ? _T(N, _) : void 0 : i ? i.historyValue : void 0,
      history: !_ || r.source ? i : void 0,
      actions: _ ? K : [],
      activities: _ ? A : i ? i.activities : {},
      events: [],
      configuration: x,
      transitions: r.transitions,
      children: ae,
      done: E,
      tags: Fd(x),
      machine: this
    }), Re = o !== ve;
    se.changed = c.name === Qh || Re;
    var ct = se.history;
    ct && delete ct.history;
    var oe = !E && (this._transient || m.some(function(ne) {
      return ne._transient;
    }));
    if (!b && (!oe || c.name === io))
      return se;
    var Q = se;
    if (!E)
      for (oe && (Q = this.resolveRaisedTransition(Q, {
        type: gT
      }, c, s)); xe.length; ) {
        var we = xe.shift();
        Q = this.resolveRaisedTransition(Q, we._event, c, s);
      }
    var ke = Q.changed || (ct ? !!Q.actions.length || Re || typeof ct.value != typeof Q.value || !up(Q.value, ct.value) : void 0);
    return Q.changed = ke, Q.history = ct, Q;
  }, t.prototype.getStateNode = function(r) {
    if (eo(r))
      return this.machine.getStateNodeById(r);
    if (!this.states)
      throw new Error("Unable to retrieve child state '".concat(r, "' from '").concat(this.id, "'; no child states exist."));
    var i = this.states[r];
    if (!i)
      throw new Error("Child state '".concat(r, "' does not exist on '").concat(this.id, "'"));
    return i;
  }, t.prototype.getStateNodeById = function(r) {
    var i = eo(r) ? r.slice(cc.length) : r;
    if (i === this.id)
      return this;
    var o = this.machine.idMap[i];
    if (!o)
      throw new Error("Child state node '#".concat(i, "' does not exist on machine '").concat(this.id, "'"));
    return o;
  }, t.prototype.getStateNodeByPath = function(r) {
    if (typeof r == "string" && eo(r))
      try {
        return this.getStateNodeById(r.slice(1));
      } catch {
      }
    for (var i = ac(r, this.delimiter).slice(), o = this; i.length; ) {
      var s = i.shift();
      if (!s.length)
        break;
      o = o.getStateNode(s);
    }
    return o;
  }, t.prototype.resolve = function(r) {
    var i, o = this;
    if (!r)
      return this.initialStateValue || Xi;
    switch (this.type) {
      case "parallel":
        return Ro(this.initialStateValue, function(c, l) {
          return c ? o.getStateNode(l).resolve(r[l] || c) : Xi;
        });
      case "compound":
        if (ft(r)) {
          var s = this.getStateNode(r);
          return s.type === "parallel" || s.type === "compound" ? (i = {}, i[r] = s.initialStateValue, i) : r;
        }
        return Object.keys(r).length ? Ro(r, function(c, l) {
          return c ? o.getStateNode(l).resolve(c) : Xi;
        }) : this.initialStateValue || {};
      default:
        return r || Xi;
    }
  }, t.prototype.getResolvedPath = function(r) {
    if (eo(r)) {
      var i = this.machine.idMap[r.slice(cc.length)];
      if (!i)
        throw new Error("Unable to find state node '".concat(r, "'"));
      return i.path;
    }
    return ac(r, this.delimiter);
  }, Object.defineProperty(t.prototype, "initialStateValue", {
    get: function() {
      var r;
      if (this.__cache.initialStateValue)
        return this.__cache.initialStateValue;
      var i;
      if (this.type === "parallel")
        i = Dd(this.states, function(o) {
          return o.initialStateValue || Xi;
        }, function(o) {
          return o.type !== "history";
        });
      else if (this.initial !== void 0) {
        if (!this.states[this.initial])
          throw new Error("Initial state '".concat(this.initial, "' not found on '").concat(this.key, "'"));
        i = hs(this.states[this.initial]) ? this.initial : (r = {}, r[this.initial] = this.states[this.initial].initialStateValue, r);
      } else
        i = {};
      return this.__cache.initialStateValue = i, this.__cache.initialStateValue;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getInitialState = function(r, i) {
    this._init();
    var o = this.getStateNodes(r);
    return this.resolveTransition({
      configuration: o,
      entrySet: Et([], rt(o), !1),
      exitSet: [],
      transitions: [],
      source: void 0,
      actions: []
    }, void 0, i != null ? i : this.machine.context, void 0);
  }, Object.defineProperty(t.prototype, "initialState", {
    get: function() {
      var r = this.initialStateValue;
      if (!r)
        throw new Error("Cannot retrieve initial state from simple state '".concat(this.id, "'."));
      return this.getInitialState(r);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "target", {
    get: function() {
      var r;
      if (this.type === "history") {
        var i = this.config;
        ft(i.target) ? r = eo(i.target) ? ls(this.machine.getStateNodeById(i.target).path.slice(this.path.length - 1)) : i.target : r = i.target;
      }
      return r;
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getRelativeStateNodes = function(r, i, o) {
    return o === void 0 && (o = !0), o ? r.type === "history" ? r.resolveHistory(i) : r.initialStateNodes : [r];
  }, Object.defineProperty(t.prototype, "initialStateNodes", {
    get: function() {
      var r = this;
      if (hs(this))
        return [this];
      if (this.type === "compound" && !this.initial)
        return Bt || er(!1, "Compound state node '".concat(this.id, "' has no initial state.")), [this];
      var i = is(this.initialStateValue);
      return kt(i.map(function(o) {
        return r.getFromRelativePath(o);
      }));
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.getFromRelativePath = function(r) {
    if (!r.length)
      return [this];
    var i = rt(r), o = i[0], s = i.slice(1);
    if (!this.states)
      throw new Error("Cannot retrieve subPath '".concat(o, "' from node with no states"));
    var c = this.getStateNode(o);
    if (c.type === "history")
      return c.resolveHistory();
    if (!this.states[o])
      throw new Error("Child state '".concat(o, "' does not exist on '").concat(this.id, "'"));
    return this.states[o].getFromRelativePath(s);
  }, t.prototype.historyValue = function(r) {
    if (!!Object.keys(this.states).length)
      return {
        current: r || this.initialStateValue,
        states: Dd(this.states, function(i, o) {
          if (!r)
            return i.historyValue();
          var s = ft(r) ? void 0 : r[o];
          return i.historyValue(s || i.initialStateValue);
        }, function(i) {
          return !i.history;
        })
      };
  }, t.prototype.resolveHistory = function(r) {
    var i = this;
    if (this.type !== "history")
      return [this];
    var o = this.parent;
    if (!r) {
      var s = this.target;
      return s ? kt(is(s).map(function(l) {
        return o.getFromRelativePath(l);
      })) : o.initialStateNodes;
    }
    var c = MT(o.path, "states")(r).current;
    return ft(c) ? [o.getStateNode(c)] : kt(is(c).map(function(l) {
      return i.history === "deep" ? o.getFromRelativePath(l) : [o.states[l[0]]];
    }));
  }, Object.defineProperty(t.prototype, "stateIds", {
    get: function() {
      var r = this, i = kt(Object.keys(this.states).map(function(o) {
        return r.states[o].stateIds;
      }));
      return [this.id].concat(i);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "events", {
    get: function() {
      var r, i, o, s;
      if (this.__cache.events)
        return this.__cache.events;
      var c = this.states, l = new Set(this.ownEvents);
      if (c)
        try {
          for (var d = nt(Object.keys(c)), p = d.next(); !p.done; p = d.next()) {
            var v = p.value, w = c[v];
            if (w.states)
              try {
                for (var m = (o = void 0, nt(w.events)), b = m.next(); !b.done; b = m.next()) {
                  var x = b.value;
                  l.add("".concat(x));
                }
              } catch (E) {
                o = {
                  error: E
                };
              } finally {
                try {
                  b && !b.done && (s = m.return) && s.call(m);
                } finally {
                  if (o)
                    throw o.error;
                }
              }
          }
        } catch (E) {
          r = {
            error: E
          };
        } finally {
          try {
            p && !p.done && (i = d.return) && i.call(d);
          } finally {
            if (r)
              throw r.error;
          }
        }
      return this.__cache.events = Array.from(l);
    },
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(t.prototype, "ownEvents", {
    get: function() {
      var r = new Set(this.transitions.filter(function(i) {
        return !(!i.target && !i.actions.length && i.internal);
      }).map(function(i) {
        return i.eventType;
      }));
      return Array.from(r);
    },
    enumerable: !1,
    configurable: !0
  }), t.prototype.resolveTarget = function(r) {
    var i = this;
    if (r !== void 0)
      return r.map(function(o) {
        if (!ft(o))
          return o;
        var s = o[0] === i.delimiter;
        if (s && !i.parent)
          return i.getStateNodeByPath(o.slice(1));
        var c = s ? i.key + o : o;
        if (i.parent)
          try {
            var l = i.parent.getStateNodeByPath(c);
            return l;
          } catch (d) {
            throw new Error("Invalid transition definition for state node '".concat(i.id, `':
`).concat(d.message));
          }
        else
          return i.getStateNodeByPath(c);
      });
  }, t.prototype.formatTransition = function(r) {
    var i = this, o = LT(r.target), s = "internal" in r ? r.internal : o ? o.some(function(p) {
      return ft(p) && p[0] === i.delimiter;
    }) : !0, c = this.machine.options.guards, l = this.resolveTarget(o), d = le(le({}, r), {
      actions: Jn(Xr(r.actions)),
      cond: ep(r.cond, c),
      target: l,
      source: this,
      internal: s,
      eventType: r.event,
      toJSON: function() {
        return le(le({}, d), {
          target: d.target ? d.target.map(function(p) {
            return "#".concat(p.id);
          }) : void 0,
          source: "#".concat(i.id)
        });
      }
    });
    return d;
  }, t.prototype.formatTransitions = function() {
    var r, i, o = this, s;
    if (!this.config.on)
      s = [];
    else if (Array.isArray(this.config.on))
      s = this.config.on;
    else {
      var c = this.config.on, l = Do, d = c[l], p = d === void 0 ? [] : d, v = xc(c, [typeof l == "symbol" ? l : l + ""]);
      s = kt(Object.keys(v).map(function(A) {
        !Bt && A === io && er(!1, "Empty string transition configs (e.g., `{ on: { '': ... }}`) for transient transitions are deprecated. Specify the transition in the `{ always: ... }` property instead. " + 'Please check the `on` configuration for "#'.concat(o.id, '".'));
        var j = Zi(A, v[A]);
        return Bt || uM(o, A, j), j;
      }).concat(Zi(Do, p)));
    }
    var w = this.config.always ? Zi("", this.config.always) : [], m = this.config.onDone ? Zi(String(Qa(this.id)), this.config.onDone) : [];
    Bt || er(!(this.config.onDone && !this.parent), 'Root nodes cannot have an ".onDone" transition. Please check the config of "'.concat(this.id, '".'));
    var b = kt(this.invoke.map(function(A) {
      var j = [];
      return A.onDone && j.push.apply(j, Et([], rt(Zi(String(as(A.id)), A.onDone)), !1)), A.onError && j.push.apply(j, Et([], rt(Zi(String(Po(A.id)), A.onError)), !1)), j;
    })), x = this.after, E = kt(Et(Et(Et(Et([], rt(m), !1), rt(b), !1), rt(s), !1), rt(w), !1).map(function(A) {
      return Xr(A).map(function(j) {
        return o.formatTransition(j);
      });
    }));
    try {
      for (var _ = nt(x), N = _.next(); !N.done; N = _.next()) {
        var U = N.value;
        E.push(U);
      }
    } catch (A) {
      r = {
        error: A
      };
    } finally {
      try {
        N && !N.done && (i = _.return) && i.call(_);
      } finally {
        if (r)
          throw r.error;
      }
    }
    return E;
  }, t;
}(), zd = !1;
function lM(t, r) {
  return !Bt && !t.predictableActionArguments && !zd && (zd = !0, console.warn("It is highly recommended to set `predictableActionArguments` to `true` when using `createMachine`. https://xstate.js.org/docs/guides/actions.html")), new cM(t, r);
}
var ut = zT, fM = Ac;
const lc = {
  id: "password",
  initial: "showForm",
  entry: ["clearError", "setupView"],
  states: {
    showForm: {
      on: {
        submit: [
          {
            actions: "setPassword",
            target: "send",
            cond: "passwordsMatch"
          },
          {
            actions: "setErrorForPasswordMismatch",
            target: "showForm"
          }
        ],
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    send: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          const r = {
            method: "password",
            email: t.user.email,
            password: t.view.password,
            redirect: t.config.redirect,
            options: {
              noResetEmail: !0
            }
          };
          return sr(t.user.name) && (r.name = t.user.name), sr(t.user.username) && (r.username = t.user.username), sr(t.user.emailOrUsername) && (r.emailOrUsername = t.user.emailOrUsername), Wt({
            method: t.config.type,
            args: [r]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "#beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            target: "showPasswordSet"
          }
        ]
      }
    },
    showPasswordSet: {
      type: "final"
    }
  }
}, Bd = {
  id: "selectFactor",
  initial: "showForm",
  entry: ["clearError", "setupView", "enableBack"],
  states: {
    ...lc.states,
    showForm: {
      on: {
        ...lc.states.showForm.on,
        selectFactor: [
          ...Object.values(Br).map((t) => ({
            target: `#${t.name}`,
            cond: t.testIs
          })),
          {
            target: "#unhandledError"
          }
        ]
      }
    },
    showPasswordSet: {
      always: "#finish"
    }
  }
}, dM = {
  id: "useTotpCode",
  initial: "showForm",
  entry: ["clearError", "setupView", "setShowEmailOrUsernameIfFirstFactor"],
  states: {
    showForm: {
      on: {
        submit: {
          actions: "setTotpCode",
          target: "send"
        },
        useBackupCode: {
          actions: "setUseBackupCode"
        },
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    send: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          const r = t, i = {
            method: "totp",
            redirect: r.config.redirect
          };
          return r.view.useBackupCode ? i.backupCode = r.view.backupCode : i.totpCode = r.view.totpCode, r.view.emailOrUsername ? i.emailOrUsername = r.view.emailOrUsername : r.user.email ? i.emailOrUsername = r.user.email : r.user.username ? i.emailOrUsername = r.user.username : r.user.emailOrUsername && (i.emailOrUsername = r.user.emailOrUsername), Wt({
            method: "login",
            args: [i]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "#beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            target: "showTotpSuccess"
          }
        ]
      }
    },
    sendBackupCode: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          const r = t, i = {
            method: "totp",
            backupCode: r.view.backupCode,
            redirect: r.config.redirect
          };
          return r.view.emailOrUsername ? i.emailOrUsername = r.view.emailOrUsername : r.user.email ? i.emailOrUsername = r.user.email : r.user.username ? i.emailOrUsername = r.user.username : r.user.emailOrUsername && (i.emailOrUsername = r.user.emailOrUsername), Wt({
            method: "login",
            args: [i]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "#beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            target: "showTotpSuccess"
          }
        ]
      }
    },
    showTotpSuccess: {
      type: "final"
    }
  }
}, hM = {
  id: "setUpTotp",
  initial: "getQrCode",
  entry: ["clearError", "setupView"],
  states: {
    getQrCode: {
      invoke: {
        src: () => Wt({ method: "store.user.getTotp" }),
        onError: {
          actions: "setErrorFromApiError",
          target: "showErrorMessage"
        },
        onDone: {
          actions: "setQrCode",
          target: "showQrCode"
        }
      }
    },
    showQrCode: {
      on: {
        submit: {
          actions: "setTotpCode",
          target: "confirmTotpCode"
        },
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    confirmTotpCode: {
      entry: "clearError",
      invoke: {
        src: (t, r) => {
          const i = {
            method: "totp"
          };
          return sr(r.totpCode) && (i.totpCode = r.totpCode), t.isSecondFactor || (sr(t.user.email) ? i.email = t.user.email : sr(t.user.emailOrUsername) && (i.emailOrUsername = t.user.emailOrUsername)), i.redirect = !1, Wt({
            method: "login",
            args: [i]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showQrCode"
        },
        onDone: {
          actions: "storeFactorResponse",
          target: "showBackupCodes"
        }
      }
    },
    showBackupCodes: {
      on: {
        finish: [
          {
            actions: "setAllowedSecondFactorsFromView",
            target: "#beginSecondFactor",
            cond: "secondFactorRequiredFromView"
          },
          {
            actions: "redirectIfLoggedIn",
            target: "showTotpSetupComplete"
          }
        ]
      }
    },
    showErrorMessage: {
      on: {
        retry: "getQrCode",
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    showTotpSetupComplete: {
      type: "final"
    }
  }
}, pM = {
  id: "smsCode",
  initial: "showForm",
  entry: ["clearError", "setupView"],
  states: {
    showForm: {
      on: {
        submit: {
          actions: "setPhoneNumber",
          target: "send"
        },
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    send: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          const r = {
            channel: "sms",
            phoneNumber: t.view.phoneNumber
          };
          return sr(t.user.name) && (r.name = t.user.name), sr(t.user.username) && (r.username = t.user.username), Wt({
            method: "sendVerificationCode",
            args: [r]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: {
          target: "showCodeForm"
        }
      }
    },
    showCodeForm: {
      on: {
        submit: {
          actions: "setCode",
          target: "verifyCode"
        },
        resend: "send",
        back: {
          actions: "clearError",
          target: "showForm"
        }
      }
    },
    verifyCode: {
      entry: "clearError",
      invoke: {
        src: (t) => Wt({
          method: "login",
          args: [
            {
              method: "verificationCode",
              channel: "sms",
              phoneNumber: t.view.phoneNumber,
              verificationCode: t.view.verificationCode,
              redirect: t.config.redirect
            }
          ]
        }),
        onError: {
          actions: "setErrorFromApiError",
          target: "showCodeForm"
        },
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "#beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            target: "showCodeVerified"
          }
        ]
      }
    },
    showCodeVerified: {
      type: "final"
    }
  }
}, gM = {
  id: "emailCode",
  initial: "showForm",
  entry: ["clearError", "setupView"],
  states: {
    showForm: {
      on: {
        submit: {
          actions: "setEmail",
          target: "send"
        },
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    send: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          const r = {
            channel: "email",
            email: t.user.email
          };
          return sr(t.user.name) && (r.name = t.user.name), sr(t.user.username) && (r.username = t.user.username), Wt({
            method: "sendVerificationCode",
            args: [r]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: {
          target: "showCodeForm"
        }
      }
    },
    showCodeForm: {
      on: {
        submit: {
          actions: "setCode",
          target: "verifyCode"
        },
        resend: "send",
        back: {
          actions: "clearError",
          target: "showForm"
        }
      }
    },
    verifyCode: {
      entry: "clearError",
      invoke: {
        src: (t) => Wt({
          method: "login",
          args: [
            {
              method: "verificationCode",
              channel: "email",
              email: t.user.email,
              verificationCode: t.view.verificationCode,
              redirect: t.config.redirect
            }
          ]
        }),
        onError: {
          actions: "setErrorFromApiError",
          target: "showCodeForm"
        },
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "#beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            actions: "redirectIfLoggedIn",
            target: "showCodeVerified"
          }
        ]
      }
    },
    showCodeVerified: {
      type: "final"
    }
  }
}, mM = {
  id: "emailLink",
  initial: "showForm",
  entry: ["clearError", "setupView"],
  states: {
    showForm: {
      on: {
        submit: {
          actions: "setEmail",
          target: "send"
        },
        back: {
          actions: "clearError",
          target: "#backToFactors"
        }
      }
    },
    send: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          if (t.config.type === "reset")
            return Wt({
              method: "sendResetLink",
              args: [t.user.email]
            });
          const r = {
            method: "passwordless",
            email: t.user.email,
            redirect: t.config.redirect
          };
          return sr(t.user.name) && (r.name = t.user.name), sr(t.user.username) && (r.username = t.user.username), Wt({
            method: t.config.type,
            args: [r]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: {
          target: "showEmailSent"
        }
      }
    },
    showEmailSent: {
      on: {
        resend: "resend",
        back: "showForm"
      }
    },
    resend: {
      entry: ["clearError", "clearResentMessage"],
      invoke: {
        src: (t) => {
          const r = {
            method: "passwordless",
            email: t.user.email
          };
          return sr(t.user.name) && (r.name = t.user.name), sr(t.user.username) && (r.username = t.user.username), Wt({
            method: t.config.type,
            args: [r]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: {
          actions: "setResentMessage",
          target: "showEmailSent"
        }
      }
    }
  }
}, vM = {
  id: "setNewPassword",
  initial: "showForm",
  entry: ["clearError", "setupView"],
  states: {
    showForm: {
      on: {
        submit: [
          {
            actions: "setPasswordForReset",
            target: "send",
            cond: "passwordsMatch"
          },
          {
            actions: "setErrorForPasswordMismatch",
            target: "showForm"
          }
        ]
      }
    },
    send: {
      entry: "clearError",
      invoke: {
        src: (t) => {
          const r = {
            password: t.view.password,
            redirect: t.config.redirect
          };
          return sr(t.view.existingPassword) && (r.existingPassword = t.view.existingPassword), Wt({
            method: "updatePassword",
            args: [r]
          });
        },
        onError: {
          actions: "setErrorFromApiError",
          target: "showForm"
        },
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "#beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            target: "showNewPasswordSet"
          }
        ]
      }
    },
    showNewPasswordSet: {
      type: "final"
    }
  }
}, yM = WT, wM = ut({ error: void 0 }), bM = ut({
  error: (t, r) => r.data
}), SM = ut({
  error: {
    statusCode: 0,
    message: "The passwords don't match. Please re-enter your password.",
    error: {
      type: "password_mismatch_error"
    }
  }
}), TM = ut({
  allowBack: !1
}), MM = ut({
  allowBack: !0
});
function Wd(t) {
  return typeof window != "object" || typeof window.location != "object" || !window.location.href || window.location.href.indexOf(`${t}=`) < 0 ? "" : decodeURIComponent(
    window.location.href.split(`${t}=`)[1].split("&")[0]
  );
}
const EM = ut((t) => {
  var o;
  if (((o = t.query) == null ? void 0 : o.isValid) === !1)
    return {};
  const r = Wd("uuid"), i = Wd("token");
  return {
    query: {
      uuid: r,
      token: i,
      isValid: !0
    }
  };
}), xM = ut(() => ({
  query: {
    isValid: !1
  }
})), CM = (t, r) => {
  const i = Yh(r.factor);
  if (!i)
    return ut({
      view: {
        password: ""
      }
    });
  if (Br[i]) {
    const o = Br[i].viewContext;
    return ut({
      view: o
    });
  }
  return ut({
    view: {}
  });
}, _M = ut({
  user: (t, r) => ({
    email: r.email,
    name: r.name,
    username: r.username
  })
}), NM = ut(
  (t, r) => ({
    view: {
      ...t.view,
      verificationCode: r.verificationCode
    }
  })
), OM = ut(
  (t, r) => ({
    user: {
      email: r.email,
      name: r.name,
      username: r.username,
      emailOrUsername: r.emailOrUsername
    },
    view: {
      ...t.view,
      password: r.password
    }
  })
), LM = ut(
  (t, r) => ({
    view: {
      ...t.view,
      password: r.password,
      confirmPassword: r.confirmPassword,
      existingPassword: r.existingPassword
    }
  })
), AM = ut(
  (t, r) => ({
    view: {
      ...t.view,
      phoneNumber: r.phoneNumber
    }
  })
), IM = ut(
  (t, r) => ({
    view: {
      ...t.view,
      qrCode: r.data.qrCode,
      backupCodes: r.data.backupCodes
    }
  })
), jM = ut(
  (t, r) => {
    var i, o, s;
    return {
      view: {
        ...t.view,
        totpCode: (i = r.totpCode) != null ? i : "",
        backupCode: (o = r.backupCode) != null ? o : "",
        emailOrUsername: (s = r.emailOrUsername) != null ? s : ""
      }
    };
  }
), kM = ut(
  (t, r) => ({
    view: {
      ...t.view,
      useBackupCode: r.useBackupCode
    }
  })
), DM = (t) => ut({
  view: {
    ...t.view,
    showEmailOrUsername: !t.isSecondFactor
  }
}), RM = ut(
  (t, r) => {
    var i, o, s;
    return {
      view: {
        ...t.view,
        isMfaRequired: (i = r.data) == null ? void 0 : i.isMfaRequired,
        allowedSecondFactors: ((s = (o = r.data) == null ? void 0 : o.authentication) == null ? void 0 : s.secondFactors) || []
      }
    };
  }
), PM = ut(
  (t, r) => ({
    allowedSecondFactors: r.data.authentication.secondFactors
  })
), FM = ut(
  (t) => ({
    allowedSecondFactors: t.view.allowedSecondFactors
  })
), UM = ut({
  isSecondFactor: !0
}), zM = (t) => {
  t.config.redirect !== !1 && Wt({ method: "redirectIfLoggedIn", args: [] });
}, BM = (t) => {
  t.config.redirectOnLoad && Wt({ method: "redirectIfLoggedIn", args: [] });
}, WM = ut(
  (t, r) => sr(r.data) ? {
    config: {
      ...t.config,
      tenantId: r.data
    }
  } : {
    config: {
      ...t.config,
      shouldFetchFlow: !1
    }
  }
), qM = ut(
  (t, r) => r.data ? {
    config: {
      ...t.config,
      mode: r.data.mode,
      flow: r.data.authentication
    }
  } : (console.warn(
    "Userfront toolkit: received no data from Userfront.setMode. This is likely a problem on Userfront's side."
  ), {})
), YM = yM([
  {
    cond: (t) => !!t.activeFactor,
    actions: [
      fM((t) => ({
        type: Yh(t.activeFactor)
      }))
    ]
  }
]), VM = ut(
  (t, r) => ({
    config: {
      ...t.config,
      activeFactor: r.factor
    }
  })
), GM = ut((t) => ({
  view: {
    ...t.view,
    message: "Email resent."
  }
})), KM = ut((t) => ({
  view: {
    ...t.view,
    message: ""
  }
})), $M = ut((t) => ({
  action: t.config.type === "login" ? "use" : "setup"
})), QM = ut((t) => {
  var i, o;
  return ((i = t.allowedSecondFactors) == null ? void 0 : i.some(
    (s) => s.isConfiguredByUser
  )) ? {
    action: "use",
    allowedSecondFactors: (o = t.allowedSecondFactors) == null ? void 0 : o.filter(
      (s) => s.isConfiguredByUser
    )
  } : {
    action: "setup"
  };
}), HM = {
  guards: {
    hasMultipleFirstFactors: (t, r) => {
      var o, s;
      return ((s = (o = t.config.flow) == null ? void 0 : o.firstFactors) != null ? s : []).length > 1;
    },
    hasNoFirstFactors: (t) => {
      var i, o;
      return ((o = (i = t.config.flow) == null ? void 0 : i.firstFactors) != null ? o : []).length === 0;
    },
    hasOnlyEmailLinkFirstFactor: fn({
      channel: "email",
      strategy: "link"
    }),
    hasOnlyEmailCodeFirstFactor: fn({
      channel: "email",
      strategy: "verificationCode"
    }),
    hasOnlySmsCodeFirstFactor: fn({
      channel: "sms",
      strategy: "verificationCode"
    }),
    hasOnlyPasswordFirstFactor: fn({
      channel: "email",
      strategy: "password"
    }),
    hasOnlyTotpFirstFactor: fn({
      channel: "authenticator",
      strategy: "totp"
    }),
    hasOnlySsoFirstFactor: (t) => {
      var i;
      const r = (i = t.config.flow) == null ? void 0 : i.firstFactors[0];
      return r ? ns(r) : !1;
    },
    hasMultipleSecondFactors: (t, r) => {
      var i, o;
      return ((o = (i = t.allowedSecondFactors) == null ? void 0 : i.length) != null ? o : 0) > 1;
    },
    hasOnlyEmailLinkSecondFactor: fn({
      channel: "email",
      strategy: "link",
      secondFactor: !0
    }),
    hasOnlyEmailCodeSecondFactor: fn({
      channel: "email",
      strategy: "verificationCode",
      secondFactor: !0
    }),
    hasOnlySmsCodeSecondFactor: fn({
      channel: "sms",
      strategy: "verificationCode",
      secondFactor: !0
    }),
    hasOnlyPasswordSecondFactor: fn({
      channel: "email",
      strategy: "password",
      secondFactor: !0
    }),
    hasOnlyTotpSecondFactor: fn({
      channel: "authenticator",
      strategy: "totp",
      secondFactor: !0
    }),
    hasOnlySsoSecondFactor: (t) => {
      var i;
      const r = (i = t.allowedSecondFactors) == null ? void 0 : i[0];
      return r ? ns(r) : !1;
    },
    isEmailLink: (t, r) => ro(r.factor, Br.emailLink),
    isEmailCode: (t, r) => ro(r.factor, Br.emailCode),
    isSmsCode: (t, r) => ro(r.factor, Br.smsCode),
    isPassword: (t, r) => ro(r.factor, Br.password),
    isTotp: (t, r) => ro(r.factor, Br.totp),
    isSsoProvider: (t, r) => ns(r.factor),
    hasLinkQueryParams: Gh,
    hasNoActiveFactor: lT,
    isLocalMode: cT,
    isLocalModeWithoutFlow: sT,
    isLoggedIn: cs,
    isLoggedInOrHasLinkCredentials: fT,
    isMissingFlow: Vh,
    isMissingFlowFromServer: uT,
    isMissingTenantId: aT,
    isPasswordReset: dT,
    isSecondFactor: iT,
    isSetup: hT,
    passwordsMatch: oT,
    secondFactorRequired: rT,
    secondFactorRequiredFromView: nT
  },
  actions: {
    clearError: wM,
    clearResentMessage: KM,
    disableBack: TM,
    enableBack: MM,
    markAsSecondFactor: UM,
    markQueryParamsInvalid: xM,
    readQueryParams: EM,
    redirectIfLoggedIn: zM,
    redirectOnLoad: BM,
    resumeIfNeeded: YM,
    setActiveFactor: VM,
    setAllowedSecondFactors: PM,
    setAllowedSecondFactorsFromView: FM,
    setCode: NM,
    setEmail: _M,
    setErrorForPasswordMismatch: SM,
    setErrorFromApiError: bM,
    setFirstFactorAction: $M,
    setFlowFromUserfrontApi: qM,
    setPassword: OM,
    setPasswordForReset: LM,
    setPhoneNumber: AM,
    setQrCode: IM,
    setResentMessage: GM,
    setSecondFactorAction: QM,
    setShowEmailOrUsernameIfFirstFactor: DM,
    setTenantIdIfPresent: WM,
    setTotpCode: jM,
    setupView: CM,
    setUseBackupCode: kM,
    storeFactorResponse: RM
  }
}, ps = {
  user: {
    email: ""
  },
  config: {
    flow: null,
    tenantId: null,
    shouldFetchFlow: !0,
    mode: "live",
    compact: !1,
    locale: "en-US",
    type: "login",
    action: "use"
  },
  view: {},
  isSecondFactor: !1
}, JM = {
  schema: {
    context: {},
    events: {}
  },
  id: "universal",
  predictableActionArguments: !0,
  initial: "init",
  states: {
    backToFactors: {
      id: "backToFactors",
      always: [
        {
          target: "selectSecondFactor",
          cond: "isSecondFactor"
        },
        {
          target: "selectFirstFactor"
        }
      ]
    },
    init: {
      always: [
        {
          target: "getGlobalTenantId",
          cond: "isMissingTenantId"
        },
        {
          target: "initUserfront"
        }
      ]
    },
    getGlobalTenantId: {
      invoke: {
        src: () => Ph("store.tenantId"),
        onDone: [
          {
            target: "initFlow",
            actions: "setTenantIdIfPresent"
          }
        ],
        onError: [
          {
            target: "initFlow",
            actions: "setTenantIdIfPresent"
          }
        ]
      }
    },
    initUserfront: {
      invoke: {
        src: async (t) => (pS({
          method: "init",
          args: [t.config.tenantId]
        }), t.config.tenantId),
        onDone: [
          {
            target: "initFlow",
            actions: "setTenantIdIfPresent"
          }
        ],
        onError: [
          {
            target: "initFlow",
            actions: "setTenantIdIfPresent"
          }
        ]
      }
    },
    initFlow: {
      entry: ["readQueryParams"],
      always: [
        {
          target: "initPasswordReset",
          cond: "isPasswordReset"
        },
        {
          target: "alreadyLoggedIn",
          cond: "isLoggedIn"
        },
        {
          target: "missingFlowInLocalModeError",
          cond: "isLocalModeWithoutFlow"
        },
        {
          target: "showPlaceholderAndFetchFlow",
          cond: "isMissingFlow"
        },
        {
          target: "beginFlow",
          cond: "isLocalMode"
        },
        {
          target: "showPreviewAndFetchFlow"
        }
      ]
    },
    alreadyLoggedIn: {
      entry: ["redirectOnLoad"],
      id: "alreadyLoggedIn",
      type: "final"
    },
    initPasswordReset: {
      invoke: {
        src: () => Wt({ method: "setMode" }),
        onError: [
          {
            target: "setNewPassword",
            cond: "isLoggedInOrHasLinkCredentials"
          },
          {
            target: "emailLink"
          }
        ],
        onDone: [
          {
            target: "setNewPassword",
            cond: "isLoggedInOrHasLinkCredentials",
            actions: "setFlowFromUserfrontApi"
          },
          {
            target: "emailLink",
            actions: "setFlowFromUserfrontApi"
          }
        ]
      }
    },
    setNewPassword: vM,
    showPlaceholderAndFetchFlow: {
      invoke: {
        src: () => Wt({ method: "setMode" }),
        onError: {
          target: "missingFlowFromServerError"
        },
        onDone: [
          {
            target: "beginFlow",
            actions: "setFlowFromUserfrontApi"
          }
        ]
      }
    },
    showPreviewAndFetchFlow: {
      invoke: {
        src: () => Wt({ method: "setMode" }),
        onError: {
          target: "missingFlowFromServerError"
        },
        onDone: [
          {
            target: "beginFlow",
            cond: "hasNoActiveFactor",
            actions: "setFlowFromUserfrontApi"
          },
          {
            actions: ["setFlowFromUserfrontApi", "resumeIfNeeded"]
          }
        ]
      },
      on: {
        selectFactor: {
          actions: "setActiveFactor"
        }
      }
    },
    missingFlowInLocalModeError: {
      entry: ut({ error: Id("Missing flow in local mode") })
    },
    missingFlowFromServerError: {
      entry: ut({ error: Id("Missing flow from server") })
    },
    unhandledError: {
      id: "unhandledError",
      entry: ut({ error: eT })
    },
    beginFlow: {
      entry: [
        "redirectOnLoad",
        "setFirstFactorAction",
        "setupView"
      ],
      always: [
        {
          target: "handleLoginWithLink",
          cond: "hasLinkQueryParams"
        },
        {
          target: "noFirstFactors",
          cond: "hasNoFirstFactors"
        },
        {
          actions: "enableBack",
          target: "selectFirstFactor",
          cond: "hasMultipleFirstFactors"
        },
        {
          target: "selectFirstFactor",
          cond: "hasOnlySsoFirstFactor"
        },
        ...Object.values(Br).map((t) => ({
          actions: "disableBack",
          target: t.name,
          cond: t.testOnlyFirst
        })),
        {
          target: "unhandledError"
        }
      ]
    },
    noFirstFactors: {
      id: "noFirstFactors",
      always: [
        {
          target: "disabled"
        }
      ]
    },
    disabled: {
      id: "disabled",
      type: "final"
    },
    selectFirstFactor: Bd,
    emailLink: mM,
    emailCode: gM,
    smsCode: pM,
    password: lc,
    totpCode: {
      id: "totpCode",
      always: [
        {
          target: "setUpTotp",
          cond: "isSetup"
        },
        {
          target: "useTotpCode"
        }
      ]
    },
    useTotpCode: dM,
    setUpTotp: hM,
    ssoProvider: {
      id: "ssoProvider",
      invoke: {
        src: (t, r) => {
          var i;
          return Wt({
            method: "login",
            args: [
              {
                method: (i = r.factor) == null ? void 0 : i.strategy
              }
            ]
          });
        },
        onError: {
          target: "unhandledError"
        }
      }
    },
    handleLoginWithLink: {
      id: "handleLoginWithLink",
      invoke: {
        src: (t) => Wt({
          method: "login",
          args: [
            {
              method: "link",
              token: t.query.token,
              uuid: t.query.uuid
            }
          ]
        }),
        onDone: [
          {
            actions: "setAllowedSecondFactors",
            target: "beginSecondFactor",
            cond: "secondFactorRequired"
          },
          {
            target: "finish"
          }
        ],
        onError: [
          {
            actions: ["setErrorFromApiError", "markQueryParamsInvalid"],
            target: "beginFlow"
          }
        ]
      }
    },
    beginSecondFactor: {
      id: "beginSecondFactor",
      entry: ["setSecondFactorAction", "setupView"],
      always: [
        {
          target: "finish",
          cond: "isLoggedIn"
        },
        {
          actions: ["enableBack", "markAsSecondFactor"],
          target: "selectSecondFactor",
          cond: "hasMultipleSecondFactors"
        },
        {
          actions: "markAsSecondFactor",
          target: "selectSecondFactor",
          cond: "hasOnlySsoSecondFactor"
        },
        ...Object.values(Br).map((t) => ({
          actions: ["disableBack", "markAsSecondFactor"],
          target: t.name,
          cond: t.testOnlySecond
        })),
        {
          target: "unhandledError"
        }
      ]
    },
    selectSecondFactor: Bd,
    finish: {
      id: "finish",
      type: "final"
    }
  }
}, jc = (t, r = {}) => lM(JM, {
  ...HM,
  ...r
}).withContext(t);
var lp = { exports: {} }, Yu = {}, kc = { exports: {} }, Vu = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qd;
function ZM() {
  if (qd)
    return Vu;
  qd = 1;
  var t = en;
  function r(m, b) {
    return m === b && (m !== 0 || 1 / m === 1 / b) || m !== m && b !== b;
  }
  var i = typeof Object.is == "function" ? Object.is : r, o = t.useState, s = t.useEffect, c = t.useLayoutEffect, l = t.useDebugValue;
  function d(m, b) {
    var x = b(), E = o({ inst: { value: x, getSnapshot: b } }), _ = E[0].inst, N = E[1];
    return c(function() {
      _.value = x, _.getSnapshot = b, p(_) && N({ inst: _ });
    }, [m, x, b]), s(function() {
      return p(_) && N({ inst: _ }), m(function() {
        p(_) && N({ inst: _ });
      });
    }, [m]), l(x), x;
  }
  function p(m) {
    var b = m.getSnapshot;
    m = m.value;
    try {
      var x = b();
      return !i(m, x);
    } catch {
      return !0;
    }
  }
  function v(m, b) {
    return b();
  }
  var w = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? v : d;
  return Vu.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : w, Vu;
}
var Gu = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Yd;
function XM() {
  return Yd || (Yd = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = en, r = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function i(j) {
      {
        for (var R = arguments.length, F = new Array(R > 1 ? R - 1 : 0), B = 1; B < R; B++)
          F[B - 1] = arguments[B];
        o("error", j, F);
      }
    }
    function o(j, R, F) {
      {
        var B = r.ReactDebugCurrentFrame, $ = B.getStackAddendum();
        $ !== "" && (R += "%s", F = F.concat([$]));
        var H = F.map(function(te) {
          return String(te);
        });
        H.unshift("Warning: " + R), Function.prototype.apply.call(console[j], console, H);
      }
    }
    function s(j, R) {
      return j === R && (j !== 0 || 1 / j === 1 / R) || j !== j && R !== R;
    }
    var c = typeof Object.is == "function" ? Object.is : s, l = t.useState, d = t.useEffect, p = t.useLayoutEffect, v = t.useDebugValue, w = !1, m = !1;
    function b(j, R, F) {
      w || t.startTransition !== void 0 && (w = !0, i("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var B = R();
      if (!m) {
        var $ = R();
        c(B, $) || (i("The result of getSnapshot should be cached to avoid an infinite loop"), m = !0);
      }
      var H = l({
        inst: {
          value: B,
          getSnapshot: R
        }
      }), te = H[0].inst, G = H[1];
      return p(function() {
        te.value = B, te.getSnapshot = R, x(te) && G({
          inst: te
        });
      }, [j, B, R]), d(function() {
        x(te) && G({
          inst: te
        });
        var ve = function() {
          x(te) && G({
            inst: te
          });
        };
        return j(ve);
      }, [j]), v(B), B;
    }
    function x(j) {
      var R = j.getSnapshot, F = j.value;
      try {
        var B = R();
        return !c(F, B);
      } catch {
        return !0;
      }
    }
    function E(j, R, F) {
      return R();
    }
    var _ = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", N = !_, U = N ? E : b, A = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : U;
    Gu.useSyncExternalStore = A, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Gu;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = ZM() : t.exports = XM();
})(kc);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Vd;
function eE() {
  if (Vd)
    return Yu;
  Vd = 1;
  var t = en, r = kc.exports;
  function i(v, w) {
    return v === w && (v !== 0 || 1 / v === 1 / w) || v !== v && w !== w;
  }
  var o = typeof Object.is == "function" ? Object.is : i, s = r.useSyncExternalStore, c = t.useRef, l = t.useEffect, d = t.useMemo, p = t.useDebugValue;
  return Yu.useSyncExternalStoreWithSelector = function(v, w, m, b, x) {
    var E = c(null);
    if (E.current === null) {
      var _ = { hasValue: !1, value: null };
      E.current = _;
    } else
      _ = E.current;
    E = d(function() {
      function U(B) {
        if (!A) {
          if (A = !0, j = B, B = b(B), x !== void 0 && _.hasValue) {
            var $ = _.value;
            if (x($, B))
              return R = $;
          }
          return R = B;
        }
        if ($ = R, o(j, B))
          return $;
        var H = b(B);
        return x !== void 0 && x($, H) ? $ : (j = B, R = H);
      }
      var A = !1, j, R, F = m === void 0 ? null : m;
      return [function() {
        return U(w());
      }, F === null ? void 0 : function() {
        return U(F());
      }];
    }, [w, m, b, x]);
    var N = s(v, E[0], E[1]);
    return l(function() {
      _.hasValue = !0, _.value = N;
    }, [N]), p(N), N;
  }, Yu;
}
var Ku = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Gd;
function tE() {
  return Gd || (Gd = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = en, r = kc.exports;
    function i(w, m) {
      return w === m && (w !== 0 || 1 / w === 1 / m) || w !== w && m !== m;
    }
    var o = typeof Object.is == "function" ? Object.is : i, s = r.useSyncExternalStore, c = t.useRef, l = t.useEffect, d = t.useMemo, p = t.useDebugValue;
    function v(w, m, b, x, E) {
      var _ = c(null), N;
      _.current === null ? (N = {
        hasValue: !1,
        value: null
      }, _.current = N) : N = _.current;
      var U = d(function() {
        var F = !1, B, $, H = function(be) {
          if (!F) {
            F = !0, B = be;
            var xe = x(be);
            if (E !== void 0 && N.hasValue) {
              var K = N.value;
              if (E(K, xe))
                return $ = K, K;
            }
            return $ = xe, xe;
          }
          var ie = B, ae = $;
          if (o(ie, be))
            return ae;
          var se = x(be);
          return E !== void 0 && E(ae, se) ? ae : (B = be, $ = se, se);
        }, te = b === void 0 ? null : b, G = function() {
          return H(m());
        }, ve = te === null ? void 0 : function() {
          return H(te());
        };
        return [G, ve];
      }, [m, b, x, E]), A = U[0], j = U[1], R = s(w, A, j);
      return l(function() {
        N.hasValue = !0, N.value = R;
      }, [R]), p(R), R;
    }
    Ku.useSyncExternalStoreWithSelector = v, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), Ku;
}
(function(t) {
  process.env.NODE_ENV === "production" ? t.exports = eE() : t.exports = tE();
})(lp);
var rE = Qd;
function Kd(t) {
  var r = $u.useRef();
  return r.current || (r.current = { v: t() }), r.current.v;
}
var gs = globalThis && globalThis.__assign || function() {
  return gs = Object.assign || function(t) {
    for (var r, i = 1, o = arguments.length; i < o; i++) {
      r = arguments[i];
      for (var s in r)
        Object.prototype.hasOwnProperty.call(r, s) && (t[s] = r[s]);
    }
    return t;
  }, gs.apply(this, arguments);
}, nE = globalThis && globalThis.__rest || function(t, r) {
  var i = {};
  for (var o in t)
    Object.prototype.hasOwnProperty.call(t, o) && r.indexOf(o) < 0 && (i[o] = t[o]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, o = Object.getOwnPropertySymbols(t); s < o.length; s++)
      r.indexOf(o[s]) < 0 && Object.prototype.propertyIsEnumerable.call(t, o[s]) && (i[o[s]] = t[o[s]]);
  return i;
}, iE = globalThis && globalThis.__read || function(t, r) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var o = i.call(t), s, c = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(s = o.next()).done; )
      c.push(s.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return c;
};
function oE(t, r) {
  var i = Kd(function() {
    return typeof t == "function" ? t() : t;
  });
  if (process.env.NODE_ENV !== "production" && typeof t != "function") {
    var o = iE(Qt(i), 1), s = o[0];
    t !== s && console.warn("Machine given to `useMachine` has changed between renders. This is not supported and might lead to unexpected results.\nPlease make sure that you pass the same Machine as argument each time.");
  }
  var c = r.context, l = r.guards, d = r.actions, p = r.activities, v = r.services, w = r.delays;
  r.state;
  var m = nE(r, ["context", "guards", "actions", "activities", "services", "delays", "state"]), b = Kd(function() {
    var x = {
      context: c,
      guards: l,
      actions: d,
      activities: p,
      services: v,
      delays: w
    }, E = i.withConfig(x, function() {
      return gs(gs({}, i.context), c);
    });
    return cp(E, m);
  });
  return rE(function() {
    Object.assign(b.machine.options.actions, d), Object.assign(b.machine.options.guards, l), Object.assign(b.machine.options.activities, p), Object.assign(b.machine.options.services, v), Object.assign(b.machine.options.delays, w);
  }, [d, l, p, v, w]), b;
}
var aE = globalThis && globalThis.__read || function(t, r) {
  var i = typeof Symbol == "function" && t[Symbol.iterator];
  if (!i)
    return t;
  var o = i.call(t), s, c = [], l;
  try {
    for (; (r === void 0 || r-- > 0) && !(s = o.next()).done; )
      c.push(s.value);
  } catch (d) {
    l = { error: d };
  } finally {
    try {
      s && !s.done && (i = o.return) && i.call(o);
    } finally {
      if (l)
        throw l.error;
    }
  }
  return c;
};
function sE(t) {
  return t;
}
function fp(t) {
  for (var r = [], i = 1; i < arguments.length; i++)
    r[i - 1] = arguments[i];
  var o = aE(r, 1), s = o[0], c = s === void 0 ? {} : s, l = oE(t, c), d = Ou(function() {
    return l.status === zt.NotStarted ? c.state ? zr.create(c.state) : l.machine.initialState : l.state;
  }, [l]), p = Ou(function(m, b) {
    if (l.status === zt.NotStarted)
      return !0;
    var x = b.changed === void 0 && (Object.keys(b.children).length > 0 || typeof m.changed == "boolean");
    return !(b.changed || x);
  }, [l]), v = Ou(function(m) {
    var b = l.subscribe(m).unsubscribe;
    return b;
  }, [l]), w = lp.exports.useSyncExternalStoreWithSelector(v, d, d, sE, p);
  return fc(function() {
    var m = c.state;
    return l.start(m ? zr.create(m) : void 0), function() {
      l.stop(), l.status = zt.NotStarted;
    };
  }, []), [w, l.send, l];
}
function Dc({
  type: t,
  tenantId: r,
  flow: i,
  compact: o,
  theme: s,
  redirect: c,
  redirectOnLoadIfLoggedIn: l = !1,
  shouldFetchFlow: d = !0,
  xstateDevTools: p = !1
}) {
  const [v, w] = fp(() => {
    const m = {
      ...ps.config
    };
    r && (m.tenantId = r), i && (m.flow = i), t && (m.type = t), m.compact = !!o, m.shouldFetchFlow = !!d, m.redirect = c, m.redirectOnLoad = !!l;
    const b = {
      ...ps,
      config: m
    };
    return jc(b);
  }, {
    devTools: p
  });
  return /* @__PURE__ */ D(Ec, {
    state: v,
    onEvent: w,
    theme: s
  });
}
function gE(t) {
  return /* @__PURE__ */ D(Dc, {
    type: "signup",
    ...t
  });
}
function mE(t) {
  return /* @__PURE__ */ D(Dc, {
    type: "login",
    ...t
  });
}
function vE(t) {
  return /* @__PURE__ */ D(Dc, {
    type: "reset",
    ...t
  });
}
const yE = ({
  redirect: t,
  disabled: r = !1,
  demo: i = !1,
  theme: o = {},
  children: s,
  style: c = {}
}) => {
  const l = s || "Log out", d = async () => {
    if (!i)
      try {
        const x = {};
        t != null && (x.redirect = t), Wt({
          method: "logout",
          args: [x]
        });
      } catch (x) {
        console.warn(`Userfront.logout failed. Error: ${x.error}. Message: ${x.message}`);
      }
  }, p = (o == null ? void 0 : o.colors) || {}, v = {
    "--userfront-light-color": p.light || "#ffffff",
    "--userfront-dark-color": p.dark || "#5e72e4",
    "--userfront-accent-color": p.accent || "#13a0ff"
  };
  p.lightBackground && (v["--userfront-light-background-color"] = p.lightBackground), p.darkBackground && (v["--userfront-dark-background-color"] = p.darkBackground), o != null && o.fontFamily && (v["--userfront-font-family"] = o.fontFamily), o == null || o.colorScheme, o == null || o.colorScheme, (o == null ? void 0 : o.size) === "compact" && (v["--userfront-em-size"] = "14px", v["--userfront-spacing"] = "0.5em"), (o == null ? void 0 : o.size) === "mini" && (v["--userfront-em-size"] = "12px", v["--userfront-spacing"] = "0.5em", v["--userfront-container-width"] = "250px"), (o == null ? void 0 : o.size) === "spaced" && (v["--userfront-em-size"] = "14px", v["--userfront-spacing"] = "20px"), (o == null ? void 0 : o.size) === "large" && (v["--userfront-em-size"] = "20px", v["--userfront-spacing"] = "18px");
  const w = {
    gradientButtons: "userfront-gradient-buttons",
    hideSecuredMessage: "userfront-hide-branding",
    raisedButtons: "userfront-raised-buttons",
    dottedOutlines: "userfront-dotted-outlines"
  }, m = (o == null ? void 0 : o.extras) || {};
  let b = "";
  return Object.entries(m).filter(([x, E]) => Boolean(E)).forEach(([x]) => {
    x in w ? b += ` ${w[x]}` : b += ` userfront-${x}`;
  }), b = b.trim(), /* @__PURE__ */ D("button", {
    onClick: d,
    style: {
      ...v,
      ...c
    },
    className: `userfront-toolkit userfront-element userfront-button userfront-button-logout ${b}`,
    "aria-disabled": r,
    disabled: r,
    children: l
  });
}, or = {
  store: {
    tenantId: "demo1234"
  },
  mfaRequired: async () => ({
    mode: "test",
    message: "MFA required",
    isMfaRequired: !0,
    firstFactorToken: "uf_test_first_factor_207a4d56ce7e40bc9dafb0918fb6599a",
    authentication: {
      firstFactor: {
        strategy: "link",
        channel: "email"
      },
      secondFactors: [
        {
          strategy: "totp",
          channel: "authenticator",
          isConfiguredByUser: !0
        },
        {
          strategy: "verificationCode",
          channel: "sms",
          isConfiguredByUser: !1
        }
      ]
    }
  }),
  mfaSetupRequired: async () => ({
    mode: "test",
    message: "MFA required",
    isMfaRequired: !0,
    firstFactorToken: "uf_test_first_factor_207a4d56ce7e40bc9dafb0918fb6599a",
    authentication: {
      firstFactor: {
        strategy: "link",
        channel: "email"
      },
      secondFactors: [
        {
          strategy: "totp",
          channel: "authenticator",
          isConfiguredByUser: !1
        },
        {
          strategy: "verificationCode",
          channel: "sms",
          isConfiguredByUser: !1
        }
      ]
    }
  }),
  login: async () => ({
    mode: "test",
    message: "OK",
    redirectTo: "https://example.com/path",
    sessionId: "8976836f-f43d-425d-ab93-86e620c51e5c",
    nonce: "71539dd5-7efc-43d1-b355-9c7e48f165b5",
    tokens: {
      access: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      id: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      refresh: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 1
        }
      }
    },
    userId: 5,
    tenantId: "demo1234",
    userUuid: "a9c9b41c-ce76-4f7e-915a-abf18a36a4ae",
    username: "janedoe",
    email: "user@example.com",
    phoneNumber: "+15558675309",
    name: "Jane Doe",
    image: "https://res.cloudinary.com/component/image/upload/avatars/avatar-16.png",
    locked: !1,
    data: {
      custom: "data"
    },
    isConfirmed: !0,
    isMfaRequired: !1,
    lastActiveAt: "2022-12-15T23:36:33.299Z",
    lastMessagedAt: "2022-12-15T16:15:14.372Z",
    confirmedAt: "2022-12-15T06:33:43.416Z",
    createdAt: "2022-12-13T20:21:45.837Z",
    updatedAt: "2022-12-16T00:06:45.138Z",
    tenant: {
      tenantId: "demo1234",
      name: "Demo Account"
    },
    authentication: {
      firstFactors: [
        {
          strategy: "password",
          channel: "email"
        },
        {
          strategy: "link",
          channel: "email"
        },
        {
          strategy: "google",
          channel: "email"
        }
      ],
      secondFactors: [
        {
          strategy: "totp",
          channel: "authenticator"
        }
      ]
    },
    authorization: {
      demo1234: {
        roles: []
      }
    }
  }),
  signup: async () => ({
    mode: "test",
    message: "OK",
    redirectTo: "https://example.com/path",
    sessionId: "8976836f-f43d-425d-ab93-86e620c51e5c",
    nonce: "71539dd5-7efc-43d1-b355-9c7e48f165b5",
    tokens: {
      access: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      id: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      refresh: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 1
        }
      }
    },
    userId: 5,
    tenantId: "demo1234",
    userUuid: "a9c9b41c-ce76-4f7e-915a-abf18a36a4ae",
    username: "janedoe",
    email: "user@example.com",
    phoneNumber: "+15558675309",
    name: "Jane Doe",
    image: "https://res.cloudinary.com/component/image/upload/avatars/avatar-16.png",
    locked: !1,
    data: {
      custom: "data"
    },
    isConfirmed: !0,
    isMfaRequired: !1,
    lastActiveAt: "2022-12-15T23:36:33.299Z",
    lastMessagedAt: "2022-12-15T16:15:14.372Z",
    confirmedAt: "2022-12-15T06:33:43.416Z",
    createdAt: "2022-12-13T20:21:45.837Z",
    updatedAt: "2022-12-16T00:06:45.138Z",
    tenant: {
      tenantId: "demo1234",
      name: "Demo Account"
    },
    authentication: {
      firstFactors: [
        {
          strategy: "password",
          channel: "email"
        },
        {
          strategy: "link",
          channel: "email"
        },
        {
          strategy: "google",
          channel: "email"
        }
      ],
      secondFactors: [
        {
          strategy: "totp",
          channel: "authenticator"
        }
      ]
    },
    authorization: {
      demo1234: {
        roles: []
      }
    }
  }),
  sendVerificationCode: async () => ({}),
  logout: async () => ({
    message: "OK",
    redirectTo: "https://example.com/path"
  }),
  redirectIfLoggedIn: async () => {
  },
  resetPassword: async () => ({
    mode: "test",
    message: "OK",
    redirectTo: "https://example.com/path",
    sessionId: "8976836f-f43d-425d-ab93-86e620c51e5c",
    nonce: "71539dd5-7efc-43d1-b355-9c7e48f165b5",
    tokens: {
      access: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      id: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      refresh: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 1
        }
      }
    }
  }),
  updatePassword: async () => ({
    mode: "test",
    message: "OK",
    redirectTo: "https://example.com/path",
    sessionId: "8976836f-f43d-425d-ab93-86e620c51e5c",
    nonce: "71539dd5-7efc-43d1-b355-9c7e48f165b5",
    tokens: {
      access: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      id: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 7
        }
      },
      refresh: {
        value: "e2y...",
        cookieOptions: {
          secure: !0,
          sameSite: "Strict",
          expires: 1
        }
      }
    }
  }),
  sendLoginLink: async () => ({
    message: "OK",
    result: {
      email: "user@example.com",
      submittedAt: "2022-12-16T00:08:26.172Z",
      messageId: "ed2052f6-da85-48aa-a24e-3eab4c5b08d0"
    }
  }),
  sendResetLink: async () => ({
    message: "OK",
    result: {
      email: "user@example.com",
      submittedAt: "2022-12-16T00:08:26.172Z",
      messageId: "ed2052f6-da85-48aa-a24e-3eab4c5b08d0"
    }
  }),
  setMode: async () => ({
    mode: "live",
    authentication: {
      firstFactors: [
        { channel: "email", strategy: "link" },
        { channel: "email", strategy: "azure" },
        { channel: "email", strategy: "verificationCode" },
        { channel: "email", strategy: "password" },
        { channel: "sms", strategy: "verificationCode" },
        { channel: "email", strategy: "google" },
        { channel: "email", strategy: "apple" },
        { channel: "email", strategy: "github" },
        { channel: "email", strategy: "okta" }
      ]
    }
  })
};
class uE {
  constructor({ authFlow: r, mode: i }) {
    this.store = {
      tenantId: "demo1234",
      tokens: {},
      user: {
        getTotp: async () => ({
          totpSecret: "ABYBCGY6PELUWISB",
          qrCode: "data:image/png;base64,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",
          backupCodes: [
            "60bb6-9393a",
            "1b8ef-e3e4b",
            "1488f-7cd2e",
            "3169e-fa7e3"
          ]
        })
      }
    }, this.logAllMethodCalls = !1, this.requireMfa = !0, this.requireMfaSetup = !1, this.isAwaitingSecondFactor = !1, this.authFlow = r, this.mode = i, this.login = this.login.bind(this), this.signup = this.signup.bind(this), this.resetPassword = this.resetPassword.bind(this), this.updatePassword = this.updatePassword.bind(this), this.setMode = this.setMode.bind(this);
  }
  attachToWindow() {
    typeof window !== void 0 && (window._mockUserfront = this);
  }
  async login() {
    return this.isAwaitingSecondFactor ? (this.isAwaitingSecondFactor = !1, or.login()) : this.requireMfaSetup ? (this.isAwaitingSecondFactor = !0, or.mfaSetupRequired()) : this.requireMfa ? (this.isAwaitingSecondFactor = !0, or.mfaRequired()) : or.login();
  }
  async signup() {
    return this.isAwaitingSecondFactor ? (this.isAwaitingSecondFactor = !1, or.signup()) : this.requireMfaSetup ? (this.isAwaitingSecondFactor = !0, or.mfaSetupRequired()) : or.signup();
  }
  async sendVerificationCode() {
    return or.sendVerificationCode();
  }
  async logout() {
    return or.logout();
  }
  async redirectIfLoggedIn() {
    return or.redirectIfLoggedIn();
  }
  async resetPassword() {
    return this.updatePassword();
  }
  async updatePassword() {
    return this.isAwaitingSecondFactor ? (this.isAwaitingSecondFactor = !1, or.updatePassword()) : this.requireMfa ? (this.isAwaitingSecondFactor = !0, or.mfaRequired()) : or.updatePassword();
  }
  async sendLoginLink() {
    return or.sendLoginLink();
  }
  async sendResetLink() {
    return or.sendResetLink();
  }
  async setMode() {
    const r = or.setMode();
    return this.authFlow ? {
      mode: this.mode,
      authentication: this.authFlow
    } : r;
  }
}
const cE = ({ authFlow: t, mode: r = "live" } = {}) => new uE({ authFlow: t, mode: r }), lE = ({ authFlow: t, mode: r = "live" } = {}) => {
  const i = cE({ authFlow: t, mode: r });
  return Rh(i), i;
}, dp = {
  ...ps
}, fE = jc(dp), dE = {
  firstFactors: [{
    channel: "email",
    strategy: "google"
  }, {
    channel: "email",
    strategy: "apple"
  }, {
    channel: "email",
    strategy: "link"
  }, {
    channel: "email",
    strategy: "password"
  }]
}, wE = ({
  type: t,
  theme: r,
  authFlow: i = dE,
  mode: o = "live"
}) => {
  dp.config.type = t;
  const s = lE({
    authFlow: i,
    mode: o
  }), c = fE, l = {}, [d, p] = fp(c, l);
  return fc(() => {
    s.attachToWindow();
  }, []), /* @__PURE__ */ D(Ec, {
    state: d,
    onEvent: (w) => {
      p(w);
    },
    theme: r,
    isDemo: !0,
    demoMode: o
  });
};
Nh.build = (t) => {
  console.error(`Userfront.build(${t}) has been removed. Instead, import the component directly:
    import { SignupForm, LoginForm, PasswordResetForm, SetNewPasswordForm, LogoutButton } from "@userfront/toolkit/react"
  See https://userfront.com/dashboard/toolkit for more information about upgrading to the new toolkit.`);
};
const bE = {
  UnboundUniversalForm: Ec,
  createUniversalFormModel: jc,
  defaultUniversalFormContext: ps,
  overrideUserfrontSingleton: Rh
};
export {
  wE as DemoForm,
  mE as LoginForm,
  yE as LogoutButton,
  vE as PasswordResetForm,
  gE as SignupForm,
  bE as _devTools,
  Nh as default
};
